var _defs, _feBlend, _feBlend2, _feBlend3, _feBlend4, _feBlend5, _feBlend6, _feBlend7, _feBlend8, _feBlend9, _feBlend10, _feBlend11, _feBlend12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wall",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 400,
    height: 400
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000022545713040613794130000013595285676791165355_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157987387641518686420000001122174535994060963_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.656,
    y1: 282.5863,
    x2: 199.656,
    y2: -25.6255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FACD5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0013,
    style: {
      stopColor: "#FACD5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0972,
    style: {
      stopColor: "#FCDB7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    style: {
      stopColor: "#FDE595"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3036,
    style: {
      stopColor: "#FEEDA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4195,
    style: {
      stopColor: "#FFF2B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5627,
    style: {
      stopColor: "#FFF3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6143,
    style: {
      stopColor: "#E8F1B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    style: {
      stopColor: "#ADEBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    style: {
      stopColor: "#4FE2C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DBCA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "url(#SVGID_00000157987387641518686420000001122174535994060963_)"
    },
    points: " -3.056,266.442 402.368,266.442 402.368,-76.084 -3.056,-76.084  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A6EAC3"
    },
    points: "350.224,188.16 352.793,127.023 369.991,126.621 370.702,105.985 382.069,106.239  381.979,136.514 385.403,137.373 385.157,145.519 389.063,145.765 389.835,122.306 400.611,123.556 399.632,160.025  407.436,160.924 406.979,172.568 409.307,172.562 408.45,136.019 413.573,135.747 414.344,117.398 425.92,117.607  425.612,163.634 432.445,164.175 433.596,107.305 450.942,107.098 450.707,188.623 350.224,188.16  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.232,115.284 449.52,115.375 449.52,113.834 435.232,113.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.292,118.67 449.461,118.759 449.461,117.251 435.292,117.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.352,122.056 449.401,122.143 449.401,120.667 435.352,120.755  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.411,125.442 449.341,125.527 449.341,124.084 435.411,124.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.471,128.828 449.281,128.911 449.281,127.5 435.471,127.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.531,132.214 449.222,132.295 449.222,130.917 435.531,130.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.59,135.6 449.162,135.679 449.162,134.333 435.59,134.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.65,138.985 449.102,139.063 449.102,137.75 435.65,137.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.71,142.371 449.043,142.447 449.043,141.167 435.71,141.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.769,145.757 448.983,145.831 448.983,144.583 435.769,144.657  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.829,149.143 448.923,149.215 448.923,148 435.829,148.072  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.889,152.529 448.864,152.599 448.864,151.416 435.889,151.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "435.948,155.915 448.804,155.983 448.804,154.833 435.948,154.901  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "436.008,159.301 448.744,159.367 448.744,158.249 436.008,158.315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "436.068,162.687 448.685,162.751 448.685,161.666 436.068,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "436.128,166.073 448.625,166.135 448.625,165.082 436.128,165.145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "436.187,169.459 448.565,169.519 448.565,168.499 436.187,168.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "436.247,172.845 448.506,172.903 448.506,171.915 436.247,171.974  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.469,130.562 368.757,130.632 368.757,129.45 354.469,129.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.547,133.958 368.679,134.026 368.679,132.876 354.547,132.945  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.625,137.353 368.601,137.42 368.601,136.303 354.625,136.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.703,140.749 368.523,140.814 368.523,139.73 354.703,139.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.781,144.145 368.445,144.208 368.445,143.156 354.781,143.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.859,147.541 368.366,147.601 368.366,146.583 354.859,146.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.937,150.937 368.288,150.995 368.288,150.009 354.937,150.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.015,154.333 368.21,154.389 368.21,153.436 355.015,153.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.093,157.729 368.132,157.783 368.132,156.862 355.093,156.917  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.171,161.124 368.054,161.177 368.054,160.289 355.171,160.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.249,164.52 367.976,164.571 367.976,163.715 355.249,163.766  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.327,167.916 367.898,167.965 367.898,167.142 355.327,167.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.405,171.312 367.82,171.359 367.82,170.568 355.405,170.615  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.483,174.708 367.742,174.753 367.742,173.995 355.483,174.04  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "390.946,127.118 398.984,127.192 398.984,125.95 390.946,126.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "390.986,130.434 398.867,130.505 398.867,129.295 390.986,129.367  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.027,133.749 398.751,133.818 398.751,132.64 391.027,132.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.068,137.064 398.635,137.132 398.635,135.985 391.068,136.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.109,140.379 398.518,140.445 398.518,139.33 391.109,139.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.149,143.694 398.402,143.758 398.402,142.675 391.149,142.739  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.19,147.009 398.286,147.071 398.286,146.02 391.19,146.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.231,150.324 398.169,150.384 398.169,149.365 391.231,149.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.272,153.639 398.053,153.697 398.053,152.71 391.272,152.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.313,156.954 397.936,157.011 397.936,156.055 391.313,156.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.353,160.269 397.82,160.324 397.82,159.4 391.353,159.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.394,163.584 397.704,163.637 397.704,162.745 391.394,162.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.435,166.899 397.587,166.95 397.587,166.09 391.435,166.141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.476,170.214 397.471,170.263 397.471,169.435 391.476,169.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "391.516,173.529 397.355,173.577 397.355,172.78 391.516,172.827  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.292,120.449h1.274v2.729h-1.274V120.449z M420.777,123.178h1.274v-2.729h-1.274V123.178z  M415.747,123.178h1.274v-2.729h-1.274V123.178z M418.262,123.178h1.274v-2.729h-1.274V123.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.257,124.356h1.26v2.698h-1.26V124.356z M420.77,127.054h1.26v-2.698h-1.26V127.054z  M415.796,127.054h1.26v-2.698h-1.26V127.054z M418.283,127.054h1.26v-2.698h-1.26V127.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.222,128.263h1.246v2.668h-1.246V128.263z M420.763,130.931h1.246v-2.668h-1.246V130.931z  M415.845,130.931h1.246v-2.668h-1.246V130.931z M418.304,130.931h1.246v-2.668h-1.246V130.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.187,132.171h1.232v2.638h-1.232V132.171z M420.756,134.808h1.232v-2.638h-1.232V134.808z  M415.895,134.808h1.232v-2.638h-1.232V134.808z M418.325,134.808h1.232v-2.638h-1.232V134.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.152,136.078h1.217v2.607h-1.217V136.078z M420.749,138.685h1.217v-2.607h-1.217V138.685z  M415.943,138.685h1.218v-2.607h-1.218V138.685z M418.346,138.685h1.218v-2.607h-1.218V138.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.117,139.985h1.203v2.577h-1.203V139.985z M420.742,142.562h1.203v-2.577h-1.203V142.562z  M415.992,142.562h1.203v-2.577h-1.203V142.562z M418.367,142.562h1.203v-2.577h-1.203V142.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.082,143.892h1.189v2.547h-1.189V143.892z M420.736,146.439h1.189v-2.547h-1.189V146.439z  M416.042,146.439h1.189v-2.547h-1.189V146.439z M418.388,146.439h1.189v-2.547h-1.189V146.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.048,147.799h1.175v2.516h-1.175V147.799z M420.729,150.316h1.175v-2.516h-1.175V150.316z  M416.09,150.316h1.175v-2.516h-1.175V150.316z M418.41,150.316h1.175v-2.516h-1.175V150.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M423.013,151.706h1.161v2.486h-1.161V151.706z M420.722,154.192h1.161v-2.486h-1.161V154.192z  M416.139,154.192h1.161v-2.486h-1.161V154.192z M418.431,154.192h1.161v-2.486h-1.161V154.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M422.978,155.613h1.147v2.456h-1.147V155.613z M420.715,158.069h1.147v-2.456h-1.147V158.069z  M416.189,158.069h1.147v-2.456h-1.147V158.069z M418.452,158.069h1.147v-2.456h-1.147V158.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M422.943,159.521h1.133v2.425h-1.133V159.521z M420.708,161.946h1.132v-2.425h-1.132V161.946z  M416.238,161.946h1.133v-2.425h-1.133V161.946z M418.473,161.946h1.133v-2.425h-1.133V161.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M422.908,163.428h1.118v2.395h-1.118V163.428z M420.701,165.823h1.118v-2.395h-1.118V165.823z  M416.287,165.823h1.118v-2.395h-1.118V165.823z M418.494,165.823h1.118v-2.395h-1.118V165.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M422.873,167.335h1.104v2.365h-1.104V167.335z M420.694,169.7h1.104v-2.365h-1.104V169.7z  M416.336,169.7h1.104v-2.365h-1.104V169.7z M418.515,169.7h1.104v-2.365h-1.104V169.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M422.839,171.242h1.09v2.334h-1.09V171.242z M420.687,173.577h1.09v-2.334h-1.09V173.577z  M416.385,173.577h1.09v-2.334h-1.09V173.577z M418.536,173.577h1.09v-2.334h-1.09V173.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M388.519,148.278h1.06v2.342h-1.06V148.278z M386.426,150.62h1.06v-2.342h-1.06V150.62z  M382.241,150.62h1.06v-2.342h-1.06V150.62z M384.334,150.62h1.06v-2.342h-1.06V150.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M388.456,152.339h1.035v2.225h-1.035V152.339z M386.414,154.564h1.035v-2.225h-1.035V154.564z  M382.33,154.564h1.035v-2.225h-1.035V154.564z M384.372,154.564h1.035v-2.225h-1.035V154.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M388.393,156.399h1.009v2.109h-1.009V156.399z M386.402,158.508h1.009v-2.109h-1.009V158.508z  M382.418,158.508h1.009v-2.109h-1.009V158.508z M384.41,158.508h1.009v-2.109h-1.009V158.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M388.331,160.46h0.984v1.992h-0.984V160.46z M386.389,162.452h0.984v-1.992h-0.984V162.452z  M382.506,162.452h0.984v-1.992h-0.984V162.452z M384.448,162.452h0.984v-1.992h-0.984V162.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M388.268,164.52h0.958v1.876h-0.958V164.52z M386.377,166.396h0.958v-1.876h-0.958V166.396z  M382.595,166.396h0.958v-1.876h-0.958V166.396z M384.486,166.396h0.958v-1.876h-0.958V166.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M388.205,168.581h0.932v1.759h-0.932V168.581z M386.364,170.34h0.933v-1.759h-0.933V170.34z  M382.683,170.34h0.933v-1.759h-0.933V170.34z M384.524,170.34h0.933v-1.759h-0.933V170.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M388.142,172.641h0.907v1.643h-0.907V172.641z M386.352,174.284h0.907v-1.643h-0.907V174.284z  M382.771,174.284h0.907v-1.643h-0.907V174.284z M384.562,174.284h0.907v-1.643h-0.907V174.284z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "412.7,138.137 413.399,172.903 412.7,173.122 411.702,138.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "410.837,138.137 411.535,172.903 410.837,173.122 409.838,138.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "380.875,108.233 380.179,174.27 379.551,174.27 379.551,108.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "378.839,108.233 378.143,174.27 377.515,174.27 377.515,108.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "376.803,108.233 376.107,174.27 375.479,174.27 375.479,108.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "374.767,108.233 374.071,174.27 373.443,174.27 373.443,108.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "372.732,108.233 372.036,174.27 371.408,174.27 371.408,108.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A6EAC3"
    },
    points: "74.21,194.119 71.641,132.981 54.443,132.579 53.732,111.944 42.365,112.197  42.455,142.472 39.031,143.331 39.277,151.477 35.372,151.723 34.599,128.264 23.823,129.514 24.802,165.983 16.998,166.882  17.455,178.526 15.127,178.521 15.984,141.977 10.861,141.706 10.09,123.356 -1.486,123.565 -1.178,169.592 -8.011,170.133  -9.162,113.263 -26.508,113.057 -26.273,194.581 74.21,194.119  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-10.798,121.242 -25.086,121.333 -25.086,119.793 -10.798,119.884  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-10.858,124.628 -25.027,124.717 -25.027,123.209 -10.858,123.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-10.918,128.014 -24.967,128.101 -24.967,126.626 -10.918,126.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-10.977,131.4 -24.907,131.486 -24.907,130.042 -10.977,130.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.037,134.786 -24.847,134.87 -24.847,133.459 -11.037,133.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.097,138.172 -24.788,138.253 -24.788,136.875 -11.097,136.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.156,141.558 -24.728,141.637 -24.728,140.292 -11.156,140.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.216,144.944 -24.668,145.021 -24.668,143.708 -11.216,143.786  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.276,148.329 -24.609,148.406 -24.609,147.125 -11.276,147.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.335,151.715 -24.549,151.79 -24.549,150.541 -11.335,150.615  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.395,155.101 -24.489,155.173 -24.489,153.958 -11.395,154.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.455,158.487 -24.43,158.557 -24.43,157.374 -11.455,157.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.514,161.873 -24.37,161.941 -24.37,160.791 -11.514,160.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.574,165.259 -24.31,165.326 -24.31,164.207 -11.574,164.274  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.634,168.645 -24.251,168.71 -24.251,167.624 -11.634,167.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.693,172.031 -24.191,172.094 -24.191,171.04 -11.693,171.103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.753,175.417 -24.131,175.477 -24.131,174.457 -11.753,174.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "-11.813,178.803 -24.072,178.861 -24.072,177.873 -11.813,177.932  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.965,136.52 55.677,136.59 55.677,135.408 69.965,135.478  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.887,139.916 55.755,139.984 55.755,138.835 69.887,138.903  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.809,143.312 55.833,143.378 55.833,142.261 69.809,142.327  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.731,146.708 55.911,146.772 55.911,145.688 69.731,145.752  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.653,150.103 55.989,150.166 55.989,149.114 69.653,149.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.575,153.499 56.068,153.56 56.068,152.541 69.575,152.601  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.497,156.895 56.146,156.954 56.146,155.967 69.497,156.026  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.419,160.291 56.224,160.348 56.224,159.394 69.419,159.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.341,163.687 56.302,163.741 56.302,162.82 69.341,162.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.263,167.083 56.38,167.135 56.38,166.247 69.263,166.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.185,170.479 56.458,170.529 56.458,169.674 69.185,169.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.107,173.874 56.536,173.923 56.536,173.1 69.107,173.149  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "69.029,177.27 56.614,177.317 56.614,176.527 69.029,176.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "68.951,180.666 56.692,180.711 56.692,179.953 68.951,179.998  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.488,133.077 25.45,133.15 25.45,131.908 33.488,131.982  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.448,136.392 25.567,136.464 25.567,135.253 33.448,135.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.407,139.707 25.683,139.777 25.683,138.598 33.407,138.668  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.366,143.022 25.799,143.09 25.799,141.943 33.366,142.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.325,146.337 25.916,146.403 25.916,145.288 33.325,145.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.285,149.652 26.032,149.716 26.032,148.633 33.285,148.697  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.244,152.967 26.149,153.029 26.149,151.978 33.244,152.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.203,156.282 26.265,156.342 26.265,155.323 33.203,155.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.162,159.597 26.381,159.656 26.381,158.668 33.162,158.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.121,162.912 26.498,162.969 26.498,162.013 33.121,162.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.081,166.227 26.614,166.282 26.614,165.358 33.081,165.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "33.04,169.542 26.73,169.595 26.73,168.703 33.04,168.756  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "32.999,172.857 26.847,172.908 26.847,172.048 32.999,172.099  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "32.958,176.172 26.963,176.221 26.963,175.393 32.958,175.442  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "32.918,179.487 27.079,179.535 27.079,178.738 32.918,178.785  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.687,126.407H7.412v2.729h1.274V126.407z M6.172,126.407H4.898v2.729h1.274V126.407z  M1.143,129.136h-1.274v-2.729h1.274V129.136z M3.657,126.407H2.383v2.729h1.274V126.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.638,130.314h-1.26v2.698h1.26V130.314z M6.151,130.314h-1.26v2.698h1.26V130.314z  M1.177,133.013h-1.26v-2.698h1.26V133.013z M3.664,130.314h-1.26v2.698h1.26V130.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.589,134.221H7.343v2.668h1.246V134.221z M6.13,134.221H4.884v2.668H6.13V134.221z  M1.212,136.889h-1.246v-2.668h1.246V136.889z M3.671,134.221H2.425v2.668h1.246V134.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.54,138.129H7.308v2.638H8.54V138.129z M6.109,138.129H4.877v2.638h1.232V138.129z  M1.247,140.766H0.015v-2.638h1.232V140.766z M3.678,138.129H2.446v2.638h1.232V138.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.491,142.036H7.273v2.607h1.217V142.036z M6.088,142.036H4.87v2.607h1.217V142.036z  M1.282,144.643H0.064v-2.607h1.217V144.643z M3.685,142.036H2.467v2.607h1.217V142.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.442,145.943H7.238v2.577h1.203V145.943z M6.067,145.943H4.863v2.577h1.203V145.943z  M1.317,148.52H0.113v-2.577h1.203V148.52z M3.692,145.943H2.488v2.577h1.203V145.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.393,149.85H7.203v2.547h1.189V149.85z M6.046,149.85H4.856v2.547h1.189V149.85z M1.352,152.397 H0.162v-2.547h1.189V152.397z M3.699,149.85H2.509v2.547h1.189V149.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.344,153.757H7.169v2.516h1.175V153.757z M6.025,153.757H4.85v2.516h1.175V153.757z  M1.386,156.274H0.211v-2.516h1.175V156.274z M3.705,153.757H2.53v2.516h1.175V153.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.295,157.665H7.134v2.486h1.161V157.665z M6.003,157.665H4.843v2.486h1.161V157.665z  M1.421,160.15H0.26v-2.486h1.161V160.15z M3.712,157.665H2.552v2.486h1.161V157.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.246,161.572H7.099v2.456h1.147V161.572z M5.982,161.572H4.836v2.456h1.147V161.572z  M1.456,164.027H0.309v-2.456h1.147V164.027z M3.719,161.572H2.573v2.456h1.147V161.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.197,165.479H7.064v2.425h1.133V165.479z M5.961,165.479H4.829v2.425h1.133V165.479z  M1.491,167.904H0.358v-2.425h1.132V167.904z M3.726,165.479H2.594v2.425h1.132V165.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.148,169.386H7.029v2.395h1.118V169.386z M5.94,169.386H4.822v2.395H5.94V169.386z  M1.526,171.781H0.407v-2.395h1.118V171.781z M3.733,169.386H2.615v2.395h1.118V169.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.099,173.293H6.994v2.365h1.104V173.293z M5.919,173.293H4.815v2.365h1.104V173.293z  M1.561,175.658H0.456v-2.365h1.104V175.658z M3.74,173.293H2.636v2.365H3.74V173.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M8.05,177.2H6.96v2.335h1.09V177.2z M5.898,177.2h-1.09v2.335h1.09V177.2z M1.595,179.535h-1.09 V177.2h1.09V179.535z M3.747,177.2h-1.09v2.335h1.09V177.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M42.193,154.236h-1.06v2.342h1.06V154.236z M40.1,154.236h-1.06v2.342h1.06V154.236z  M35.915,156.578h-1.06v-2.342h1.06V156.578z M38.008,154.236h-1.06v2.342h1.06V154.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M42.104,158.297H41.07v2.225h1.035V158.297z M40.062,158.297h-1.035v2.225h1.035V158.297z  M35.978,160.522h-1.035v-2.225h1.035V160.522z M38.02,158.297h-1.035v2.225h1.035V158.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M42.016,162.357h-1.009v2.109h1.009V162.357z M40.024,162.357h-1.009v2.109h1.009V162.357z  M36.041,164.466h-1.009v-2.109h1.009V164.466z M38.033,162.357h-1.009v2.109h1.009V162.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M41.928,166.418h-0.984v1.992h0.984V166.418z M39.986,166.418h-0.984v1.992h0.984V166.418z  M36.104,168.41H35.12v-1.992h0.984V168.41z M38.045,166.418h-0.984v1.992h0.984V166.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M41.839,170.478h-0.958v1.876h0.958V170.478z M39.948,170.478H38.99v1.876h0.958V170.478z  M36.166,172.354h-0.958v-1.876h0.958V172.354z M38.057,170.478h-0.958v1.876h0.958V170.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M41.751,174.539h-0.933v1.759h0.933V174.539z M39.91,174.539h-0.933v1.759h0.933V174.539z  M36.229,176.298h-0.933v-1.759h0.933V176.298z M38.07,174.539h-0.933v1.759h0.933V174.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M41.663,178.599h-0.907v1.642h0.907V178.599z M39.872,178.599h-0.907v1.642h0.907V178.599z  M36.292,180.242h-0.907v-1.642h0.907V180.242z M38.082,178.599h-0.907v1.642h0.907V178.599z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "11.734,144.095 11.035,178.861 11.734,179.08 12.732,144.095  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "13.597,144.095 12.899,178.861 13.597,179.08 14.596,144.095  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "43.559,114.191 44.255,180.228 44.883,180.228 44.883,114.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "45.595,114.191 46.291,180.228 46.919,180.228 46.919,114.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "47.631,114.191 48.327,180.228 48.955,180.228 48.955,114.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "49.667,114.191 50.363,180.228 50.991,180.228 50.991,114.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "51.702,114.191 52.398,180.228 53.027,180.228 53.027,114.191  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A6EAC3"
    },
    points: "142.636,192.229 140.067,131.091 122.869,130.689 122.158,110.054 110.79,110.307  110.881,140.582 107.456,141.441 107.703,149.588 103.797,149.833 103.024,126.374 92.248,127.624 93.228,164.093 85.424,164.992  85.881,176.636 83.553,176.631 84.41,140.087 79.287,139.816 78.515,121.466 66.94,121.675 67.248,167.702 60.415,168.243  59.264,111.373 41.917,111.167 42.153,192.691 142.636,192.229  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.627,119.352 43.34,119.443 43.34,117.903 57.627,117.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.568,122.738 43.399,122.827 43.399,121.319 57.568,121.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.508,126.124 43.459,126.212 43.459,124.736 57.508,124.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.448,129.51 43.519,129.596 43.519,128.152 57.448,128.238  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.389,132.896 43.578,132.98 43.578,131.569 57.389,131.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.329,136.282 43.638,136.364 43.638,134.985 57.329,135.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.269,139.668 43.698,139.748 43.698,138.402 57.269,138.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.21,143.054 43.757,143.132 43.757,141.818 57.21,141.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.15,146.44 43.817,146.516 43.817,145.235 57.15,145.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.09,149.826 43.877,149.9 43.877,148.651 57.09,148.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "57.031,153.212 43.936,153.284 43.936,152.068 57.031,152.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "56.971,156.597 43.996,156.668 43.996,155.484 56.971,155.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "56.911,159.983 44.056,160.052 44.056,158.901 56.911,158.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "56.852,163.369 44.115,163.436 44.115,162.317 56.852,162.384  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "56.792,166.755 44.175,166.82 44.175,165.734 56.792,165.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "56.732,170.141 44.235,170.204 44.235,169.15 56.732,169.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "56.673,173.527 44.294,173.588 44.294,172.567 56.673,172.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "56.613,176.913 44.354,176.972 44.354,175.984 56.613,176.042  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "138.391,134.63 124.103,134.7 124.103,133.518 138.391,133.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "138.313,138.026 124.181,138.094 124.181,136.945 138.313,137.013  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "138.235,141.422 124.259,141.488 124.259,140.371 138.235,140.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "138.157,144.818 124.337,144.882 124.337,143.798 138.157,143.862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "138.079,148.213 124.415,148.276 124.415,147.224 138.079,147.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "138.001,151.609 124.493,151.67 124.493,150.651 138.001,150.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.923,155.005 124.571,155.064 124.571,154.077 137.923,154.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.845,158.401 124.649,158.458 124.649,157.504 137.845,157.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.767,161.797 124.727,161.852 124.727,160.931 137.767,160.985  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.689,165.193 124.805,165.245 124.805,164.357 137.689,164.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.611,168.589 124.883,168.639 124.883,167.784 137.611,167.834  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.533,171.984 124.961,172.033 124.961,171.21 137.533,171.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.454,175.38 125.039,175.427 125.039,174.637 137.454,174.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "137.376,178.776 125.118,178.821 125.118,178.063 137.376,178.108  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.914,131.187 93.876,131.26 93.876,130.018 101.914,130.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.873,134.502 93.993,134.574 93.993,133.363 101.873,133.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.833,137.817 94.109,137.887 94.109,136.708 101.833,136.778  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.792,141.132 94.225,141.2 94.225,140.053 101.792,140.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.751,144.447 94.342,144.513 94.342,143.398 101.751,143.464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.71,147.762 94.458,147.826 94.458,146.743 101.71,146.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.67,151.077 94.574,151.139 94.574,150.088 101.67,150.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.629,154.392 94.691,154.453 94.691,153.433 101.629,153.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.588,157.707 94.807,157.766 94.807,156.778 101.588,156.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.547,161.022 94.923,161.079 94.923,160.123 101.547,160.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.507,164.337 95.04,164.392 95.04,163.468 101.507,163.523  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.466,167.652 95.156,167.705 95.156,166.813 101.466,166.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.425,170.967 95.272,171.018 95.272,170.158 101.425,170.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.384,174.283 95.389,174.332 95.389,173.503 101.384,173.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "101.343,177.598 95.505,177.645 95.505,176.848 101.343,176.895  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M77.112,124.517h-1.274v2.729h1.274V124.517z M74.598,124.517h-1.274v2.729h1.274V124.517z  M69.568,127.246h-1.274v-2.729h1.274V127.246z M72.083,124.517h-1.274v2.729h1.274V124.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M77.063,128.424h-1.26v2.698h1.26V128.424z M74.577,128.424h-1.26v2.698h1.26V128.424z  M69.603,131.123h-1.26v-2.698h1.26V131.123z M72.09,128.424h-1.26v2.698h1.26V128.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M77.014,132.332h-1.246V135h1.246V132.332z M74.555,132.332H73.31V135h1.246V132.332z M69.638,135 h-1.246v-2.668h1.246V135z M72.097,132.332h-1.246V135h1.246V132.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.965,136.239h-1.232v2.638h1.232V136.239z M74.535,136.239h-1.232v2.638h1.232V136.239z  M69.673,138.876h-1.232v-2.638h1.232V138.876z M72.104,136.239h-1.232v2.638h1.232V136.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.916,140.146h-1.217v2.607h1.217V140.146z M74.513,140.146h-1.217v2.607h1.217V140.146z  M69.708,142.753H68.49v-2.607h1.218V142.753z M72.11,140.146h-1.217v2.607h1.217V140.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.867,144.053h-1.203v2.577h1.203V144.053z M74.492,144.053h-1.203v2.577h1.203V144.053z  M69.743,146.63h-1.203v-2.577h1.203V146.63z M72.117,144.053h-1.203v2.577h1.203V144.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.818,147.96h-1.189v2.547h1.189V147.96z M74.471,147.96h-1.189v2.547h1.189V147.96z  M69.777,150.507h-1.189v-2.547h1.189V150.507z M72.124,147.96h-1.189v2.547h1.189V147.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.769,151.867h-1.175v2.516h1.175V151.867z M74.45,151.867h-1.175v2.516h1.175V151.867z  M69.812,154.384h-1.175v-2.516h1.175V154.384z M72.131,151.867h-1.175v2.516h1.175V151.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.72,155.775H75.56v2.486h1.161V155.775z M74.429,155.775h-1.161v2.486h1.161V155.775z  M69.847,158.261h-1.161v-2.486h1.161V158.261z M72.138,155.775h-1.161v2.486h1.161V155.775z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.671,159.682h-1.147v2.456h1.147V159.682z M74.408,159.682h-1.147v2.456h1.147V159.682z  M69.882,162.137h-1.147v-2.456h1.147V162.137z M72.145,159.682h-1.147v2.456h1.147V159.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.622,163.589H75.49v2.425h1.132V163.589z M74.387,163.589h-1.132v2.425h1.132V163.589z  M69.917,166.014h-1.132v-2.425h1.132V166.014z M72.152,163.589h-1.132v2.425h1.132V163.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.573,167.496h-1.118v2.395h1.118V167.496z M74.366,167.496h-1.118v2.395h1.118V167.496z  M69.951,169.891h-1.118v-2.395h1.118V169.891z M72.159,167.496H71.04v2.395h1.118V167.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.524,171.403H75.42v2.365h1.104V171.403z M74.345,171.403h-1.104v2.365h1.104V171.403z  M69.986,173.768h-1.104v-2.365h1.104V173.768z M72.166,171.403h-1.104v2.365h1.104V171.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M76.475,175.31h-1.09v2.335h1.09V175.31z M74.324,175.31h-1.09v2.335h1.09V175.31z  M70.021,177.645h-1.09v-2.335h1.09V177.645z M72.173,175.31h-1.09v2.335h1.09V175.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M110.618,152.346h-1.06v2.342h1.06V152.346z M108.526,152.346h-1.06v2.342h1.06V152.346z  M104.341,154.688h-1.06v-2.342h1.06V154.688z M106.433,152.346h-1.06v2.342h1.06V152.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M110.53,156.407h-1.035v2.225h1.035V156.407z M108.488,156.407h-1.035v2.225h1.035V156.407z  M104.404,158.632h-1.035v-2.225h1.035V158.632z M106.446,156.407h-1.035v2.225h1.035V156.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M110.442,160.467h-1.009v2.109h1.009V160.467z M108.45,160.467h-1.009v2.109h1.009V160.467z  M104.466,162.576h-1.009v-2.109h1.009V162.576z M106.458,160.467h-1.009v2.109h1.009V160.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M110.353,164.528h-0.984v1.992h0.984V164.528z M108.412,164.528h-0.984v1.992h0.984V164.528z  M104.529,166.52h-0.984v-1.992h0.984V166.52z M106.471,164.528h-0.984v1.992h0.984V164.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M110.265,168.588h-0.958v1.876h0.958V168.588z M108.374,168.588h-0.958v1.876h0.958V168.588z  M104.592,170.464h-0.958v-1.876h0.958V170.464z M106.483,168.588h-0.958v1.876h0.958V168.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M110.177,172.649h-0.933v1.759h0.933V172.649z M108.336,172.649h-0.933v1.759h0.933V172.649z  M104.655,174.408h-0.933v-1.759h0.933V174.408z M106.495,172.649h-0.933v1.759h0.933V172.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M110.088,176.709h-0.907v1.642h0.907V176.709z M108.298,176.709h-0.907v1.642h0.907V176.709z  M104.718,178.352h-0.907v-1.642h0.907V178.352z M106.508,176.709h-0.907v1.642h0.907V176.709z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "80.16,142.205 79.461,176.972 80.16,177.19 81.158,142.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "82.023,142.205 81.324,176.972 82.023,177.19 83.021,142.205  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "111.985,112.301 112.681,178.338 113.309,178.338 113.309,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "114.021,112.301 114.717,178.338 115.345,178.338 115.345,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "116.056,112.301 116.753,178.338 117.381,178.338 117.381,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "118.092,112.301 118.788,178.338 119.416,178.338 119.416,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "120.128,112.301 120.824,178.338 121.452,178.338 121.452,112.301  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A6EAC3"
    },
    points: "269.648,192.229 272.217,131.091 289.415,130.689 290.126,110.054 301.494,110.307  301.403,140.582 304.827,141.441 304.581,149.588 308.487,149.833 309.26,126.374 320.035,127.624 319.056,164.093  326.861,164.992 326.403,176.636 328.731,176.631 327.874,140.087 332.997,139.816 333.769,121.466 345.344,121.675  345.036,167.702 351.869,168.243 353.02,111.373 370.367,111.167 370.131,192.691 269.648,192.229  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.656,119.352 368.944,119.443 368.944,117.903 354.656,117.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.716,122.738 368.885,122.827 368.885,121.319 354.716,121.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.776,126.124 368.825,126.212 368.825,124.736 354.776,124.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.836,129.51 368.765,129.596 368.765,128.152 354.836,128.238  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.895,132.896 368.706,132.98 368.706,131.569 354.895,131.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "354.955,136.282 368.646,136.364 368.646,134.985 354.955,135.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.015,139.668 368.586,139.748 368.586,138.402 355.015,138.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.074,143.054 368.527,143.132 368.527,141.818 355.074,141.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.134,146.44 368.467,146.516 368.467,145.235 355.134,145.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.194,149.826 368.407,149.9 368.407,148.651 355.194,148.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.253,153.212 368.348,153.284 368.348,152.068 355.253,152.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.313,156.597 368.288,156.668 368.288,155.484 355.313,155.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.373,159.983 368.228,160.052 368.228,158.901 355.373,158.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.432,163.369 368.169,163.436 368.169,162.317 355.432,162.384  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.492,166.755 368.109,166.82 368.109,165.734 355.492,165.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.552,170.141 368.049,170.204 368.049,169.15 355.552,169.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.611,173.527 367.99,173.588 367.99,172.567 355.611,172.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "355.671,176.913 367.93,176.972 367.93,175.984 355.671,176.042  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "273.893,134.63 288.181,134.7 288.181,133.518 273.893,133.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "273.971,138.026 288.103,138.094 288.103,136.945 273.971,137.013  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.049,141.422 288.025,141.488 288.025,140.371 274.049,140.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.127,144.818 287.947,144.882 287.947,143.798 274.127,143.862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.205,148.213 287.869,148.276 287.869,147.224 274.205,147.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.283,151.609 287.791,151.67 287.791,150.651 274.283,150.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.361,155.005 287.713,155.064 287.713,154.077 274.361,154.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.439,158.401 287.635,158.458 287.635,157.504 274.439,157.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.517,161.797 287.557,161.852 287.557,160.931 274.517,160.985  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.595,165.193 287.479,165.245 287.479,164.357 274.595,164.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.673,168.589 287.4,168.639 287.4,167.784 274.673,167.834  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.751,171.984 287.322,172.033 287.322,171.21 274.751,171.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.829,175.38 287.245,175.427 287.245,174.637 274.829,174.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "274.908,178.776 287.166,178.821 287.166,178.063 274.908,178.108  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.37,131.187 318.408,131.26 318.408,130.018 310.37,130.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.411,134.502 318.292,134.574 318.292,133.363 310.411,133.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.451,137.817 318.175,137.887 318.175,136.708 310.451,136.778  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.492,141.132 318.059,141.2 318.059,140.053 310.492,140.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.533,144.447 317.943,144.513 317.943,143.398 310.533,143.464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.574,147.762 317.826,147.826 317.826,146.743 310.574,146.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.614,151.077 317.71,151.139 317.71,150.088 310.614,150.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.655,154.392 317.593,154.453 317.593,153.433 310.655,153.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.696,157.707 317.477,157.766 317.477,156.778 310.696,156.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.737,161.022 317.361,161.079 317.361,160.123 310.737,160.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.777,164.337 317.244,164.392 317.244,163.468 310.777,163.523  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.818,167.652 317.128,167.705 317.128,166.813 310.818,166.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.859,170.967 317.012,171.018 317.012,170.158 310.859,170.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.9,174.283 316.895,174.332 316.895,173.503 310.9,173.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "310.941,177.598 316.779,177.645 316.779,176.848 310.941,176.895  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.716,124.517h1.274v2.729h-1.274V124.517z M340.201,127.246h1.274v-2.729h-1.274V127.246z  M335.172,127.246h1.274v-2.729h-1.274V127.246z M337.686,127.246h1.274v-2.729h-1.274V127.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.681,128.424h1.26v2.698h-1.26V128.424z M340.194,131.123h1.26v-2.698h-1.26V131.123z  M335.221,131.123h1.26v-2.698h-1.26V131.123z M337.707,131.123h1.26v-2.698h-1.26V131.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.646,132.332h1.246V135h-1.246V132.332z M340.187,135h1.246v-2.668h-1.246V135z M335.27,135 h1.246v-2.668h-1.246V135z M337.728,135h1.246v-2.668h-1.246V135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.611,136.239h1.232v2.638h-1.232V136.239z M340.18,138.876h1.232v-2.638h-1.232V138.876z  M335.319,138.876h1.232v-2.638h-1.232V138.876z M337.75,138.876h1.232v-2.638h-1.232V138.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.576,140.146h1.217v2.607h-1.217V140.146z M340.173,142.753h1.217v-2.607h-1.217V142.753z  M335.368,142.753h1.217v-2.607h-1.217V142.753z M337.771,142.753h1.217v-2.607h-1.217V142.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.542,144.053h1.203v2.577h-1.203V144.053z M340.167,146.63h1.203v-2.577h-1.203V146.63z  M335.417,146.63h1.203v-2.577h-1.203V146.63z M337.792,146.63h1.203v-2.577h-1.203V146.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.507,147.96h1.189v2.547h-1.189V147.96z M340.16,150.507h1.189v-2.547h-1.189V150.507z  M335.466,150.507h1.189v-2.547h-1.189V150.507z M337.813,150.507h1.189v-2.547h-1.189V150.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.472,151.867h1.175v2.516h-1.175V151.867z M340.153,154.384h1.175v-2.516h-1.175V154.384z  M335.515,154.384h1.175v-2.516h-1.175V154.384z M337.834,154.384h1.175v-2.516h-1.175V154.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.437,155.775h1.161v2.486h-1.161V155.775z M340.146,158.261h1.161v-2.486h-1.161V158.261z  M335.564,158.261h1.161v-2.486h-1.161V158.261z M337.855,158.261h1.161v-2.486h-1.161V158.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.402,159.682h1.147v2.456h-1.147V159.682z M340.139,162.137h1.147v-2.456h-1.147V162.137z  M335.613,162.137h1.147v-2.456h-1.147V162.137z M337.876,162.137h1.147v-2.456h-1.147V162.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.367,163.589h1.133v2.425h-1.133V163.589z M340.132,166.014h1.133v-2.425h-1.133V166.014z  M335.662,166.014h1.133v-2.425h-1.133V166.014z M337.897,166.014h1.133v-2.425h-1.133V166.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.332,167.496h1.118v2.395h-1.118V167.496z M340.125,169.891h1.118v-2.395h-1.118V169.891z  M335.711,169.891h1.118v-2.395h-1.118V169.891z M337.918,169.891h1.118v-2.395h-1.118V169.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.298,171.403h1.104v2.365h-1.104V171.403z M340.118,173.768h1.104v-2.365h-1.104V173.768z  M335.76,173.768h1.104v-2.365h-1.104V173.768z M337.939,173.768h1.104v-2.365h-1.104V173.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M342.263,175.31h1.09v2.335h-1.09V175.31z M340.111,177.645h1.09v-2.335h-1.09V177.645z  M335.809,177.645h1.09v-2.335h-1.09V177.645z M337.96,177.645h1.09v-2.335h-1.09V177.645z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M307.943,152.346h1.06v2.342h-1.06V152.346z M305.851,154.688h1.06v-2.342h-1.06V154.688z  M301.665,154.688h1.06v-2.342h-1.06V154.688z M303.758,154.688h1.06v-2.342h-1.06V154.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M307.88,156.407h1.035v2.225h-1.035V156.407z M305.838,158.632h1.035v-2.225h-1.035V158.632z  M301.754,158.632h1.035v-2.225h-1.035V158.632z M303.796,158.632h1.035v-2.225h-1.035V158.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M307.818,160.467h1.009v2.109h-1.009V160.467z M305.826,162.576h1.009v-2.109h-1.009V162.576z  M301.842,162.576h1.009v-2.109h-1.009V162.576z M303.834,162.576h1.009v-2.109h-1.009V162.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M307.755,164.528h0.984v1.992h-0.984V164.528z M305.813,166.52h0.984v-1.992h-0.984V166.52z  M301.931,166.52h0.984v-1.992h-0.984V166.52z M303.872,166.52h0.984v-1.992h-0.984V166.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M307.692,168.588h0.958v1.876h-0.958V168.588z M305.801,170.464h0.958v-1.876h-0.958V170.464z  M302.019,170.464h0.958v-1.876h-0.958V170.464z M303.91,170.464h0.958v-1.876h-0.958V170.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M307.629,172.649h0.933v1.759h-0.933V172.649z M305.788,174.408h0.933v-1.759h-0.933V174.408z  M302.107,174.408h0.933v-1.759h-0.933V174.408z M303.948,174.408h0.933v-1.759h-0.933V174.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEA9A"
    },
    d: "M307.566,176.709h0.907v1.642h-0.907V176.709z M305.776,178.352h0.907v-1.642h-0.907V178.352z  M302.196,178.352h0.907v-1.642h-0.907V178.352z M303.986,178.352h0.907v-1.642h-0.907V178.352z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "332.124,142.205 332.823,176.972 332.124,177.19 331.126,142.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "330.261,142.205 330.96,176.972 330.261,177.19 329.263,142.205  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "300.299,112.301 299.603,178.338 298.975,178.338 298.975,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "298.263,112.301 297.567,178.338 296.939,178.338 296.939,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "296.227,112.301 295.531,178.338 294.903,178.338 294.903,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "294.192,112.301 293.496,178.338 292.867,178.338 292.867,112.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEA9A"
    },
    points: "292.156,112.301 291.46,178.338 290.832,178.338 290.832,112.301  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: -28.904,
    y: 185.695,
    style: {
      fill: "#A6EAC3"
    },
    width: 479.847,
    height: 40.014
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#75CCB9"
    },
    points: " 408.372,173.385 394.545,173.549 393.627,218.881 388.181,218.449 388.426,181.761 379.199,181.595 378.585,196.221  374.501,196.438 375.184,225.566 373.328,225.571 373.693,216.289 367.472,215.573 368.253,186.503 359.663,185.507  359.047,204.206 355.934,204.01 356.13,197.516 353.401,196.832 353.473,172.7 344.412,172.497 344.133,180.589 344.144,176.627  330.317,176.792 329.998,192.559 328.758,222.073 323.953,221.692 324.199,185.004 314.972,184.837 314.357,199.464  310.273,199.68 310.956,228.809 309.1,228.814 309.465,219.532 303.244,218.815 304.025,189.746 295.435,188.749 294.819,207.449  291.706,207.253 291.902,200.759 289.173,200.074 289.245,175.943 280.184,175.74 279.617,192.189 265.909,192.51 263.861,241.242  343.957,241.611 408.184,241.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#75CCB9"
    },
    points: " 114.021,173.385 100.193,173.549 99.276,218.881 93.83,218.449 94.075,181.761 84.848,181.595 84.233,196.221 80.149,196.438  80.833,225.566 78.977,225.571 79.341,216.289 73.121,215.573 73.901,186.503 65.312,185.507 64.696,204.206 61.582,204.01  61.779,197.516 59.049,196.832 59.121,172.7 50.06,172.497 49.782,180.589 49.793,176.627 35.966,176.792 35.647,192.559  34.406,222.073 29.602,221.692 29.847,185.004 20.621,184.837 20.006,199.464 15.922,199.68 16.605,228.809 14.749,228.814  15.114,219.532 8.893,218.815 9.674,189.746 1.084,188.749 0.468,207.449 -2.645,207.253 -2.449,200.759 -5.178,200.074  -5.106,175.943 -14.167,175.74 -14.734,192.189 -28.442,192.51 -30.491,241.242 49.605,241.611 113.833,241.95  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6.058,
    y: 237.33,
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#3D858F"
    },
    width: 410.138,
    height: 36.721
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172431257290757585170000011548601838341185945_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.139,
    y1: 363.1882,
    x2: -11.2582,
    y2: 363.1882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0C59A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1907,
    style: {
      stopColor: "#DDC49B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3568,
    style: {
      stopColor: "#D2C19C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5138,
    style: {
      stopColor: "#C0BBA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6652,
    style: {
      stopColor: "#A7B4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8127,
    style: {
      stopColor: "#86AAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    style: {
      stopColor: "#5F9EB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#519AB3"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -6.545,
    y: 310.706,
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "url(#SVGID_00000172431257290757585170000011548601838341185945_)"
    },
    width: 411.273,
    height: 104.965
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#305575"
    },
    d: " M141.747,338.074c-0.876,0-1.586-0.458-1.586-1.022c0-0.565,0.71-1.022,1.586-1.022c0.876,0,1.586,0.458,1.586,1.022 C143.333,337.616,142.623,338.074,141.747,338.074z M146.018,336.87c0.287,0,0.519-0.15,0.519-0.335 c0-0.185-0.232-0.335-0.519-0.335c-0.287,0-0.519,0.15-0.519,0.335C145.499,336.72,145.731,336.87,146.018,336.87z  M144.798,334.289c-0.477,0-0.863,0.249-0.863,0.556c0,0.307,0.386,0.556,0.863,0.556s0.863-0.249,0.863-0.556 C145.661,334.538,145.275,334.289,144.798,334.289z M143.428,333.007c-0.415,0-0.751,0.217-0.751,0.484 c0,0.267,0.336,0.484,0.751,0.484c0.415,0,0.751-0.217,0.751-0.484C144.179,333.223,143.843,333.007,143.428,333.007z  M142.925,352.652c-0.301,0-0.544,0.157-0.544,0.351c0,0.194,0.244,0.351,0.544,0.351c0.301,0,0.544-0.157,0.544-0.351 C143.469,352.809,143.226,352.652,142.925,352.652z M147.747,352.838c0-0.451-0.567-0.817-1.267-0.817 c-0.7,0-1.267,0.366-1.267,0.817c0,0.451,0.567,0.817,1.267,0.817C147.18,353.654,147.747,353.289,147.747,352.838z M151.9,335.681 c-0.804,0-1.456,0.42-1.456,0.938c0,0.518,0.652,0.938,1.456,0.938c0.357,0,0.68-0.086,0.934-0.224 c-0.001,0.011-0.005,0.021-0.005,0.032c0,0.401,0.505,0.726,1.127,0.726c0.622,0,1.127-0.325,1.127-0.726 c0-0.401-0.505-0.726-1.127-0.726c-0.23,0-0.443,0.045-0.622,0.121c0.011-0.046,0.022-0.093,0.022-0.141 C153.356,336.101,152.704,335.681,151.9,335.681z M138.173,335.839c0-0.253-0.318-0.459-0.712-0.459 c-0.393,0-0.712,0.205-0.712,0.459c0,0.253,0.319,0.459,0.712,0.459C137.855,336.298,138.173,336.093,138.173,335.839z  M140.798,333.993c0-0.181-0.227-0.327-0.507-0.327c-0.28,0-0.507,0.146-0.507,0.327c0,0.181,0.227,0.327,0.507,0.327 C140.57,334.32,140.798,334.173,140.798,333.993z M137.806,332.999c-0.489,0-0.885,0.255-0.885,0.571 c0,0.315,0.396,0.571,0.885,0.571c0.489,0,0.885-0.255,0.885-0.571C138.691,333.255,138.295,332.999,137.806,332.999z  M139.092,341.217c0.313,0,0.568-0.164,0.568-0.366c0-0.202-0.254-0.366-0.568-0.366c-0.314,0-0.568,0.164-0.568,0.366 C138.524,341.053,138.778,341.217,139.092,341.217z M165.267,348.949c-0.414,0-0.749,0.216-0.749,0.483s0.335,0.483,0.749,0.483 c0.414,0,0.749-0.216,0.749-0.483S165.681,348.949,165.267,348.949z M167.304,333.707c0.461,0,0.835-0.241,0.835-0.538 s-0.374-0.538-0.835-0.538c-0.461,0-0.835,0.241-0.835,0.538S166.843,333.707,167.304,333.707z M151.155,339.389 c0.445,0,0.805-0.232,0.805-0.519c0-0.287-0.36-0.519-0.805-0.519c-0.445,0-0.805,0.232-0.805,0.519 C150.35,339.157,150.71,339.389,151.155,339.389z M163.616,345.149c0-0.324-0.408-0.587-0.91-0.587 c-0.424,0-0.777,0.188-0.878,0.44c-0.15-0.457-0.778-0.8-1.531-0.8c-0.865,0-1.566,0.452-1.566,1.01c0,0.558,0.701,1.01,1.566,1.01 c0.803,0,1.456-0.391,1.548-0.892c0.119,0.235,0.457,0.406,0.862,0.406C163.208,345.736,163.616,345.473,163.616,345.149z  M164.216,333.588c0.462,0,0.836-0.241,0.836-0.539c0-0.298-0.374-0.539-0.836-0.539s-0.836,0.241-0.836,0.539 C163.38,333.347,163.754,333.588,164.216,333.588z M162.344,333.533c-0.215,0-0.41,0.056-0.552,0.147 c-0.17-0.086-0.382-0.139-0.615-0.139c-0.553,0-1.002,0.289-1.002,0.646c0,0.357,0.449,0.646,1.002,0.646 c0.167,0,0.323-0.029,0.462-0.076c-0.111,0.13-0.18,0.277-0.18,0.436c0,0.501,0.63,0.908,1.408,0.908 c0.731,0,1.325-0.36,1.394-0.82c0.039,0.003,0.077,0.008,0.118,0.008c0.605,0,1.095-0.316,1.095-0.706s-0.49-0.706-1.095-0.706 c-0.474,0-0.874,0.196-1.026,0.468c-0.106-0.025-0.219-0.041-0.335-0.049c0.069-0.075,0.112-0.162,0.112-0.256 C163.128,333.759,162.776,333.533,162.344,333.533z M165.127,339.013c0,0.296,0.373,0.537,0.833,0.537 c0.46,0,0.832-0.24,0.832-0.537c0-0.296-0.373-0.537-0.832-0.537C165.5,338.476,165.127,338.716,165.127,339.013z M133.451,348.284 c0-0.212-0.267-0.384-0.596-0.384c-0.329,0-0.596,0.172-0.596,0.384c0,0.212,0.267,0.384,0.596,0.384 C133.184,348.669,133.451,348.497,133.451,348.284z M157.258,352.798c0.747,0,1.352-0.39,1.352-0.872 c0-0.481-0.605-0.872-1.352-0.872c-0.747,0-1.352,0.39-1.352,0.872C155.906,352.408,156.511,352.798,157.258,352.798z  M154.74,348.006c-0.83,0-1.504,0.434-1.504,0.969s0.673,0.969,1.504,0.969s1.504-0.434,1.504-0.969 S155.571,348.006,154.74,348.006z M157.142,334.919c0.467,0,0.845-0.244,0.845-0.545c0-0.301-0.378-0.545-0.845-0.545 c-0.467,0-0.846,0.244-0.846,0.545C156.296,334.675,156.675,334.919,157.142,334.919z M151.953,348.715 c-0.672,0-1.216,0.351-1.216,0.784c0,0.433,0.545,0.784,1.216,0.784c0.672,0,1.216-0.351,1.216-0.784 C153.169,349.066,152.625,348.715,151.953,348.715z M147.726,337.249c-0.343,0-0.622,0.18-0.622,0.401s0.278,0.401,0.622,0.401 c0.343,0,0.622-0.179,0.622-0.401S148.069,337.249,147.726,337.249z M149.538,334.808c-0.703,0-1.273,0.367-1.273,0.82 c0,0.453,0.57,0.82,1.273,0.82c0.703,0,1.273-0.367,1.273-0.82C150.811,335.175,150.241,334.808,149.538,334.808z M149.331,350.413 c-0.338,0-0.612,0.177-0.612,0.395c0,0.218,0.274,0.395,0.612,0.395c0.338,0,0.612-0.177,0.612-0.395 C149.943,350.59,149.669,350.413,149.331,350.413z M139.376,348.486c-0.684,0-1.238,0.357-1.238,0.798 c0,0.441,0.554,0.798,1.238,0.798c0.684,0,1.239-0.357,1.239-0.798C140.615,348.843,140.06,348.486,139.376,348.486z  M113.802,340.259c0,0.189,0.237,0.341,0.53,0.341c0.293,0,0.53-0.153,0.53-0.341c0-0.189-0.237-0.341-0.53-0.341 C114.039,339.917,113.802,340.07,113.802,340.259z M116.635,340.432c0.258,0,0.467-0.135,0.467-0.301s-0.209-0.301-0.467-0.301 c-0.258,0-0.466,0.135-0.466,0.301S116.377,340.432,116.635,340.432z M124.202,336.352c0,0.167,0.21,0.302,0.468,0.302 c0.259,0,0.468-0.135,0.468-0.302c0-0.167-0.21-0.302-0.468-0.302C124.411,336.05,124.202,336.185,124.202,336.352z  M112.625,335.32c-0.878,0-1.589,0.459-1.589,1.025s0.712,1.025,1.589,1.025c0.491,0,0.924-0.147,1.216-0.372 c0.028,0.459,0.611,0.827,1.33,0.827c0.738,0,1.336-0.385,1.336-0.861c0-0.475-0.598-0.861-1.336-0.861 c-0.378,0-0.718,0.102-0.961,0.265c0-0.008,0.004-0.015,0.004-0.022C114.214,335.779,113.502,335.32,112.625,335.32z  M123.054,333.579c-0.574,0-1.04,0.3-1.04,0.67c0,0.37,0.465,0.67,1.04,0.67c0.108,0,0.21-0.014,0.308-0.033 c-0.007,0.031-0.015,0.061-0.015,0.093c0,0.328,0.413,0.594,0.922,0.594s0.922-0.266,0.922-0.594c0-0.328-0.413-0.594-0.922-0.594 c-0.071,0-0.139,0.006-0.205,0.016c0.018-0.049,0.029-0.099,0.029-0.152C124.094,333.879,123.628,333.579,123.054,333.579z  M117.76,344.514c0-0.416-0.523-0.753-1.168-0.753c-0.645,0-1.168,0.337-1.168,0.753s0.523,0.753,1.168,0.753 C117.237,345.267,117.76,344.93,117.76,344.514z M114.382,350.428c-0.608,0-1.1,0.318-1.1,0.709c0,0.392,0.493,0.709,1.1,0.709 c0.608,0,1.1-0.318,1.1-0.709C115.483,350.746,114.99,350.428,114.382,350.428z M110.624,340.35c0,0.351,0.441,0.635,0.985,0.635 s0.985-0.284,0.985-0.635s-0.441-0.635-0.985-0.635S110.624,339.999,110.624,340.35z M101.938,336.761 c0,0.417,0.524,0.755,1.171,0.755s1.171-0.338,1.171-0.755s-0.524-0.755-1.171-0.755S101.938,336.344,101.938,336.761z  M111.975,342.752c0-0.334-0.42-0.604-0.937-0.604s-0.937,0.271-0.937,0.604c0,0.334,0.42,0.604,0.937,0.604 S111.975,343.086,111.975,342.752z M105.838,352.402c0-0.228-0.287-0.413-0.64-0.413s-0.64,0.185-0.64,0.413 s0.287,0.413,0.64,0.413S105.838,352.63,105.838,352.402z M107.881,336.278c0.326,0,0.589-0.17,0.589-0.38s-0.264-0.38-0.589-0.38 c-0.325,0-0.589,0.17-0.589,0.38S107.556,336.278,107.881,336.278z M133.138,339.739c0-0.396-0.498-0.716-1.111-0.716 c-0.614,0-1.111,0.321-1.111,0.716c0,0.396,0.498,0.716,1.111,0.716C132.64,340.455,133.138,340.134,133.138,339.739z  M107.947,344.717c-0.391,0-0.708,0.204-0.708,0.457s0.317,0.457,0.708,0.457c0.391,0,0.708-0.204,0.708-0.457 S108.338,344.717,107.947,344.717z M108.665,340.83c-0.559,0-1.026,0.255-1.136,0.594c-0.187-0.316-0.659-0.542-1.215-0.542 c-0.72,0-1.304,0.376-1.304,0.841s0.584,0.84,1.304,0.84c0.642,0,1.173-0.3,1.281-0.693c0.176,0.269,0.589,0.458,1.071,0.458 c0.641,0,1.161-0.335,1.161-0.749C109.826,341.165,109.306,340.83,108.665,340.83z M129.259,336.677 c0-0.289-0.363-0.523-0.811-0.523c-0.448,0-0.811,0.234-0.811,0.523s0.363,0.523,0.811,0.523 C128.896,337.2,129.259,336.966,129.259,336.677z M126.688,338.926c0-0.286-0.36-0.518-0.804-0.518 c-0.444,0-0.804,0.232-0.804,0.518c0,0.286,0.36,0.518,0.804,0.518C126.328,339.445,126.688,339.213,126.688,338.926z  M127.459,336.079c0.542,0,0.981-0.283,0.981-0.632c0-0.349-0.439-0.632-0.981-0.632c-0.542,0-0.981,0.283-0.981,0.632 C126.478,335.796,126.917,336.079,127.459,336.079z M126.213,346.761c0.292,0,0.529-0.153,0.529-0.341 c0-0.188-0.237-0.341-0.529-0.341c-0.292,0-0.529,0.152-0.529,0.341C125.684,346.609,125.921,346.761,126.213,346.761z  M129.91,346.057c0-0.228-0.286-0.412-0.64-0.412c-0.353,0-0.64,0.185-0.64,0.412s0.286,0.412,0.64,0.412 C129.623,346.47,129.91,346.285,129.91,346.057z M225.117,332.962c-0.265,0-0.51-0.051-0.717-0.138 c0.015,0.043,0.024,0.088,0.024,0.134c0,0.309-0.351,0.564-0.809,0.613c0.033,0.057,0.053,0.118,0.053,0.182 c0,0.29-0.365,0.526-0.816,0.526c-0.451,0-0.816-0.236-0.816-0.526c0-0.236,0.243-0.434,0.575-0.5 c-0.018-0.021-0.036-0.042-0.05-0.065c-0.156,0.096-0.366,0.156-0.599,0.156c-0.479,0-0.868-0.25-0.868-0.56 c0-0.309,0.389-0.56,0.868-0.56c0.345,0,0.64,0.131,0.78,0.319c0.177-0.127,0.431-0.208,0.716-0.208 c0.155,0,0.299,0.026,0.429,0.067c-0.05-0.09-0.082-0.185-0.082-0.286c0-0.181,0.09-0.348,0.24-0.486 c-0.007-0.036-0.017-0.072-0.017-0.109c0-0.29,0.229-0.544,0.575-0.694l-4.918,0.12c0.211,0.13,0.344,0.312,0.344,0.515 c0,0.393-0.495,0.712-1.105,0.712c-0.61,0-1.105-0.319-1.105-0.712c0-0.107,0.04-0.208,0.106-0.3 c-0.215,0.082-0.463,0.132-0.731,0.132c-0.354,0-0.675-0.085-0.927-0.221c-0.02,0.017-0.041,0.034-0.065,0.048 c-0.129,0.268-0.447,0.479-0.857,0.57c-0.082,0.243-0.417,0.425-0.818,0.425c-0.463,0-0.838-0.242-0.838-0.54 c0-0.082,0.03-0.159,0.081-0.228c-0.078-0.076-0.136-0.161-0.175-0.251l-0.228,0.006c-0.24,0.322-0.746,0.546-1.336,0.546 c-0.551,0-1.026-0.195-1.283-0.482l-11.496,0.28c0.432,0.174,0.721,0.481,0.721,0.834c0,0.391-0.356,0.726-0.867,0.885 c0.637,0.078,1.119,0.438,1.119,0.871c0,0.49-0.617,0.888-1.377,0.888c-0.761,0-1.377-0.397-1.377-0.888 c0-0.343,0.305-0.637,0.746-0.785c-0.736-0.071-1.303-0.477-1.303-0.971c0-0.171,0.074-0.33,0.193-0.47 c-0.082-0.003-0.161-0.014-0.235-0.031c0.001,0.007,0.006,0.013,0.006,0.02c0,0.175-0.22,0.317-0.491,0.317 c-0.271,0-0.491-0.142-0.491-0.317c0-0.122,0.111-0.226,0.269-0.278l-1.907,0.046c0.334,0.07,0.577,0.27,0.577,0.509 c0,0.297-0.373,0.538-0.834,0.538s-0.834-0.241-0.834-0.538c0-0.222,0.209-0.413,0.507-0.495l-3.127,0.076 c-0.14,0.249-0.506,0.428-0.941,0.428c-0.408,0-0.758-0.158-0.915-0.383l-5.547,0.135c-0.168,0.166-0.458,0.276-0.788,0.276 c-0.304,0-0.572-0.095-0.744-0.239l-4.534,0.111c0.072,0.111,0.112,0.233,0.112,0.362c0,0.52-0.654,0.941-1.46,0.941 c-0.38,0-0.722-0.096-0.982-0.249c-0.071,0.015-0.146,0.025-0.226,0.025c-0.001,0-0.001,0-0.001,0c0,0,0,0,0,0 c0.005,0.028,0.013,0.055,0.013,0.084c0,0.408-0.513,0.739-1.147,0.739c-0.614,0-1.111-0.312-1.141-0.703 c-0.3-0.085-0.546-0.231-0.71-0.412c-0.11,0.336-0.572,0.588-1.125,0.588c-0.635,0-1.151-0.332-1.151-0.742 c0-0.17,0.092-0.324,0.241-0.449l-7.961,0.194c0.022,0.065,0.034,0.132,0.034,0.201c0,0.528-0.664,0.956-1.483,0.956 c-0.7,0-1.283-0.314-1.439-0.734c-0.234,0.116-0.523,0.188-0.841,0.188c-0.539,0-1-0.201-1.227-0.491l-0.31,0.008 c0.204,0.075,0.374,0.182,0.494,0.313c0.193,0.103,0.319,0.257,0.319,0.431c0,0.172-0.123,0.324-0.313,0.427 c-0.23,0.256-0.654,0.431-1.146,0.431c-0.381,0-0.722-0.105-0.965-0.271c-0.051,0.006-0.102,0.01-0.155,0.01 c-0.276,0-0.521-0.082-0.686-0.209c-0.136,0.132-0.368,0.219-0.633,0.219c-0.419,0-0.76-0.219-0.76-0.49 c0-0.066,0.021-0.128,0.057-0.186c-0.076,0.022-0.159,0.034-0.247,0.034c-0.336,0-0.608-0.175-0.608-0.392 c0-0.077,0.035-0.147,0.094-0.208l-0.624,0.015c-0.212,0.222-0.559,0.385-0.969,0.438c0.126,0.079,0.204,0.19,0.204,0.313 c0,0.242-0.304,0.438-0.68,0.438c-0.375,0-0.68-0.196-0.68-0.438c0-0.153,0.121-0.287,0.305-0.365 c-0.258-0.068-0.478-0.182-0.64-0.326l-0.595,0.014c-0.219,0.335-0.733,0.57-1.333,0.57c-0.559,0-1.038-0.207-1.279-0.506 l-10.144,0.247c-0.095,0.057-0.222,0.093-0.362,0.093c-0.125,0-0.239-0.029-0.329-0.076h-0.003 c-0.123,0.462-0.743,0.814-1.494,0.814c-0.711,0-1.299-0.316-1.464-0.742l-0.412,0.01c-0.122,0.319-0.566,0.556-1.099,0.556 c-0.502,0-0.924-0.212-1.073-0.503l-0.336,0.008c0.03,0.072,0.051,0.147,0.051,0.225c0,0.484-0.609,0.877-1.361,0.877 c-0.752,0-1.361-0.393-1.361-0.877c0-0.055,0.01-0.108,0.025-0.16l-8.388,0.205c0.053,0.074,0.084,0.155,0.084,0.241 c0,0.319-0.402,0.578-0.897,0.578s-0.897-0.259-0.897-0.578c0-0.071,0.023-0.138,0.059-0.201l-4.222,0.103 c0.105,0.116,0.17,0.249,0.17,0.394c0,0.433-0.545,0.784-1.216,0.784c-0.046,0-0.089-0.005-0.134-0.009 c-0.254,0.274-0.713,0.459-1.243,0.459c-0.802,0-1.453-0.419-1.453-0.936c0-0.232,0.136-0.442,0.353-0.605l-6.119,0.149 c0.08,0.067,0.129,0.15,0.129,0.241c0,0.219-0.276,0.397-0.616,0.397c-0.34,0-0.616-0.178-0.616-0.397 c0-0.08,0.037-0.154,0.101-0.216l-8.481,0.207c0.034,0.053,0.053,0.11,0.053,0.171c0,0.244-0.308,0.443-0.687,0.443 c-0.379,0-0.687-0.198-0.687-0.443c0-0.049,0.015-0.096,0.038-0.14l-0.843,0.02c-0.207,0.166-0.52,0.274-0.876,0.274 c-0.325,0-0.615-0.09-0.82-0.232l-0.161,0.004c-0.091,0.431-0.658,0.764-1.352,0.764c-0.659,0-1.208-0.3-1.339-0.699l-1.466,0.036 c-0.172,0.055-0.364,0.088-0.569,0.088c-0.173,0-0.336-0.023-0.487-0.062l-1.078,0.026c0.012,0.035,0.021,0.071,0.021,0.108 c0,0.267-0.336,0.483-0.749,0.483c-0.168,0-0.322-0.037-0.447-0.097c-0.177,0.141-0.445,0.232-0.748,0.232 c-0.534,0-0.967-0.279-0.967-0.623c0-0.011,0.004-0.022,0.005-0.033l-13.926,0.34c-0.236,0.365-0.794,0.621-1.445,0.621 c-0.608,0-1.129-0.226-1.389-0.552l-11.572,0.282c0.112,0.115,0.179,0.25,0.179,0.396c0,0.413-0.519,0.747-1.159,0.747 c-0.47,0-0.873-0.182-1.055-0.441c-0.032,0.368-0.5,0.661-1.079,0.661c-0.599,0-1.085-0.313-1.085-0.699 c0-0.237,0.183-0.445,0.463-0.572l-0.528,0.013c-0.164,0.363-0.678,0.63-1.294,0.63c-0.58,0-1.071-0.236-1.264-0.567l-0.904,0.022 c-0.252,0.147-0.583,0.239-0.95,0.239c-0.328,0-0.626-0.075-0.867-0.195l-3.938,0.096c0.385,0.15,0.646,0.419,0.646,0.73 c0,0.472-0.594,0.855-1.326,0.855c-0.116,0-0.226-0.013-0.333-0.031c-0.214,0.16-0.526,0.263-0.879,0.263 c-0.161,0-0.315-0.021-0.454-0.059c0.001,0.01,0.005,0.02,0.005,0.03c0,0.172-0.125,0.323-0.317,0.424 c0.002,0.018,0.009,0.036,0.009,0.055c0,0.486-0.611,0.88-1.365,0.88s-1.365-0.394-1.365-0.88c0-0.486,0.611-0.88,1.365-0.88 c0.076,0,0.148,0.007,0.22,0.014c0.154-0.099,0.367-0.161,0.602-0.161c0.06,0,0.118,0.004,0.175,0.012 c-0.024-0.06-0.04-0.121-0.04-0.186c0-0.415,0.522-0.751,1.165-0.751c0.019,0,0.037,0.003,0.056,0.004 c0.097-0.113,0.233-0.209,0.394-0.283l-10.595,0.258c0.015,0.046,0.023,0.094,0.023,0.143c0,0.387-0.486,0.7-1.086,0.7 c-0.197,0-0.378-0.036-0.538-0.095c-0.135,0.271-0.524,0.468-0.989,0.468c-0.576,0-1.043-0.301-1.043-0.672 c0-0.18,0.111-0.342,0.289-0.462l-3.276,0.08c-0.067,0.023-0.139,0.04-0.22,0.04c-0.071,0-0.136-0.012-0.196-0.03l-2.297,0.056 c0.095,0.109,0.153,0.232,0.153,0.366c0,0.415-0.521,0.751-1.165,0.751s-1.165-0.336-1.165-0.751c0-0.113,0.042-0.219,0.111-0.315 l-9.361,0.228c-0.277,0.289-0.769,0.484-1.335,0.484c-0.523,0-0.984-0.167-1.27-0.42l-2.283,0.056 c0.037,0.086,0.064,0.175,0.064,0.27c0,0.265-0.162,0.503-0.421,0.683c0.027,0.063,0.044,0.128,0.05,0.195 c0.264-0.272,0.73-0.455,1.265-0.455c0.826,0,1.496,0.432,1.496,0.964s-0.67,0.964-1.496,0.964c-0.132,0-0.257-0.014-0.378-0.035 c-0.045,0.007-0.091,0.011-0.139,0.011c-0.292,0-0.535-0.131-0.601-0.306c-0.217-0.159-0.353-0.362-0.37-0.588 c-0.258,0.259-0.707,0.432-1.22,0.432c-0.801,0-1.451-0.419-1.451-0.935c0-0.079,0.02-0.155,0.049-0.229 c-0.283,0.262-0.752,0.434-1.284,0.434c-0.865,0-1.566-0.452-1.566-1.01c0-0.087,0.022-0.17,0.054-0.25l-7.544,0.184l-6.58-37.348 h435.307c0.977,0,0.849,0.391,1.818,0.469v23.335c0.22,0.083,0.369,0.236,0.369,0.412s-0.149,0.329-0.369,0.412v0.698 c0,0.313,0.207,1.203,0.207,1.516l-3.836,0.094c0,0.002,0.001,0.003,0.001,0.005c0,0.553-0.696,1.002-1.554,1.002 c-0.652,0-1.209-0.26-1.439-0.627c-0.12,0.049-0.262,0.079-0.415,0.079c-0.134,0-0.257-0.024-0.367-0.062 c0.013,0.03,0.022,0.06,0.022,0.093c0,0.187-0.235,0.339-0.525,0.339s-0.526-0.152-0.526-0.339s0.235-0.339,0.526-0.339 c0.06,0,0.117,0.008,0.17,0.02c-0.016-0.022-0.026-0.046-0.037-0.069l-1.048,0.026c0.237,0.156,0.384,0.369,0.384,0.605 c0,0.478-0.601,0.865-1.342,0.865c-0.741,0-1.342-0.387-1.342-0.865c0-0.213,0.124-0.406,0.322-0.556l-3.14,0.077 c-0.08,0.38-0.58,0.674-1.192,0.674c-0.58,0-1.064-0.264-1.181-0.616l-0.964,0.023c-0.076,0.234-0.398,0.411-0.785,0.411 c-0.365,0-0.669-0.158-0.767-0.373l-0.13,0.003c0.105,0.127,0.167,0.271,0.167,0.425c0,0.511-0.642,0.925-1.434,0.925 c-0.682,0-1.25-0.308-1.396-0.719c-0.241,0.186-0.599,0.307-1.005,0.307c-0.71,0-1.284-0.363-1.311-0.817l-4.306,0.105 c0.015,0.022,0.031,0.043,0.038,0.068c0.562,0.079,0.983,0.401,0.983,0.786c0,0.445-0.56,0.806-1.25,0.806 c-0.595,0-1.091-0.269-1.217-0.628c-0.181,0.354-0.693,0.612-1.303,0.612c-0.761,0-1.378-0.398-1.378-0.888 c0-0.266,0.185-0.502,0.473-0.665l-3.895,0.095c0.159,0.146,0.255,0.324,0.255,0.516c0,0.498-0.626,0.901-1.398,0.901 c-0.772,0-1.398-0.403-1.398-0.901c0-0.169,0.076-0.324,0.201-0.459l-1.48,0.036c-0.062,0.247-0.392,0.437-0.794,0.437 c-0.38,0-0.697-0.17-0.783-0.399L370,327.28c0.048,0.056,0.078,0.119,0.078,0.188c0,0.188-0.208,0.345-0.484,0.381 c0.182,0.157,0.294,0.35,0.294,0.561c0,0.519-0.653,0.94-1.459,0.94c-0.58,0-1.077-0.22-1.312-0.536 c-0.246,0.153-0.578,0.248-0.947,0.248c-0.754,0-1.366-0.394-1.366-0.88c0-0.073,0.018-0.143,0.044-0.211 c0.02-0.098,0.08-0.186,0.171-0.259c0.138-0.14,0.336-0.252,0.57-0.324l-4.829,0.118c0.188,0.163,0.302,0.364,0.302,0.583 c0,0.544-0.684,0.984-1.527,0.984c-0.843,0-1.527-0.441-1.527-0.984c0-0.192,0.089-0.37,0.237-0.521l-3.538,0.086 c-0.151,0.228-0.496,0.39-0.905,0.39c-0.383,0-0.712-0.142-0.877-0.347l-3.46,0.084c0.101,0.125,0.163,0.264,0.163,0.414 c0,0.498-0.626,0.901-1.398,0.901c-0.622,0-1.143-0.264-1.324-0.626c-0.128,0.459-0.747,0.807-1.495,0.807 c-0.841,0-1.522-0.439-1.522-0.981c0-0.135,0.043-0.264,0.119-0.382l-0.209,0.005c-0.042,0.387-0.537,0.693-1.147,0.693 c-0.581,0-1.057-0.277-1.139-0.637L341,327.988c-0.134,0.467-0.766,0.821-1.529,0.821c-0.721,0-1.322-0.318-1.5-0.747l-6.327,0.154 c-0.087,0.088-0.232,0.15-0.406,0.15c-0.161,0-0.297-0.053-0.386-0.131l-0.904,0.022c0.272,0.167,0.444,0.402,0.444,0.663 c0,0.507-0.637,0.917-1.423,0.917s-1.423-0.411-1.423-0.917c0-0.237,0.143-0.451,0.372-0.613l-10.2,0.249 c-0.139,0.439-0.741,0.769-1.463,0.769c-0.682,0-1.25-0.296-1.429-0.699l-52.656,1.284c-0.255,0.129-0.573,0.208-0.922,0.208 c-0.311,0-0.6-0.061-0.84-0.165l-1.668,0.041c0.206,0.129,0.334,0.308,0.334,0.508c0,0.048-0.008,0.095-0.022,0.141 c0.244-0.126,0.55-0.204,0.887-0.204c0.788,0,1.428,0.412,1.428,0.92c0,0.508-0.639,0.92-1.428,0.92 c-0.789,0-1.428-0.412-1.428-0.92c0-0.093,0.028-0.181,0.067-0.265c-0.174,0.074-0.381,0.117-0.604,0.117 c-0.607,0-1.1-0.317-1.1-0.709c0-0.181,0.108-0.344,0.281-0.469l-4.9,0.12c-0.217,0.085-0.472,0.133-0.744,0.133 c-0.231,0-0.446-0.038-0.64-0.1l-2.31,0.056c0.517,0.054,0.912,0.341,0.912,0.69c0,0.387-0.487,0.701-1.088,0.701 c-0.601,0-1.088-0.314-1.088-0.701c0-0.33,0.354-0.604,0.83-0.679l-9.807,0.239c-0.256,0.261-0.704,0.436-1.218,0.436 c-0.475,0-0.892-0.15-1.155-0.378l-5.18,0.126c-0.192,0.122-0.455,0.198-0.746,0.198c-0.26,0-0.496-0.063-0.68-0.163l-3.394,0.083 c0.081,0.029,0.158,0.062,0.227,0.101c0.102-0.057,0.234-0.093,0.38-0.093c0.322,0,0.584,0.168,0.584,0.376 c0,0.194-0.23,0.353-0.524,0.372c-0.009,0.157-0.082,0.303-0.207,0.426c0.012,0.045,0.022,0.091,0.022,0.139 C226.43,332.583,225.843,332.962,225.117,332.962z M386.926,326.867c0.264,0.128,0.456,0.315,0.523,0.531 c0.102-0.179,0.297-0.326,0.549-0.42c-0.003-0.013-0.012-0.025-0.012-0.039c0-0.035,0.013-0.068,0.031-0.099L386.926,326.867z  M366.657,327.362c0.305,0.076,0.558,0.221,0.712,0.406c0.266-0.182,0.641-0.298,1.061-0.298c0.159,0,0.309,0.02,0.452,0.051 c-0.004-0.017-0.008-0.034-0.008-0.052c0-0.058,0.021-0.112,0.056-0.162L366.657,327.362z M346.756,327.847 c0.042,0.053,0.079,0.108,0.107,0.166c0.019-0.059,0.049-0.116,0.085-0.17L346.756,327.847z M-2.891,336.962 c0,0,0-0.001-0.001-0.002c-0.001,0.001-0.001,0.002-0.002,0.003C-2.893,336.964-2.892,336.963-2.891,336.962z M49.203,335.105 l-0.565,0.014c0.186,0.072,0.337,0.177,0.429,0.304C49.074,335.308,49.125,335.201,49.203,335.105z M154.911,332.527l-2.182,0.053 c0.075,0.065,0.12,0.145,0.12,0.232c0,0.042-0.013,0.081-0.032,0.119c0.111-0.041,0.237-0.066,0.373-0.066 c0.2,0,0.381,0.051,0.516,0.132c0.147-0.19,0.449-0.322,0.802-0.322c0.04,0,0.078,0.004,0.117,0.008 C154.708,332.622,154.807,332.571,154.911,332.527z M171.348,332.126l-0.09,0.002c0.024,0.018,0.053,0.033,0.075,0.052 C171.335,332.161,171.344,332.144,171.348,332.126z M120.717,334.263c-0.826,0-1.495,0.432-1.495,0.964 c0,0.532,0.669,0.964,1.495,0.964c0.826,0,1.495-0.432,1.495-0.964C122.213,334.695,121.543,334.263,120.717,334.263z  M119.435,346.546c0,0.205,0.258,0.371,0.576,0.371c0.318,0,0.576-0.166,0.576-0.371s-0.258-0.371-0.576-0.371 C119.693,346.174,119.435,346.34,119.435,346.546z M118.596,340.546c0,0.427,0.538,0.774,1.201,0.774 c0.663,0,1.201-0.346,1.201-0.774s-0.537-0.774-1.201-0.774C119.133,339.772,118.596,340.119,118.596,340.546z M117.914,337.163 c-0.411,0-0.744,0.215-0.744,0.48c0,0.265,0.333,0.48,0.744,0.48c0.411,0,0.744-0.215,0.744-0.48 C118.658,337.378,118.325,337.163,117.914,337.163z M124.238,341.49c0-0.502-0.631-0.908-1.409-0.908 c-0.778,0-1.409,0.407-1.409,0.908c0,0.502,0.631,0.909,1.409,0.909C123.607,342.398,124.238,341.992,124.238,341.49z  M124.859,352.586c0-0.42-0.528-0.76-1.179-0.76c-0.651,0-1.179,0.34-1.179,0.76s0.528,0.76,1.179,0.76 C124.332,353.346,124.859,353.006,124.859,352.586z M121.983,337.789c0-0.238-0.299-0.431-0.668-0.431s-0.668,0.193-0.668,0.431 c0,0.238,0.299,0.431,0.668,0.431S121.983,338.026,121.983,337.789z M133.381,335.27c0,0.355,0.446,0.642,0.996,0.642 c0.55,0,0.996-0.288,0.996-0.642c0-0.091-0.03-0.177-0.083-0.256c0,0,0.001,0,0.001,0c0.412,0,0.747-0.215,0.747-0.481 c0-0.266-0.334-0.481-0.747-0.481c-0.412,0-0.747,0.215-0.747,0.481c0,0.037,0.008,0.072,0.02,0.107 c-0.061-0.008-0.124-0.012-0.188-0.012C133.827,334.628,133.381,334.915,133.381,335.27z M204.843,338.948 c0,0.346,0.435,0.626,0.971,0.626s0.971-0.28,0.971-0.626c0-0.346-0.435-0.626-0.971-0.626S204.843,338.602,204.843,338.948z  M206.865,335.11c0,0.343,0.431,0.621,0.963,0.621s0.963-0.278,0.963-0.621c0-0.343-0.431-0.621-0.963-0.621 S206.865,334.767,206.865,335.11z M207.346,332.918c-0.479,0-0.867,0.25-0.867,0.559s0.388,0.559,0.867,0.559 c0.479,0,0.867-0.25,0.867-0.559S207.825,332.918,207.346,332.918z M202.042,342.169c0,0.288,0.362,0.521,0.808,0.521 c0.446,0,0.808-0.233,0.808-0.521c0-0.288-0.362-0.521-0.808-0.521C202.403,341.649,202.042,341.882,202.042,342.169z  M206.248,340.943c-0.824,0-1.492,0.431-1.492,0.962c0,0.531,0.668,0.962,1.492,0.962c0.824,0,1.492-0.431,1.492-0.962 C207.741,341.373,207.072,340.943,206.248,340.943z M205.673,335.364c0-0.346-0.434-0.626-0.971-0.626 c-0.536,0-0.971,0.28-0.971,0.626c0,0.346,0.435,0.626,0.971,0.626C205.238,335.99,205.673,335.71,205.673,335.364z  M204.337,331.718c0-0.177-0.222-0.32-0.496-0.32c-0.274,0-0.496,0.143-0.496,0.32c0,0.177,0.222,0.32,0.496,0.32 C204.114,332.038,204.337,331.895,204.337,331.718z M200.324,345.614c-0.454,0-0.821,0.237-0.821,0.53 c0,0.292,0.368,0.529,0.821,0.529c0.454,0,0.821-0.237,0.821-0.529C201.145,345.851,200.778,345.614,200.324,345.614z  M196.543,342.831c-0.495,0-0.897,0.259-0.897,0.578s0.402,0.578,0.897,0.578c0.495,0,0.897-0.259,0.897-0.578 S197.039,342.831,196.543,342.831z M208.036,338.759c-0.673,0-1.218,0.351-1.218,0.785s0.545,0.785,1.218,0.785 c0.672,0,1.218-0.351,1.218-0.785S208.709,338.759,208.036,338.759z M195.577,348.255c0-0.467-0.588-0.846-1.313-0.846 c-0.725,0-1.313,0.379-1.313,0.846c0,0.467,0.588,0.846,1.313,0.846C194.989,349.101,195.577,348.722,195.577,348.255z  M202.052,336.311c0.406,0,0.735-0.212,0.735-0.474c0-0.262-0.329-0.474-0.735-0.474c-0.406,0-0.735,0.212-0.735,0.474 C201.317,336.099,201.646,336.311,202.052,336.311z M201.679,332.818c0.535,0,0.969-0.279,0.969-0.624 c0-0.345-0.434-0.624-0.969-0.624c-0.026,0-0.05,0.004-0.075,0.005c-0.036-0.004-0.074-0.007-0.112-0.007 c-0.268,0-0.497,0.107-0.591,0.258c-0.118,0.103-0.19,0.23-0.19,0.369C200.71,332.539,201.144,332.818,201.679,332.818z  M204.807,334.498c0.856,0,1.549-0.447,1.549-0.999c0-0.552-0.694-0.999-1.549-0.999c-0.856,0-1.549,0.447-1.549,0.999 C203.258,334.051,203.951,334.498,204.807,334.498z M209.244,337.152c0,0.4,0.503,0.725,1.124,0.725s1.124-0.325,1.124-0.725 c0-0.4-0.503-0.725-1.124-0.725S209.244,336.752,209.244,337.152z M212.393,332.564c-0.331,0-0.599,0.173-0.599,0.386 s0.268,0.386,0.599,0.386c0.331,0,0.598-0.173,0.598-0.386S212.724,332.564,212.393,332.564z M220.933,335.252 c-0.026,0-0.05,0.004-0.076,0.005c0.106-0.116,0.171-0.25,0.171-0.395c0-0.433-0.545-0.785-1.217-0.785 c-0.483,0-0.897,0.183-1.094,0.446c-0.033-0.163-0.246-0.289-0.507-0.289c-0.284,0-0.513,0.148-0.513,0.331 c0,0.183,0.23,0.331,0.513,0.331c0.161,0,0.303-0.049,0.397-0.124c-0.005,0.029-0.014,0.058-0.014,0.089 c0,0.419,0.512,0.759,1.154,0.78c-0.178,0.157-0.287,0.349-0.287,0.559c0,0.524,0.66,0.95,1.473,0.95 c0.814,0,1.473-0.425,1.473-0.95C222.406,335.677,221.747,335.252,220.933,335.252z M217.603,350.62 c-0.627,0-1.134,0.327-1.134,0.731s0.508,0.731,1.134,0.731c0.626,0,1.134-0.327,1.134-0.731S218.229,350.62,217.603,350.62z  M223.515,350.376c0.566,0,1.024-0.296,1.024-0.66c0-0.365-0.459-0.66-1.024-0.66c-0.566,0-1.024,0.296-1.024,0.66 C222.49,350.081,222.949,350.376,223.515,350.376z M217.081,335.862c0.412,0,0.745-0.215,0.745-0.48c0-0.265-0.334-0.48-0.745-0.48 c-0.412,0-0.745,0.215-0.745,0.48C216.335,335.647,216.669,335.862,217.081,335.862z M104.805,337.046 c0,0.535,0.672,0.968,1.502,0.968c0.829,0,1.502-0.434,1.502-0.968c0-0.535-0.672-0.968-1.502-0.968 C105.478,336.078,104.805,336.512,104.805,337.046z M220.207,349.254c-0.504,0-0.913,0.264-0.913,0.589s0.409,0.589,0.913,0.589 c0.504,0,0.913-0.263,0.913-0.589S220.711,349.254,220.207,349.254z M210.208,334.118c0,0.362,0.455,0.655,1.016,0.655 c0.561,0,1.016-0.293,1.016-0.655c0-0.362-0.455-0.655-1.016-0.655C210.663,333.463,210.208,333.756,210.208,334.118z  M212.465,343.652c-0.264,0-0.479,0.138-0.479,0.309c0,0.17,0.214,0.309,0.479,0.309c0.264,0,0.479-0.138,0.479-0.309 C212.944,343.79,212.73,343.652,212.465,343.652z M189.479,337.427c0.734,0,1.328-0.383,1.328-0.856s-0.595-0.856-1.328-0.856 c-0.734,0-1.328,0.383-1.328,0.856S188.746,337.427,189.479,337.427z M210.322,349.014c-0.67,0-1.213,0.35-1.213,0.782 c0,0.432,0.543,0.782,1.213,0.782c0.67,0,1.213-0.35,1.213-0.782C211.535,349.364,210.992,349.014,210.322,349.014z  M214.826,343.701c-0.845,0-1.53,0.442-1.53,0.986s0.685,0.986,1.53,0.986c0.845,0,1.53-0.442,1.53-0.986 S215.672,343.701,214.826,343.701z M214.455,336.567c0.646,0,1.171-0.338,1.171-0.755c0-0.417-0.524-0.755-1.171-0.755 c-0.646,0-1.171,0.338-1.171,0.755C213.285,336.229,213.809,336.567,214.455,336.567z M183.416,337.39 c0.39,0,0.716-0.171,0.814-0.403c0.561-0.047,1.013-0.315,1.126-0.668c0.207,0.207,0.566,0.344,0.977,0.344 c0.643,0,1.164-0.336,1.164-0.75c0-0.414-0.521-0.75-1.164-0.75c-0.544,0-0.997,0.241-1.125,0.566 c-0.227-0.259-0.652-0.435-1.146-0.435c-0.73,0-1.322,0.382-1.322,0.852c0,0.108,0.034,0.21,0.091,0.305 c-0.161,0.099-0.261,0.238-0.261,0.393C182.569,337.145,182.948,337.39,183.416,337.39z M176.853,336.767 c0,0.565,0.71,1.023,1.587,1.023s1.587-0.458,1.587-1.023s-0.711-1.023-1.587-1.023S176.853,336.202,176.853,336.767z  M172.908,346.815c0-0.478-0.6-0.865-1.341-0.865s-1.341,0.387-1.341,0.865c0,0.477,0.601,0.865,1.341,0.865 S172.908,347.292,172.908,346.815z M176.088,334.748c0.268,0,0.485-0.14,0.485-0.313c0-0.172-0.217-0.312-0.485-0.312 c-0.268,0-0.485,0.14-0.485,0.312C175.604,334.608,175.82,334.748,176.088,334.748z M176.253,343.873 c0.334,0,0.605-0.175,0.605-0.39c0-0.215-0.271-0.39-0.605-0.39c-0.334,0-0.605,0.175-0.605,0.39 C175.648,343.698,175.919,343.873,176.253,343.873z M189.449,334.042c-0.591,0-1.07,0.309-1.07,0.69c0,0.381,0.479,0.69,1.07,0.69 c0.591,0,1.07-0.309,1.07-0.69C190.519,334.35,190.04,334.042,189.449,334.042z M177.918,333.942c-0.601,0-1.088,0.314-1.088,0.701 c0,0.387,0.487,0.701,1.088,0.701c0.601,0,1.088-0.314,1.088-0.701C179.005,334.256,178.518,333.942,177.918,333.942z  M180.277,334.782c0.443,0,0.802-0.232,0.802-0.517s-0.359-0.517-0.802-0.517c-0.443,0-0.802,0.232-0.802,0.517 S179.834,334.782,180.277,334.782z M168.356,340.508c0,0.222,0.279,0.401,0.622,0.401c0.344,0,0.622-0.18,0.622-0.401 c0-0.221-0.279-0.401-0.622-0.401C168.635,340.107,168.356,340.287,168.356,340.508z M169.669,349.356 c0-0.425-0.535-0.77-1.195-0.77s-1.195,0.345-1.195,0.77s0.535,0.77,1.195,0.77S169.669,349.782,169.669,349.356z M159.623,340.032 c-0.352,0-0.638,0.184-0.638,0.411s0.286,0.411,0.638,0.411c0.352,0,0.638-0.184,0.638-0.411S159.975,340.032,159.623,340.032z  M172.202,337.143c-0.8,0-1.449,0.418-1.449,0.934s0.649,0.934,1.449,0.934s1.449-0.418,1.449-0.934 S173.003,337.143,172.202,337.143z M170.161,333.52c-0.483,0-0.874,0.252-0.874,0.563c0,0.311,0.391,0.563,0.874,0.563 c0.483,0,0.874-0.252,0.874-0.563C171.035,333.772,170.643,333.52,170.161,333.52z M172.644,342.319c0,0.304,0.382,0.55,0.854,0.55 c0.471,0,0.854-0.246,0.854-0.55c0-0.304-0.382-0.55-0.854-0.55C173.026,341.769,172.644,342.015,172.644,342.319z  M180.885,335.797c-0.393,0-0.711,0.205-0.711,0.458s0.318,0.458,0.711,0.458c0.393,0,0.711-0.205,0.711-0.458 S181.278,335.797,180.885,335.797z M179.662,350.477c-0.716,0-1.297,0.374-1.297,0.836c0,0.462,0.581,0.836,1.297,0.836 c0.716,0,1.297-0.374,1.297-0.836C180.959,350.852,180.378,350.477,179.662,350.477z M193.052,335.728 c-0.426,0-0.772,0.223-0.772,0.498c0,0.275,0.346,0.498,0.772,0.498c0.427,0,0.772-0.223,0.772-0.498 C193.824,335.951,193.479,335.728,193.052,335.728z M194.892,336.063c0,0.56,0.704,1.014,1.573,1.014 c0.869,0,1.573-0.454,1.573-1.014c0-0.56-0.704-1.014-1.573-1.014C195.596,335.049,194.892,335.503,194.892,336.063z  M192.643,332.428c-0.506,0-0.917,0.265-0.917,0.591c0,0.326,0.411,0.591,0.917,0.591c0.507,0,0.917-0.265,0.917-0.591 C193.561,332.693,193.15,332.428,192.643,332.428z M190.912,332.043c-0.367,0-0.664,0.191-0.664,0.428s0.297,0.428,0.664,0.428 c0.367,0,0.664-0.192,0.664-0.428S191.278,332.043,190.912,332.043z M182.128,333.882c0-0.165-0.207-0.298-0.462-0.298 c-0.255,0-0.462,0.133-0.462,0.298c0,0.164,0.207,0.298,0.462,0.298C181.921,334.18,182.128,334.046,182.128,333.882z  M195.299,332.856c-0.3,0-0.577,0.058-0.813,0.154c-0.212,0.038-0.379,0.142-0.446,0.276c-0.166,0.157-0.264,0.348-0.264,0.552 c0,0.542,0.682,0.982,1.523,0.982c0.841,0,1.523-0.44,1.523-0.982C196.823,333.296,196.141,332.856,195.299,332.856z  M191.102,345.31c-0.446,0-0.807,0.233-0.807,0.52c0,0.287,0.362,0.521,0.807,0.521c0.446,0,0.808-0.233,0.808-0.521 C191.909,345.543,191.548,345.31,191.102,345.31z M164.742,335.954c-0.671,0-1.215,0.351-1.215,0.783 c0,0.433,0.544,0.783,1.215,0.783c0.671,0,1.215-0.351,1.215-0.783C165.957,336.305,165.413,335.954,164.742,335.954z  M184.075,344.842c0-0.414-0.521-0.75-1.163-0.75s-1.163,0.336-1.163,0.75c0,0.414,0.521,0.75,1.163,0.75 S184.075,345.256,184.075,344.842z M186.867,333.16c0.321,0,0.58-0.167,0.58-0.374c0-0.207-0.26-0.374-0.58-0.374 c-0.321,0-0.58,0.168-0.58,0.374C186.287,332.993,186.547,333.16,186.867,333.16z M185.376,348.949 c-0.465,0-0.842,0.243-0.842,0.543c0,0.3,0.377,0.543,0.842,0.543c0.465,0,0.842-0.243,0.842-0.543 C186.218,349.192,185.841,348.949,185.376,348.949z M187.751,341.573c-0.699,0-1.265,0.365-1.265,0.815s0.566,0.815,1.265,0.815 s1.265-0.365,1.265-0.815S188.45,341.573,187.751,341.573z M186.897,338.223c0.442,0,0.8-0.231,0.8-0.515 c0-0.285-0.358-0.515-0.8-0.515c-0.441,0-0.799,0.231-0.799,0.515C186.098,337.992,186.456,338.223,186.897,338.223z  M131.601,336.142c0-0.182-0.229-0.329-0.51-0.329s-0.51,0.147-0.51,0.329c0,0.182,0.229,0.329,0.51,0.329 S131.601,336.323,131.601,336.142z M41.235,354.215c-0.495,0-0.896,0.259-0.896,0.577c0,0.319,0.401,0.577,0.896,0.577 c0.495,0,0.896-0.258,0.896-0.577C42.131,354.473,41.73,354.215,41.235,354.215z M26.323,343.372c-0.427,0-0.774,0.223-0.774,0.499 s0.346,0.499,0.774,0.499c0.427,0,0.773-0.223,0.773-0.499S26.75,343.372,26.323,343.372z M24.151,338.822 c0,0.299,0.376,0.542,0.84,0.542c0.464,0,0.84-0.242,0.84-0.542s-0.376-0.542-0.84-0.542 C24.527,338.28,24.151,338.523,24.151,338.822z M28.122,336.074c-0.676,0-1.225,0.353-1.225,0.789s0.548,0.789,1.225,0.789 s1.225-0.353,1.225-0.789S28.798,336.074,28.122,336.074z M23.059,342.092c-0.672,0-1.217,0.351-1.217,0.784 s0.545,0.784,1.217,0.784c0.672,0,1.217-0.351,1.217-0.784S23.731,342.092,23.059,342.092z M21.583,339.993 c-0.365,0-0.661,0.191-0.661,0.426c0,0.235,0.296,0.426,0.661,0.426s0.661-0.191,0.661-0.426 C22.245,340.184,21.949,339.993,21.583,339.993z M21.651,355.502c0,0.176,0.221,0.319,0.495,0.319s0.494-0.143,0.494-0.319 c0-0.176-0.221-0.319-0.494-0.319S21.651,355.326,21.651,355.502z M30.326,340.145c0,0.508,0.639,0.92,1.428,0.92 c0.789,0,1.428-0.412,1.428-0.92c0-0.508-0.639-0.92-1.428-0.92C30.966,339.225,30.326,339.637,30.326,340.145z M31.588,339.234 c0.443,0,0.803-0.232,0.803-0.518c0-0.199-0.176-0.369-0.43-0.456c0.047-0.054,0.076-0.115,0.076-0.181 c0-0.206-0.259-0.372-0.578-0.372s-0.577,0.167-0.577,0.372c0,0.1,0.062,0.191,0.163,0.258c-0.159,0.095-0.259,0.229-0.259,0.379 C30.785,339.002,31.145,339.234,31.588,339.234z M18.531,337.014c-0.649,0-1.175,0.339-1.175,0.757 c0,0.418,0.526,0.757,1.175,0.757c0.649,0,1.175-0.339,1.175-0.757c0-0.031-0.009-0.06-0.014-0.09 c0.141,0.131,0.375,0.217,0.641,0.217c0.43,0,0.778-0.225,0.778-0.502c0-0.277-0.349-0.502-0.778-0.502 c-0.43,0-0.779,0.225-0.779,0.502c0,0.004,0.002,0.007,0.002,0.011C19.355,337.174,18.974,337.014,18.531,337.014z M16.252,339.951 c0-0.372-0.468-0.674-1.046-0.674c-0.578,0-1.046,0.302-1.046,0.674s0.468,0.674,1.046,0.674 C15.783,340.625,16.252,340.323,16.252,339.951z M26.415,351.124c0,0.292,0.367,0.528,0.819,0.528s0.819-0.236,0.819-0.528 c0-0.292-0.367-0.528-0.819-0.528S26.415,350.832,26.415,351.124z M29.105,338.981c0.1-0.069,0.163-0.16,0.163-0.262 c0-0.212-0.266-0.383-0.595-0.383s-0.595,0.172-0.595,0.383c0,0.062,0.025,0.12,0.066,0.172c-0.623,0.088-1.091,0.446-1.091,0.874 c0,0.495,0.622,0.896,1.39,0.896s1.39-0.401,1.39-0.896C29.834,339.425,29.537,339.133,29.105,338.981z M20.892,335.914 c-0.399,0-0.723,0.209-0.723,0.466s0.324,0.466,0.723,0.466c0.399,0,0.723-0.209,0.723-0.466S21.291,335.914,20.892,335.914z  M30.853,351.782c0.167,0,0.316-0.046,0.421-0.119c0.148,0.039,0.309,0.061,0.479,0.061c0.702,0,1.272-0.367,1.272-0.82 c0-0.453-0.569-0.82-1.272-0.82s-1.272,0.367-1.272,0.82c0,0.069,0.017,0.136,0.043,0.2c-0.15,0.067-0.249,0.179-0.249,0.305 C30.276,351.616,30.535,351.782,30.853,351.782z M38.107,354.642c0-0.198-0.249-0.359-0.556-0.359c-0.307,0-0.556,0.16-0.556,0.359 c0,0.198,0.249,0.358,0.556,0.358C37.858,355,38.107,354.84,38.107,354.642z M41.076,338.917c0,0.307,0.386,0.555,0.862,0.555 s0.862-0.249,0.862-0.555c0-0.307-0.386-0.556-0.862-0.556S41.076,338.61,41.076,338.917z M10.642,358.782 c0-0.379-0.477-0.686-1.065-0.686c-0.588,0-1.065,0.307-1.065,0.686s0.477,0.686,1.065,0.686 C10.165,359.469,10.642,359.161,10.642,358.782z M42.494,335.697c-0.469,0-0.848,0.245-0.848,0.547c0,0.302,0.38,0.547,0.848,0.547 c0.469,0,0.848-0.245,0.848-0.547C43.343,335.942,42.963,335.697,42.494,335.697z M17.446,342.471c0,0.295,0.371,0.535,0.829,0.535 s0.829-0.239,0.829-0.535c0-0.295-0.371-0.535-0.829-0.535S17.446,342.176,17.446,342.471z M36.28,358.84 c-0.682,0-1.234,0.356-1.234,0.796c0,0.439,0.553,0.796,1.234,0.796s1.234-0.356,1.234-0.796 C37.514,359.196,36.961,358.84,36.28,358.84z M36.635,338.836c-0.576,0-1.043,0.301-1.043,0.673c0,0.372,0.467,0.673,1.043,0.673 c0.576,0,1.043-0.301,1.043-0.673C37.678,339.137,37.211,338.836,36.635,338.836z M41.884,341.816c0,0.375,0.471,0.679,1.053,0.679 c0.582,0,1.053-0.304,1.053-0.679c0-0.375-0.472-0.679-1.053-0.679C42.355,341.137,41.884,341.441,41.884,341.816z M37.903,341.51 c-0.254,0-0.46,0.133-0.46,0.297c0,0.164,0.206,0.296,0.46,0.296c0.254,0,0.46-0.133,0.46-0.296 C38.363,341.642,38.157,341.51,37.903,341.51z M36.27,344.55c0-0.355-0.446-0.642-0.996-0.642c-0.55,0-0.996,0.288-0.996,0.642 c0,0.355,0.446,0.642,0.996,0.642C35.824,345.192,36.27,344.904,36.27,344.55z M38.404,336.971c0,0.13,0.072,0.248,0.187,0.343 c-0.059,0.099-0.095,0.206-0.095,0.319c0,0.491,0.617,0.889,1.379,0.889c0.761,0,1.379-0.398,1.379-0.889 c0-0.447-0.514-0.814-1.181-0.876c-0.1-0.155-0.305-0.272-0.557-0.32c0.196-0.034,0.344-0.144,0.344-0.281 c0-0.163-0.205-0.296-0.459-0.296c-0.253,0-0.459,0.132-0.459,0.296c0,0.115,0.105,0.212,0.253,0.261 C38.752,336.443,38.404,336.68,38.404,336.971z M18.13,351.855c-0.608,0-1.101,0.318-1.101,0.709c0,0.392,0.493,0.709,1.101,0.709 c0.608,0,1.101-0.318,1.101-0.709C19.231,352.173,18.738,351.855,18.13,351.855z M42.929,339.42c0,0.499,0.627,0.904,1.402,0.904 c0.774,0,1.402-0.405,1.402-0.904c0-0.335-0.285-0.623-0.704-0.779c0.025,0.001,0.049,0.005,0.075,0.005 c0.735,0,1.33-0.384,1.33-0.857c0-0.474-0.595-0.857-1.33-0.857s-1.33,0.384-1.33,0.857c0,0.314,0.264,0.585,0.654,0.735 c-0.032-0.001-0.063-0.006-0.096-0.006C43.557,338.517,42.929,338.922,42.929,339.42z M48.325,340.121 c0-0.487-0.612-0.881-1.367-0.881c-0.755,0-1.367,0.394-1.367,0.881c0,0.486,0.612,0.881,1.367,0.881 C47.713,341.001,48.325,340.607,48.325,340.121z M46.679,342.017c0-0.31-0.39-0.562-0.871-0.562c-0.481,0-0.871,0.251-0.871,0.562 c0,0.31,0.39,0.562,0.871,0.562C46.288,342.579,46.679,342.327,46.679,342.017z M25.511,336.646c-0.58,0-1.05,0.303-1.05,0.677 c0,0.374,0.47,0.677,1.05,0.677s1.05-0.303,1.05-0.677C26.56,336.949,26.09,336.646,25.511,336.646z M-8.343,339.067 c0,0.321,0.403,0.581,0.901,0.581c0.497,0,0.9-0.26,0.9-0.581c0-0.17-0.115-0.322-0.296-0.428c0.276-0.077,0.469-0.254,0.469-0.461 c0-0.278-0.349-0.503-0.78-0.503c-0.431,0-0.78,0.225-0.78,0.503c0,0.131,0.08,0.25,0.207,0.339 C-8.081,338.594-8.343,338.81-8.343,339.067z M-7.442,341.711c0.653,0,1.183-0.341,1.183-0.762c0-0.421-0.529-0.762-1.183-0.762 c-0.653,0-1.183,0.341-1.183,0.762C-8.625,341.37-8.095,341.711-7.442,341.711z M-16.485,365.469c0,0.402,0.506,0.729,1.131,0.729 c0.624,0,1.131-0.326,1.131-0.729c0-0.403-0.506-0.729-1.131-0.729C-15.979,364.741-16.485,365.067-16.485,365.469z  M12.725,342.078c-0.624,0-1.129,0.326-1.129,0.728s0.506,0.728,1.129,0.728c0.624,0,1.129-0.326,1.129-0.728 S13.349,342.078,12.725,342.078z M15.399,357.087c0,0.211,0.265,0.381,0.592,0.381c0.327,0,0.592-0.171,0.592-0.381 s-0.265-0.381-0.592-0.381C15.663,356.706,15.399,356.876,15.399,357.087z M2.39,338.573c0,0.532,0.67,0.964,1.495,0.964 c0.826,0,1.495-0.432,1.495-0.964c0-0.072-0.014-0.142-0.038-0.209c0.038-0.009,0.076-0.018,0.112-0.029 c0.23,0.186,0.554,0.321,0.931,0.367c0.058,0.008,0.117,0.013,0.178,0.014c0.252,0.195,0.626,0.322,1.05,0.322 c0.758,0,1.372-0.396,1.372-0.884c0-0.02-0.007-0.039-0.009-0.059c0.218,0.108,0.487,0.175,0.783,0.175 c0.712,0,1.289-0.372,1.289-0.831c0-0.434-0.518-0.786-1.176-0.824c0.078-0.056,0.126-0.129,0.126-0.211 c0-0.175-0.221-0.317-0.493-0.317c-0.272,0-0.493,0.142-0.493,0.317c0,0.115,0.096,0.215,0.238,0.271 c-0.252,0.07-0.459,0.191-0.598,0.342c-0.158-0.405-0.721-0.706-1.398-0.706c-0.55,0-1.022,0.2-1.267,0.491 c-0.064,0.02-0.128,0.04-0.187,0.065c-0.247-0.146-0.573-0.237-0.934-0.237c-0.767,0-1.389,0.401-1.389,0.895 c0,0.041,0.01,0.081,0.019,0.12C2.862,337.756,2.39,338.127,2.39,338.573z M15.055,337.164c-0.79,0-1.431,0.413-1.431,0.922 c0,0.51,0.641,0.923,1.431,0.923c0.79,0,1.431-0.413,1.431-0.923C16.486,337.577,15.845,337.164,15.055,337.164z M-10.494,358.391 c-0.783,0-1.418,0.409-1.418,0.914c0,0.505,0.635,0.914,1.418,0.914c0.783,0,1.418-0.409,1.418-0.914 C-9.076,358.801-9.711,358.391-10.494,358.391z M-2.695,358.315c-0.65,0-1.177,0.34-1.177,0.759c0,0.419,0.527,0.759,1.177,0.759 s1.177-0.34,1.177-0.759C-1.517,358.654-2.044,358.315-2.695,358.315z M422.444,324.059c0.385,0,0.698-0.201,0.698-0.45 c0-0.248-0.312-0.45-0.698-0.45c-0.385,0-0.697,0.201-0.697,0.45C421.747,323.858,422.059,324.059,422.444,324.059z  M-11.318,338.813c0,0.165,0.207,0.298,0.463,0.298c0.255,0,0.461-0.133,0.462-0.297c0.15,0.041,0.315,0.063,0.487,0.063 c0.692,0,1.254-0.362,1.254-0.808c0-0.446-0.561-0.808-1.254-0.808c-0.692,0-1.254,0.362-1.254,0.808 c0,0.169,0.081,0.326,0.219,0.455C-11.153,338.552-11.318,338.668-11.318,338.813z M419.527,327.006c0.46,0,0.832-0.24,0.832-0.536 c0-0.296-0.372-0.536-0.832-0.536s-0.832,0.24-0.832,0.536C418.695,326.766,419.068,327.006,419.527,327.006z M-13.467,357.925 c-0.297,0-0.537,0.155-0.537,0.346c0,0.191,0.24,0.346,0.537,0.346c0.297,0,0.537-0.155,0.537-0.346 C-12.93,358.08-13.171,357.925-13.467,357.925z M-12.984,343.437c0,0.384,0.483,0.695,1.078,0.695c0.595,0,1.078-0.311,1.078-0.695 c0-0.384-0.483-0.695-1.078-0.695C-12.501,342.742-12.984,343.053-12.984,343.437z M-14.706,363.678 c0,0.417,0.524,0.755,1.171,0.755c0.647,0,1.171-0.338,1.171-0.755c0-0.417-0.524-0.755-1.171-0.755 C-14.182,362.923-14.706,363.261-14.706,363.678z M0.341,342.827c-0.608,0-1.1,0.318-1.1,0.709c0,0.392,0.493,0.709,1.1,0.709 c0.608,0,1.1-0.318,1.1-0.709C1.441,343.145,0.948,342.827,0.341,342.827z M0.189,361.11c0,0.544,0.684,0.984,1.527,0.984 c0.843,0,1.527-0.441,1.527-0.984c0-0.544-0.684-0.984-1.527-0.984C0.873,360.126,0.189,360.566,0.189,361.11z M-1.539,344.015 c0-0.257-0.324-0.466-0.723-0.466c-0.399,0-0.723,0.209-0.723,0.466c0,0.258,0.324,0.466,0.723,0.466 C-1.863,344.481-1.539,344.272-1.539,344.015z M-2.819,340.537c-0.814,0-1.473,0.425-1.473,0.95c0,0.525,0.66,0.95,1.473,0.95 s1.473-0.425,1.473-0.95C-1.346,340.962-2.006,340.537-2.819,340.537z M2.068,355.736c0,0.368,0.463,0.667,1.034,0.667 c0.571,0,1.034-0.299,1.034-0.667c0-0.368-0.463-0.667-1.034-0.667C2.531,355.069,2.068,355.367,2.068,355.736z M-2.688,363.571 c0-0.233-0.293-0.421-0.654-0.421c-0.361,0-0.654,0.189-0.654,0.421c0,0.233,0.293,0.422,0.654,0.422 C-2.981,363.992-2.688,363.803-2.688,363.571z M-6.434,344.541c0,0.511,0.643,0.926,1.436,0.926s1.436-0.414,1.436-0.926 c0-0.511-0.643-0.926-1.436-0.926S-6.434,344.03-6.434,344.541z M10.962,341.473c0-0.357-0.448-0.646-1.002-0.646 c-0.553,0-1.002,0.289-1.002,0.646s0.449,0.646,1.002,0.646C10.513,342.119,10.962,341.83,10.962,341.473z M13.027,357.734 c-0.398,0-0.72,0.208-0.72,0.464c0,0.256,0.322,0.464,0.72,0.464c0.398,0,0.72-0.208,0.72-0.464 C13.747,357.942,13.424,357.734,13.027,357.734z M11.137,338.754c0,0.309,0.389,0.56,0.868,0.56s0.868-0.251,0.868-0.56 c0-0.309-0.389-0.56-0.868-0.56S11.137,338.444,11.137,338.754z M12.539,336.314c-0.414,0-0.75,0.216-0.75,0.483 c0,0.267,0.336,0.483,0.75,0.483c0.414,0,0.75-0.216,0.75-0.483C13.289,336.531,12.953,336.314,12.539,336.314z M4.968,340.047 c-0.322,0-0.584,0.168-0.584,0.376c0,0.208,0.261,0.376,0.584,0.376c0.322,0,0.584-0.168,0.584-0.376 C5.552,340.215,5.29,340.047,4.968,340.047z M2.017,340.17c0,0.23,0.29,0.417,0.647,0.417s0.647-0.187,0.647-0.417 c0-0.23-0.29-0.417-0.647-0.417S2.017,339.939,2.017,340.17z M4.286,355.096c0,0.435,0.547,0.787,1.222,0.787 c0.675,0,1.222-0.353,1.222-0.787s-0.547-0.787-1.222-0.787C4.833,354.308,4.286,354.661,4.286,355.096z M62.951,339.714 c-0.524,0-0.948,0.274-0.948,0.611c0,0.337,0.424,0.611,0.948,0.611c0.524,0,0.948-0.274,0.948-0.611 C63.899,339.988,63.475,339.714,62.951,339.714z M79.157,345.531c0-0.513-0.646-0.929-1.442-0.929 c-0.796,0-1.442,0.416-1.442,0.929s0.646,0.93,1.442,0.93C78.511,346.46,79.157,346.044,79.157,345.531z M71.476,338.802 c-0.246,0-0.463,0.078-0.596,0.198c-0.086-0.048-0.198-0.078-0.321-0.078c-0.272,0-0.493,0.142-0.493,0.318 c0,0.175,0.221,0.318,0.493,0.318c0.101,0,0.195-0.02,0.273-0.053c0.125,0.147,0.365,0.249,0.644,0.249 c0.407,0,0.737-0.213,0.737-0.475S71.883,338.802,71.476,338.802z M76.407,337.849c-0.326,0-0.59,0.17-0.59,0.38 s0.264,0.38,0.59,0.38c0.326,0,0.59-0.17,0.59-0.38S76.732,337.849,76.407,337.849z M76.625,347.124 c0-0.355-0.446-0.642-0.996-0.642c-0.55,0-0.996,0.287-0.996,0.642c0,0.355,0.446,0.642,0.996,0.642 C76.179,347.766,76.625,347.478,76.625,347.124z M74.492,341.648c0,0.378,0.476,0.685,1.062,0.685c0.587,0,1.062-0.307,1.062-0.685 c0-0.378-0.476-0.685-1.062-0.685C74.968,340.963,74.492,341.27,74.492,341.648z M87.115,346.338c0.503,0,0.91-0.263,0.91-0.587 c0-0.324-0.408-0.587-0.91-0.587c-0.503,0-0.91,0.263-0.91,0.587C86.204,346.075,86.612,346.338,87.115,346.338z M78.979,338.415 c-0.369,0-0.669,0.193-0.669,0.431c0,0.238,0.299,0.431,0.669,0.431s0.669-0.193,0.669-0.431 C79.648,338.608,79.348,338.415,78.979,338.415z M86.163,339.456c-0.775,0-1.404,0.405-1.404,0.905c0,0.5,0.629,0.905,1.404,0.905 s1.404-0.405,1.404-0.905C87.567,339.861,86.938,339.456,86.163,339.456z M90.565,337.117c-0.286,0-0.517,0.149-0.517,0.333 c0,0.184,0.232,0.333,0.517,0.333s0.517-0.149,0.517-0.333C91.082,337.266,90.851,337.117,90.565,337.117z M92.858,336.402 c0-0.334-0.42-0.605-0.938-0.605c-0.518,0-0.938,0.271-0.938,0.605c0,0.334,0.42,0.605,0.938,0.605 C92.438,337.007,92.858,336.736,92.858,336.402z M88.359,336.438c-0.501,0-0.906,0.261-0.906,0.584 c0,0.323,0.406,0.584,0.906,0.584c0.5,0,0.906-0.262,0.906-0.584C89.265,336.7,88.859,336.438,88.359,336.438z M85.431,353.606 c-0.494,0-0.895,0.258-0.895,0.577c0,0.319,0.401,0.577,0.895,0.577c0.494,0,0.895-0.258,0.895-0.577 C86.327,353.865,85.926,353.606,85.431,353.606z M89.755,336.626c-0.255,0-0.461,0.133-0.461,0.297 c0,0.164,0.206,0.297,0.461,0.297c0.255,0,0.461-0.133,0.461-0.297C90.216,336.759,90.01,336.626,89.755,336.626z M87.572,340.508 c0,0.542,0.681,0.981,1.522,0.981c0.84,0,1.522-0.439,1.522-0.981c0-0.542-0.681-0.981-1.522-0.981 C88.253,339.527,87.572,339.966,87.572,340.508z M82.567,347.579c0-0.324-0.408-0.587-0.91-0.587c-0.503,0-0.911,0.263-0.911,0.587 c0,0.324,0.408,0.587,0.911,0.587C82.16,348.166,82.567,347.903,82.567,347.579z M94.596,336.935c-0.857,0-1.552,0.448-1.552,1.001 c0,0.553,0.695,1.001,1.552,1.001c0.857,0,1.552-0.448,1.552-1.001C96.148,337.383,95.453,336.935,94.596,336.935z M93.297,353.195 c0,0.345,0.434,0.625,0.97,0.625c0.536,0,0.97-0.28,0.97-0.625c0-0.345-0.434-0.625-0.97-0.625 C93.731,352.57,93.297,352.849,93.297,353.195z M95.884,337.12c0,0.165,0.208,0.299,0.464,0.299c0.256,0,0.464-0.134,0.464-0.299 c0-0.165-0.208-0.299-0.464-0.299C96.092,336.821,95.884,336.955,95.884,337.12z M97.306,334.838c-0.46,0-0.833,0.24-0.833,0.537 c0,0.297,0.373,0.537,0.833,0.537c0.46,0,0.833-0.24,0.833-0.537C98.139,335.078,97.766,334.838,97.306,334.838z M70.67,334.87 c-0.673,0-1.219,0.352-1.219,0.786c0,0.434,0.546,0.786,1.219,0.786c0.673,0,1.219-0.352,1.219-0.786 C71.888,335.222,71.343,334.87,70.67,334.87z M102.865,351.168c0-0.348-0.437-0.63-0.977-0.63c-0.54,0-0.977,0.282-0.977,0.63 c0,0.348,0.437,0.63,0.977,0.63C102.428,351.798,102.865,351.516,102.865,351.168z M101.181,341.484 c0-0.176-0.221-0.318-0.494-0.318s-0.494,0.143-0.494,0.318c0,0.176,0.221,0.318,0.494,0.318S101.181,341.66,101.181,341.484z  M99.516,351.005c-0.558,0-1.01,0.292-1.01,0.651c0,0.36,0.452,0.651,1.01,0.651c0.558,0,1.01-0.291,1.01-0.651 C100.525,351.297,100.073,351.005,99.516,351.005z M92.731,342.004c-0.374,0-0.677,0.195-0.677,0.436s0.303,0.436,0.677,0.436 c0.374,0,0.677-0.195,0.677-0.436S93.105,342.004,92.731,342.004z M68.064,351.714c0.59,0,1.068-0.308,1.068-0.688 c0-0.38-0.478-0.688-1.068-0.688s-1.068,0.308-1.068,0.688C66.996,351.406,67.474,351.714,68.064,351.714z M97.982,352.005 c0-0.225-0.283-0.408-0.632-0.408c-0.349,0-0.632,0.182-0.632,0.408s0.283,0.408,0.632,0.408 C97.699,352.413,97.982,352.23,97.982,352.005z M93.031,336.016c0,0.362,0.456,0.656,1.018,0.656c0.542,0,0.982-0.274,1.012-0.619 c0.059,0.015,0.122,0.023,0.189,0.023c0.291,0,0.527-0.152,0.527-0.34c0-0.101-0.07-0.19-0.178-0.253 c0.123-0.122,0.196-0.266,0.196-0.422c0-0.428-0.538-0.775-1.202-0.775s-1.202,0.347-1.202,0.775c0,0.141,0.063,0.271,0.164,0.384 C93.243,335.558,93.031,335.77,93.031,336.016z M101.712,335.483c0-0.45-0.566-0.815-1.264-0.815s-1.264,0.365-1.264,0.815 c0,0.444,0.551,0.803,1.235,0.813c-0.445,0.078-0.774,0.338-0.774,0.649c0,0.373,0.469,0.675,1.048,0.675 c0.579,0,1.048-0.302,1.048-0.675c0-0.362-0.442-0.655-0.997-0.672C101.298,336.187,101.712,335.867,101.712,335.483z  M98.055,339.403c-0.036-0.003-0.071-0.007-0.108-0.007c-0.552,0-1,0.289-1,0.645s0.448,0.645,1,0.645 c0.228,0,0.435-0.051,0.604-0.134c0.043,0.004,0.086,0.009,0.131,0.009c0.557,0,1.009-0.291,1.009-0.651 c0-0.359-0.452-0.651-1.009-0.651C98.443,339.258,98.227,339.314,98.055,339.403z M73.796,338.93c0.313,0,0.566-0.163,0.566-0.365 s-0.253-0.365-0.566-0.365c-0.313,0-0.566,0.163-0.566,0.365S73.483,338.93,73.796,338.93z M53.42,346.72 c0-0.271-0.341-0.491-0.761-0.491s-0.761,0.22-0.761,0.491s0.341,0.491,0.761,0.491S53.42,346.991,53.42,346.72z M57.335,352.366 c-0.757,0-1.37,0.395-1.37,0.883c0,0.488,0.613,0.883,1.37,0.883s1.37-0.395,1.37-0.883 C58.705,352.761,58.092,352.366,57.335,352.366z M50.339,352.236c-0.771,0-1.396,0.403-1.396,0.9s0.625,0.9,1.396,0.9 c0.771,0,1.396-0.403,1.396-0.9S51.11,352.236,50.339,352.236z M63.771,338.839c0,0.502,0.632,0.909,1.411,0.909 s1.411-0.407,1.411-0.909s-0.632-0.909-1.411-0.909S63.771,338.336,63.771,338.839z M65.673,346.506 c0-0.214-0.27-0.388-0.602-0.388s-0.602,0.174-0.602,0.388c0,0.214,0.27,0.388,0.602,0.388S65.673,346.721,65.673,346.506z  M64.892,356.258c0-0.355-0.447-0.643-0.998-0.643s-0.998,0.288-0.998,0.643c0,0.355,0.447,0.643,0.998,0.643 S64.892,356.613,64.892,356.258z M66.591,335.896c0-0.362-0.456-0.656-1.018-0.656c-0.562,0-1.018,0.294-1.018,0.656 s0.456,0.656,1.018,0.656C66.136,336.553,66.591,336.259,66.591,335.896z M51.681,340.75c-0.687,0-1.244,0.359-1.244,0.802 c0,0.443,0.557,0.802,1.244,0.802s1.244-0.359,1.244-0.802C52.924,341.109,52.368,340.75,51.681,340.75z M55.06,342.468 c0-0.181-0.228-0.328-0.509-0.328c-0.281,0-0.509,0.147-0.509,0.328c0,0.181,0.228,0.328,0.509,0.328 C54.833,342.796,55.06,342.649,55.06,342.468z M50.568,338.836c0.13,0.025,0.266,0.043,0.409,0.043 c0.786,0,1.423-0.411,1.423-0.917s-0.637-0.917-1.423-0.917c-0.506,0-0.947,0.171-1.199,0.427c-0.063-0.006-0.125-0.012-0.19-0.012 c-0.258,0-0.497,0.05-0.699,0.134c-0.213-0.165-0.53-0.273-0.889-0.273c-0.64,0-1.159,0.335-1.159,0.747 c0,0.413,0.519,0.747,1.159,0.747c0.178,0,0.344-0.028,0.495-0.074c0.23,0.234,0.632,0.39,1.093,0.39 C49.981,339.131,50.33,339.015,50.568,338.836z M52.608,338.533c0,0.206,0.258,0.372,0.577,0.372s0.578-0.167,0.578-0.372 c0-0.206-0.259-0.372-0.578-0.372S52.608,338.328,52.608,338.533z M46.922,352.02c-0.795,0-1.439,0.415-1.439,0.928 s0.644,0.928,1.439,0.928c0.795,0,1.439-0.415,1.439-0.928S47.716,352.02,46.922,352.02z M54.37,335.706 c-0.796,0-1.441,0.416-1.441,0.929c0,0.513,0.645,0.929,1.441,0.929c0.796,0,1.441-0.416,1.441-0.929 C55.811,336.121,55.166,335.706,54.37,335.706z M55.414,339.12c-0.356,0-0.644,0.186-0.644,0.415c0,0.229,0.288,0.415,0.644,0.415 c0.356,0,0.644-0.186,0.644-0.415C56.058,339.306,55.77,339.12,55.414,339.12z M85.026,335.01c0-0.259-0.326-0.469-0.727-0.469 c-0.23,0-0.432,0.07-0.566,0.177c-0.113-0.021-0.23-0.035-0.353-0.035c-0.537,0-0.998,0.21-1.198,0.509 c-0.094-0.013-0.19-0.021-0.29-0.021c-0.617,0-1.133,0.266-1.303,0.628c-0.189,0.094-0.313,0.24-0.313,0.405 c0,0.266,0.315,0.482,0.718,0.507c0.241,0.136,0.553,0.222,0.898,0.222c0.592,0,1.091-0.244,1.281-0.583 c0.068,0.007,0.136,0.013,0.207,0.013c0.158,0,0.307-0.021,0.447-0.054c-0.132,0.119-0.212,0.265-0.212,0.423 c0,0.404,0.508,0.731,1.134,0.731c0.626,0,1.134-0.327,1.134-0.731c0-0.404-0.508-0.731-1.134-0.731 c-0.122,0-0.238,0.016-0.348,0.039c0.175-0.143,0.284-0.321,0.284-0.518c0-0.038-0.01-0.075-0.018-0.112 C84.882,335.331,85.026,335.182,85.026,335.01z M73.672,354.093c0.829,0,1.501-0.433,1.501-0.967c0-0.161-0.066-0.31-0.174-0.443 c0.007-0.037,0.017-0.073,0.017-0.111c0-0.483-0.607-0.874-1.356-0.874c-0.749,0-1.356,0.391-1.356,0.874 c0,0.046,0.01,0.09,0.021,0.134c-0.096,0.128-0.155,0.269-0.155,0.42C72.171,353.66,72.843,354.093,73.672,354.093z  M68.883,345.428c0,0.374,0.47,0.677,1.05,0.677c0.58,0,1.05-0.303,1.05-0.677c0-0.149-0.077-0.286-0.204-0.398 c0.027-0.05,0.045-0.102,0.045-0.158c0-0.265-0.333-0.48-0.745-0.48c-0.411,0-0.745,0.215-0.745,0.48c0,0,0,0.001,0,0.001 C69.062,344.996,68.883,345.198,68.883,345.428z M72.657,342.572c0,0.205,0.258,0.371,0.576,0.371s0.576-0.166,0.576-0.371 c0-0.205-0.258-0.371-0.576-0.371S72.657,342.367,72.657,342.572z M68.79,337.256c0-0.199-0.251-0.361-0.56-0.361 c-0.309,0-0.56,0.161-0.56,0.361c0,0.199,0.251,0.361,0.56,0.361C68.54,337.617,68.79,337.455,68.79,337.256z M89.936,348.033 c0,0.198,0.249,0.359,0.556,0.359c0.307,0,0.556-0.16,0.556-0.359c0-0.198-0.249-0.358-0.556-0.358 C90.185,347.674,89.936,347.835,89.936,348.033z M44.32,351.731c0-0.3-0.377-0.543-0.842-0.543c-0.465,0-0.842,0.243-0.842,0.543 c0,0.3,0.377,0.543,0.842,0.543C43.943,352.274,44.32,352.031,44.32,351.731z M75.705,336.645c0,0.466,0.587,0.845,1.311,0.845 s1.311-0.378,1.311-0.845c0-0.198-0.11-0.378-0.287-0.522c0.062,0.02,0.129,0.033,0.203,0.033c0.256,0,0.463-0.134,0.463-0.298 c0-0.042-0.013-0.081-0.037-0.117c0.268-0.103,0.449-0.29,0.449-0.505c0-0.326-0.41-0.59-0.915-0.59 c-0.506,0-0.915,0.264-0.915,0.59c0,0.235,0.214,0.436,0.522,0.531c-0.015,0.029-0.028,0.059-0.028,0.091 c0,0.047,0.02,0.09,0.05,0.129c-0.224-0.116-0.505-0.187-0.814-0.187C76.292,335.8,75.705,336.178,75.705,336.645z M57.085,341.003 c-0.335,0-0.607,0.175-0.607,0.392c0,0.216,0.272,0.392,0.607,0.392s0.607-0.175,0.607-0.392 C57.693,341.179,57.421,341.003,57.085,341.003z M57.87,351.281c0,0.553,0.696,1.002,1.554,1.002s1.554-0.449,1.554-1.002 s-0.696-1.002-1.554-1.002S57.87,350.728,57.87,351.281z M66.649,341.686c0,0.451,0.567,0.816,1.266,0.816 c0.699,0,1.266-0.365,1.266-0.816c0-0.451-0.567-0.816-1.266-0.816C67.216,340.87,66.649,341.235,66.649,341.686z M58.218,339.308 c-0.484,0-0.876,0.253-0.876,0.565c0,0.312,0.392,0.565,0.876,0.565c0.484,0,0.876-0.253,0.876-0.565 C59.095,339.561,58.702,339.308,58.218,339.308z M62.866,336.117c-0.309,0-0.581,0.1-0.743,0.253 c-0.21,0.002-0.404,0.042-0.572,0.108c-0.197-0.222-0.564-0.374-0.99-0.374c-0.51,0-0.938,0.217-1.085,0.514 c-0.211,0.132-0.343,0.315-0.343,0.52c0,0.4,0.503,0.724,1.123,0.724c0.408,0,0.763-0.142,0.959-0.352 c0.204,0.187,0.54,0.31,0.922,0.31c0.555,0,1.013-0.259,1.106-0.6c0.307-0.092,0.521-0.292,0.521-0.524 C63.765,336.376,63.362,336.117,62.866,336.117z M57.22,334.99c-0.471,0-0.852,0.246-0.852,0.549c0,0.303,0.382,0.549,0.852,0.549 c0.471,0,0.853-0.246,0.853-0.549C58.072,335.236,57.691,334.99,57.22,334.99z M102.488,335.256c0,0.327,0.411,0.592,0.918,0.592 c0.213,0,0.406-0.049,0.562-0.127c0.274,0.246,0.718,0.407,1.223,0.407c0.833,0,1.508-0.435,1.508-0.972 c0-0.523-0.642-0.946-1.444-0.968c-0.111-0.247-0.461-0.429-0.88-0.429c-0.508,0-0.921,0.266-0.921,0.594 c0,0.12,0.057,0.232,0.152,0.326c-0.065-0.009-0.131-0.015-0.2-0.015C102.899,334.664,102.488,334.929,102.488,335.256z  M136.169,343.05c-0.377,0-0.682,0.197-0.682,0.44s0.305,0.44,0.682,0.44c0.377,0,0.682-0.197,0.682-0.44 S136.546,343.05,136.169,343.05z M252.537,333.021c0-0.516-0.649-0.934-1.449-0.934c-0.8,0-1.449,0.418-1.449,0.934 c0,0.516,0.649,0.934,1.449,0.934C251.888,333.955,252.537,333.537,252.537,333.021z M239.851,347.483 c-0.261,0-0.503,0.051-0.707,0.135c-0.254-0.161-0.602-0.261-0.986-0.261c-0.776,0-1.405,0.405-1.405,0.906 c0,0.5,0.629,0.906,1.405,0.906c0.327,0,0.624-0.075,0.863-0.196c0.226,0.121,0.513,0.197,0.83,0.197 c0.722,0,1.308-0.378,1.308-0.843C241.159,347.861,240.574,347.483,239.851,347.483z M249.38,337.353 c-0.294,0-0.533,0.154-0.533,0.343s0.238,0.343,0.533,0.343s0.533-0.154,0.533-0.343S249.674,337.353,249.38,337.353z  M252.097,340.741c0-0.256-0.322-0.463-0.719-0.463c-0.397,0-0.719,0.207-0.719,0.463c0,0.256,0.322,0.464,0.719,0.464 C251.775,341.205,252.097,340.997,252.097,340.741z M249.031,347.742c-0.424,0-0.768,0.222-0.768,0.495 c0,0.274,0.344,0.495,0.768,0.495c0.424,0,0.768-0.222,0.768-0.495C249.799,347.964,249.455,347.742,249.031,347.742z  M253.9,331.381c0-0.208-0.261-0.376-0.583-0.376c-0.322,0-0.583,0.168-0.583,0.376c0,0.208,0.261,0.376,0.583,0.376 C253.638,331.757,253.9,331.589,253.9,331.381z M240.545,337.155c-0.576,0-1.043,0.301-1.043,0.672s0.467,0.672,1.043,0.672 c0.576,0,1.043-0.301,1.043-0.672S241.122,337.155,240.545,337.155z M392.423,331.455c-0.427,0-0.772,0.223-0.772,0.498 s0.346,0.498,0.772,0.498c0.427,0,0.772-0.223,0.772-0.498S392.849,331.455,392.423,331.455z M254.874,333.712 c0.65,0,1.177-0.34,1.177-0.759c0-0.419-0.527-0.759-1.177-0.759s-1.177,0.34-1.177,0.759 C253.697,333.373,254.224,333.712,254.874,333.712z M243.309,331.966c0-0.445-0.56-0.806-1.251-0.806 c-0.435,0-0.818,0.144-1.042,0.361c-0.157-0.226-0.508-0.384-0.917-0.384c-0.555,0-1.006,0.29-1.006,0.648s0.45,0.648,1.006,0.648 c0.31,0,0.583-0.092,0.768-0.234c0.156,0.331,0.627,0.573,1.191,0.573C242.749,332.772,243.309,332.411,243.309,331.966z  M392.525,329.979c-0.604,0-1.093,0.315-1.093,0.704c0,0.389,0.489,0.704,1.093,0.704c0.603,0,1.093-0.315,1.093-0.704 C393.618,330.295,393.129,329.979,392.525,329.979z M394.158,346.451c-0.309,0-0.56,0.161-0.56,0.361 c0,0.199,0.251,0.361,0.56,0.361c0.309,0,0.56-0.161,0.56-0.361C394.717,346.612,394.467,346.451,394.158,346.451z M251.113,335.72 c0,0.169,0.213,0.306,0.475,0.306c0.262,0,0.475-0.137,0.475-0.306c0-0.169-0.213-0.306-0.475-0.306 C251.326,335.414,251.113,335.551,251.113,335.72z M267.447,347.19c0-0.429-0.54-0.777-1.206-0.777 c-0.666,0-1.206,0.348-1.206,0.777c0,0.429,0.54,0.777,1.206,0.777C266.907,347.968,267.447,347.62,267.447,347.19z  M256.295,347.196c0-0.371-0.467-0.672-1.043-0.672s-1.043,0.301-1.043,0.672c0,0.371,0.467,0.672,1.043,0.672 S256.295,347.567,256.295,347.196z M263.457,337.214c-0.825,0-1.493,0.431-1.493,0.962s0.668,0.962,1.493,0.962 c0.825,0,1.493-0.431,1.493-0.962S264.282,337.214,263.457,337.214z M270.783,346.088c-0.586,0-1.061,0.306-1.061,0.684 s0.475,0.684,1.061,0.684c0.586,0,1.06-0.306,1.06-0.684S271.369,346.088,270.783,346.088z M263.471,346.269 c0-0.303-0.381-0.548-0.851-0.548c-0.47,0-0.851,0.246-0.851,0.548c0,0.303,0.381,0.549,0.851,0.549 C263.09,346.817,263.471,346.572,263.471,346.269z M271.619,335.488c-0.559,0-1.012,0.292-1.012,0.652s0.453,0.652,1.012,0.652 c0.559,0,1.012-0.292,1.012-0.652S272.178,335.488,271.619,335.488z M268.381,345.583c-0.595,0-1.077,0.311-1.077,0.695 c0,0.384,0.482,0.695,1.077,0.695c0.595,0,1.077-0.311,1.077-0.695C269.458,345.894,268.976,345.583,268.381,345.583z  M263.06,332.981c0.803,0,1.453-0.42,1.453-0.937c0-0.518-0.651-0.937-1.453-0.937s-1.454,0.419-1.454,0.937 C261.606,332.562,262.257,332.981,263.06,332.981z M389.162,333.199c0-0.491-0.617-0.888-1.378-0.888 c-0.57,0-1.058,0.223-1.268,0.541c-0.079-0.387-0.587-0.687-1.209-0.687c-0.676,0-1.225,0.353-1.225,0.789s0.548,0.789,1.225,0.789 c0.495,0,0.918-0.19,1.112-0.462c0.065,0.452,0.648,0.806,1.365,0.806C388.545,334.087,389.162,333.69,389.162,333.199z  M260.43,348.096c-0.446,0-0.808,0.233-0.808,0.521c0,0.288,0.362,0.521,0.808,0.521c0.447,0,0.808-0.233,0.808-0.521 C261.239,348.329,260.877,348.096,260.43,348.096z M260.423,335.5c-0.629,0-1.139,0.329-1.139,0.734 c0,0.406,0.51,0.734,1.139,0.734c0.629,0,1.139-0.329,1.139-0.734C261.562,335.829,261.052,335.5,260.423,335.5z M386.912,336.181 c-0.479,0-0.868,0.25-0.868,0.559c0,0.309,0.389,0.559,0.868,0.559c0.479,0,0.868-0.25,0.868-0.559 C387.78,336.431,387.391,336.181,386.912,336.181z M228.561,340.285c0.512,0,0.927-0.268,0.927-0.598 c0-0.33-0.415-0.598-0.927-0.598s-0.927,0.268-0.927,0.598C227.634,340.017,228.049,340.285,228.561,340.285z M402.724,337.551 c-0.436,0-0.789,0.228-0.789,0.508c0,0.281,0.353,0.508,0.789,0.508c0.436,0,0.789-0.228,0.789-0.508 C403.512,337.779,403.159,337.551,402.724,337.551z M233.986,334.069c-0.335,0-0.607,0.175-0.607,0.391 c0,0.116,0.08,0.219,0.204,0.29c-0.114,0.098-0.184,0.218-0.184,0.35c0,0.323,0.407,0.585,0.908,0.585 c0.501,0,0.908-0.262,0.908-0.585c0-0.262-0.269-0.482-0.638-0.556c0.009-0.027,0.015-0.055,0.015-0.085 C234.592,334.244,234.321,334.069,233.986,334.069z M249.179,334.631c0-0.281-0.354-0.509-0.79-0.509 c-0.437,0-0.79,0.228-0.79,0.509c0,0.281,0.354,0.509,0.79,0.509C248.825,335.14,249.179,334.912,249.179,334.631z  M239.938,336.036c0.81,0,1.467-0.423,1.467-0.946c0-0.522-0.657-0.946-1.467-0.946c-0.81,0-1.467,0.423-1.467,0.946 C238.47,335.613,239.127,336.036,239.938,336.036z M234.645,349.444c0.777,0,1.407-0.406,1.407-0.907 c0-0.501-0.63-0.907-1.407-0.907c-0.777,0-1.407,0.406-1.407,0.907C233.238,349.037,233.868,349.444,234.645,349.444z  M238.044,341.361c0-0.559-0.703-1.013-1.571-1.013c-0.868,0-1.571,0.453-1.571,1.013c0,0.559,0.703,1.013,1.571,1.013 C237.341,342.374,238.044,341.92,238.044,341.361z M245.324,334.34c0.646,0,1.169-0.337,1.169-0.754 c0-0.416-0.523-0.754-1.169-0.754c-0.646,0-1.169,0.337-1.169,0.754C244.155,334.003,244.678,334.34,245.324,334.34z  M244.181,339.119c0-0.326-0.41-0.59-0.915-0.59s-0.915,0.264-0.915,0.59c0,0.326,0.41,0.59,0.915,0.59 S244.181,339.445,244.181,339.119z M242.494,343.942c0,0.242,0.304,0.438,0.679,0.438c0.375,0,0.679-0.196,0.679-0.438 c0-0.242-0.304-0.438-0.679-0.438C242.798,343.504,242.494,343.7,242.494,343.942z M248.025,332.164 c0-0.434-0.545-0.785-1.218-0.785c-0.673,0-1.218,0.351-1.218,0.785c0,0.434,0.545,0.785,1.218,0.785 C247.48,332.949,248.025,332.597,248.025,332.164z M245.683,340.025c0.453,0,0.83-0.203,0.931-0.475 c0.056,0.005,0.111,0.011,0.169,0.011c0.66,0,1.195-0.345,1.195-0.771c0-0.425-0.535-0.77-1.195-0.77 c-0.66,0-1.195,0.345-1.195,0.77c0,0.002,0.001,0.003,0.001,0.005c-0.484,0.031-0.864,0.292-0.864,0.612 C244.724,339.748,245.153,340.025,245.683,340.025z M237.034,336.872c-0.711,0-1.287,0.371-1.287,0.829 c0,0.458,0.576,0.83,1.287,0.83c0.711,0,1.287-0.371,1.287-0.83C238.321,337.243,237.744,336.872,237.034,336.872z  M397.346,344.414c-0.36,0-0.651,0.188-0.651,0.42c0,0.232,0.292,0.42,0.651,0.42c0.36,0,0.651-0.188,0.651-0.42 C397.997,344.602,397.706,344.414,397.346,344.414z M276.232,335.747c0-0.358-0.45-0.648-1.005-0.648 c-0.555,0-1.005,0.29-1.005,0.648c0,0.358,0.45,0.648,1.005,0.648C275.781,336.395,276.232,336.105,276.232,335.747z  M228.526,333.797c-0.863,0-1.563,0.451-1.563,1.007s0.7,1.007,1.563,1.007s1.563-0.451,1.563-1.007 S229.39,333.797,228.526,333.797z M229.34,337.933c-0.397,0-0.719,0.207-0.719,0.463c0,0.256,0.322,0.463,0.719,0.463 c0.397,0,0.719-0.207,0.719-0.463C230.059,338.14,229.737,337.933,229.34,337.933z M233.418,332.663 c0-0.397-0.364-0.736-0.887-0.894c-0.241-0.13-0.548-0.212-0.888-0.212c-0.126,0-0.247,0.014-0.363,0.035 c0.01-0.026,0.018-0.053,0.018-0.081c0-0.182-0.229-0.329-0.511-0.329c-0.282,0-0.511,0.147-0.511,0.329 c0,0.152,0.16,0.278,0.376,0.316c-0.245,0.161-0.397,0.382-0.397,0.626c0,0.13,0.045,0.252,0.122,0.364 c0.115,0.472,0.744,0.835,1.509,0.835C232.731,333.651,233.418,333.208,233.418,332.663z M231.072,339.567 c-0.274,0-0.497,0.143-0.497,0.32c0,0.177,0.222,0.32,0.497,0.32c0.274,0,0.497-0.143,0.497-0.32 C231.569,339.71,231.346,339.567,231.072,339.567z M400.705,346.115c-0.789,0-1.428,0.412-1.428,0.921 c0,0.508,0.639,0.921,1.428,0.921c0.789,0,1.428-0.412,1.428-0.921C402.133,346.527,401.494,346.115,400.705,346.115z  M229.125,332.622c0-0.48-0.604-0.869-1.349-0.869s-1.349,0.389-1.349,0.869c0,0.48,0.604,0.87,1.349,0.87 S229.125,333.103,229.125,332.622z M402.936,335.055c0-0.484-0.608-0.875-1.358-0.875s-1.358,0.392-1.358,0.875 c0,0.483,0.608,0.875,1.358,0.875S402.936,335.538,402.936,335.055z M225.242,348.643c0,0.324,0.408,0.587,0.911,0.587 s0.91-0.263,0.91-0.587c0-0.324-0.408-0.587-0.91-0.587S225.242,348.319,225.242,348.643z M237.793,333.596 c0-0.204-0.257-0.37-0.574-0.37c-0.317,0-0.574,0.165-0.574,0.37c0,0.204,0.257,0.37,0.574,0.37 C237.536,333.966,237.793,333.8,237.793,333.596z M399.604,330.799c0-0.438-0.551-0.793-1.23-0.793c-0.679,0-1.23,0.355-1.23,0.793 c0,0.404,0.47,0.733,1.076,0.783c0.086,0.081,0.224,0.138,0.388,0.138c0.243,0,0.435-0.118,0.465-0.27 C399.393,331.307,399.604,331.069,399.604,330.799z M378.774,345.975c-0.481,0-0.893,0.175-1.106,0.43 c-0.313,0.136-0.52,0.367-0.52,0.629c0,0.418,0.526,0.758,1.176,0.758c0.335,0,0.635-0.091,0.849-0.236 c0.5-0.108,0.862-0.409,0.862-0.768C380.035,346.339,379.471,345.975,378.774,345.975z M311.85,330.481 c-0.423,0-0.765,0.221-0.765,0.493c0,0.273,0.343,0.493,0.765,0.493s0.765-0.221,0.765-0.493 C312.616,330.702,312.273,330.481,311.85,330.481z M328.77,345.579c0.524,0,0.949-0.274,0.949-0.612 c0-0.338-0.425-0.612-0.949-0.612c-0.524,0-0.949,0.274-0.949,0.612C327.821,345.305,328.246,345.579,328.77,345.579z  M325.154,342.877c0-0.551-0.693-0.997-1.547-0.997c-0.855,0-1.547,0.446-1.547,0.997c0,0.497,0.566,0.906,1.304,0.982 c-0.037,0.061-0.059,0.126-0.059,0.196c0,0.294,0.37,0.532,0.825,0.532c0.456,0,0.825-0.238,0.825-0.532 c0-0.176-0.134-0.331-0.338-0.428C324.943,343.444,325.154,343.178,325.154,342.877z M326.097,336.769 c-0.587,0-1.063,0.307-1.063,0.685s0.476,0.685,1.063,0.685c0.587,0,1.063-0.307,1.063-0.685S326.684,336.769,326.097,336.769z  M332.316,344.296c-0.862,0-1.561,0.451-1.561,1.007s0.699,1.007,1.561,1.007c0.862,0,1.561-0.451,1.561-1.007 S333.178,344.296,332.316,344.296z M357.529,346.434c-0.859,0-1.555,0.449-1.555,1.003c0,0.17,0.072,0.328,0.188,0.468 c-0.378,0.152-0.63,0.421-0.63,0.729c0,0.476,0.599,0.862,1.337,0.862c0.738,0,1.337-0.386,1.337-0.862 c0-0.096-0.03-0.186-0.075-0.273c0.56-0.152,0.954-0.508,0.954-0.925C359.084,346.883,358.388,346.434,357.529,346.434z  M365.911,338.785c0-0.262-0.329-0.473-0.734-0.473c-0.406,0-0.734,0.212-0.734,0.473s0.329,0.473,0.734,0.473 C365.582,339.259,365.911,339.047,365.911,338.785z M318.555,341.315c0-0.398-0.501-0.721-1.118-0.721 c-0.618,0-1.118,0.323-1.118,0.721c0,0.398,0.501,0.721,1.118,0.721C318.054,342.036,318.555,341.713,318.555,341.315z  M363.577,340.33c0-0.251-0.316-0.455-0.706-0.455c-0.39,0-0.706,0.204-0.706,0.455c0,0.098,0.049,0.188,0.131,0.263 c-0.086-0.011-0.174-0.017-0.264-0.017c-0.753,0-1.363,0.393-1.363,0.879s0.61,0.879,1.363,0.879c0.753,0,1.363-0.393,1.363-0.879 c0-0.271-0.194-0.51-0.493-0.671C363.277,340.772,363.577,340.574,363.577,340.33z M314.005,342.436 c0.859,0,1.556-0.449,1.556-1.003c0-0.554-0.697-1.003-1.556-1.003s-1.556,0.449-1.556,1.003 C312.449,341.987,313.146,342.436,314.005,342.436z M362.543,333.536c-0.826,0-1.496,0.432-1.496,0.964 c0,0.532,0.669,0.964,1.496,0.964c0.826,0,1.495-0.432,1.495-0.964C364.038,333.967,363.369,333.536,362.543,333.536z  M354.834,346.928c0.65,0,1.176-0.339,1.176-0.758c0-0.419-0.526-0.758-1.176-0.758c-0.65,0-1.176,0.339-1.176,0.758 C353.658,346.589,354.185,346.928,354.834,346.928z M321.612,344.609c0-0.407-0.512-0.737-1.143-0.737 c-0.631,0-1.143,0.33-1.143,0.737c0,0.407,0.512,0.737,1.143,0.737C321.1,345.346,321.612,345.016,321.612,344.609z  M345.776,339.251c-0.397,0-0.719,0.207-0.719,0.463c0,0.256,0.322,0.463,0.719,0.463s0.719-0.207,0.719-0.463 C346.494,339.458,346.173,339.251,345.776,339.251z M384.307,338.578c-0.832,0-1.506,0.435-1.506,0.971 c0,0.536,0.674,0.971,1.506,0.971c0.832,0,1.506-0.435,1.506-0.971C385.813,339.013,385.139,338.578,384.307,338.578z  M348.189,333.379c0-0.226-0.284-0.409-0.634-0.409c-0.35,0-0.634,0.183-0.634,0.409c0,0.226,0.284,0.409,0.634,0.409 C347.905,333.788,348.189,333.605,348.189,333.379z M348.193,330.707c0-0.475-0.597-0.859-1.333-0.859 c-0.736,0-1.333,0.385-1.333,0.859c0,0.475,0.597,0.859,1.333,0.859C347.597,331.566,348.193,331.181,348.193,330.707z  M344.615,342.476c0-0.561-0.705-1.015-1.574-1.015c-0.869,0-1.574,0.454-1.574,1.015c0,0.56,0.705,1.015,1.574,1.015 C343.91,343.491,344.615,343.037,344.615,342.476z M335.005,333.687c0-0.4-0.503-0.725-1.124-0.725s-1.125,0.324-1.125,0.725 c0,0.4,0.504,0.725,1.125,0.725S335.005,334.087,335.005,333.687z M353.568,334.226c0.007,0,0.013,0.001,0.02,0.001 c0.741,0,1.342-0.387,1.342-0.865c0-0.478-0.601-0.865-1.342-0.865c-0.741,0-1.342,0.387-1.342,0.865 c0,0.185,0.092,0.356,0.245,0.496c-0.507,0.046-0.899,0.324-0.899,0.663c0,0.371,0.467,0.672,1.043,0.672s1.043-0.301,1.043-0.672 C353.678,334.415,353.636,334.316,353.568,334.226z M352.769,343.063c0-0.351-0.442-0.636-0.987-0.636 c-0.545,0-0.987,0.285-0.987,0.636c0,0.351,0.442,0.636,0.987,0.636C352.327,343.699,352.769,343.414,352.769,343.063z  M349.533,332.871c-0.7,0-1.267,0.366-1.267,0.817s0.567,0.817,1.267,0.817c0.7,0,1.267-0.366,1.267-0.817 S350.232,332.871,349.533,332.871z M339.15,333.08c0,0.383,0.481,0.693,1.075,0.693c0.594,0,1.075-0.31,1.075-0.693 c0-0.383-0.482-0.693-1.075-0.693c-0.092,0-0.181,0.01-0.267,0.024c0.289-0.111,0.485-0.312,0.485-0.545 c0-0.351-0.442-0.636-0.987-0.636c-0.545,0-0.987,0.285-0.987,0.636c0,0.351,0.442,0.636,0.987,0.636 c0.08,0,0.158-0.008,0.232-0.02C339.368,332.603,339.15,332.824,339.15,333.08z M337.984,340.326c-0.467,0-0.846,0.244-0.846,0.546 c0,0.301,0.379,0.546,0.846,0.546c0.467,0,0.846-0.244,0.846-0.546C338.83,340.57,338.451,340.326,337.984,340.326z  M348.869,345.053c-0.525,0-0.952,0.275-0.952,0.613s0.426,0.613,0.952,0.613c0.526,0,0.952-0.275,0.952-0.613 S349.395,345.053,348.869,345.053z M376.446,328.837c-0.268,0-0.485,0.14-0.485,0.313c0,0.173,0.217,0.313,0.485,0.313 c0.268,0,0.485-0.14,0.485-0.313C376.931,328.977,376.714,328.837,376.446,328.837z M375.931,335.542 c-0.519,0-0.94,0.271-0.94,0.606c0,0.335,0.421,0.606,0.94,0.606c0.519,0,0.94-0.271,0.94-0.606 C376.871,335.813,376.45,335.542,375.931,335.542z M379.385,329.367c-0.487,0-0.883,0.255-0.883,0.569 c0,0.314,0.395,0.569,0.883,0.569s0.883-0.255,0.883-0.569C380.268,329.622,379.872,329.367,379.385,329.367z M257.641,350.274 c0.74,0,1.339-0.387,1.339-0.863c0-0.477-0.599-0.863-1.339-0.863s-1.339,0.386-1.339,0.863 C256.302,349.887,256.901,350.274,257.641,350.274z M375.108,342.636c-0.265,0-0.479,0.138-0.479,0.309s0.214,0.309,0.479,0.309 c0.265,0,0.479-0.138,0.479-0.309S375.373,342.636,375.108,342.636z M283.326,333.638c-0.553,0-1.002,0.289-1.002,0.646 s0.448,0.646,1.002,0.646c0.553,0,1.002-0.289,1.002-0.646S283.879,333.638,283.326,333.638z M311.029,333.481 c-0.447,0-0.837,0.15-1.062,0.376c-0.141-0.051-0.301-0.083-0.475-0.083c-0.234,0-0.445,0.056-0.613,0.144 c-0.108-0.178-0.376-0.305-0.691-0.305c-0.089,0-0.173,0.012-0.252,0.03c-0.169-0.115-0.406-0.188-0.671-0.188 c-0.511,0-0.925,0.267-0.925,0.596s0.414,0.596,0.925,0.596c0.22,0,0.419-0.052,0.578-0.134c0.104,0.035,0.22,0.057,0.345,0.057 c0.128,0,0.246-0.023,0.351-0.059c0.083,0.292,0.477,0.513,0.953,0.513c0.245,0,0.466-0.06,0.637-0.157 c0.229,0.15,0.547,0.243,0.9,0.243c0.698,0,1.265-0.365,1.265-0.815S311.728,333.481,311.029,333.481z M381.859,342.369 c0-0.283-0.356-0.513-0.796-0.513c-0.439,0-0.795,0.229-0.795,0.513s0.356,0.513,0.795,0.513 C381.503,342.882,381.859,342.652,381.859,342.369z M280.872,343.268c0-0.309-0.389-0.56-0.869-0.56 c-0.48,0-0.869,0.251-0.869,0.56c0,0.309,0.389,0.56,0.869,0.56C280.483,343.828,280.872,343.577,280.872,343.268z M277.018,344.89 c-0.833,0-1.507,0.435-1.507,0.972c0,0.537,0.675,0.972,1.507,0.972c0.832,0,1.507-0.435,1.507-0.972 C278.525,345.325,277.85,344.89,277.018,344.89z M371.75,342.876c-0.478,0-0.865,0.25-0.865,0.557s0.387,0.557,0.865,0.557 c0.477,0,0.865-0.249,0.865-0.557S372.227,342.876,371.75,342.876z M284.783,331.667c0-0.564-0.709-1.021-1.585-1.021 c-0.875,0-1.584,0.457-1.584,1.021c0,0.564,0.709,1.021,1.584,1.021C284.074,332.688,284.783,332.231,284.783,331.667z  M381.889,335.127c-0.621,0-1.124,0.324-1.124,0.724c0,0.4,0.503,0.724,1.124,0.724s1.124-0.324,1.124-0.724 C383.013,335.452,382.51,335.127,381.889,335.127z M302.15,338.902c-0.598,0-1.083,0.313-1.083,0.698 c0,0.386,0.485,0.698,1.083,0.698c0.598,0,1.083-0.313,1.083-0.698C303.233,339.215,302.748,338.902,302.15,338.902z  M300.388,336.757c0-0.339-0.426-0.613-0.952-0.613c-0.526,0-0.952,0.275-0.952,0.613c0,0.339,0.426,0.613,0.952,0.613 C299.962,337.37,300.388,337.095,300.388,336.757z M298.564,337.981c-0.256,0-0.463,0.134-0.463,0.298s0.207,0.298,0.463,0.298 c0.256,0,0.463-0.134,0.463-0.298S298.819,337.981,298.564,337.981z M311.551,348.2c0-0.234-0.294-0.424-0.657-0.424 c-0.363,0-0.657,0.19-0.657,0.424c0,0.005,0.002,0.009,0.002,0.014c-0.238,0.103-0.394,0.278-0.394,0.477 c0,0.318,0.4,0.575,0.892,0.575c0.493,0,0.892-0.258,0.892-0.575c0-0.115-0.054-0.221-0.144-0.311 C311.527,348.326,311.551,348.265,311.551,348.2z M307.879,347.151c-0.447,0-0.809,0.234-0.809,0.522 c0,0.288,0.362,0.522,0.809,0.522c0.447,0,0.809-0.233,0.809-0.522C308.689,347.385,308.326,347.151,307.879,347.151z  M368.294,342.6c0,0.177,0.222,0.32,0.496,0.32c0.274,0,0.496-0.143,0.496-0.32c0-0.177-0.222-0.32-0.496-0.32 C368.516,342.281,368.294,342.424,368.294,342.6z M286.743,348.911c0-0.375-0.471-0.678-1.052-0.678s-1.052,0.304-1.052,0.678 c0,0.375,0.471,0.678,1.052,0.678S286.743,349.285,286.743,348.911z M288.078,348.058c-0.621,0-1.125,0.325-1.125,0.725 c0,0.4,0.503,0.725,1.125,0.725c0.621,0,1.124-0.324,1.124-0.725C289.202,348.383,288.699,348.058,288.078,348.058z  M291.714,338.475c0-0.497-0.625-0.9-1.395-0.9c-0.771,0-1.395,0.403-1.395,0.9s0.625,0.9,1.395,0.9 C291.089,339.375,291.714,338.972,291.714,338.475z M367.126,331.379c0.138,0.026,0.281,0.044,0.432,0.044 c0.7,0,1.285-0.301,1.478-0.712c0.128,0.039,0.269,0.062,0.42,0.062c0.55,0,0.997-0.288,0.997-0.642 c0-0.355-0.446-0.642-0.997-0.642c-0.317,0-0.596,0.097-0.779,0.246c-0.282-0.19-0.678-0.31-1.119-0.31 c-0.832,0-1.505,0.423-1.544,0.953c-0.253-0.145-0.583-0.235-0.948-0.235c-0.792,0-1.434,0.414-1.434,0.924 c0,0.359,0.321,0.667,0.784,0.82c-0.01,0.046-0.022,0.091-0.022,0.138c0,0.553,0.695,1.001,1.552,1.001s1.552-0.448,1.552-1.001 C367.5,331.777,367.356,331.554,367.126,331.379z M283.979,335.027c-0.442,0-0.801,0.231-0.801,0.516 c0,0.285,0.358,0.516,0.801,0.516c0.442,0,0.801-0.231,0.801-0.516C284.78,335.259,284.421,335.027,283.979,335.027z  M412.461,327.863c0,0.553,0.696,1.001,1.554,1.001c0.858,0,1.554-0.448,1.554-1.001s-0.696-1.001-1.554-1.001 C413.157,326.861,412.461,327.31,412.461,327.863z M378.071,328.092c-0.437,0-0.792,0.229-0.792,0.511 c0,0.282,0.355,0.51,0.792,0.51s0.792-0.229,0.792-0.51C378.863,328.321,378.508,328.092,378.071,328.092z M315.813,331.084 c0-0.17-0.214-0.308-0.478-0.308s-0.478,0.138-0.478,0.308c0,0.17,0.214,0.308,0.478,0.308S315.813,331.254,315.813,331.084z  M357.149,327.599c-0.256,0-0.463,0.133-0.463,0.298c0,0.165,0.207,0.298,0.463,0.298c0.255,0,0.463-0.134,0.463-0.298 C357.612,327.732,357.405,327.599,357.149,327.599z M382.656,329.235c-0.3,0-0.544,0.157-0.544,0.351 c0,0.193,0.243,0.35,0.544,0.35c0.3,0,0.544-0.157,0.544-0.35C383.199,329.392,382.956,329.235,382.656,329.235z M314.433,332.785 c-0.316,0-0.572,0.165-0.572,0.369c0,0.204,0.256,0.369,0.572,0.369c0.316,0,0.573-0.165,0.573-0.369 C315.005,332.95,314.749,332.785,314.433,332.785z M356.231,335.017c0.698,0,1.264-0.365,1.264-0.814 c0-0.45-0.566-0.815-1.264-0.815c-0.698,0-1.263,0.365-1.263,0.815C354.968,334.652,355.534,335.017,356.231,335.017z  M372.921,329.131c0-0.476-0.598-0.861-1.336-0.861c-0.738,0-1.336,0.386-1.336,0.861s0.598,0.861,1.336,0.861 C372.323,329.992,372.921,329.607,372.921,329.131z M355.918,331.418c0.327,0,0.593-0.171,0.593-0.382 c0-0.211-0.265-0.382-0.593-0.382c-0.327,0-0.593,0.171-0.593,0.382C355.326,331.247,355.591,331.418,355.918,331.418z  M320.892,337.183c0.339,0,0.615-0.177,0.615-0.396c0-0.219-0.275-0.396-0.615-0.396c-0.34,0-0.615,0.177-0.615,0.396 C320.278,337.006,320.553,337.183,320.892,337.183z M429.306,330.377c-0.816,0-1.478,0.427-1.478,0.953 c0,0.526,0.662,0.953,1.478,0.953c0.816,0,1.478-0.427,1.478-0.953C430.784,330.803,430.123,330.377,429.306,330.377z  M320.335,331.542c0,0.205,0.258,0.371,0.575,0.371c0.318,0,0.575-0.166,0.575-0.371s-0.258-0.371-0.575-0.371 C320.593,331.171,320.335,331.337,320.335,331.542z M343.581,330.043c0-0.383-0.482-0.694-1.076-0.694 c-0.594,0-1.076,0.311-1.076,0.694s0.482,0.694,1.076,0.694C343.099,330.737,343.581,330.426,343.581,330.043z M386.189,329.476 c-0.802,0-1.451,0.419-1.451,0.936c0,0.517,0.65,0.936,1.451,0.936c0.801,0,1.451-0.419,1.451-0.936 C387.641,329.895,386.991,329.476,386.189,329.476z M300.879,333.295c0,0.422,0.53,0.763,1.184,0.763 c0.654,0,1.184-0.342,1.184-0.763c0-0.422-0.53-0.764-1.184-0.764C301.409,332.531,300.879,332.873,300.879,333.295z  M383.919,328.757c0-0.29-0.365-0.526-0.815-0.526c-0.45,0-0.816,0.235-0.816,0.526c0,0.29,0.365,0.526,0.816,0.526 C383.554,329.283,383.919,329.048,383.919,328.757z M305.047,339.628c0.582,0,1.054-0.304,1.054-0.679 c0-0.375-0.472-0.679-1.054-0.679c-0.582,0-1.054,0.304-1.054,0.679C303.993,339.324,304.465,339.628,305.047,339.628z  M307.748,330.977c0-0.38-0.478-0.688-1.067-0.688c-0.589,0-1.067,0.308-1.067,0.688c0,0.38,0.478,0.688,1.067,0.688 C307.27,331.664,307.748,331.356,307.748,330.977z M391.839,327.295c0-0.235-0.295-0.425-0.66-0.425s-0.66,0.19-0.66,0.425 c0,0.235,0.295,0.425,0.66,0.425S391.839,327.53,391.839,327.295z M417.018,330.803c-0.104,0-0.203,0.012-0.299,0.028 c-0.102-0.022-0.209-0.036-0.323-0.036c-0.571,0-1.034,0.299-1.034,0.667c0,0.343,0.404,0.623,0.921,0.659 c0.2,0.107,0.454,0.174,0.734,0.174c0.639,0,1.157-0.334,1.157-0.746C418.175,331.137,417.657,330.803,417.018,330.803z  M304.732,335.261c0.301,0,0.545-0.157,0.545-0.351c0-0.194-0.244-0.351-0.545-0.351s-0.545,0.157-0.545,0.351 C304.186,335.104,304.431,335.261,304.732,335.261z M432.167,328.784c-0.587,0-1.063,0.307-1.063,0.685 c0,0.378,0.476,0.685,1.063,0.685c0.587,0,1.063-0.307,1.063-0.685C433.23,329.091,432.754,328.784,432.167,328.784z  M303.964,330.008c0-0.509-0.64-0.921-1.43-0.921c-0.789,0-1.429,0.413-1.429,0.921c0,0.509,0.64,0.922,1.429,0.922 C303.324,330.93,303.964,330.517,303.964,330.008z M370.125,333.038c0,0.179,0.225,0.324,0.502,0.324s0.502-0.145,0.502-0.324 c0-0.179-0.225-0.323-0.502-0.323S370.125,332.86,370.125,333.038z M375.067,328.962c0-0.241-0.302-0.436-0.676-0.436 c-0.373,0-0.676,0.195-0.676,0.436c0,0.241,0.303,0.436,0.676,0.436C374.765,329.398,375.067,329.203,375.067,328.962z  M420.212,340.922c-0.352,0-0.637,0.184-0.637,0.411c0,0.227,0.285,0.411,0.637,0.411c0.352,0,0.637-0.184,0.637-0.411 C420.849,341.106,420.563,340.922,420.212,340.922z M334.406,331.787c-0.278,0-0.503,0.145-0.503,0.324 c0,0.179,0.225,0.324,0.503,0.324c0.278,0,0.503-0.145,0.503-0.324C334.909,331.932,334.684,331.787,334.406,331.787z  M423.007,330.198c-0.727,0-1.316,0.38-1.316,0.848s0.589,0.848,1.316,0.848c0.727,0,1.316-0.38,1.316-0.848 S423.734,330.198,423.007,330.198z M426.039,328.98c-0.517,0-0.936,0.27-0.936,0.603s0.419,0.603,0.936,0.603 c0.517,0,0.936-0.27,0.936-0.603S426.556,328.98,426.039,328.98z M328.974,332.9c0.228,0.099,0.502,0.156,0.797,0.156 c0.792,0,1.433-0.414,1.433-0.924c0-0.51-0.642-0.924-1.433-0.924s-1.433,0.414-1.433,0.924c0,0.077,0.019,0.151,0.047,0.223 c-0.012,0.033-0.02,0.067-0.02,0.102C328.365,332.685,328.632,332.872,328.974,332.9z M332.609,332.153 c0-0.18-0.226-0.326-0.506-0.326c-0.279,0-0.506,0.146-0.506,0.326s0.226,0.326,0.506,0.326 C332.383,332.479,332.609,332.333,332.609,332.153z M331.666,334.475c0.413,0,0.748-0.216,0.748-0.482 c0-0.266-0.335-0.482-0.748-0.482c-0.413,0-0.748,0.216-0.748,0.482C330.919,334.259,331.253,334.475,331.666,334.475z  M361.737,332.12c0.875,0,1.584-0.457,1.584-1.021s-0.709-1.021-1.584-1.021c-0.685,0-1.262,0.281-1.484,0.674 c-0.119-0.204-0.422-0.349-0.78-0.349c-0.462,0-0.836,0.241-0.836,0.539s0.374,0.539,0.836,0.539c0.294,0,0.552-0.098,0.701-0.246 C360.278,331.733,360.934,332.12,361.737,332.12z M334.379,329.637c-0.384,0-0.695,0.201-0.695,0.448s0.311,0.448,0.695,0.448 c0.384,0,0.695-0.201,0.695-0.448S334.763,329.637,334.379,329.637z M358.423,332.959c0,0.367,0.462,0.665,1.031,0.665 c0.57,0,1.031-0.298,1.031-0.665c0-0.367-0.462-0.665-1.031-0.665C358.885,332.294,358.423,332.591,358.423,332.959z  M318.431,332.043c0.537,0,0.972-0.281,0.972-0.627c0-0.278-0.283-0.512-0.673-0.593c0.029-0.063,0.05-0.129,0.05-0.198 c0-0.387-0.486-0.7-1.086-0.7c-0.6,0-1.086,0.313-1.086,0.7c0,0.338,0.372,0.621,0.867,0.686c-0.009,0.035-0.017,0.07-0.017,0.106 C317.459,331.763,317.894,332.043,318.431,332.043z M335.179,334.991c0,0.552,0.693,0.999,1.549,0.999 c0.855,0,1.549-0.447,1.549-0.999c0-0.551-0.693-0.998-1.549-0.998C335.873,333.993,335.179,334.44,335.179,334.991z  M340.769,331.792c0,0.509,0.64,0.921,1.43,0.921c0.789,0,1.429-0.413,1.429-0.921c0-0.509-0.64-0.921-1.429-0.921 C341.409,330.871,340.769,331.283,340.769,331.792z M323.132,331.963c-0.627,0-1.135,0.328-1.135,0.732 c0,0.404,0.508,0.732,1.135,0.732s1.135-0.328,1.135-0.732C324.268,332.29,323.759,331.963,323.132,331.963z M337.357,330.645 c0.374,0,0.678-0.196,0.678-0.437c0-0.241-0.304-0.437-0.678-0.437c-0.375,0-0.678,0.196-0.678,0.437 C336.679,330.449,336.983,330.645,337.357,330.645z M374.067,333.672c0.668,0,1.209-0.349,1.209-0.78 c0-0.431-0.541-0.78-1.209-0.78s-1.209,0.349-1.209,0.78C372.858,333.323,373.399,333.672,374.067,333.672z M321.215,329.506 c0-0.491-0.617-0.889-1.379-0.889c-0.762,0-1.379,0.398-1.379,0.889s0.618,0.889,1.379,0.889 C320.598,330.395,321.215,329.997,321.215,329.506z M326.804,333.341c0.841,0,1.524-0.44,1.524-0.982 c0-0.542-0.682-0.982-1.524-0.982c-0.841,0-1.524,0.44-1.524,0.982C325.28,332.901,325.963,333.341,326.804,333.341z  M326.415,329.613c0-0.213-0.268-0.385-0.598-0.385c-0.33,0-0.597,0.172-0.597,0.385s0.268,0.385,0.597,0.385 C326.147,329.999,326.415,329.826,326.415,329.613z M323.261,329.214c-0.817,0-1.479,0.427-1.479,0.953 c0,0.422,0.428,0.776,1.017,0.901c0.058,0.233,0.368,0.411,0.745,0.411c0.418,0,0.757-0.219,0.757-0.488 c0-0.046-0.013-0.089-0.031-0.131c0.287-0.174,0.469-0.419,0.469-0.693C324.74,329.641,324.077,329.214,323.261,329.214z  M372.623,331.605c0.602,0,1.089-0.314,1.089-0.702c0-0.388-0.488-0.702-1.089-0.702s-1.089,0.314-1.089,0.702 C371.534,331.291,372.022,331.605,372.623,331.605z M305.059,331.771c-0.729,0-1.32,0.381-1.32,0.851 c0,0.47,0.591,0.851,1.32,0.851s1.32-0.381,1.32-0.851C306.38,332.152,305.789,331.771,305.059,331.771z M278.34,330.47 c0-0.376-0.472-0.68-1.055-0.68c-0.583,0-1.055,0.305-1.055,0.68c0,0.375,0.472,0.68,1.055,0.68 C277.868,331.15,278.34,330.845,278.34,330.47z M274.415,333.707c0,0.172,0.217,0.312,0.484,0.312c0.267,0,0.484-0.14,0.484-0.312 c0-0.172-0.217-0.312-0.484-0.312C274.632,333.395,274.415,333.535,274.415,333.707z M293.29,330.66 c0-0.539-0.678-0.976-1.514-0.976c-0.429,0-0.815,0.116-1.091,0.301c-0.698,0.101-1.22,0.501-1.22,0.982 c0,0.112,0.035,0.218,0.088,0.319c-0.157-0.045-0.329-0.071-0.511-0.071c-0.698,0-1.264,0.365-1.264,0.815 c0,0.45,0.566,0.815,1.264,0.815c0.698,0,1.264-0.365,1.264-0.815c0-0.065-0.015-0.127-0.037-0.188 c0.226,0.082,0.482,0.132,0.759,0.132c0.504,0,0.947-0.156,1.233-0.395C292.859,331.448,293.29,331.088,293.29,330.66z  M273.195,339.403c0,0.174,0.219,0.315,0.489,0.315c0.27,0,0.489-0.141,0.489-0.315s-0.219-0.315-0.489-0.315 C273.414,339.088,273.195,339.229,273.195,339.403z M276.954,333.769c0,0.215,0.27,0.389,0.604,0.389 c0.334,0,0.604-0.174,0.604-0.389c0-0.215-0.271-0.389-0.604-0.389C277.225,333.379,276.954,333.554,276.954,333.769z  M420.433,329.929c0-0.266-0.283-0.488-0.665-0.553c-0.064-0.02-0.134-0.033-0.21-0.033c-0.063,0-0.122,0.009-0.177,0.023 c-0.414,0.049-0.728,0.282-0.728,0.563c0,0.317,0.398,0.573,0.89,0.573S420.433,330.246,420.433,329.929z M280.821,336.462 c0,0.175,0.22,0.316,0.491,0.316c0.271,0,0.491-0.142,0.491-0.316c0-0.175-0.22-0.316-0.491-0.316 C281.041,336.146,280.821,336.287,280.821,336.462z M278.379,332.718c0-0.225-0.283-0.408-0.633-0.408 c-0.349,0-0.633,0.183-0.633,0.408c0,0.225,0.283,0.408,0.633,0.408C278.096,333.126,278.379,332.943,278.379,332.718z  M267.996,331.081c-0.179,0-0.341,0.047-0.46,0.121c-0.301,0.072-0.517,0.257-0.517,0.476c0,0.281,0.353,0.509,0.789,0.509 s0.789-0.228,0.789-0.509c0-0.001,0-0.001,0-0.002c0.036-0.052,0.056-0.11,0.056-0.171 C268.654,331.271,268.36,331.081,267.996,331.081z M412.128,335.09c0-0.42-0.528-0.761-1.18-0.761c-0.652,0-1.18,0.341-1.18,0.761 c0,0.42,0.528,0.761,1.18,0.761C411.599,335.851,412.128,335.51,412.128,335.09z M411.706,341.369c-0.337,0-0.61,0.176-0.61,0.393 c0,0.217,0.273,0.393,0.61,0.393c0.337,0,0.61-0.176,0.61-0.393C412.316,341.545,412.043,341.369,411.706,341.369z  M256.981,333.507c-0.514,0-0.931,0.269-0.931,0.6s0.417,0.6,0.931,0.6c0.514,0,0.931-0.269,0.931-0.6 S257.495,333.507,256.981,333.507z M265.515,333.53c-0.486,0-0.879,0.254-0.879,0.567c0,0.313,0.394,0.567,0.879,0.567 c0.486,0,0.879-0.254,0.879-0.567C266.394,333.784,266.001,333.53,265.515,333.53z M404.887,329.546 c0,0.533,0.67,0.965,1.496,0.965c0.826,0,1.496-0.432,1.496-0.965c0-0.533-0.67-0.964-1.496-0.964 C405.557,328.581,404.887,329.013,404.887,329.546z M265.529,331.807c-0.617,0-1.117,0.322-1.117,0.72s0.5,0.72,1.117,0.72 s1.117-0.322,1.117-0.72S266.145,331.807,265.529,331.807z M405.696,331.875c0-0.154-0.085-0.294-0.221-0.407 c0-0.007,0.003-0.013,0.003-0.019c0-0.545-0.685-0.987-1.531-0.987c-0.562,0-1.047,0.197-1.314,0.488 c-0.136-0.28-0.537-0.484-1.015-0.484c-0.59,0-1.069,0.309-1.069,0.689c0,0.381,0.479,0.689,1.069,0.689 c0.332,0,0.624-0.099,0.82-0.252c0.108,0.477,0.739,0.844,1.509,0.844c0.049,0,0.095-0.006,0.143-0.009 c0.164,0.071,0.362,0.113,0.575,0.113C405.235,332.539,405.696,332.242,405.696,331.875z M280.339,332.521 c-0.567,0-1.026,0.296-1.026,0.661c0,0.365,0.459,0.661,1.026,0.661c0.567,0,1.026-0.296,1.026-0.661 C281.365,332.817,280.905,332.521,280.339,332.521z M268.585,333.798c0.26,0,0.471-0.136,0.471-0.304 c0-0.168-0.211-0.304-0.471-0.304c-0.26,0-0.471,0.136-0.471,0.304C268.113,333.662,268.324,333.798,268.585,333.798z  M408.839,339.56c-0.271,0-0.49,0.141-0.49,0.316c0,0.174,0.219,0.316,0.49,0.316s0.49-0.141,0.49-0.316 C409.329,339.702,409.109,339.56,408.839,339.56z M409.046,332.925c0.634,0,1.149-0.332,1.149-0.741 c0-0.409-0.514-0.741-1.149-0.741c-0.447,0-0.83,0.166-1.02,0.407c-0.487,0.027-0.87,0.287-0.87,0.607 c0,0.338,0.425,0.612,0.95,0.612c0.255,0,0.485-0.066,0.656-0.171C408.853,332.914,408.947,332.925,409.046,332.925z  M395.506,330.328c-0.785,0-1.422,0.41-1.422,0.917c0,0.506,0.637,0.917,1.422,0.917c0.785,0,1.422-0.411,1.422-0.917 C396.928,330.739,396.291,330.328,395.506,330.328z M406.476,343.708c-0.734,0-1.328,0.383-1.328,0.856 c0,0.473,0.595,0.856,1.328,0.856c0.733,0,1.328-0.383,1.328-0.856C407.804,344.091,407.21,343.708,406.476,343.708z  M271.517,334.016c0,0.191,0.24,0.345,0.536,0.345c0.296,0,0.536-0.155,0.536-0.345c0-0.191-0.24-0.346-0.536-0.346 C271.757,333.67,271.517,333.825,271.517,334.016z M285.571,333.269c-0.441,0-0.799,0.23-0.799,0.515s0.358,0.515,0.799,0.515 s0.799-0.231,0.799-0.515S286.012,333.269,285.571,333.269z M293.729,333.439c-0.079,0.066-0.128,0.147-0.128,0.237 c0,0.216,0.271,0.391,0.606,0.391s0.606-0.175,0.606-0.391c0-0.092-0.051-0.175-0.133-0.241c0.577-0.13,0.994-0.481,0.994-0.897 c0-0.527-0.663-0.954-1.48-0.954c-0.818,0-1.48,0.427-1.48,0.954C292.713,332.959,293.14,333.313,293.729,333.439z  M345.729,332.743c0-0.216-0.272-0.392-0.607-0.392c-0.335,0-0.607,0.175-0.607,0.392c0,0.216,0.272,0.392,0.607,0.392 C345.457,333.135,345.729,332.959,345.729,332.743z M389.959,330.133c0-0.243-0.306-0.441-0.684-0.441 c-0.378,0-0.684,0.197-0.684,0.441c0,0.243,0.306,0.441,0.684,0.441C389.653,330.574,389.959,330.377,389.959,330.133z  M351.968,328.621c0-0.243-0.305-0.44-0.682-0.44c-0.377,0-0.682,0.197-0.682,0.44c0,0.243,0.305,0.44,0.682,0.44 C351.662,329.061,351.968,328.864,351.968,328.621z M294.127,342.459c0.525,0,0.95-0.274,0.95-0.612 c0-0.338-0.425-0.612-0.95-0.612c-0.524,0-0.95,0.274-0.95,0.612C293.177,342.185,293.602,342.459,294.127,342.459z  M299.257,333.04c0.696,0,1.26-0.364,1.26-0.812c0-0.449-0.564-0.812-1.26-0.812s-1.26,0.364-1.26,0.812 C297.997,332.676,298.561,333.04,299.257,333.04z M344.522,333.638c-0.354,0-0.642,0.185-0.642,0.414 c0,0.228,0.287,0.413,0.642,0.413c0.354,0,0.641-0.185,0.641-0.413C345.164,333.823,344.877,333.638,344.522,333.638z  M417.095,336.346c-0.523,0-0.947,0.273-0.947,0.611s0.424,0.611,0.947,0.611c0.523,0,0.947-0.273,0.947-0.611 S417.618,336.346,417.095,336.346z M291.365,333.49c-0.638,0-1.156,0.334-1.156,0.745c0,0.411,0.518,0.745,1.156,0.745 c0.638,0,1.156-0.334,1.156-0.745C292.521,333.824,292.003,333.49,291.365,333.49z M286.847,335.253 c0.402,0,0.744-0.162,0.883-0.389c0.2,0.059,0.42,0.093,0.654,0.093c0.874,0,1.582-0.457,1.582-1.02c0-0.563-0.708-1.02-1.582-1.02 s-1.582,0.457-1.582,1.02c0,0.032,0.01,0.061,0.014,0.092c-0.51,0.011-0.92,0.279-0.92,0.611 C285.896,334.978,286.322,335.253,286.847,335.253z M414.543,331.003c0-0.441-0.554-0.798-1.238-0.798 c-0.123,0-0.24,0.015-0.352,0.037c0.072-0.099,0.115-0.208,0.115-0.325c0-0.427-0.537-0.772-1.199-0.772 c-0.662,0-1.198,0.346-1.198,0.772s0.537,0.772,1.198,0.772c0.113,0,0.221-0.013,0.325-0.032c-0.079,0.105-0.127,0.222-0.127,0.346 c0,0.441,0.554,0.798,1.238,0.798C413.989,331.801,414.543,331.444,414.543,331.003z M390.09,332.957 c0.753,0,1.362-0.393,1.362-0.878c0-0.485-0.61-0.878-1.362-0.878c-0.753,0-1.363,0.393-1.363,0.878 C388.727,332.564,389.337,332.957,390.09,332.957z M296.639,333.955c0.42,0,0.761-0.22,0.761-0.49c0-0.271-0.341-0.49-0.761-0.49 s-0.761,0.22-0.761,0.49C295.878,333.735,296.219,333.955,296.639,333.955z M349.441,331.314c0,0.399,0.501,0.722,1.12,0.722 c0.618,0,1.12-0.323,1.12-0.722c0-0.399-0.501-0.722-1.12-0.722C349.942,330.592,349.441,330.915,349.441,331.314z  M296.849,334.812c-0.658,0-1.191,0.344-1.191,0.768c0,0.424,0.533,0.768,1.191,0.768c0.658,0,1.191-0.344,1.191-0.768 C298.041,335.156,297.507,334.812,296.849,334.812z M256.747,337.78c0,0.263,0.331,0.476,0.739,0.476s0.739-0.213,0.739-0.476 s-0.331-0.476-0.739-0.476S256.747,337.517,256.747,337.78z M395.256,335.489c-0.704,0-1.276,0.368-1.276,0.822 c0,0.454,0.571,0.822,1.276,0.822s1.276-0.368,1.276-0.822C396.532,335.857,395.96,335.489,395.256,335.489z M414.636,339.283 c-0.409,0-0.741,0.214-0.741,0.478c0,0.264,0.332,0.478,0.741,0.478s0.741-0.214,0.741-0.478 C415.376,339.497,415.045,339.283,414.636,339.283z M296.367,340.677c0.846,0,1.533-0.442,1.533-0.988 c0-0.546-0.686-0.988-1.533-0.988c-0.846,0-1.533,0.442-1.533,0.988C294.835,340.234,295.521,340.677,296.367,340.677z  M31.69,370.133c0-0.556-0.699-1.007-1.562-1.007c-0.862,0-1.562,0.451-1.562,1.007c0,0.556,0.699,1.007,1.562,1.007 C30.991,371.139,31.69,370.689,31.69,370.133z M27.685,378.648c-0.572,0-1.036,0.299-1.036,0.667c0,0.369,0.464,0.668,1.036,0.668 c0.572,0,1.035-0.299,1.035-0.668C28.72,378.947,28.257,378.648,27.685,378.648z M28.603,361.091c0-0.427-0.537-0.773-1.2-0.773 c-0.663,0-1.2,0.346-1.2,0.773c0,0.427,0.537,0.773,1.2,0.773C28.066,361.865,28.603,361.518,28.603,361.091z M24.926,357.959 c0.129,0.026,0.264,0.044,0.407,0.044c0.755,0,1.366-0.394,1.366-0.881c0-0.486-0.612-0.881-1.366-0.881 c-0.51,0-0.95,0.182-1.185,0.45c-0.158-0.039-0.328-0.062-0.507-0.062c-0.792,0-1.435,0.414-1.435,0.925 c0,0.511,0.642,0.925,1.435,0.925C24.207,358.479,24.692,358.266,24.926,357.959z M38.509,375.922c0.6,0,1.087-0.314,1.087-0.7 s-0.486-0.7-1.087-0.7c-0.6,0-1.086,0.314-1.086,0.7S37.909,375.922,38.509,375.922z M36.613,367.979 c-0.536,0-0.97,0.28-0.97,0.625s0.434,0.625,0.97,0.625c0.536,0,0.97-0.28,0.97-0.625S37.149,367.979,36.613,367.979z  M-13.572,356.315c-0.296,0-0.536,0.155-0.536,0.345c0,0.191,0.24,0.345,0.536,0.345c0.296,0,0.535-0.155,0.535-0.345 C-13.036,356.47-13.276,356.315-13.572,356.315z M36.112,361.188c0-0.196-0.246-0.354-0.55-0.354c-0.303,0-0.549,0.159-0.549,0.354 c0,0.196,0.246,0.354,0.549,0.354C35.866,361.542,36.112,361.383,36.112,361.188z M36.198,375.592 c-0.543,0-0.983,0.284-0.983,0.633c0,0.35,0.44,0.634,0.983,0.634c0.543,0,0.983-0.284,0.983-0.634 C37.18,375.876,36.741,375.592,36.198,375.592z M352.277,354.033c-0.298,0-0.541,0.156-0.541,0.349 c0,0.192,0.242,0.348,0.541,0.348c0.299,0,0.541-0.156,0.541-0.348C352.818,354.189,352.576,354.033,352.277,354.033z  M39.01,380.419c-0.848,0-1.535,0.443-1.535,0.99s0.687,0.99,1.535,0.99s1.535-0.443,1.535-0.99S39.858,380.419,39.01,380.419z  M45.427,376.612c0-0.34-0.427-0.615-0.954-0.615s-0.954,0.275-0.954,0.615c0,0.34,0.427,0.615,0.954,0.615 S45.427,376.952,45.427,376.612z M40.458,372.75c-0.731,0-1.324,0.382-1.324,0.853c0,0.471,0.593,0.853,1.324,0.853 c0.731,0,1.324-0.382,1.324-0.853C41.782,373.132,41.189,372.75,40.458,372.75z M349.049,357.337c-0.332,0-0.601,0.173-0.601,0.388 c0,0.214,0.269,0.387,0.601,0.387s0.601-0.173,0.601-0.387C349.65,357.511,349.381,357.337,349.049,357.337z M44.243,347.984 c0-0.434-0.546-0.786-1.219-0.786c-0.673,0-1.219,0.352-1.219,0.786c0,0.434,0.546,0.786,1.219,0.786 C43.698,348.77,44.243,348.418,44.243,347.984z M-25.959,380.941c-0.794,0-1.437,0.415-1.437,0.927 c0,0.512,0.643,0.927,1.437,0.927c0.794,0,1.437-0.415,1.437-0.927C-24.521,381.355-25.165,380.941-25.959,380.941z  M43.963,366.756c0,0.507,0.638,0.919,1.425,0.919c0.787,0,1.425-0.411,1.425-0.919c0-0.507-0.638-0.919-1.425-0.919 C44.601,365.837,43.963,366.249,43.963,366.756z M365.536,344.502c-0.296,0-0.535,0.155-0.535,0.345 c0,0.191,0.24,0.345,0.535,0.345c0.296,0,0.535-0.154,0.535-0.345C366.072,344.656,365.832,344.502,365.536,344.502z  M31.317,383.214c-0.674,0-1.22,0.352-1.22,0.787c0,0.435,0.546,0.787,1.22,0.787s1.221-0.352,1.221-0.787 C32.537,383.566,31.991,383.214,31.317,383.214z M46.338,346.858c0.371,0,0.671-0.194,0.671-0.433c0-0.239-0.3-0.433-0.671-0.433 s-0.671,0.194-0.671,0.433C45.667,346.664,45.968,346.858,46.338,346.858z M33.208,382.519c-0.488,0-0.884,0.255-0.884,0.57 c0,0.315,0.396,0.57,0.884,0.57c0.488,0,0.884-0.255,0.884-0.57C34.091,382.774,33.696,382.519,33.208,382.519z M40.359,345.965 c-0.475,0-0.861,0.248-0.861,0.555s0.385,0.555,0.861,0.555c0.476,0,0.861-0.248,0.861-0.555S40.835,345.965,40.359,345.965z  M37.311,349.861c-0.803,0-1.455,0.42-1.455,0.938c0,0.518,0.651,0.938,1.455,0.938c0.803,0,1.455-0.42,1.455-0.938 C38.766,350.281,38.115,349.861,37.311,349.861z M360.029,343.832c-0.81,0-1.467,0.423-1.467,0.946 c0,0.491,0.582,0.889,1.323,0.936c-0.069,0.059-0.112,0.132-0.112,0.212c0,0.195,0.245,0.353,0.548,0.353 c0.303,0,0.548-0.158,0.548-0.353c0-0.12-0.093-0.225-0.235-0.289c0.507-0.149,0.861-0.477,0.861-0.859 C361.496,344.255,360.839,343.832,360.029,343.832z M354.596,349.871c-0.368,0-0.666,0.192-0.666,0.429 c0,0.237,0.298,0.429,0.666,0.429c0.368,0,0.665-0.192,0.665-0.429C355.262,350.063,354.964,349.871,354.596,349.871z  M32.539,378.812c0-0.542-0.682-0.981-1.522-0.981c-0.841,0-1.522,0.439-1.522,0.981s0.681,0.981,1.522,0.981 C31.858,379.793,32.539,379.354,32.539,378.812z M25.14,377.451c-0.481,0-0.87,0.251-0.87,0.561c0,0.31,0.39,0.561,0.87,0.561 c0.481,0,0.87-0.251,0.87-0.561C26.01,377.702,25.621,377.451,25.14,377.451z M-3.908,382.326c-0.668,0-1.21,0.349-1.21,0.78 s0.542,0.78,1.21,0.78c0.668,0,1.21-0.349,1.21-0.78S-3.24,382.326-3.908,382.326z M-6.456,383.603 c-0.769,0-1.393,0.402-1.393,0.898s0.624,0.898,1.393,0.898c0.769,0,1.393-0.402,1.393-0.898S-5.687,383.603-6.456,383.603z  M-4.125,371.233c-0.856,0-1.551,0.448-1.551,1c0,0.552,0.694,1,1.551,1c0.856,0,1.551-0.448,1.551-1 C-2.574,371.68-3.268,371.233-4.125,371.233z M-3.747,349.695c0-0.46-0.579-0.833-1.293-0.833s-1.293,0.373-1.293,0.833 c0,0.46,0.579,0.833,1.293,0.833S-3.747,350.155-3.747,349.695z M-6.481,374.33c0,0.177,0.222,0.32,0.497,0.32 c0.274,0,0.497-0.143,0.497-0.32c0-0.177-0.223-0.32-0.497-0.32C-6.259,374.009-6.481,374.153-6.481,374.33z M0.18,373.973 c0-0.278-0.35-0.503-0.781-0.503c-0.431,0-0.781,0.225-0.781,0.503c0,0.278,0.35,0.503,0.781,0.503 C-0.17,374.477,0.18,374.251,0.18,373.973z M1.334,385.562c-0.682,0-1.234,0.356-1.234,0.796s0.553,0.796,1.234,0.796 c0.682,0,1.234-0.356,1.234-0.796S2.016,385.562,1.334,385.562z M-11.676,380.729c-0.878,0-1.589,0.459-1.589,1.025 c0,0.566,0.712,1.025,1.589,1.025c0.878,0,1.589-0.459,1.589-1.025C-10.086,381.188-10.798,380.729-11.676,380.729z M1.404,378.691 c-0.805,0-1.458,0.421-1.458,0.94c0,0.519,0.653,0.94,1.458,0.94c0.805,0,1.458-0.421,1.458-0.94 C2.861,379.112,2.209,378.691,1.404,378.691z M5.429,373.294c0-0.364-0.457-0.658-1.021-0.658c-0.564,0-1.021,0.295-1.021,0.658 c0,0.364,0.457,0.659,1.021,0.659C4.972,373.952,5.429,373.658,5.429,373.294z M2.97,377.663c-0.366,0-0.663,0.191-0.663,0.427 c0,0.236,0.297,0.427,0.663,0.427c0.366,0,0.663-0.191,0.663-0.427C3.633,377.854,3.336,377.663,2.97,377.663z M-14.214,393.543 c-0.862,0-1.561,0.451-1.561,1.007c0,0.556,0.699,1.006,1.561,1.006c0.862,0,1.561-0.451,1.561-1.006 C-12.653,393.994-13.352,393.543-14.214,393.543z M-10.232,370.022c-0.31,0-0.562,0.162-0.562,0.362c0,0.2,0.252,0.362,0.562,0.362 c0.31,0,0.562-0.162,0.562-0.362C-9.67,370.184-9.922,370.022-10.232,370.022z M7.654,356.731c-0.484,0-0.876,0.253-0.876,0.565 c0,0.312,0.392,0.565,0.876,0.565s0.876-0.253,0.876-0.565C8.531,356.984,8.138,356.731,7.654,356.731z M7.511,372.462 c0.464,0,0.84-0.242,0.84-0.541c0-0.299-0.376-0.541-0.84-0.541c-0.464,0-0.84,0.242-0.84,0.541 C6.671,372.22,7.047,372.462,7.511,372.462z M21.727,365.016c-0.497,0-0.899,0.259-0.899,0.58c0,0.32,0.403,0.58,0.899,0.58 s0.899-0.26,0.899-0.58C22.627,365.275,22.224,365.016,21.727,365.016z M9.412,349.845c-0.375,0-0.68,0.196-0.68,0.438 s0.304,0.438,0.68,0.438c0.375,0,0.68-0.196,0.68-0.438S9.787,349.845,9.412,349.845z M392.255,345.338 c-0.036,0-0.071,0.003-0.106,0.007c0.091-0.118,0.147-0.249,0.147-0.389c0-0.485-0.61-0.878-1.362-0.878 c-0.752,0-1.362,0.393-1.362,0.878c0,0.116,0.037,0.226,0.1,0.327c-0.595,0.059-1.052,0.387-1.052,0.787 c0,0.441,0.555,0.799,1.239,0.799c0.684,0,1.239-0.358,1.239-0.799c0-0.085-0.026-0.165-0.064-0.242 c0.218-0.01,0.42-0.053,0.598-0.121c-0.002,0.013-0.006,0.025-0.006,0.038c0,0.224,0.282,0.406,0.629,0.406 c0.347,0,0.629-0.182,0.629-0.406C392.884,345.52,392.602,345.338,392.255,345.338z M12.837,365.845 c-0.44,0-0.796,0.23-0.796,0.513c0,0.283,0.357,0.513,0.796,0.513c0.44,0,0.796-0.23,0.796-0.513 C13.634,366.075,13.277,365.845,12.837,365.845z M10.664,346.56c0,0.385,0.484,0.697,1.081,0.697c0.597,0,1.082-0.312,1.082-0.697 s-0.484-0.697-1.082-0.697C11.148,345.863,10.664,346.175,10.664,346.56z M398.023,342.326c-0.4,0-0.723,0.209-0.723,0.466 c0,0.257,0.324,0.466,0.723,0.466c0.399,0,0.723-0.209,0.723-0.466C398.746,342.535,398.422,342.326,398.023,342.326z  M-7.448,357.981c0.767,0,1.389-0.401,1.389-0.896c0-0.495-0.622-0.896-1.389-0.896c-0.385,0-0.733,0.101-0.984,0.264 c-0.113-0.069-0.253-0.119-0.409-0.145c0-0.006,0.003-0.011,0.003-0.017c0-0.517-0.65-0.936-1.453-0.936 c-0.802,0-1.453,0.419-1.453,0.936c0,0.517,0.65,0.936,1.453,0.936c0.147,0,0.285-0.018,0.419-0.044 c0.16,0.179,0.457,0.301,0.801,0.301c0.123,0,0.24-0.016,0.348-0.044C-8.509,357.758-8.019,357.981-7.448,357.981z M-1.7,347.437 c-0.661,0-1.198,0.346-1.198,0.772c0,0.426,0.536,0.772,1.198,0.772c0.661,0,1.198-0.346,1.198-0.772 C-0.503,347.783-1.039,347.437-1.7,347.437z M1.031,349.871c-0.342,0-0.62,0.179-0.62,0.399c0,0.221,0.277,0.399,0.62,0.399 c0.342,0,0.62-0.179,0.62-0.399C1.651,350.05,1.373,349.871,1.031,349.871z M395.989,349.68c-0.783,0-1.417,0.409-1.417,0.914 c0,0.504,0.634,0.913,1.417,0.913c0.783,0,1.417-0.409,1.417-0.913C397.406,350.089,396.772,349.68,395.989,349.68z M3.301,350.264 c0.873,0,1.581-0.456,1.581-1.019s-0.708-1.019-1.581-1.019c-0.873,0-1.581,0.456-1.581,1.019S2.428,350.264,3.301,350.264z  M5.433,380.545c-0.571,0-1.034,0.299-1.034,0.667c0,0.368,0.463,0.667,1.034,0.667c0.571,0,1.034-0.298,1.034-0.667 C6.467,380.843,6.004,380.545,5.433,380.545z M45.473,381.946c-0.76,0-1.376,0.397-1.376,0.887c0,0.49,0.616,0.887,1.376,0.887 c0.76,0,1.376-0.397,1.376-0.887C46.849,382.344,46.233,381.946,45.473,381.946z M376.182,347.865 c-0.328,0-0.594,0.172-0.594,0.383c0,0.212,0.266,0.383,0.594,0.383c0.328,0,0.595-0.172,0.595-0.383 C376.776,348.037,376.51,347.865,376.182,347.865z M371.749,341.24c0-0.471-0.593-0.853-1.323-0.853s-1.323,0.382-1.323,0.853 c0,0.471,0.592,0.853,1.323,0.853S371.749,341.711,371.749,341.24z M7.492,378.09c-0.544,0-0.986,0.285-0.986,0.636 s0.441,0.635,0.986,0.635c0.544,0,0.986-0.284,0.986-0.635S8.037,378.09,7.492,378.09z M-16.792,379.292 c0,0.176,0.221,0.319,0.495,0.319c0.273,0,0.494-0.143,0.494-0.319c0-0.176-0.221-0.319-0.494-0.319 C-16.571,378.974-16.792,379.116-16.792,379.292z M-17.839,384.082c0,0.441,0.555,0.799,1.24,0.799s1.24-0.358,1.24-0.799 s-0.555-0.799-1.24-0.799S-17.839,383.64-17.839,384.082z M373.617,344.082c-0.63,0-1.14,0.329-1.14,0.735 c0,0.406,0.511,0.735,1.14,0.735c0.63,0,1.14-0.329,1.14-0.735C374.757,344.411,374.246,344.082,373.617,344.082z M19.727,377.194 c-0.319,0-0.577,0.167-0.577,0.372c0,0.206,0.259,0.372,0.577,0.372c0.319,0,0.577-0.167,0.577-0.372 C20.304,377.361,20.046,377.194,19.727,377.194z M21.555,374.82c0.133-0.088,0.215-0.207,0.215-0.34 c0-0.269-0.338-0.487-0.755-0.487c-0.417,0-0.755,0.218-0.755,0.487c0,0.25,0.294,0.454,0.67,0.481 c-0.072,0.063-0.116,0.14-0.116,0.224c0,0.21,0.264,0.38,0.59,0.38c0.326,0,0.59-0.17,0.59-0.38 C21.994,375.01,21.807,374.863,21.555,374.82z M16.6,347.193c0,0.349,0.438,0.631,0.979,0.631c0.541,0,0.979-0.283,0.979-0.631 c0-0.349-0.439-0.631-0.979-0.631C17.039,346.562,16.6,346.844,16.6,347.193z M20.558,352.09c-0.42,0-0.76,0.219-0.76,0.49 c0,0.271,0.34,0.49,0.76,0.49c0.42,0,0.76-0.219,0.76-0.49C21.318,352.309,20.978,352.09,20.558,352.09z M368.476,343.95 c-0.78,0-1.413,0.408-1.413,0.911s0.633,0.911,1.413,0.911s1.413-0.408,1.413-0.911S369.256,343.95,368.476,343.95z  M28.141,354.674c0,0.485,0.61,0.878,1.363,0.878c0.753,0,1.363-0.393,1.363-0.878c0-0.485-0.61-0.878-1.363-0.878 C28.751,353.795,28.141,354.189,28.141,354.674z M12.885,375.143c-0.67,0-1.214,0.35-1.214,0.783s0.543,0.783,1.214,0.783 s1.214-0.35,1.214-0.783S13.555,375.143,12.885,375.143z M11.595,380.114c-0.572,0-1.036,0.299-1.036,0.668 s0.464,0.668,1.036,0.668s1.036-0.299,1.036-0.668S12.167,380.114,11.595,380.114z M-16.652,394.698 c-0.68,0-1.232,0.355-1.232,0.794s0.551,0.794,1.232,0.794s1.232-0.355,1.232-0.794S-15.972,394.698-16.652,394.698z  M16.212,377.106c-0.66,0-1.195,0.345-1.195,0.77c0,0.425,0.535,0.77,1.195,0.77c0.66,0,1.194-0.345,1.194-0.77 C17.406,377.451,16.872,377.106,16.212,377.106z M386.177,340.127c-0.343,0-0.621,0.179-0.621,0.4s0.278,0.4,0.621,0.4 c0.343,0,0.62-0.179,0.62-0.4S386.52,340.127,386.177,340.127z M11.902,369.943c0-0.416-0.523-0.753-1.167-0.753 c-0.645,0-1.167,0.337-1.167,0.753c0,0.416,0.523,0.753,1.167,0.753C11.379,370.696,11.902,370.359,11.902,369.943z  M-17.524,348.83c-0.263,0-0.476,0.137-0.476,0.307c0,0.17,0.213,0.307,0.476,0.307s0.476-0.137,0.476-0.307 C-17.047,348.967-17.26,348.83-17.524,348.83z M381.657,351.21c-0.548,0-0.992,0.286-0.992,0.639c0,0.353,0.444,0.639,0.992,0.639 c0.548,0,0.992-0.286,0.992-0.639C382.648,351.496,382.204,351.21,381.657,351.21z M30.581,366.475c0,0.255,0.32,0.462,0.716,0.462 s0.716-0.207,0.716-0.462c0-0.255-0.32-0.461-0.716-0.461S30.581,366.22,30.581,366.475z M384.069,341.098 c-0.633,0-1.146,0.331-1.146,0.739s0.513,0.739,1.146,0.739c0.633,0,1.146-0.331,1.146-0.739S384.703,341.098,384.069,341.098z  M16.265,359.21c-0.854,0-1.546,0.446-1.546,0.996c0,0.55,0.692,0.997,1.546,0.997c0.854,0,1.546-0.446,1.546-0.997 C17.811,359.656,17.119,359.21,16.265,359.21z M17.065,367.188c0-0.276-0.347-0.5-0.776-0.5c-0.428,0-0.776,0.224-0.776,0.5 c0,0.276,0.347,0.5,0.776,0.5C16.717,367.688,17.065,367.464,17.065,367.188z M78.913,350.392c0,0.312,0.392,0.565,0.877,0.565 c0.484,0,0.877-0.253,0.877-0.565c0-0.312-0.392-0.565-0.877-0.565C79.305,349.827,78.913,350.08,78.913,350.392z M243.58,362.158 c-0.714,0-1.293,0.373-1.293,0.833c0,0.46,0.579,0.833,1.293,0.833c0.714,0,1.293-0.373,1.293-0.833 C244.872,362.531,244.294,362.158,243.58,362.158z M226.329,355.669c-0.615,0-1.114,0.322-1.114,0.718s0.499,0.718,1.114,0.718 c0.615,0,1.114-0.322,1.114-0.718S226.944,355.669,226.329,355.669z M252.058,358.636c-0.601,0-1.089,0.314-1.089,0.702 c0,0.388,0.487,0.702,1.089,0.702c0.601,0,1.089-0.314,1.089-0.702C253.147,358.95,252.66,358.636,252.058,358.636z  M119.985,366.472c-0.656,0-1.187,0.343-1.187,0.765c0,0.423,0.532,0.765,1.187,0.765c0.656,0,1.187-0.343,1.187-0.765 C121.172,366.815,120.64,366.472,119.985,366.472z M248.046,352.832c-0.603,0-1.091,0.315-1.091,0.704 c0,0.388,0.489,0.703,1.091,0.703c0.603,0,1.091-0.315,1.091-0.703C249.137,353.147,248.648,352.832,248.046,352.832z  M117.777,367.058c-0.479,0-0.867,0.25-0.867,0.559s0.388,0.559,0.867,0.559s0.867-0.25,0.867-0.559 S118.255,367.058,117.777,367.058z M235.689,352.07c-0.589,0-1.066,0.308-1.066,0.687c0,0.38,0.477,0.688,1.066,0.688 c0.589,0,1.066-0.308,1.066-0.688C236.756,352.378,236.278,352.07,235.689,352.07z M245.809,358.77 c-0.737,0-1.335,0.385-1.335,0.861c0,0.475,0.598,0.861,1.335,0.861c0.737,0,1.335-0.385,1.335-0.861 C247.144,359.155,246.546,358.77,245.809,358.77z M135.31,358.073c-0.529,0-0.958,0.276-0.958,0.618s0.429,0.618,0.958,0.618 c0.529,0,0.958-0.277,0.958-0.618S135.839,358.073,135.31,358.073z M134.15,366.496c-0.723,0-1.309,0.378-1.309,0.844 s0.586,0.844,1.309,0.844c0.723,0,1.309-0.378,1.309-0.844S134.873,366.496,134.15,366.496z M228.657,349.075 c-0.742,0-1.343,0.388-1.343,0.866c0,0.478,0.601,0.866,1.343,0.866c0.742,0,1.343-0.388,1.343-0.866 C230,349.462,229.399,349.075,228.657,349.075z M130.124,360.058c-0.513,0-0.928,0.268-0.928,0.598s0.416,0.598,0.928,0.598 s0.928-0.268,0.928-0.598S130.636,360.058,130.124,360.058z M126.468,366.424c-0.273,0-0.495,0.143-0.495,0.319 c0,0.176,0.222,0.319,0.495,0.319c0.273,0,0.495-0.143,0.495-0.319C126.963,366.566,126.742,366.424,126.468,366.424z  M126.887,356.018c-0.656,0-1.188,0.343-1.188,0.766s0.532,0.766,1.188,0.766s1.188-0.343,1.188-0.766 S127.543,356.018,126.887,356.018z M233.343,359.03c-0.335,0-0.607,0.175-0.607,0.391s0.272,0.391,0.607,0.391 c0.335,0,0.607-0.175,0.607-0.391S233.678,359.03,233.343,359.03z M123.962,370.171c-0.576,0-1.043,0.301-1.043,0.672 c0,0.371,0.467,0.672,1.043,0.672c0.576,0,1.043-0.301,1.043-0.672C125.005,370.471,124.538,370.171,123.962,370.171z  M270.664,350.665c-0.49,0-0.887,0.256-0.887,0.572c0,0.316,0.397,0.572,0.887,0.572c0.49,0,0.887-0.256,0.887-0.572 C271.551,350.921,271.154,350.665,270.664,350.665z M263.275,348.815c-0.58,0-1.05,0.303-1.05,0.677c0,0.374,0.47,0.677,1.05,0.677 c0.58,0,1.05-0.303,1.05-0.677C264.325,349.118,263.855,348.815,263.275,348.815z M98.533,360.277c-0.865,0-1.566,0.452-1.566,1.01 c0,0.558,0.701,1.01,1.566,1.01c0.865,0,1.566-0.452,1.566-1.01C100.099,360.729,99.398,360.277,98.533,360.277z M266.759,348.11 c-0.397,0-0.718,0.207-0.718,0.463c0,0.256,0.321,0.463,0.718,0.463s0.718-0.207,0.718-0.463 C267.478,348.317,267.156,348.11,266.759,348.11z M94.2,370.469c-0.52,0-0.941,0.272-0.941,0.607s0.421,0.607,0.941,0.607 c0.52,0,0.941-0.272,0.941-0.607S94.719,370.469,94.2,370.469z M111.859,356.495c-0.73,0-1.321,0.381-1.321,0.852 c0,0.47,0.591,0.852,1.321,0.852c0.73,0,1.321-0.381,1.321-0.852C113.18,356.876,112.588,356.495,111.859,356.495z M95.253,356.916 c-0.312,0-0.565,0.163-0.565,0.364c0,0.201,0.253,0.364,0.565,0.364c0.312,0,0.565-0.163,0.565-0.364 C95.818,357.079,95.565,356.916,95.253,356.916z M96.908,373.755c-0.691,0-1.251,0.361-1.251,0.806c0,0.445,0.56,0.806,1.251,0.806 c0.691,0,1.251-0.361,1.251-0.806C98.159,374.116,97.599,373.755,96.908,373.755z M254.459,356.041 c-0.33,0-0.598,0.173-0.598,0.386c0,0.213,0.268,0.385,0.598,0.385c0.33,0,0.598-0.173,0.598-0.385 C255.057,356.214,254.79,356.041,254.459,356.041z M103.146,366.334c-0.661,0-1.197,0.346-1.197,0.772s0.536,0.772,1.197,0.772 s1.197-0.345,1.197-0.772S103.807,366.334,103.146,366.334z M112.383,371.175c-0.281,0-0.508,0.147-0.508,0.328 c0,0.181,0.228,0.328,0.508,0.328c0.281,0,0.508-0.147,0.508-0.328C112.891,371.322,112.664,371.175,112.383,371.175z  M257.397,354.581c-0.783,0-1.418,0.409-1.418,0.914c0,0.505,0.635,0.914,1.418,0.914c0.783,0,1.418-0.409,1.418-0.914 C258.816,354.99,258.181,354.581,257.397,354.581z M259.598,350.024c-0.608,0-1.101,0.318-1.101,0.71 c0,0.392,0.493,0.71,1.101,0.71c0.608,0,1.101-0.318,1.101-0.71C260.699,350.342,260.206,350.024,259.598,350.024z  M106.466,369.288c-0.662,0-1.199,0.346-1.199,0.773c0,0.427,0.537,0.773,1.199,0.773c0.662,0,1.199-0.346,1.199-0.773 C107.665,369.634,107.128,369.288,106.466,369.288z M107.173,357.737c0-0.178-0.224-0.322-0.5-0.322c-0.276,0-0.5,0.144-0.5,0.322 c0,0.178,0.224,0.322,0.5,0.322C106.949,358.059,107.173,357.915,107.173,357.737z M189.718,362.075 c-0.43,0-0.778,0.224-0.778,0.501c0,0.277,0.348,0.501,0.778,0.501c0.43,0,0.778-0.225,0.778-0.501 C190.496,362.3,190.148,362.075,189.718,362.075z M195.321,360.874c-0.369,0-0.669,0.193-0.669,0.431 c0,0.238,0.299,0.431,0.669,0.431c0.369,0,0.669-0.193,0.669-0.431C195.99,361.067,195.69,360.874,195.321,360.874z  M198.292,362.736c-0.497,0-0.899,0.259-0.899,0.58c0,0.32,0.403,0.58,0.899,0.58c0.497,0,0.899-0.259,0.899-0.58 C199.191,362.995,198.788,362.736,198.292,362.736z M199.64,352.318c-0.563,0-1.02,0.294-1.02,0.658s0.457,0.658,1.02,0.658 c0.563,0,1.02-0.294,1.02-0.658S200.203,352.318,199.64,352.318z M191.393,356.23c-0.665,0-1.204,0.348-1.204,0.776 c0,0.429,0.539,0.776,1.204,0.776c0.665,0,1.204-0.348,1.204-0.776C192.597,356.577,192.058,356.23,191.393,356.23z  M184.187,364.258c-0.652,0-1.181,0.341-1.181,0.761s0.529,0.761,1.181,0.761c0.652,0,1.181-0.341,1.181-0.761 S184.839,364.258,184.187,364.258z M185.37,355.88c-0.745,0-1.349,0.389-1.349,0.87c0,0.48,0.604,0.87,1.349,0.87 c0.745,0,1.349-0.389,1.349-0.87C186.719,356.269,186.115,355.88,185.37,355.88z M273.882,356.251 c-0.545,0-0.987,0.285-0.987,0.636c0,0.351,0.442,0.636,0.987,0.636s0.987-0.285,0.987-0.636 C274.868,356.536,274.427,356.251,273.882,356.251z M202.836,354.527c-0.73,0-1.321,0.381-1.321,0.852 c0,0.47,0.592,0.852,1.321,0.852c0.73,0,1.321-0.381,1.321-0.852C204.157,354.908,203.566,354.527,202.836,354.527z  M219.605,353.292c-0.491,0-0.89,0.257-0.89,0.574c0,0.317,0.398,0.574,0.89,0.574c0.491,0,0.89-0.257,0.89-0.574 C220.495,353.549,220.097,353.292,219.605,353.292z M216.487,354.084c-0.305,0-0.553,0.16-0.553,0.356 c0,0.197,0.248,0.356,0.553,0.356c0.305,0,0.553-0.159,0.553-0.356C217.04,354.243,216.792,354.084,216.487,354.084z  M223.85,357.065c-0.673,0-1.218,0.352-1.218,0.785s0.545,0.785,1.218,0.785s1.218-0.352,1.218-0.785 S224.523,357.065,223.85,357.065z M209.615,359.53c-0.391,0-0.707,0.204-0.707,0.456c0,0.252,0.316,0.456,0.707,0.456 c0.39,0,0.707-0.204,0.707-0.456C210.322,359.734,210.005,359.53,209.615,359.53z M214.401,357.523 c-0.444,0-0.805,0.232-0.805,0.519s0.36,0.519,0.805,0.519c0.444,0,0.805-0.232,0.805-0.519S214.846,357.523,214.401,357.523z  M205.469,351.264c-0.587,0-1.064,0.307-1.064,0.686s0.476,0.685,1.064,0.685c0.587,0,1.063-0.307,1.063-0.685 S206.056,351.264,205.469,351.264z M212.252,358.009c-0.456,0-0.825,0.238-0.825,0.532c0,0.294,0.369,0.532,0.825,0.532 s0.825-0.238,0.825-0.532C213.076,358.247,212.707,358.009,212.252,358.009z M172.085,362.868c-0.355,0-0.643,0.186-0.643,0.415 s0.288,0.415,0.643,0.415c0.355,0,0.643-0.186,0.643-0.415S172.44,362.868,172.085,362.868z M159.307,357.81 c-0.811,0-1.468,0.424-1.468,0.946c0,0.523,0.657,0.946,1.468,0.946c0.811,0,1.468-0.424,1.468-0.946 C160.775,358.233,160.118,357.81,159.307,357.81z M156.611,362.261c-0.718,0-1.301,0.375-1.301,0.839 c0,0.463,0.583,0.839,1.301,0.839c0.719,0,1.301-0.376,1.301-0.839C157.912,362.636,157.329,362.261,156.611,362.261z  M152.117,366.072c-0.876,0-1.587,0.458-1.587,1.023s0.71,1.023,1.587,1.023c0.876,0,1.587-0.458,1.587-1.023 S152.993,366.072,152.117,366.072z M154.82,365.279c-0.446,0-0.808,0.233-0.808,0.521s0.362,0.521,0.808,0.521 s0.808-0.233,0.808-0.521S155.266,365.279,154.82,365.279z M147.86,358.625c-0.715,0-1.294,0.373-1.294,0.834 c0,0.461,0.579,0.834,1.294,0.834s1.294-0.373,1.294-0.834C149.154,358.998,148.575,358.625,147.86,358.625z M143.171,368.868 c-0.612,0-1.108,0.32-1.108,0.714c0,0.394,0.496,0.714,1.108,0.714c0.612,0,1.108-0.32,1.108-0.714 C144.279,369.188,143.783,368.868,143.171,368.868z M144.418,358.128c-0.463,0-0.839,0.242-0.839,0.541 c0,0.299,0.376,0.541,0.839,0.541c0.463,0,0.839-0.242,0.839-0.541C145.257,358.371,144.881,358.128,144.418,358.128z  M138.029,358.353c-0.486,0-0.88,0.254-0.88,0.567c0,0.313,0.394,0.567,0.88,0.567s0.88-0.254,0.88-0.567 C138.91,358.607,138.516,358.353,138.029,358.353z M173.646,352.504c-0.458,0-0.83,0.239-0.83,0.535 c0,0.295,0.371,0.535,0.83,0.535c0.458,0,0.83-0.24,0.83-0.535C174.476,352.744,174.105,352.504,173.646,352.504z M177.204,354.924 c-0.829,0-1.501,0.433-1.501,0.967c0,0.534,0.672,0.967,1.501,0.967s1.501-0.433,1.501-0.967 C178.704,355.358,178.033,354.924,177.204,354.924z M180.178,356.337c-0.32,0-0.58,0.167-0.58,0.374c0,0.207,0.26,0.374,0.58,0.374 c0.32,0,0.58-0.167,0.58-0.374C180.758,356.505,180.498,356.337,180.178,356.337z M168.999,365.255 c-0.691,0-1.251,0.361-1.251,0.806s0.56,0.807,1.251,0.807c0.691,0,1.251-0.361,1.251-0.807S169.69,365.255,168.999,365.255z  M164.064,365.237c-0.662,0-1.199,0.346-1.199,0.773s0.537,0.773,1.199,0.773s1.199-0.346,1.199-0.773 S164.727,365.237,164.064,365.237z M165.84,360.409c-0.566,0-1.025,0.296-1.025,0.661s0.459,0.661,1.025,0.661 c0.566,0,1.025-0.296,1.025-0.661S166.406,360.409,165.84,360.409z M89.601,342.894c0-0.471-0.592-0.852-1.322-0.852 c-0.73,0-1.322,0.382-1.322,0.852c0,0.471,0.592,0.852,1.322,0.852C89.009,343.746,89.601,343.365,89.601,342.894z  M328.815,356.583c-0.543,0-0.982,0.284-0.982,0.633c0,0.35,0.44,0.633,0.982,0.633s0.982-0.284,0.982-0.633 C329.797,356.867,329.357,356.583,328.815,356.583z M335.201,355.986c-0.636,0-1.152,0.332-1.152,0.742s0.516,0.742,1.152,0.742 c0.636,0,1.152-0.332,1.152-0.742S335.837,355.986,335.201,355.986z M331.98,343.17c0-0.351-0.442-0.636-0.987-0.636 s-0.986,0.285-0.986,0.636s0.442,0.636,0.986,0.636S331.98,343.521,331.98,343.17z M61.989,366.973 c0.852,0,1.542-0.445,1.542-0.994s-0.69-0.994-1.542-0.994c-0.852,0-1.542,0.445-1.542,0.994S61.138,366.973,61.989,366.973z  M59.31,356.199c-0.265,0-0.481,0.139-0.481,0.31s0.215,0.31,0.481,0.31c0.265,0,0.48-0.139,0.48-0.31 S59.575,356.199,59.31,356.199z M62.119,353.067c0-0.336-0.423-0.609-0.944-0.609c-0.521,0-0.944,0.272-0.944,0.609 c0,0.336,0.423,0.609,0.944,0.609C61.697,353.676,62.119,353.403,62.119,353.067z M92.118,343.971c0-0.487-0.613-0.882-1.369-0.882 s-1.368,0.395-1.368,0.882c0,0.487,0.613,0.882,1.368,0.882S92.118,344.458,92.118,343.971z M321.791,350.913 c-0.359,0-0.65,0.188-0.65,0.419c0,0.231,0.291,0.419,0.65,0.419c0.359,0,0.65-0.188,0.65-0.419 C322.441,351.1,322.15,350.913,321.791,350.913z M319.058,354.585c-0.578,0-1.047,0.302-1.047,0.675 c0,0.373,0.469,0.675,1.047,0.675c0.578,0,1.047-0.302,1.047-0.675C320.104,354.887,319.636,354.585,319.058,354.585z  M62.173,375.695c0-0.191-0.24-0.345-0.535-0.345c-0.239,0-0.439,0.101-0.508,0.241c-0.02-0.001-0.038-0.004-0.058-0.004 c-0.665,0-1.204,0.347-1.204,0.776c0,0.429,0.539,0.776,1.204,0.776c0.665,0,1.204-0.348,1.204-0.776 c0-0.168-0.085-0.323-0.227-0.45C62.125,375.853,62.173,375.778,62.173,375.695z M314.053,354.058c-0.679,0-1.23,0.355-1.23,0.793 s0.551,0.793,1.23,0.793c0.679,0,1.23-0.355,1.23-0.793S314.733,354.058,314.053,354.058z M315.679,343.863 c-0.56,0-1.014,0.293-1.014,0.654s0.454,0.653,1.014,0.653c0.56,0,1.014-0.292,1.014-0.653S316.238,343.863,315.679,343.863z  M63.221,372.286c-0.395,0-0.715,0.206-0.715,0.461c0,0.254,0.32,0.461,0.715,0.461c0.395,0,0.715-0.206,0.715-0.461 C63.935,372.492,63.615,372.286,63.221,372.286z M68.978,348.07c0-0.513-0.645-0.929-1.441-0.929c-0.796,0-1.441,0.416-1.441,0.929 c0,0.513,0.645,0.929,1.441,0.929C68.333,348.999,68.978,348.583,68.978,348.07z M65.304,365.162c-0.563,0-1.019,0.294-1.019,0.657 c0,0.363,0.456,0.657,1.019,0.657c0.563,0,1.019-0.294,1.019-0.657C66.323,365.457,65.867,365.162,65.304,365.162z M65.028,344.719 c0-0.452-0.568-0.818-1.269-0.818c-0.701,0-1.269,0.366-1.269,0.818c0,0.452,0.568,0.818,1.269,0.818 C64.46,345.537,65.028,345.171,65.028,344.719z M342.239,343.832c-0.122,0-0.235,0.024-0.328,0.065 c-0.209-0.269-0.637-0.455-1.135-0.455c-0.704,0-1.274,0.368-1.274,0.821c0,0.454,0.57,0.821,1.274,0.821 c0.55,0,1.015-0.226,1.193-0.541c0.081,0.027,0.172,0.044,0.27,0.044c0.324,0,0.586-0.169,0.586-0.378 S342.563,343.832,342.239,343.832z M55.132,345.741c-0.474,0-0.858,0.248-0.858,0.553s0.384,0.553,0.858,0.553 c0.474,0,0.858-0.248,0.858-0.553S55.606,345.741,55.132,345.741z M344.9,347.363c-0.485,0-0.877,0.253-0.877,0.566 s0.393,0.566,0.877,0.566c0.485,0,0.878-0.253,0.878-0.566S345.385,347.363,344.9,347.363z M56.91,366.417 c0-0.481-0.605-0.872-1.352-0.872s-1.352,0.39-1.352,0.872c0,0.481,0.605,0.872,1.352,0.872S56.91,366.898,56.91,366.417z  M53.53,369.097c0.659,0,1.192-0.344,1.192-0.769s-0.534-0.769-1.192-0.769c-0.659,0-1.192,0.344-1.192,0.769 S52.871,369.097,53.53,369.097z M53.132,353.045c0.283,0,0.512-0.148,0.512-0.33c0-0.182-0.229-0.33-0.512-0.33 s-0.512,0.148-0.512,0.33C52.62,352.897,52.849,353.045,53.132,353.045z M54.499,371.35c0.718,0,1.3-0.375,1.3-0.838 c0-0.463-0.582-0.838-1.3-0.838c-0.718,0-1.3,0.375-1.3,0.838C53.198,370.975,53.78,371.35,54.499,371.35z M339.816,349.797 c-0.352,0-0.638,0.184-0.638,0.411c0,0.227,0.286,0.411,0.638,0.411c0.352,0,0.638-0.184,0.638-0.411 C340.453,349.981,340.168,349.797,339.816,349.797z M336.561,343.281c-0.292,0-0.561,0.055-0.794,0.146 c-0.099-0.125-0.299-0.211-0.531-0.211c-0.331,0-0.6,0.173-0.6,0.387c0,0.182,0.196,0.334,0.46,0.375 c-0.047,0.095-0.078,0.194-0.078,0.299c0,0.549,0.691,0.995,1.543,0.995c0.852,0,1.543-0.445,1.543-0.995 S337.414,343.281,336.561,343.281z M57.209,370.742c-0.563,0-1.019,0.294-1.019,0.657c0,0.363,0.456,0.657,1.019,0.657 s1.019-0.294,1.019-0.657C58.229,371.036,57.772,370.742,57.209,370.742z M52.918,373.275c-0.373,0-0.676,0.195-0.676,0.436 s0.303,0.436,0.676,0.436s0.676-0.195,0.676-0.436S53.291,373.275,52.918,373.275z M55.058,381.459c-0.486,0-0.88,0.254-0.88,0.567 s0.394,0.567,0.88,0.567c0.486,0,0.88-0.254,0.88-0.567S55.544,381.459,55.058,381.459z M50.7,375.087 c-0.474,0-0.859,0.248-0.859,0.554s0.384,0.554,0.859,0.554s0.859-0.248,0.859-0.554S51.174,375.087,50.7,375.087z M49.935,347.288 c-0.515,0-0.933,0.269-0.933,0.601s0.417,0.601,0.933,0.601c0.515,0,0.932-0.269,0.932-0.601S50.45,347.288,49.935,347.288z  M50.009,376.766c-0.515,0-0.932,0.269-0.932,0.601c0,0.332,0.417,0.601,0.932,0.601c0.515,0,0.932-0.269,0.932-0.601 C50.941,377.035,50.524,376.766,50.009,376.766z M91.301,364.263c0-0.565-0.711-1.023-1.587-1.023s-1.587,0.458-1.587,1.023 s0.711,1.023,1.587,1.023S91.301,364.828,91.301,364.263z M84.559,368.049c-0.5,0-0.906,0.262-0.906,0.584 c0,0.322,0.406,0.584,0.906,0.584c0.5,0,0.906-0.262,0.906-0.584C85.465,368.311,85.059,368.049,84.559,368.049z M80.155,373.478 c-0.749,0-1.357,0.392-1.357,0.875c0,0.165,0.075,0.318,0.199,0.45c-0.232-0.093-0.503-0.15-0.797-0.15 c-0.834,0-1.51,0.436-1.51,0.973c0,0.537,0.676,0.973,1.51,0.973c0.834,0,1.51-0.436,1.51-0.973c0-0.193-0.089-0.371-0.239-0.522 c0.202,0.077,0.434,0.124,0.685,0.124c0.749,0,1.357-0.392,1.357-0.875S80.904,373.478,80.155,373.478z M83.976,364.977 c0-0.297-0.373-0.538-0.834-0.538s-0.834,0.241-0.834,0.538c0,0.297,0.373,0.538,0.834,0.538S83.976,365.274,83.976,364.977z  M82.025,370.961c-0.451,0-0.817,0.236-0.817,0.527s0.366,0.527,0.817,0.527c0.451,0,0.817-0.236,0.817-0.527 S82.476,370.961,82.025,370.961z M72.833,378.35c-0.42,0-0.76,0.219-0.76,0.49c0,0.271,0.34,0.49,0.76,0.49 c0.42,0,0.76-0.219,0.76-0.49C73.593,378.57,73.253,378.35,72.833,378.35z M73.839,364.379c-0.588,0-1.064,0.307-1.064,0.686 s0.477,0.686,1.064,0.686s1.064-0.307,1.064-0.686S74.427,364.379,73.839,364.379z M77.233,362.07c0-0.431-0.543-0.781-1.212-0.781 c-0.669,0-1.212,0.35-1.212,0.781c0,0.431,0.543,0.781,1.212,0.781C76.69,362.852,77.233,362.502,77.233,362.07z M74.052,362.38 c0-0.49-0.617-0.888-1.378-0.888c-0.599,0-1.103,0.248-1.293,0.592c-0.135-0.389-0.672-0.68-1.317-0.68 c-0.746,0-1.352,0.39-1.352,0.871c0,0.285,0.216,0.536,0.544,0.695c-0.184,0.124-0.299,0.291-0.299,0.477 c0,0.382,0.48,0.691,1.072,0.691s1.072-0.31,1.072-0.691c0-0.175-0.105-0.334-0.271-0.456c0.229-0.102,0.402-0.249,0.499-0.42 c0.136,0.399,0.685,0.697,1.344,0.697C73.435,363.268,74.052,362.871,74.052,362.38z M87.825,355.433 c0-0.433-0.545-0.785-1.217-0.785c-0.672,0-1.217,0.351-1.217,0.785s0.545,0.785,1.217,0.785 C87.28,356.218,87.825,355.866,87.825,355.433z M91.124,370.022c-0.639,0-1.158,0.334-1.158,0.746c0,0.412,0.518,0.746,1.158,0.746 c0.639,0,1.158-0.334,1.158-0.746C92.282,370.357,91.763,370.022,91.124,370.022z M276.516,353.51c-0.287,0-0.519,0.15-0.519,0.335 s0.232,0.335,0.519,0.335c0.287,0,0.519-0.15,0.519-0.335S276.803,353.51,276.516,353.51z M280.878,360.295 c-0.525,0-0.951,0.275-0.951,0.613c0,0.339,0.426,0.613,0.951,0.613c0.525,0,0.951-0.275,0.951-0.613 C281.829,360.569,281.403,360.295,280.878,360.295z M87.636,367.61c0-0.29-0.365-0.525-0.814-0.525 c-0.45,0-0.815,0.235-0.815,0.525c0,0.29,0.365,0.525,0.815,0.525C87.271,368.135,87.636,367.9,87.636,367.61z M95.891,369.433 c0,0.295,0.371,0.534,0.829,0.534c0.458,0,0.829-0.239,0.829-0.534c0-0.295-0.371-0.534-0.829-0.534 C96.262,368.899,95.891,369.138,95.891,369.433z M88.303,369.466c-0.692,0-1.252,0.361-1.252,0.807 c0,0.446,0.561,0.807,1.252,0.807c0.692,0,1.252-0.361,1.252-0.807C89.556,369.828,88.995,369.466,88.303,369.466z M83.007,354.536 c0.344,0,0.622-0.18,0.622-0.401s-0.279-0.401-0.622-0.401c-0.344,0-0.622,0.18-0.622,0.401S82.663,354.536,83.007,354.536z  M297.06,349.401c-0.858,0-1.553,0.448-1.553,1.001c0,0.553,0.695,1.001,1.553,1.001s1.553-0.448,1.553-1.001 C298.613,349.85,297.918,349.401,297.06,349.401z M292.945,354.445c-0.737,0-1.335,0.385-1.335,0.861 c0,0.475,0.598,0.861,1.335,0.861c0.738,0,1.336-0.385,1.336-0.861C294.28,354.83,293.682,354.445,292.945,354.445z  M76.789,354.133c0.516,0,0.934-0.27,0.934-0.603s-0.418-0.602-0.934-0.602c-0.516,0-0.935,0.27-0.935,0.602 S76.273,354.133,76.789,354.133z M295.672,359.506c-0.484,0-0.876,0.253-0.876,0.565c0,0.312,0.392,0.565,0.876,0.565 c0.484,0,0.876-0.253,0.876-0.565C296.549,359.759,296.156,359.506,295.672,359.506z M69.636,370.417 c-0.559,0-1.013,0.292-1.013,0.653c0,0.361,0.453,0.653,1.013,0.653c0.559,0,1.013-0.292,1.013-0.653 C70.649,370.709,70.196,370.417,69.636,370.417z M300.444,347.541c-0.374,0-0.678,0.196-0.678,0.437 c0,0.241,0.303,0.437,0.678,0.437s0.678-0.196,0.678-0.437C301.122,347.736,300.819,347.541,300.444,347.541z M46.042,373.751 c-0.621,0-1.125,0.325-1.125,0.725c0,0.401,0.504,0.725,1.125,0.725s1.125-0.325,1.125-0.725 C47.167,374.076,46.663,373.751,46.042,373.751z M304.386,353.015c-0.789,0-1.429,0.412-1.429,0.921 c0,0.509,0.64,0.921,1.429,0.921c0.789,0,1.429-0.412,1.429-0.921C305.815,353.428,305.176,353.015,304.386,353.015z  M286.607,349.934c-0.738,0-1.336,0.386-1.336,0.861c0,0.476,0.598,0.861,1.336,0.861c0.738,0,1.336-0.386,1.336-0.861 C287.943,350.319,287.345,349.934,286.607,349.934z M282.979,347.29c-0.474,0-0.858,0.248-0.858,0.553 c0,0.176,0.13,0.331,0.329,0.432c-0.193,0.084-0.32,0.227-0.32,0.389c0,0.259,0.326,0.469,0.728,0.469s0.728-0.21,0.728-0.469 c0-0.13-0.081-0.247-0.213-0.332c0.276-0.092,0.466-0.276,0.466-0.49C283.837,347.538,283.453,347.29,282.979,347.29z  M68.279,375.862c-0.565,0-1.024,0.295-1.024,0.66c0,0.364,0.458,0.66,1.024,0.66s1.023-0.295,1.023-0.66 C69.302,376.157,68.844,375.862,68.279,375.862z M308.001,345.783c0-0.42-0.528-0.761-1.18-0.761c-0.652,0-1.18,0.341-1.18,0.761 c0,0.42,0.528,0.761,1.18,0.761C307.472,346.543,308.001,346.203,308.001,345.783z M290.781,358.547 c-0.453,0-0.82,0.237-0.82,0.529c0,0.292,0.367,0.529,0.82,0.529c0.453,0,0.82-0.237,0.82-0.529 C291.601,358.784,291.234,358.547,290.781,358.547z M79.925,360.425c0.843,0,1.527-0.441,1.527-0.984s-0.684-0.984-1.527-0.984 c-0.843,0-1.527,0.441-1.527,0.984S79.081,360.425,79.925,360.425z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126317940200293379980000008274062690188770215_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.7727,
    y1: 268.3145,
    x2: 200.7727,
    y2: 228.5565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0C59A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#519AB3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000126317940200293379980000008274062690188770215_)"
    },
    points: "105.182,265.163  138.061,245.527 271.636,245.527 296.364,265.163  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031204685014617344070000007816461759767671719_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.6541,
    y1: 247.5597,
    x2: 133.2298,
    y2: 168.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5D6A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1284,
    style: {
      stopColor: "#EDD3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3307,
    style: {
      stopColor: "#D6CAA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5816,
    style: {
      stopColor: "#B1BDA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#7FAAA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65A0A8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031204685014617344070000007816461759767671719_)"
    },
    points: "138.061,245.527  135.454,168.921 100.364,150.193 105.182,265.163  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#65A0A8"
    },
    points: "271.636,245.527 272.546,170.012 308.909,153.83 296.364,265.163  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166672088727090456860000015634228650947894920_",
    gradientUnits: "userSpaceOnUse",
    x1: 204,
    y1: 252.7993,
    x2: 204,
    y2: 164.036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5D6A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1284,
    style: {
      stopColor: "#EDD3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3307,
    style: {
      stopColor: "#D6CAA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5816,
    style: {
      stopColor: "#B1BDA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8686,
    style: {
      stopColor: "#7FAAA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65A0A8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000166672088727090456860000015634228650947894920_)"
    },
    points: "135.454,168.921  272.546,170.012 271.636,245.527 138.061,245.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#004D5C"
    },
    points: "96.73,150.13 135.454,168.921 272.546,170.012 308.909,153.83  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152952547680784825950000000480535237527407506_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.9054,
    y1: 245.0417,
    x2: 181.9054,
    y2: 184.549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152952547680784825950000000480535237527407506_)"
    },
    points: "192.751,245.527  171.067,245.527 169.848,187.708 193.962,188.057  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163057053240809709520000005564604364914745264_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.906,
    y1: 243.0115,
    x2: 181.906,
    y2: 181.9656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163057053240809709520000005564604364914745264_)"
    },
    points: "172.182,245.527  171.706,189.554 192.106,189.849 191.273,245.527  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    d: "M190.721,221.329c0,0.584-0.447,1.265-1.03,1.265c-0.584,0-1.057-0.295-1.057-0.879 c0-0.584,0.473-1.235,1.057-1.235C190.275,220.481,190.721,220.745,190.721,221.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0A426"
    },
    d: "M190.824,220.806c0,0.584-0.447,1.265-1.03,1.265c-0.584,0-1.057-0.295-1.057-0.879 c0-0.584,0.473-1.235,1.057-1.235C190.377,219.958,190.824,220.223,190.824,220.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#AB1535"
    },
    d: "M190.589,220.414c0.014,0.054,0.023,0.112,0.023,0.179 c0,0.453-0.355,1.002-0.795,1.002c-0.395,0-0.818-0.174-0.818-0.662c0-0.147,0.044-0.304,0.115-0.448 c-0.154,0.209-0.249,0.47-0.249,0.708c0,0.554,0.48,0.752,0.93,0.752c0.5,0,0.903-0.623,0.903-1.138 C190.696,220.64,190.654,220.513,190.589,220.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    d: "M190.178,220.401c0,0.223-0.171,0.483-0.393,0.483c-0.223,0-0.404-0.113-0.404-0.335 s0.181-0.471,0.404-0.471C190.008,220.077,190.178,220.178,190.178,220.401z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B86053"
    },
    d: "M192.108,189.712l-20.4-0.295l-0.14-0.002l0.001,0.14l0.238,27.987 c0.048,4.664,0.06,9.329,0.138,13.993l0.236,13.992l-0.002-13.994c-0.002-4.665-0.069-9.329-0.1-13.993l-0.237-27.847 l20.124,0.291l-0.415,27.703c-0.06,4.64-0.16,9.279-0.187,13.92l-0.093,13.921l0.323-13.918c0.112-4.639,0.151-9.279,0.23-13.919 l0.417-27.839l0.002-0.136L192.108,189.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    d: "M189.548,192.909l-15.407-0.376l-0.189-0.005l0.003,0.189l0.37,26.935l0.002,0.128 l0.128-0.001l14.764-0.055l0.507-26.631l0.003-0.18L189.548,192.909z M189.072,219.575l-14.489-0.054l-0.263-26.62l15.04,0.367 L189.072,219.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    d: "M189.145,222.773h-14.418h-0.185l0.003,0.185l0.358,19.677l0.002,0.128l0.127-0.001 l13.873-0.064l0.422-19.74l0.004-0.185H189.145z M188.776,242.567l-13.617-0.063l-0.248-19.368h14.05L188.776,242.567z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#58677D"
    },
    points: " -6.545,312.921 83.928,312.921 80.181,317.465 -6.545,317.465  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#58677D"
    },
    points: " 321.818,312.921 412.292,312.921 408.544,317.465 321.818,317.465  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#F7DCA8"
    },
    points: " 404.727,265.163 -6.545,265.163 -6.545,312.921 83.928,312.921 74.182,324.739 335.774,324.739 324.473,312.921 404.727,312.921  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#FFF7CC"
    },
    d: "M187.694,300.557H88.64 l5.908-10.734l1.149-2.081l11.037-20.034h83.251l-1.381,19.894l-0.151,2.075L187.694,300.557z M89.68,289.529l1.443-2.068 l13.739-19.752H20.114L-4,288.396v12.161h86.006L89.68,289.529z M389.757,287.319l12.425,9.359v-28.969h-38.459L389.757,287.319z  M286.085,287.744l-11.039-20.035h-83.251l1.382,19.893l0.14,2.07l0.763,10.886h99.056l-5.909-10.73L286.085,287.744z  M402.182,304.799H-4v5.576h93.327l-9.746,11.818h250.237l-11.301-11.818h83.665V304.799z M399.955,300.557l-12.334-10.582 l-25.955-22.267h-84.748l13.739,19.752l1.43,2.059l7.684,11.038H399.955z M18.058,267.709H-4v16.615L18.058,267.709z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M102.909,293.284c0,0-5.617,0.909-12.545,0.909c-6.929,0-12.545-0.909-12.545-0.909 s5.617-0.909,12.545-0.909C97.292,292.375,102.909,293.284,102.909,293.284z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M127.151,280.678c0,0-6.729,0.909-15.03,0.909s-15.03-0.909-15.03-0.909s6.729-0.909,15.03-0.909 S127.151,280.678,127.151,280.678z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M148.727,280.436c0,0-2.605,0.909-5.818,0.909c-3.213,0-5.818-0.909-5.818-0.909 s2.605-0.909,5.818-0.909C146.122,279.527,148.727,280.436,148.727,280.436z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M98.061,284.799c0,0-8.195,0.909-18.303,0.909s-18.303-0.909-18.303-0.909 s8.195-0.909,18.303-0.909S98.061,284.799,98.061,284.799z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M59.758,294.254c0,0-9.28,0.909-20.727,0.909s-20.727-0.909-20.727-0.909s9.28-0.909,20.727-0.909 S59.758,294.254,59.758,294.254z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M41.818,284.799c0,0-1.574,0.909-3.515,0.909c-1.941,0-3.515-0.909-3.515-0.909 s1.574-0.909,3.515-0.909C40.244,283.89,41.818,284.799,41.818,284.799z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M24.121,277.527c0,0-6.566,0.909-14.667,0.909c-8.1,0-14.667-0.909-14.667-0.909 s6.566-0.909,14.667-0.909C17.555,276.617,24.121,277.527,24.121,277.527z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M66.061,274.617c0,0-4.124,0.909-9.212,0.909s-9.212-0.909-9.212-0.909s4.124-0.909,9.212-0.909 S66.061,274.617,66.061,274.617z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M105.576,274.617c0,0-3.202,0.909-7.152,0.909c-3.95,0-7.152-0.909-7.152-0.909 s3.202-0.909,7.152-0.909C102.374,273.708,105.576,274.617,105.576,274.617z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M200.606,274.375c0,0-4.884,0.909-10.909,0.909c-6.025,0-10.909-0.909-10.909-0.909 s4.884-0.909,10.909-0.909C195.722,273.466,200.606,274.375,200.606,274.375z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M193.091,284.799c0,0-4.07,0.909-9.091,0.909s-9.091-0.909-9.091-0.909s4.07-0.909,9.091-0.909 S193.091,284.799,193.091,284.799z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M218.061,293.769c0,0-6.946,0.909-15.515,0.909c-8.569,0-15.515-0.909-15.515-0.909 s6.946-0.909,15.515-0.909C211.114,292.86,218.061,293.769,218.061,293.769z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M262.424,281.405c0,0-6.078,0.909-13.576,0.909s-13.576-0.909-13.576-0.909 s6.078-0.909,13.576-0.909S262.424,281.405,262.424,281.405z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M168.606,293.284c0,0-5.915,0.909-13.212,0.909c-7.297,0-13.212-0.909-13.212-0.909 s5.915-0.909,13.212-0.909C162.691,292.375,168.606,293.284,168.606,293.284z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M163.758,273.648c0,0-3.419,0.909-7.636,0.909c-4.217,0-7.636-0.909-7.636-0.909 s3.419-0.909,7.636-0.909C160.339,272.739,163.758,273.648,163.758,273.648z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M220.727,279.951c0,0-2.062,0.909-4.606,0.909c-2.544,0-4.606-0.909-4.606-0.909 s2.062-0.909,4.606-0.909C218.665,279.042,220.727,279.951,220.727,279.951z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M294.424,272.193c0,0-6.349,0.909-14.182,0.909s-14.182-0.909-14.182-0.909 s6.349-0.909,14.182-0.909S294.424,272.193,294.424,272.193z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M323.03,293.284c0,0-7.163,0.909-16,0.909c-8.837,0-16-0.909-16-0.909s7.163-0.909,16-0.909 C315.867,292.375,323.03,293.284,323.03,293.284z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M275.273,292.072c0,0-4.124,0.909-9.212,0.909c-5.088,0-9.212-0.909-9.212-0.909 s4.124-0.909,9.212-0.909C271.148,291.163,275.273,292.072,275.273,292.072z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M241.818,274.86c0,0-2.225,0.909-4.97,0.909s-4.97-0.909-4.97-0.909s2.225-0.909,4.97-0.909 S241.818,274.86,241.818,274.86z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M359.394,274.617c0,0-10.094,0.909-22.545,0.909c-12.451,0-22.545-0.909-22.545-0.909 s10.094-0.909,22.545-0.909C349.3,273.708,359.394,274.617,359.394,274.617z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M342.424,283.83c0,0-4.504,0.909-10.061,0.909c-5.556,0-10.061-0.909-10.061-0.909 s4.504-0.909,10.061-0.909C337.92,282.921,342.424,283.83,342.424,283.83z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M400.121,283.83c0,0-7.923,0.909-17.697,0.909c-9.774,0-17.697-0.909-17.697-0.909 s7.923-0.909,17.697-0.909C392.198,282.921,400.121,283.83,400.121,283.83z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M408.121,273.405c0,0-4.016,0.909-8.97,0.909s-8.97-0.909-8.97-0.909s4.016-0.909,8.97-0.909 S408.121,273.405,408.121,273.405z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M365.939,294.254c0,0-2.551,0.909-5.697,0.909c-3.146,0-5.697-0.909-5.697-0.909 s2.551-0.909,5.697-0.909C363.389,293.345,365.939,294.254,365.939,294.254z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M294.182,283.587c0,0-1.465,0.909-3.273,0.909s-3.273-0.909-3.273-0.909s1.465-0.909,3.273-0.909 S294.182,283.587,294.182,283.587z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M108.732,323.346c0,0-0.328-2.054,0.341-4.264c0.669-2.209,2.082-3.737,2.082-3.737 s0.328,2.054-0.341,4.264C110.144,321.819,108.732,323.346,108.732,323.346z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M191.437,316.068c0,0-1.232-3.109-1.637-7.058c-0.405-3.949,0.171-7.244,0.171-7.244 s1.232,3.109,1.637,7.058C192.013,312.773,191.437,316.068,191.437,316.068z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M265.368,320.182c0,0-2.121-3.509-3.673-8.191c-1.552-4.682-1.947-8.764-1.947-8.764 s2.121,3.509,3.673,8.191C264.973,316.1,265.368,320.182,265.368,320.182z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M277.477,322.606c0,0-1.572-1.115-2.507-2.99c-0.935-1.875-0.88-3.801-0.88-3.801 s1.572,1.115,2.507,2.99C277.533,320.68,277.477,322.606,277.477,322.606z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M305.774,318.279c0,0-2.895-3.247-5.492-7.807c-2.597-4.56-3.912-8.707-3.912-8.707 s2.895,3.247,5.492,7.807C304.459,314.133,305.774,318.279,305.774,318.279z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M313.793,319.482c0,0-1.947-1.366-3.403-3.652c-1.456-2.287-1.869-4.629-1.869-4.629 s1.947,1.366,3.403,3.653C313.38,317.14,313.793,319.482,313.793,319.482z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M223.394,319.466c0,0-0.401-0.395-0.886-1.126c-0.485-0.728-1.041-1.807-1.319-3.091 c-0.277-1.284-0.216-2.498-0.076-3.36c0.14-0.866,0.342-1.392,0.342-1.392s0.253,0.505,0.562,1.298 c0.31,0.796,0.689,1.867,0.949,3.07c0.261,1.203,0.358,2.336,0.404,3.188C223.415,318.902,223.394,319.466,223.394,319.466z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M137.093,320.921c0,0-0.106-1.058-0.092-2.759c0.013-1.7,0.163-4.047,0.668-6.58 c0.507-2.533,1.271-4.757,1.911-6.332c0.641-1.576,1.144-2.512,1.144-2.512s-0.067,1.062-0.264,2.738 c-0.198,1.678-0.51,3.969-1.009,6.462c-0.497,2.493-1.089,4.728-1.551,6.353C137.439,319.915,137.093,320.921,137.093,320.921z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M96.451,321.453c0,0,0.612-3.038,2.353-6.251c1.741-3.213,3.952-5.385,3.952-5.385 s-0.612,3.038-2.353,6.251C98.662,319.281,96.451,321.453,96.451,321.453z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M169.576,318.254c0,0-0.909-0.923-0.909-2.061s0.909-2.061,0.909-2.061s0.909,0.923,0.909,2.061 S169.576,318.254,169.576,318.254z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7DCA8"
    },
    d: "M46.17,122.496c0,0,0.459-0.647,1.265-1.637c0.403-0.495,0.892-1.076,1.453-1.703 c0.141-0.156,0.286-0.316,0.434-0.479c0.145-0.154,0.292-0.312,0.442-0.472c0.298-0.334,0.606-0.681,0.923-1.035 c0.321-0.359,0.647-0.71,0.982-1.037c0.329-0.319,0.65-0.62,0.96-0.904c0.315-0.285,0.598-0.548,0.901-0.797 c0.303-0.243,0.595-0.445,0.862-0.622c0.536-0.35,0.97-0.615,1.264-0.816c0.294-0.198,0.454-0.317,0.454-0.317 s-0.11,0.165-0.339,0.443c-0.227,0.279-0.588,0.66-1.031,1.111c-0.22,0.226-0.458,0.472-0.695,0.74 c-0.238,0.283-0.492,0.585-0.759,0.902c-0.271,0.317-0.561,0.647-0.864,0.982c-0.298,0.336-0.606,0.685-0.922,1.041 c-0.322,0.36-0.65,0.711-0.987,1.036c-0.169,0.162-0.341,0.319-0.514,0.467c-0.163,0.145-0.323,0.287-0.479,0.425 c-0.627,0.549-1.208,1.029-1.704,1.424C46.822,122.042,46.17,122.496,46.17,122.496z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#FFEFBC"
    },
    d: " M503.694,392.661c0,0.45-0.556,0.815-1.241,0.815c-0.686,0-1.241-0.365-1.241-0.815c0-0.45,0.556-0.815,1.241-0.815 C503.138,391.846,503.694,392.211,503.694,392.661z M498.759,383.414c-0.614,0-1.112,0.327-1.112,0.731s0.498,0.731,1.112,0.731 c0.614,0,1.112-0.327,1.112-0.731S499.374,383.414,498.759,383.414z M495.766,379.596c-0.746,0-1.351,0.397-1.351,0.888 c0,0.49,0.605,0.888,1.351,0.888c0.746,0,1.352-0.397,1.352-0.888C497.118,379.993,496.513,379.596,495.766,379.596z  M491.577,381.337c-1.045,0-1.892,0.557-1.892,1.243s0.847,1.243,1.892,1.243s1.892-0.557,1.892-1.243 S492.622,381.337,491.577,381.337z M488.529,393.399c-0.321,0-0.581,0.171-0.581,0.382c0,0.211,0.26,0.382,0.581,0.382 c0.321,0,0.581-0.171,0.581-0.382C489.11,393.57,488.85,393.399,488.529,393.399z M484.895,386.954 c-0.561,0-1.016,0.299-1.016,0.667s0.455,0.667,1.016,0.667s1.016-0.299,1.016-0.667S485.456,386.954,484.895,386.954z  M481.807,384.335c-0.62,0-1.123,0.33-1.123,0.738c0,0.407,0.503,0.738,1.123,0.738c0.62,0,1.123-0.33,1.123-0.738 C482.93,384.665,482.427,384.335,481.807,384.335z M478.692,392.684c-0.567,0-1.026,0.302-1.026,0.674 c0,0.372,0.46,0.674,1.026,0.674c0.567,0,1.026-0.302,1.026-0.674C479.719,392.986,479.259,392.684,478.692,392.684z  M475.351,392.233c-0.459,0-0.831,0.244-0.831,0.546s0.372,0.546,0.831,0.546s0.832-0.245,0.832-0.546 S475.811,392.233,475.351,392.233z M471.024,381.06c-1.042,0-1.886,0.555-1.886,1.239s0.845,1.239,1.886,1.239 s1.886-0.555,1.886-1.239S472.066,381.06,471.024,381.06z M467.941,380.362c0.6,0,1.087-0.32,1.087-0.714 c0-0.395-0.487-0.714-1.087-0.714c-0.601,0-1.087,0.32-1.087,0.714C466.853,380.042,467.34,380.362,467.941,380.362z  M465.858,395.373c-0.831,0-1.504,0.442-1.504,0.988s0.673,0.988,1.504,0.988s1.504-0.442,1.504-0.988 S466.688,395.373,465.858,395.373z M461.035,384.487c-0.857,0-1.552,0.457-1.552,1.02c0,0.563,0.695,1.02,1.552,1.02 s1.552-0.456,1.552-1.02C462.588,384.943,461.893,384.487,461.035,384.487z M458.271,385.978c-0.665,0-1.204,0.354-1.204,0.79 c0,0.437,0.539,0.791,1.204,0.791s1.203-0.354,1.203-0.791C459.475,386.332,458.936,385.978,458.271,385.978z M456.23,392.669 c0-0.637-0.786-1.153-1.756-1.153c-0.97,0-1.756,0.516-1.756,1.153c0,0.637,0.786,1.154,1.756,1.154 C455.444,393.823,456.23,393.306,456.23,392.669z M451.661,395.177c0-0.439-0.542-0.795-1.21-0.795s-1.21,0.356-1.21,0.795 s0.542,0.795,1.21,0.795S451.661,395.616,451.661,395.177z M447.102,384.456c-0.755,0-1.368,0.402-1.368,0.898 s0.612,0.898,1.368,0.898c0.755,0,1.368-0.402,1.368-0.898S447.858,384.456,447.102,384.456z M444.077,395.657 c0.891,0,1.612-0.474,1.612-1.059s-0.722-1.059-1.612-1.059s-1.613,0.474-1.613,1.059S443.186,395.657,444.077,395.657z  M440.419,378.67c-0.761,0-1.378,0.405-1.378,0.905s0.617,0.905,1.378,0.905s1.378-0.405,1.378-0.905S441.18,378.67,440.419,378.67 z M437.159,387.069c0.372,0,0.674-0.198,0.674-0.443c0-0.245-0.302-0.443-0.674-0.443c-0.372,0-0.674,0.198-0.674,0.443 C436.485,386.871,436.787,387.069,437.159,387.069z M433.688,378.896c-0.806,0-1.459,0.429-1.459,0.959 c0,0.53,0.653,0.959,1.459,0.959c0.806,0,1.46-0.429,1.46-0.959C435.148,379.325,434.495,378.896,433.688,378.896z  M430.569,396.483c0.493,0,0.893-0.263,0.893-0.586c0-0.324-0.4-0.586-0.893-0.586c-0.493,0-0.893,0.262-0.893,0.586 C429.677,396.22,430.076,396.483,430.569,396.483z M426.716,391.728c0.693,0,1.255-0.369,1.255-0.824s-0.562-0.824-1.255-0.824 c-0.693,0-1.255,0.369-1.255,0.824S426.023,391.728,426.716,391.728z M423.064,385.658c0-0.336-0.415-0.608-0.926-0.608 c-0.511,0-0.926,0.272-0.926,0.608c0,0.336,0.415,0.608,0.926,0.608C422.649,386.267,423.064,385.994,423.064,385.658z  M418.595,388.328c0.871,0,1.578-0.464,1.578-1.036c0-0.572-0.706-1.036-1.578-1.036c-0.871,0-1.578,0.464-1.578,1.036 C417.018,387.864,417.724,388.328,418.595,388.328z M415.608,390.3c0.316,0,0.572-0.168,0.572-0.376 c0-0.207-0.256-0.375-0.572-0.375c-0.316,0-0.572,0.168-0.572,0.375C415.036,390.132,415.292,390.3,415.608,390.3z  M412.385,396.633c-0.839,0-1.519,0.447-1.519,0.998c0,0.551,0.68,0.998,1.519,0.998c0.839,0,1.519-0.447,1.519-0.998 C413.904,397.08,413.224,396.633,412.385,396.633z M409.506,398.335c-0.399,0-0.722,0.212-0.722,0.475 c0,0.262,0.324,0.474,0.722,0.474c0.399,0,0.722-0.212,0.722-0.474C410.228,398.547,409.905,398.335,409.506,398.335z  M407.886,397.757c0-0.535-0.66-0.969-1.475-0.969c-0.815,0-1.475,0.434-1.475,0.969c0,0.535,0.66,0.969,1.475,0.969 C407.225,398.726,407.886,398.292,407.886,397.757z M404.079,387.629c0-0.517-0.638-0.935-1.424-0.935 c-0.786,0-1.424,0.419-1.424,0.935c0,0.517,0.638,0.935,1.424,0.935C403.442,388.565,404.079,388.146,404.079,387.629z  M400.783,381.783c0-0.435-0.536-0.787-1.198-0.787c-0.662,0-1.198,0.352-1.198,0.787s0.536,0.787,1.198,0.787 C400.246,382.57,400.783,382.218,400.783,381.783z M397.434,391.074c0-0.539-0.665-0.975-1.485-0.975s-1.485,0.437-1.485,0.975 c0,0.539,0.665,0.975,1.485,0.975S397.434,391.612,397.434,391.074z M394.134,391.484c0-0.636-0.785-1.151-1.753-1.151 s-1.753,0.516-1.753,1.151c0,0.636,0.785,1.152,1.753,1.152S394.134,392.12,394.134,391.484z M389.503,390.511 c0.949,0,1.718-0.505,1.718-1.128c0-0.623-0.769-1.129-1.718-1.129c-0.687,0-1.276,0.267-1.55,0.65 c-0.313-0.151-0.696-0.243-1.114-0.243c-1.044,0-1.889,0.556-1.889,1.241s0.846,1.241,1.889,1.241c0.808,0,1.492-0.335,1.762-0.803 C388.863,390.447,389.171,390.511,389.503,390.511z M383.995,390.864c-0.89,0-1.611,0.474-1.611,1.058 c0,0.584,0.721,1.058,1.611,1.058s1.611-0.474,1.611-1.058C385.606,391.337,384.885,390.864,383.995,390.864z M381.148,387.143 c0-0.333-0.411-0.603-0.918-0.603c-0.507,0-0.918,0.27-0.918,0.603c0,0.333,0.411,0.603,0.918,0.603 C380.737,387.746,381.148,387.476,381.148,387.143z M377.629,395.161c-0.789,0-1.429,0.42-1.429,0.939s0.64,0.939,1.429,0.939 c0.789,0,1.429-0.42,1.429-0.939S378.418,395.161,377.629,395.161z M374.25,398.483c0.431,0,0.78-0.229,0.78-0.513 s-0.349-0.513-0.78-0.513s-0.78,0.229-0.78,0.513S373.819,398.483,374.25,398.483z M369.57,390.072c0.41,0,0.743-0.219,0.743-0.488 s-0.333-0.488-0.743-0.488c-0.411,0-0.743,0.219-0.743,0.488S369.159,390.072,369.57,390.072z M366.773,386.285 c0-0.329-0.406-0.595-0.906-0.595c-0.5,0-0.906,0.267-0.906,0.595c0,0.329,0.406,0.595,0.906,0.595 C366.368,386.88,366.773,386.614,366.773,386.285z M363.213,386.837c0-0.335-0.414-0.607-0.925-0.607 c-0.511,0-0.925,0.272-0.925,0.607c0,0.335,0.414,0.607,0.925,0.607C362.799,387.444,363.213,387.172,363.213,386.837z  M359.591,381.92c0-0.452-0.558-0.819-1.247-0.819c-0.689,0-1.247,0.367-1.247,0.819s0.558,0.819,1.247,0.819 C359.033,382.739,359.591,382.372,359.591,381.92z M356.627,397.456c-0.73,0-1.322,0.389-1.322,0.868 c0,0.479,0.592,0.868,1.322,0.868s1.322-0.389,1.322-0.868C357.948,397.845,357.357,397.456,356.627,397.456z M352.83,393.937 c-0.417,0-0.756,0.222-0.756,0.496s0.338,0.496,0.756,0.496c0.417,0,0.756-0.222,0.756-0.496S353.248,393.937,352.83,393.937z  M348.948,381.281c0-0.221-0.273-0.4-0.609-0.4s-0.609,0.179-0.609,0.4c0,0.221,0.273,0.4,0.609,0.4 S348.948,381.502,348.948,381.281z M345.208,390.299c1.045,0,1.893-0.556,1.893-1.243c0-0.687-0.847-1.243-1.893-1.243 c-1.045,0-1.893,0.557-1.893,1.243C343.315,389.743,344.163,390.299,345.208,390.299z M342.214,385.537 c0.718,0,1.3-0.382,1.3-0.854c0-0.472-0.582-0.854-1.3-0.854c-0.718,0-1.3,0.382-1.3,0.854 C340.914,385.155,341.496,385.537,342.214,385.537z M339.035,380.523c-0.871,0-1.577,0.464-1.577,1.036 c0,0.572,0.706,1.036,1.577,1.036c0.871,0,1.577-0.464,1.577-1.036C340.612,380.987,339.906,380.523,339.035,380.523z  M336.931,393.381c-0.376,0-0.68,0.2-0.68,0.447c0,0.247,0.305,0.447,0.68,0.447s0.68-0.2,0.68-0.447 C337.611,393.581,337.307,393.381,336.931,393.381z M332.726,383.381c-0.516,0-0.935,0.275-0.935,0.614 c0,0.339,0.418,0.614,0.935,0.614c0.516,0,0.934-0.275,0.934-0.614C333.66,383.656,333.242,383.381,332.726,383.381z  M330.112,394.116c-0.331,0-0.6,0.176-0.6,0.394s0.268,0.394,0.6,0.394c0.331,0,0.599-0.176,0.599-0.394 S330.443,394.116,330.112,394.116z M325.579,382.691c0.719,0,1.301-0.383,1.301-0.855c0-0.472-0.583-0.855-1.301-0.855 c-0.719,0-1.302,0.383-1.302,0.855C324.278,382.308,324.86,382.691,325.579,382.691z M323.941,401.265 c0.341,0,0.618-0.182,0.618-0.406c0-0.224-0.277-0.406-0.618-0.406c-0.341,0-0.618,0.182-0.618,0.406 C323.323,401.083,323.6,401.265,323.941,401.265z M319.557,387.818c-0.781,0-1.415,0.416-1.415,0.929 c0,0.513,0.633,0.929,1.415,0.929s1.415-0.416,1.415-0.929C320.972,388.234,320.339,387.818,319.557,387.818z M315.377,381.035 c-0.917,0-1.66,0.488-1.66,1.09c0,0.602,0.743,1.09,1.66,1.09c0.917,0,1.66-0.488,1.66-1.09 C317.037,381.524,316.294,381.035,315.377,381.035z M311.321,383.418c-0.382,0-0.692,0.204-0.692,0.455s0.31,0.455,0.692,0.455 c0.382,0,0.692-0.204,0.692-0.455S311.703,383.418,311.321,383.418z M308.71,393.157c0.404,0,0.731-0.215,0.731-0.48 c0-0.265-0.328-0.48-0.731-0.48s-0.731,0.215-0.731,0.48C307.979,392.942,308.306,393.157,308.71,393.157z M305.659,390.468 c-0.637,0-1.198,0.209-1.539,0.528c-0.312-0.402-0.941-0.68-1.675-0.68c-1.042,0-1.887,0.555-1.887,1.24 c0,0.685,0.845,1.24,1.887,1.24c0.64,0,1.204-0.211,1.545-0.531c0.312,0.4,0.938,0.676,1.669,0.676 c1.039,0,1.882-0.553,1.882-1.236C307.54,391.022,306.698,390.468,305.659,390.468z M299.154,395.992c0.751,0,1.36-0.4,1.36-0.894 c0-0.493-0.609-0.893-1.36-0.893c-0.751,0-1.36,0.4-1.36,0.893C297.793,395.592,298.402,395.992,299.154,395.992z M295.413,398.203 c-0.7,0-1.267,0.373-1.267,0.832c0,0.459,0.567,0.832,1.267,0.832c0.7,0,1.267-0.373,1.267-0.832 C296.68,398.575,296.113,398.203,295.413,398.203z M291.084,392.195c-0.758,0-1.373,0.404-1.373,0.902 c0,0.498,0.615,0.902,1.373,0.902c0.758,0,1.373-0.404,1.373-0.902C292.457,392.598,291.843,392.195,291.084,392.195z  M287.056,384.623c-0.683,0-1.237,0.364-1.237,0.813c0,0.449,0.554,0.813,1.237,0.813c0.683,0,1.237-0.364,1.237-0.813 C288.293,384.987,287.739,384.623,287.056,384.623z M286.431,402.291c0-0.608-0.75-1.1-1.675-1.1c-0.925,0-1.676,0.493-1.676,1.1 c0,0.608,0.75,1.1,1.676,1.1C285.681,403.392,286.431,402.899,286.431,402.291z M279.038,384.967c-0.776,0-1.405,0.413-1.405,0.923 c0,0.51,0.629,0.923,1.405,0.923c0.776,0,1.405-0.413,1.405-0.923C280.443,385.38,279.814,384.967,279.038,384.967z  M275.754,387.294c-0.944,0-1.709,0.502-1.709,1.122c0,0.62,0.765,1.122,1.709,1.122c0.944,0,1.709-0.503,1.709-1.122 C277.463,387.796,276.698,387.294,275.754,387.294z M273.086,397.187c-0.974,0-1.764,0.519-1.764,1.159 c0,0.64,0.79,1.159,1.764,1.159c0.974,0,1.764-0.519,1.764-1.159C274.85,397.706,274.06,397.187,273.086,397.187z M270.429,388.156 c0-0.381-0.471-0.69-1.051-0.69c-0.58,0-1.051,0.309-1.051,0.69c0,0.381,0.471,0.69,1.051,0.69 C269.958,388.846,270.429,388.537,270.429,388.156z M268.449,395.403c0-0.47-0.58-0.851-1.296-0.851 c-0.716,0-1.296,0.381-1.296,0.851s0.58,0.851,1.296,0.851C267.869,396.254,268.449,395.873,268.449,395.403z M263.367,389.888 c-0.948,0-1.716,0.504-1.716,1.127c0,0.622,0.768,1.127,1.716,1.127c0.948,0,1.716-0.505,1.716-1.127 C265.083,390.393,264.315,389.888,263.367,389.888z M260.27,391.536c-1.03,0-1.864,0.548-1.864,1.225 c0,0.676,0.835,1.224,1.864,1.224c1.03,0,1.864-0.548,1.864-1.224C262.134,392.085,261.3,391.536,260.27,391.536z M256.124,387.43 c-0.417,0-0.756,0.222-0.756,0.497c0,0.274,0.339,0.497,0.756,0.497c0.418,0,0.756-0.222,0.756-0.497 C256.88,387.653,256.542,387.43,256.124,387.43z M254.584,399.491c0-0.249-0.307-0.45-0.685-0.45c-0.378,0-0.685,0.202-0.685,0.45 c0,0.249,0.307,0.45,0.685,0.45C254.278,399.941,254.584,399.739,254.584,399.491z M252.575,403.386 c0-0.423-0.522-0.766-1.166-0.766c-0.644,0-1.166,0.343-1.166,0.766c0,0.423,0.522,0.766,1.166,0.766 C252.053,404.152,252.575,403.809,252.575,403.386z M248.289,392.145c0-0.528-0.652-0.957-1.456-0.957 c-0.804,0-1.456,0.428-1.456,0.957c0,0.528,0.652,0.957,1.456,0.957C247.637,393.102,248.289,392.674,248.289,392.145z  M243.745,391.738c-0.714,0-1.293,0.38-1.293,0.849s0.579,0.849,1.293,0.849c0.714,0,1.293-0.38,1.293-0.849 S244.46,391.738,243.745,391.738z M241.305,400.605c0.445,0,0.805-0.237,0.805-0.529s-0.361-0.529-0.805-0.529 c-0.445,0-0.805,0.237-0.805,0.529S240.86,400.605,241.305,400.605z M237.749,402.786c-0.094,0-0.184,0.013-0.268,0.032 c-0.323-0.166-0.724-0.268-1.165-0.268c-1.049,0-1.9,0.559-1.9,1.248s0.851,1.248,1.9,1.248c1.05,0,1.9-0.559,1.9-1.248 c0-0.013-0.005-0.026-0.006-0.039c0.212-0.096,0.351-0.257,0.351-0.439C238.562,403.025,238.198,402.786,237.749,402.786z  M232.896,388.736c-0.385,0-0.697,0.205-0.697,0.458c0,0.253,0.312,0.458,0.697,0.458c0.385,0,0.697-0.205,0.697-0.458 C233.593,388.941,233.281,388.736,232.896,388.736z M230.207,399.329c0.32,0,0.58-0.171,0.58-0.381c0-0.21-0.26-0.381-0.58-0.381 c-0.32,0-0.58,0.171-0.58,0.381C229.627,399.158,229.886,399.329,230.207,399.329z M226.827,392.91c0-0.287-0.354-0.52-0.792-0.52 s-0.791,0.233-0.791,0.52c0,0.287,0.354,0.52,0.791,0.52S226.827,393.197,226.827,392.91z M221.848,393.351 c0.795,0,1.44-0.424,1.44-0.946c0-0.523-0.645-0.946-1.44-0.946c-0.795,0-1.44,0.423-1.44,0.946 C220.408,392.927,221.053,393.351,221.848,393.351z M218.934,391.844c0.829,0,1.501-0.442,1.501-0.986 c0-0.545-0.672-0.986-1.501-0.986c-0.829,0-1.501,0.441-1.501,0.986C217.433,391.403,218.105,391.844,218.934,391.844z  M217.461,392.508c0-0.54-0.667-0.979-1.49-0.979s-1.49,0.438-1.49,0.979c0,0.54,0.667,0.979,1.49,0.979 S217.461,393.049,217.461,392.508z M211.875,391.875c-0.533,0-0.966,0.284-0.966,0.634c0,0.35,0.432,0.634,0.966,0.634 c0.533,0,0.965-0.284,0.965-0.634C212.841,392.159,212.408,391.875,211.875,391.875z M208.046,395.679 c-0.977,0-1.769,0.52-1.769,1.162c0,0.642,0.792,1.162,1.769,1.162c0.977,0,1.769-0.52,1.769-1.162 C209.815,396.199,209.023,395.679,208.046,395.679z M205.865,401.627c-0.859,0-1.555,0.457-1.555,1.021 c0,0.564,0.696,1.021,1.555,1.021c0.859,0,1.555-0.457,1.555-1.021C207.42,402.084,206.724,401.627,205.865,401.627z  M202.038,397.475c-0.306,0-0.555,0.163-0.555,0.365c0,0.201,0.249,0.365,0.555,0.365c0.307,0,0.555-0.163,0.555-0.365 C202.593,397.638,202.344,397.475,202.038,397.475z M198.999,398.263c-0.416,0-0.753,0.221-0.753,0.494 c0,0.273,0.337,0.494,0.753,0.494s0.753-0.221,0.753-0.494C199.752,398.484,199.415,398.263,198.999,398.263z M195.076,390.459 c-0.602,0-1.09,0.32-1.09,0.716s0.488,0.716,1.09,0.716s1.09-0.32,1.09-0.716S195.678,390.459,195.076,390.459z M193.482,401.518 c-0.304,0-0.55,0.162-0.55,0.361s0.246,0.361,0.55,0.361s0.55-0.162,0.55-0.361S193.786,401.518,193.482,401.518z M189.851,405.084 c-0.53,0-0.96,0.282-0.96,0.63c0,0.348,0.43,0.63,0.96,0.63c0.53,0,0.959-0.282,0.959-0.63 C190.81,405.366,190.38,405.084,189.851,405.084z M185.009,391.772c-0.7,0-1.268,0.373-1.268,0.833c0,0.46,0.568,0.833,1.268,0.833 c0.701,0,1.268-0.373,1.268-0.833C186.277,392.145,185.709,391.772,185.009,391.772z M181.743,399.799 c-0.765,0-1.385,0.407-1.385,0.909s0.62,0.909,1.385,0.909c0.764,0,1.384-0.407,1.384-0.909S182.508,399.799,181.743,399.799z  M177.936,403.242c-0.508,0-0.919,0.27-0.919,0.604s0.411,0.604,0.919,0.604s0.919-0.27,0.919-0.604 S178.443,403.242,177.936,403.242z M174.891,401.358c-0.576,0-1.042,0.307-1.042,0.685c0,0.378,0.467,0.685,1.042,0.685 c0.576,0,1.042-0.306,1.042-0.685C175.934,401.665,175.467,401.358,174.891,401.358z M172.447,406.101 c-0.749,0-1.356,0.399-1.356,0.891c0,0.492,0.607,0.89,1.356,0.89c0.749,0,1.356-0.399,1.356-0.89 C173.803,406.5,173.196,406.101,172.447,406.101z M167.887,395.107c-0.952,0-1.723,0.507-1.723,1.132 c0,0.625,0.771,1.132,1.723,1.132c0.952,0,1.723-0.507,1.723-1.132C169.61,395.614,168.839,395.107,167.887,395.107z  M164.709,406.661c-0.851,0-1.541,0.453-1.541,1.012c0,0.559,0.69,1.012,1.541,1.012s1.541-0.453,1.541-1.012 C166.25,407.115,165.56,406.661,164.709,406.661z M160.701,403.116c-0.748,0-1.355,0.398-1.355,0.89c0,0.491,0.607,0.89,1.355,0.89 s1.355-0.398,1.355-0.89C162.055,403.515,161.449,403.116,160.701,403.116z M155.623,395.705c-0.482,0-0.873,0.257-0.873,0.573 c0,0.317,0.391,0.573,0.873,0.573c0.482,0,0.873-0.257,0.873-0.573C156.496,395.962,156.105,395.705,155.623,395.705z  M152.152,400.609c-0.409,0-0.74,0.218-0.74,0.486c0,0.268,0.331,0.486,0.74,0.486s0.74-0.218,0.74-0.486 C152.892,400.826,152.56,400.609,152.152,400.609z M147.405,393.264c-0.635,0-1.149,0.338-1.149,0.755 c0,0.417,0.514,0.755,1.149,0.755c0.635,0,1.149-0.338,1.149-0.755C148.554,393.602,148.04,393.264,147.405,393.264z  M144.332,391.684c-0.454,0-0.822,0.242-0.822,0.54c0,0.298,0.368,0.54,0.822,0.54c0.454,0,0.822-0.242,0.822-0.54 C145.154,391.926,144.786,391.684,144.332,391.684z M141.496,394.272c-0.515,0-0.932,0.274-0.932,0.612s0.417,0.612,0.932,0.612 c0.515,0,0.932-0.274,0.932-0.612S142.011,394.272,141.496,394.272z M136.997,389.619c-0.667,0-1.207,0.355-1.207,0.793 s0.54,0.793,1.207,0.793c0.666,0,1.207-0.355,1.207-0.793S137.663,389.619,136.997,389.619z M133.72,394.901 c-0.609,0-1.104,0.324-1.104,0.725c0,0.4,0.494,0.725,1.104,0.725c0.609,0,1.104-0.325,1.104-0.725 C134.824,395.225,134.33,394.901,133.72,394.901z M131.84,406.928c-0.913,0-1.654,0.486-1.654,1.086c0,0.6,0.74,1.086,1.654,1.086 s1.654-0.486,1.654-1.086C133.493,407.414,132.753,406.928,131.84,406.928z M127.578,405.718c-1.013,0-1.835,0.54-1.835,1.205 c0,0.666,0.822,1.205,1.835,1.205c1.013,0,1.835-0.54,1.835-1.205C129.413,406.257,128.591,405.718,127.578,405.718z  M123.469,404.178c-0.906,0-1.64,0.482-1.64,1.077s0.734,1.077,1.64,1.077c0.906,0,1.64-0.482,1.64-1.077 S124.375,404.178,123.469,404.178z M119.439,404.754c-0.748,0-1.355,0.398-1.355,0.89s0.606,0.89,1.355,0.89 c0.748,0,1.355-0.398,1.355-0.89S120.187,404.754,119.439,404.754z M114.347,393.716c-0.53,0-0.961,0.282-0.961,0.631 c0,0.348,0.43,0.631,0.961,0.631c0.531,0,0.961-0.283,0.961-0.631C115.308,393.998,114.878,393.716,114.347,393.716z  M110.213,392.903c-0.509,0-0.922,0.271-0.922,0.605c0,0.334,0.413,0.605,0.922,0.605c0.509,0,0.922-0.271,0.922-0.605 C111.135,393.174,110.722,392.903,110.213,392.903z M108.797,403.486c-0.87,0-1.575,0.463-1.575,1.034 c0,0.571,0.705,1.034,1.575,1.034c0.87,0,1.575-0.463,1.575-1.034C110.372,403.949,109.667,403.486,108.797,403.486z  M105.095,400.767c-0.603,0-1.093,0.321-1.093,0.718s0.489,0.718,1.093,0.718c0.603,0,1.092-0.321,1.092-0.718 S105.698,400.767,105.095,400.767z M100.71,394.908c-0.649,0-1.175,0.346-1.175,0.772c0,0.426,0.526,0.772,1.175,0.772 c0.649,0,1.175-0.345,1.175-0.772C101.885,395.254,101.359,394.908,100.71,394.908z M96.126,392.666 c-0.91,0-1.648,0.485-1.648,1.082c0,0.598,0.738,1.083,1.648,1.083c0.91,0,1.648-0.485,1.648-1.083 C97.774,393.151,97.036,392.666,96.126,392.666z M95.197,406.82c-0.424,0-0.769,0.226-0.769,0.505s0.344,0.505,0.769,0.505 s0.769-0.226,0.769-0.505S95.621,406.82,95.197,406.82z M91.508,399.712c-0.427,0-0.774,0.228-0.774,0.508 c0,0.281,0.346,0.508,0.774,0.508c0.427,0,0.774-0.228,0.774-0.508C92.282,399.94,91.935,399.712,91.508,399.712z M88.615,407.604 c-0.741,0-1.342,0.395-1.342,0.881s0.601,0.881,1.342,0.881c0.741,0,1.342-0.395,1.342-0.881S89.356,407.604,88.615,407.604z  M84.789,406.849c-0.908,0-1.644,0.484-1.644,1.08c0,0.596,0.736,1.08,1.644,1.08c0.908,0,1.644-0.483,1.644-1.08 C86.433,407.332,85.697,406.849,84.789,406.849z M81.298,407.334c-0.451,0-0.816,0.24-0.816,0.536s0.366,0.536,0.816,0.536 c0.451,0,0.817-0.24,0.817-0.536S81.748,407.334,81.298,407.334z M77.8,409.996c-0.471,0-0.852,0.251-0.852,0.56 c0,0.309,0.382,0.56,0.852,0.56c0.471,0,0.852-0.251,0.852-0.56C78.652,410.246,78.271,409.996,77.8,409.996z M74.138,403.713 c-0.891,0-1.613,0.474-1.613,1.06s0.722,1.06,1.613,1.06s1.613-0.474,1.613-1.06S75.029,403.713,74.138,403.713z M71.266,404.796 c-0.768,0-1.39,0.409-1.39,0.913c0,0.504,0.622,0.913,1.39,0.913c0.767,0,1.39-0.409,1.39-0.913 C72.656,405.205,72.034,404.796,71.266,404.796z M69.469,411.858c-0.908,0-1.643,0.483-1.643,1.079s0.736,1.079,1.643,1.079 c0.908,0,1.643-0.483,1.643-1.079S70.376,411.858,69.469,411.858z M63.563,396.407c-0.333,0-0.603,0.177-0.603,0.396 c0,0.219,0.27,0.396,0.603,0.396s0.603-0.177,0.603-0.396C64.166,396.584,63.896,396.407,63.563,396.407z M59.984,396.227 c-1.051,0-1.903,0.56-1.903,1.25c0,0.69,0.852,1.25,1.903,1.25c1.051,0,1.903-0.56,1.903-1.25 C61.887,396.786,61.035,396.227,59.984,396.227z M57.528,408.01c-0.305,0-0.553,0.163-0.553,0.363s0.248,0.363,0.553,0.363 c0.306,0,0.553-0.163,0.553-0.363S57.834,408.01,57.528,408.01z M54.187,403.858c-0.804,0-1.457,0.428-1.457,0.957 c0,0.528,0.652,0.957,1.457,0.957c0.804,0,1.456-0.428,1.456-0.957C55.643,404.286,54.991,403.858,54.187,403.858z M50.792,400.152 c-0.496,0-0.898,0.264-0.898,0.589c0,0.326,0.402,0.59,0.898,0.59c0.496,0,0.897-0.264,0.897-0.59 C51.69,400.416,51.288,400.152,50.792,400.152z M48.262,409.709c-0.475,0-0.861,0.253-0.861,0.565c0,0.312,0.385,0.565,0.861,0.565 c0.476,0,0.861-0.253,0.861-0.565C49.123,409.962,48.737,409.709,48.262,409.709z M45.536,409.063c-1.016,0-1.84,0.541-1.84,1.208 s0.824,1.208,1.84,1.208c1.016,0,1.84-0.541,1.84-1.208S46.552,409.063,45.536,409.063z M42.466,410.36 c-0.431,0-0.78,0.229-0.78,0.512c0,0.283,0.349,0.512,0.78,0.512s0.78-0.229,0.78-0.512 C43.246,410.589,42.896,410.36,42.466,410.36z M39.956,413.195c-0.361,0-0.655,0.192-0.655,0.43c0,0.237,0.293,0.43,0.655,0.43 c0.361,0,0.654-0.193,0.654-0.43C40.611,413.388,40.318,413.195,39.956,413.195z M34.849,397.478c-0.686,0-1.242,0.365-1.242,0.816 c0,0.451,0.556,0.816,1.242,0.816c0.686,0,1.242-0.365,1.242-0.816C36.091,397.843,35.535,397.478,34.849,397.478z M32.4,404.992 c-0.469,0-0.849,0.249-0.849,0.557s0.38,0.557,0.849,0.557c0.469,0,0.848-0.25,0.848-0.557S32.868,404.992,32.4,404.992z  M27.016,397.746c-0.537,0-0.972,0.286-0.972,0.639s0.435,0.639,0.972,0.639c0.537,0,0.972-0.286,0.972-0.639 S27.553,397.746,27.016,397.746z M25.557,407.242c-0.939,0-1.701,0.5-1.701,1.117c0,0.617,0.761,1.117,1.701,1.117 c0.939,0,1.701-0.5,1.701-1.117C27.257,407.743,26.496,407.242,25.557,407.242z M22.422,408.067c-0.746,0-1.351,0.397-1.351,0.887 c0,0.49,0.605,0.887,1.351,0.887c0.746,0,1.351-0.397,1.351-0.887C23.773,408.464,23.168,408.067,22.422,408.067z M20.065,411.663 c-0.976,0-1.766,0.519-1.766,1.16c0,0.641,0.791,1.16,1.766,1.16s1.766-0.519,1.766-1.16 C21.831,412.182,21.04,411.663,20.065,411.663z M15.815,401.866c-1.02,0-1.846,0.543-1.846,1.213s0.827,1.213,1.846,1.213 s1.846-0.543,1.846-1.213S16.835,401.866,15.815,401.866z M14.352,416.14c-0.497,0-0.9,0.265-0.9,0.591 c0,0.326,0.403,0.591,0.9,0.591c0.497,0,0.9-0.264,0.9-0.591C15.251,416.405,14.849,416.14,14.352,416.14z M8.7,400.051 c-0.748,0-1.354,0.398-1.354,0.889s0.606,0.889,1.354,0.889c0.748,0,1.354-0.398,1.354-0.889S9.448,400.051,8.7,400.051z  M7.308,411.94c-0.833,0-1.507,0.443-1.507,0.99c0,0.547,0.675,0.99,1.507,0.99c0.833,0,1.507-0.443,1.507-0.99 C8.815,412.384,8.14,411.94,7.308,411.94z M3.99,409.922c-0.456,0-0.826,0.243-0.826,0.543c0,0.3,0.37,0.543,0.826,0.543 c0.456,0,0.826-0.243,0.826-0.543C4.816,410.165,4.446,409.922,3.99,409.922z M-0.619,404.44c-0.78,0-1.412,0.415-1.412,0.927 c0,0.512,0.632,0.927,1.412,0.927c0.78,0,1.412-0.415,1.412-0.927C0.793,404.855,0.161,404.44-0.619,404.44z M-3.696,409.741 c-0.542,0-0.98,0.288-0.98,0.644c0,0.356,0.439,0.644,0.98,0.644c0.541,0,0.98-0.288,0.98-0.644 C-2.715,410.03-3.154,409.741-3.696,409.741z M-8.115,401.708c-0.503,0-0.91,0.268-0.91,0.598c0,0.33,0.408,0.598,0.91,0.598 c0.503,0,0.91-0.268,0.91-0.598C-7.204,401.976-7.612,401.708-8.115,401.708z M-10.432,410.872c-1.018,0-1.844,0.542-1.844,1.211 c0,0.669,0.826,1.211,1.844,1.211c1.018,0,1.844-0.542,1.844-1.211C-8.588,411.414-9.413,410.872-10.432,410.872z M-13.959,412.47 c-0.602,0-1.089,0.32-1.089,0.716s0.488,0.715,1.089,0.715c0.602,0,1.089-0.32,1.089-0.715S-13.357,412.47-13.959,412.47z  M-18.812,406.455c-0.628,0-1.137,0.334-1.137,0.747s0.509,0.747,1.137,0.747c0.628,0,1.137-0.334,1.137-0.747 S-18.184,406.455-18.812,406.455z M-21.842,412.034c-0.696,0-1.26,0.37-1.26,0.827s0.564,0.827,1.26,0.827s1.26-0.37,1.26-0.827 S-21.146,412.034-21.842,412.034z M468.132,399.644c-0.656,0-1.189,0.349-1.189,0.781c0,0.431,0.532,0.781,1.189,0.781 c0.656,0,1.189-0.35,1.189-0.781C469.321,399.993,468.789,399.644,468.132,399.644z M463.948,407.329 c-0.447,0-0.809,0.238-0.809,0.531c0,0.293,0.362,0.531,0.809,0.531s0.809-0.238,0.809-0.531 C464.756,407.567,464.394,407.329,463.948,407.329z M459.881,401.215c-0.305,0-0.553,0.163-0.553,0.363 c0,0.201,0.248,0.363,0.553,0.363c0.305,0,0.553-0.163,0.553-0.363C460.434,401.377,460.186,401.215,459.881,401.215z  M455.633,417.644c-0.546,0-0.989,0.291-0.989,0.65c0,0.359,0.443,0.65,0.989,0.65c0.546,0,0.989-0.291,0.989-0.65 C456.622,417.935,456.179,417.644,455.633,417.644z M451.296,416.764c-0.592,0-1.071,0.315-1.071,0.704s0.48,0.704,1.071,0.704 c0.592,0,1.072-0.315,1.072-0.704S451.887,416.764,451.296,416.764z M447.211,410.38c-0.407,0-0.737,0.217-0.737,0.484 s0.33,0.484,0.737,0.484c0.407,0,0.737-0.217,0.737-0.484S447.618,410.38,447.211,410.38z M444.307,410.01 c-1.011,0-1.83,0.538-1.83,1.202c0,0.664,0.819,1.202,1.83,1.202c1.011,0,1.83-0.538,1.83-1.202 C446.137,410.548,445.317,410.01,444.307,410.01z M440.904,414.947c-0.382,0-0.691,0.203-0.691,0.454 c0,0.251,0.31,0.454,0.691,0.454c0.382,0,0.691-0.203,0.691-0.454C441.596,415.151,441.286,414.947,440.904,414.947z  M437.681,399.568c-0.659,0-1.194,0.351-1.194,0.784s0.535,0.784,1.194,0.784c0.66,0,1.194-0.351,1.194-0.784 S438.341,399.568,437.681,399.568z M433.874,406.735c-0.411,0-0.744,0.219-0.744,0.489c0,0.27,0.333,0.489,0.744,0.489 s0.744-0.219,0.744-0.489C434.618,406.954,434.285,406.735,433.874,406.735z M430.363,405.777c-0.88,0-1.593,0.468-1.593,1.046 s0.713,1.046,1.593,1.046c0.88,0,1.593-0.468,1.593-1.046S431.242,405.777,430.363,405.777z M426.824,411.36 c-1.023,0-1.853,0.545-1.853,1.217s0.829,1.217,1.853,1.217s1.853-0.545,1.853-1.217S427.847,411.36,426.824,411.36z  M423.567,405.772c-0.808,0-1.463,0.43-1.463,0.961c0,0.531,0.655,0.961,1.463,0.961c0.808,0,1.463-0.43,1.463-0.961 C425.029,406.202,424.375,405.772,423.567,405.772z M419.332,408.964c-1.026,0-1.858,0.546-1.858,1.22 c0,0.674,0.832,1.22,1.858,1.22c1.026,0,1.857-0.546,1.857-1.22C421.189,409.51,420.357,408.964,419.332,408.964z M416.106,410.908 c-0.56,0-1.014,0.298-1.014,0.666c0,0.368,0.454,0.666,1.014,0.666c0.56,0,1.014-0.298,1.014-0.666 C417.12,411.207,416.666,410.908,416.106,410.908z M412.143,400.341c-0.431,0-0.78,0.229-0.78,0.513 c0,0.283,0.349,0.512,0.78,0.512c0.431,0,0.78-0.229,0.78-0.512C412.923,400.57,412.574,400.341,412.143,400.341z M408.073,409.19 c-0.762,0-1.38,0.406-1.38,0.907c0,0.501,0.618,0.907,1.38,0.907s1.38-0.406,1.38-0.907 C409.454,409.596,408.836,409.19,408.073,409.19z M404.309,418.211c-0.673,0-1.218,0.358-1.218,0.8s0.545,0.8,1.218,0.8 c0.673,0,1.218-0.358,1.218-0.8S404.981,418.211,404.309,418.211z M400.435,401.75c-0.575,0-1.042,0.306-1.042,0.684 s0.467,0.684,1.042,0.684c0.576,0,1.042-0.306,1.042-0.684S401.011,401.75,400.435,401.75z M396.49,411.813 c-0.698,0-1.265,0.372-1.265,0.831c0,0.459,0.566,0.831,1.265,0.831s1.264-0.372,1.264-0.831 C397.754,412.185,397.188,411.813,396.49,411.813z M393.813,417.377c-0.582,0-1.053,0.31-1.053,0.692s0.472,0.692,1.053,0.692 s1.053-0.31,1.053-0.692S394.394,417.377,393.813,417.377z M390.052,403.681c-0.822,0-1.489,0.438-1.489,0.978 c0,0.54,0.667,0.978,1.489,0.978c0.822,0,1.489-0.438,1.489-0.978C391.541,404.119,390.874,403.681,390.052,403.681z  M386.851,401.909c-0.639,0-1.156,0.34-1.156,0.759c0,0.419,0.518,0.759,1.156,0.759c0.638,0,1.156-0.34,1.156-0.759 C388.007,402.249,387.49,401.909,386.851,401.909z M383.315,403.37c-0.557,0-1.009,0.297-1.009,0.663 c0,0.366,0.452,0.663,1.009,0.663c0.557,0,1.009-0.297,1.009-0.663C384.325,403.667,383.873,403.37,383.315,403.37z  M380.549,409.676c-0.438,0-0.793,0.233-0.793,0.521c0,0.288,0.355,0.521,0.793,0.521c0.438,0,0.793-0.233,0.793-0.521 C381.342,409.909,380.987,409.676,380.549,409.676z M377.311,403.729c-0.362,0-0.656,0.193-0.656,0.431 c0,0.238,0.294,0.431,0.656,0.431c0.362,0,0.656-0.193,0.656-0.431C377.967,403.922,377.673,403.729,377.311,403.729z  M373.871,407.836c-0.816,0-1.478,0.435-1.478,0.971c0,0.536,0.662,0.971,1.478,0.971c0.816,0,1.478-0.435,1.478-0.971 C375.349,408.27,374.687,407.836,373.871,407.836z M369.871,404.906c-0.587,0-1.063,0.313-1.063,0.698 c0,0.386,0.476,0.698,1.063,0.698c0.587,0,1.063-0.313,1.063-0.698C370.934,405.219,370.458,404.906,369.871,404.906z  M366.465,418.122c-0.618,0-1.118,0.329-1.118,0.735c0,0.406,0.501,0.735,1.118,0.735c0.618,0,1.119-0.329,1.119-0.735 C367.583,418.451,367.082,418.122,366.465,418.122z M362.705,411.479c-0.424,0-0.767,0.225-0.767,0.504s0.343,0.504,0.767,0.504 c0.423,0,0.767-0.226,0.767-0.504S363.129,411.479,362.705,411.479z M359.577,412.843c-0.436,0-0.79,0.232-0.79,0.519 c0,0.287,0.354,0.519,0.79,0.519c0.437,0,0.79-0.232,0.79-0.519C360.367,413.075,360.014,412.843,359.577,412.843z M355.596,402.46 c-0.904,0-1.637,0.482-1.637,1.076c0,0.594,0.733,1.076,1.637,1.076c0.904,0,1.638-0.482,1.638-1.076 C357.233,402.942,356.5,402.46,355.596,402.46z M352.456,408.237c-0.386,0-0.699,0.205-0.699,0.459 c0,0.253,0.313,0.459,0.699,0.459c0.386,0,0.699-0.205,0.699-0.459C353.155,408.443,352.842,408.237,352.456,408.237z  M349.679,407.548c-0.68,0-1.231,0.362-1.231,0.809c0,0.447,0.551,0.809,1.231,0.809s1.231-0.362,1.231-0.809 C350.91,407.91,350.359,407.548,349.679,407.548z M346.031,405.584c-0.634,0-1.148,0.338-1.148,0.754 c0,0.417,0.514,0.754,1.148,0.754c0.634,0,1.148-0.338,1.148-0.754C347.18,405.922,346.666,405.584,346.031,405.584z  M342.603,407.203c-0.891,0-1.613,0.474-1.613,1.06s0.722,1.06,1.613,1.06c0.891,0,1.613-0.474,1.613-1.06 S343.494,407.203,342.603,407.203z M338.53,408.334c-0.434,0-0.785,0.231-0.785,0.516c0,0.285,0.352,0.516,0.785,0.516 s0.785-0.231,0.785-0.516C339.315,408.565,338.964,408.334,338.53,408.334z M336.239,415.336c-0.583,0-1.056,0.311-1.056,0.694 c0,0.383,0.473,0.694,1.056,0.694c0.583,0,1.056-0.311,1.056-0.694C337.295,415.647,336.823,415.336,336.239,415.336z  M331.907,410.526c-0.401,0-0.726,0.213-0.726,0.477c0,0.263,0.325,0.477,0.726,0.477s0.726-0.213,0.726-0.477 C332.633,410.739,332.308,410.526,331.907,410.526z M328.584,413.189c-0.879,0-1.592,0.468-1.592,1.046 c0,0.578,0.713,1.046,1.592,1.046c0.879,0,1.592-0.468,1.592-1.046C330.177,413.657,329.464,413.189,328.584,413.189z  M325.407,407.197c-0.964,0-1.745,0.513-1.745,1.146c0,0.633,0.781,1.146,1.745,1.146c0.964,0,1.745-0.513,1.745-1.146 C327.152,407.71,326.371,407.197,325.407,407.197z M323.143,417.785c-0.33,0-0.597,0.176-0.597,0.392 c0,0.217,0.267,0.393,0.597,0.393c0.33,0,0.598-0.176,0.598-0.393C323.741,417.961,323.473,417.785,323.143,417.785z  M318.301,404.349c-0.352,0-0.637,0.187-0.637,0.418c0,0.231,0.285,0.418,0.637,0.418c0.352,0,0.637-0.187,0.637-0.418 C318.938,404.536,318.653,404.349,318.301,404.349z M313.824,401.162c-0.41,0-0.743,0.219-0.743,0.488 c0,0.27,0.333,0.488,0.743,0.488c0.411,0,0.743-0.219,0.743-0.488C314.567,401.38,314.234,401.162,313.824,401.162z  M309.769,400.755c-0.985,0-1.784,0.525-1.784,1.172c0,0.647,0.799,1.172,1.784,1.172c0.985,0,1.784-0.525,1.784-1.172 C311.553,401.28,310.754,400.755,309.769,400.755z M306.389,413.539c-0.339,0-0.614,0.181-0.614,0.404 c0,0.223,0.275,0.404,0.614,0.404c0.339,0,0.614-0.181,0.614-0.404C307.003,413.72,306.728,413.539,306.389,413.539z  M301.194,401.696c-0.778,0-1.409,0.414-1.409,0.926c0,0.511,0.631,0.925,1.409,0.925s1.409-0.414,1.409-0.925 C302.603,402.11,301.972,401.696,301.194,401.696z M297.783,410.195c-0.786,0-1.423,0.418-1.423,0.935 c0,0.516,0.637,0.935,1.423,0.935s1.423-0.418,1.423-0.935C299.206,410.614,298.569,410.195,297.783,410.195z M294.205,403.027 c-0.789,0-1.428,0.42-1.428,0.938c0,0.518,0.639,0.938,1.428,0.938c0.788,0,1.427-0.42,1.427-0.938 C295.632,403.447,294.993,403.027,294.205,403.027z M290.298,401.237c-0.698,0-1.264,0.372-1.264,0.83 c0,0.459,0.566,0.83,1.264,0.83c0.698,0,1.264-0.372,1.264-0.83C291.562,401.609,290.996,401.237,290.298,401.237z  M287.503,406.242c-0.339,0-0.614,0.181-0.614,0.403c0,0.223,0.275,0.403,0.614,0.403c0.339,0,0.614-0.18,0.614-0.403 C288.116,406.422,287.841,406.242,287.503,406.242z M285.132,411.518c-0.741,0-1.342,0.395-1.342,0.881 c0,0.487,0.601,0.881,1.342,0.881c0.741,0,1.342-0.395,1.342-0.881C286.474,411.912,285.873,411.518,285.132,411.518z  M281.465,406.293c-0.685,0-1.241,0.365-1.241,0.815c0,0.45,0.555,0.815,1.241,0.815c0.685,0,1.241-0.365,1.241-0.815 C282.706,406.657,282.15,406.293,281.465,406.293z M278.807,420.103c-0.317,0-0.574,0.169-0.574,0.377 c0,0.208,0.257,0.377,0.574,0.377s0.575-0.169,0.575-0.377C279.382,420.272,279.124,420.103,278.807,420.103z M275.37,420.495 c-0.346,0-0.626,0.184-0.626,0.411c0,0.227,0.28,0.411,0.626,0.411c0.346,0,0.626-0.184,0.626-0.411 C275.996,420.679,275.716,420.495,275.37,420.495z M271.566,417.638c-0.979,0-1.772,0.521-1.772,1.164 c0,0.643,0.793,1.164,1.772,1.164c0.979,0,1.772-0.521,1.772-1.164C273.338,418.159,272.545,417.638,271.566,417.638z  M267.821,417.426c-0.731,0-1.324,0.389-1.324,0.87c0,0.48,0.593,0.87,1.324,0.87c0.731,0,1.324-0.389,1.324-0.87 C269.145,417.816,268.552,417.426,267.821,417.426z M262.756,406.265c-0.401,0-0.725,0.213-0.725,0.477 c0,0.263,0.325,0.477,0.725,0.477c0.401,0,0.725-0.213,0.725-0.477C263.481,406.479,263.156,406.265,262.756,406.265z  M259.263,409.803c-0.359,0-0.651,0.191-0.651,0.427c0,0.236,0.291,0.427,0.651,0.427c0.359,0,0.651-0.191,0.651-0.427 C259.913,409.995,259.622,409.803,259.263,409.803z M255.139,407.786c-0.548,0-0.993,0.292-0.993,0.652 c0,0.36,0.444,0.652,0.993,0.652c0.548,0,0.993-0.292,0.993-0.652C256.132,408.078,255.687,407.786,255.139,407.786z  M252.081,416.023c-0.635,0-1.149,0.338-1.149,0.755c0,0.417,0.514,0.755,1.149,0.755c0.635,0,1.149-0.338,1.149-0.755 C253.23,416.361,252.716,416.023,252.081,416.023z M248.829,419.857c-0.837,0-1.516,0.446-1.516,0.996s0.679,0.996,1.516,0.996 c0.837,0,1.516-0.446,1.516-0.996S249.666,419.857,248.829,419.857z M243.5,405.473c-0.475,0-0.86,0.253-0.86,0.565 c0,0.312,0.385,0.565,0.86,0.565c0.475,0,0.86-0.253,0.86-0.565C244.36,405.726,243.975,405.473,243.5,405.473z M241.226,411.582 c-0.995,0-1.801,0.53-1.801,1.183s0.806,1.183,1.801,1.183c0.995,0,1.801-0.53,1.801-1.183S242.22,411.582,241.226,411.582z  M234.529,418.874c-0.311,0-0.563,0.166-0.563,0.37c0,0.204,0.252,0.37,0.563,0.37c0.311,0,0.563-0.165,0.563-0.37 C235.092,419.039,234.84,418.874,234.529,418.874z M230.112,402.461c-0.597,0-1.08,0.318-1.08,0.71c0,0.392,0.484,0.71,1.08,0.71 c0.597,0,1.08-0.318,1.08-0.71C231.193,402.779,230.709,402.461,230.112,402.461z M227.046,413.801 c-0.379,0-0.686,0.202-0.686,0.45c0,0.249,0.307,0.45,0.686,0.45s0.686-0.202,0.686-0.45 C227.731,414.003,227.424,413.801,227.046,413.801z M223.554,409.834c-0.393,0-0.712,0.209-0.712,0.467 c0,0.258,0.319,0.467,0.712,0.467c0.393,0,0.712-0.209,0.712-0.467C224.266,410.044,223.947,409.834,223.554,409.834z  M221.009,415.779c-0.683,0-1.236,0.363-1.236,0.812s0.553,0.812,1.236,0.812s1.236-0.364,1.236-0.812 S221.692,415.779,221.009,415.779z M218.257,413.962c-1.041,0-1.885,0.554-1.885,1.238c0,0.684,0.844,1.238,1.885,1.238 c1.041,0,1.885-0.554,1.885-1.238C220.142,414.516,219.298,413.962,218.257,413.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#305575"
    },
    d: " M295.524,264.496l-6.3-5.366l3.383-34.527l-13.703,1.433V183.74h-3.489h-32.555l-0.212,9.785h-20.972l-0.202,32.417l-0.837,1.269 l-14.241,0.207l-3.08,2.669l-0.451,15.44l3.551,4.319l12.279-0.742l76.662,16.97L295.524,264.496z M252.454,212.73v-5.36 l8.345-0.984l2.151,6.324L252.454,212.73z M251.261,199.087l0.573-13.097h20.52l-0.474,4.326h-16.333l-0.273,10.968h-4.012V199.087 z M233.39,196.414v10.153h-6.792l-0.389-10.01L233.39,196.414z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#305575"
    },
    points: " 143.325,245.527 142.887,235.555 179.393,238.226 182.541,245.702 197.697,262.014 136.512,260.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#305575"
    },
    points: " 116.242,240.549 112.586,240.365 113.223,247.704 111.586,247.704 112.95,260.649 116.77,261.767 117.091,248.784  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#305575"
    },
    d: " M110.177,225.145l-0.995-27.406c0.796-1.102,1.969-1.789,3.466-2.123c1.19-0.027,2.328,0.305,3.41,1.037l0.159,28.717 L110.177,225.145z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081618345063495054920000007104898759625184134_",
    gradientUnits: "userSpaceOnUse",
    x1: 472.8411,
    y1: 246.5174,
    x2: 492.6339,
    y2: 230.2519,
    gradientTransform: "matrix(-1 0 0 1 740.99 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#305575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    style: {
      stopColor: "#349691"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#499FA9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081618345063495054920000007104898759625184134_)"
    },
    d: "M251.786,244.364l1.084,1.021h12.282 l1.084-1.026c0.225-3.648,0.339-7.135,0.286-10.377l-1.044-1.083c-4.31-0.167-8.619-0.167-12.929,0l-1.045,1.072 C251.447,237.318,251.55,240.79,251.786,244.364z M256.29,234.288c1.824-0.247,3.637-0.265,5.436,0l-0.09,1.033h-5.256 L256.29,234.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#306575"
    },
    d: "M252.491,236.666c4.242-0.082,8.483-0.082,12.725,0v0.591c-4.242,0.098-8.483,0.098-12.725,0 V236.666z M252.566,238.512c4.192,0.093,8.384,0.093,12.575,0v-0.559c-4.192-0.078-8.384-0.078-12.575,0V238.512z  M252.641,239.767c4.142,0.088,8.284,0.088,12.426,0v-0.527c-4.142-0.073-8.284-0.073-12.426,0V239.767z M252.716,241.023 c4.092,0.083,8.184,0.083,12.276,0v-0.495c-4.092-0.069-8.184-0.069-12.276,0V241.023z M252.791,242.278 c4.042,0.077,8.084,0.077,12.126,0v-0.463c-4.042-0.064-8.084-0.064-12.126,0V242.278z M252.866,243.533 c3.992,0.072,7.984,0.072,11.977,0v-0.431c-3.992-0.06-7.984-0.06-11.977,0V243.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    d: "M261.726,234.096c0,0-1.372-0.262-2.654-0.238c-1.282,0.025-3.016,0.238-3.016,0.238 l0.073,1.225l-0.427-1.401c0,0,2.297-0.332,3.309-0.332C261.004,233.586,261.726,234.096,261.726,234.096z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    points: "266.282,234.096 265.995,244.104 265.141,245.065 253.028,245.065  252.052,244.203 253.199,244.548 264.842,244.572 265.498,243.587 265.604,234.453 265.486,233.217  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFC1"
    },
    d: "M264.992,233.217c-3.419-0.232-7.684-0.214-12.276-0.098l-0.975,1.012l0.311,9.629 l0.171-9.306l0.643-1.014C256.771,233.206,260.823,233.144,264.992,233.217z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFC1"
    },
    points: "261.929,234.338 261.844,235.483 256.081,235.483 256.13,235.717  262.039,235.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#6B0A47"
    },
    points: "263.87,235.682 263.357,244.19 259.951,244.19 259.951,236.21  262.771,235.891 262.918,233.587 263.87,233.587  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50686B"
    },
    points: "275.068,182.606 249.087,230.739 249.559,231.04 276.148,183.294  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50686B"
    },
    points: "247.94,183.294 274.529,231.04 275.001,230.739 249.019,182.606  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.613,
    y: 182.16,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9964 365.9006)",
    style: {
      fill: "#708588"
    },
    width: 28.77,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.366,
    y: 182.368,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9964 365.0267)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 23.265,
    height: 0.291
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 248.12,
    y: 203.223,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9963 408.0262)",
    style: {
      fill: "#708588"
    },
    width: 27.756,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.779,
    y: 203.43,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9964 407.1522)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 22.438,
    height: 0.291
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 248.711,
    y: 224.286,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9963 450.1517)",
    style: {
      fill: "#708588"
    },
    width: 26.573,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.261,
    y: 224.493,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9964 449.2777)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 21.475,
    height: 0.291
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 248.711,
    y: 245.349,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9963 492.2772)",
    style: {
      fill: "#708588"
    },
    width: 26.573,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.261,
    y: 245.556,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 523.9964 491.4032)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 21.475,
    height: 0.291
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008842639427543916570000007862673997442834848_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.3672,
    y1: 164.7064,
    x2: 471.7971,
    y2: 249.1952,
    gradientTransform: "matrix(-1 0 0 1 740.99 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#708588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3276,
    style: {
      stopColor: "#809693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9743,
    style: {
      stopColor: "#ABC2B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADC4B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008842639427543916570000007862673997442834848_)"
    },
    points: "273.63,251.692 275.28,251.692  276.383,182.16 274.128,182.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#22567D"
    },
    points: "273.488,250.241 275.486,250.241 275.656,251.889 273.317,251.889  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.156,227.081 275.136,228.911 274.468,228.911 274.477,227.081  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.091,233.082 275.071,234.912 274.439,234.912 274.448,233.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.22,221.08 275.201,222.91 274.497,222.91 274.506,221.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "274.38,246.913 274.389,245.083 274.962,245.083 274.942,246.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.026,239.082 275.007,240.913 274.409,240.913 274.418,239.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.285,215.079 275.265,216.91 274.527,216.91 274.536,215.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.349,209.079 275.33,210.909 274.556,210.909 274.565,209.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.543,191.076 275.524,192.906 274.644,192.906 274.653,191.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.608,185.076 275.588,186.906 274.674,186.906 274.682,185.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.414,203.078 275.394,204.908 274.585,204.908 274.594,203.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "275.479,197.077 275.459,198.907 274.615,198.907 274.624,197.077  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013191991452326290010000002002464795860256653_",
    gradientUnits: "userSpaceOnUse",
    x1: -165.9982,
    y1: 164.7064,
    x2: -151.5683,
    y2: 249.1952,
    gradientTransform: "matrix(1 0 0 1 406.3717 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#708588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3276,
    style: {
      stopColor: "#809693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9743,
    style: {
      stopColor: "#ABC2B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADC4B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000013191991452326290010000002002464795860256653_)"
    },
    points: "250.366,251.692  248.716,251.692 247.613,182.16 249.868,182.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#22567D"
    },
    points: "250.509,250.241 248.51,250.241 248.34,251.889 250.679,251.889  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.841,227.081 248.86,228.911 249.528,228.911 249.519,227.081  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.905,233.082 248.925,234.912 249.558,234.912 249.549,233.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.776,221.08 248.796,222.91 249.499,222.91 249.49,221.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "249.616,246.913 249.607,245.083 249.034,245.083 249.054,246.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.97,239.082 248.989,240.913 249.587,240.913 249.578,239.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.711,215.079 248.731,216.91 249.47,216.91 249.461,215.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.647,209.079 248.666,210.909 249.44,210.909 249.431,209.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.453,191.076 248.473,192.906 249.352,192.906 249.343,191.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.388,185.076 248.408,186.906 249.323,186.906 249.314,185.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.582,203.078 248.602,204.908 249.411,204.908 249.402,203.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "248.518,197.077 248.537,198.907 249.382,198.907 249.372,197.077  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50686B"
    },
    points: "246.216,190.528 224.099,233.157 224.501,233.424 247.135,191.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#50686B"
    },
    points: "223.123,191.137 245.757,233.424 246.159,233.157 224.042,190.528  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.845,
    y: 190.133,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 381.6647)",
    style: {
      fill: "#708588"
    },
    width: 24.491,
    height: 1.399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.188,
    y: 190.316,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 380.8906)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 19.804,
    height: 0.258
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.276,
    y: 208.787,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 418.9739)",
    style: {
      fill: "#708588"
    },
    width: 23.627,
    height: 1.399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.54,
    y: 208.971,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 418.1998)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 19.1,
    height: 0.258
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.78,
    y: 227.442,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 456.2829)",
    style: {
      fill: "#708588"
    },
    width: 22.62,
    height: 1.399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.95,
    y: 227.625,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 455.5089)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 18.281,
    height: 0.258
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.78,
    y: 246.096,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 493.5921)",
    style: {
      fill: "#708588"
    },
    width: 22.62,
    height: 1.399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.95,
    y: 246.28,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 470.1799 492.818)",
    style: {
      opacity: 0.6,
      fill: "#FFF6D6"
    },
    width: 18.281,
    height: 0.258
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044150768123281206760000018297499750791287969_",
    gradientUnits: "userSpaceOnUse",
    x1: 487.1876,
    y1: 174.6882,
    x2: 499.9644,
    y2: 249.4975,
    gradientTransform: "matrix(-1 0 0 1 740.99 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#708588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3276,
    style: {
      stopColor: "#809693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9743,
    style: {
      stopColor: "#ABC2B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADC4B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000044150768123281206760000018297499750791287969_)"
    },
    points: "244.992,251.715  246.396,251.715 247.335,190.133 245.415,190.133  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#22567D"
    },
    points: "244.87,250.429 246.571,250.429 246.716,251.889 244.725,251.889  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.29,229.917 246.273,231.538 245.705,231.538 245.712,229.917  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.235,235.232 246.218,236.853 245.68,236.853 245.688,235.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.345,224.603 246.328,226.223 245.73,226.223 245.737,224.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "245.63,247.482 245.637,245.861 246.125,245.861 246.108,247.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.18,240.547 246.163,242.167 245.655,242.167 245.662,240.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.4,219.288 246.383,220.909 245.755,220.909 245.762,219.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.455,213.973 246.438,215.594 245.78,215.594 245.787,213.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.62,198.029 246.603,199.65 245.855,199.65 245.862,198.029  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.675,192.714 246.658,194.335 245.88,194.335 245.887,192.714  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.51,208.659 246.493,210.279 245.805,210.279 245.812,208.659  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "246.565,203.344 246.548,204.965 245.83,204.965 245.837,203.344  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148660102942358283380000008018539157823747263_",
    gradientUnits: "userSpaceOnUse",
    x1: -189.9942,
    y1: 174.6882,
    x2: -177.2175,
    y2: 249.4975,
    gradientTransform: "matrix(1 0 0 1 406.3717 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#708588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3276,
    style: {
      stopColor: "#809693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9743,
    style: {
      stopColor: "#ABC2B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADC4B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000148660102942358283380000008018539157823747263_)"
    },
    points: "225.188,251.715  223.784,251.715 222.845,190.133 224.765,190.133  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#22567D"
    },
    points: "225.31,250.429 223.609,250.429 223.464,251.889 225.455,251.889  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.89,229.917 223.906,231.538 224.475,231.538 224.467,229.917  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.945,235.232 223.961,236.853 224.5,236.853 224.492,235.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.835,224.603 223.851,226.223 224.45,226.223 224.442,224.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "224.55,247.482 224.542,245.861 224.055,245.861 224.071,247.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "224,240.547 224.016,242.167 224.525,242.167 224.517,240.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.78,219.288 223.796,220.909 224.425,220.909 224.417,219.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.725,213.973 223.741,215.594 224.4,215.594 224.392,213.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.56,198.029 223.576,199.65 224.325,199.65 224.317,198.029  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.505,192.714 223.521,194.335 224.3,194.335 224.292,192.714  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.67,208.659 223.686,210.279 224.375,210.279 224.367,208.659  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#708588"
    },
    points: "223.615,203.344 223.632,204.965 224.35,204.965 224.342,203.344  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "266.268,201.646 270.319,201.286 270.338,202.641 270.473,203.365 266.276,203.218  266.356,202.553  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305575"
    },
    d: "M264.95,204.253c0.385-0.388,0.829-0.731,1.326-1.035l3.958,0.139l-0.012,2.393l0.278,2.804 l-0.886,0.235l0.008,1.488l-2.262,0.738l-0.126-1.233l-0.924-0.092l-0.098-2.769l-0.74,0.681l-0.823-0.022 C264.847,206.459,264.96,205.292,264.95,204.253z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DAD1C0"
    },
    points: "264.978,201.646 265.067,202.553 264.986,203.218 269.184,203.365 269.048,202.641  269.029,201.286  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD1C0"
    },
    d: "M264.986,203.218c-0.496,0.304-0.94,0.647-1.326,1.035c0.01,1.039-0.103,2.205-0.302,3.326 l0.823,0.022l0.74-0.681l0.098,2.769l0.924,0.092l0.126,1.233l2.262-0.738l-0.008-1.488l0.886-0.235l-0.278-2.804l0.011-2.393 L264.986,203.218z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7F4EB"
    },
    points: "265.185,202.976 265.289,202.678 266.088,202.625 266.174,202.88 266.69,203.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7F4EB"
    },
    points: "265.274,202.556 265.168,201.804 266.003,201.733 265.993,202.218 266.686,202.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.45,
      fill: "#547275"
    },
    points: "267.772,203.128 268.942,203.172 268.822,202.655 268.302,202.607  268.806,202.507 268.917,201.392 267.659,201.644 268.168,202.463 267.848,202.623 268.119,202.759  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M265.063,203.511c-0.414,0.222-0.799,0.498-1.141,0.821c-0.131,0.123-0.093,0.332-0.081,0.513 c0.075,0.049,0.163,0.099,0.238,0.148c-0.085,0.011-0.12,0.034-0.205,0.045c0.025,0.752-0.068,1.541-0.297,2.258 c0.342-0.612,0.584-1.331,0.602-2.034c0.053-0.049,0.156-0.112,0.209-0.161c-0.089-0.072-0.15-0.207-0.239-0.279 c0.46,0.19,1.01,0.093,1.44-0.158c0.43-0.251,0.734-0.71,0.8-1.207C265.99,203.462,265.462,203.549,265.063,203.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M266.638,203.761c-0.296,0.54-0.217,1.264,0.19,1.725c0.406,0.461,1.11,0.626,1.676,0.392 c-0.193-0.309-0.38-0.575-0.573-0.883C267.616,204.493,267.146,204.061,266.638,203.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#547275"
    },
    d: "M268.876,208.415c-0.039,0.077-0.091,0.169-0.171,0.199 c0.133-0.07,0.247-0.099,0.38-0.169c-0.077-0.865-0.319-2.643-0.319-2.643s0.044-1.588,0.025-2.358 c-0.656-0.052-1.439-0.047-2.095-0.099c0.751,0.161,1.439,0.623,1.901,1.242c0.054,0.601,0.089,0.673,0.08,1.277L268.876,208.415z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#547275"
    },
    d: "M267.574,206.268c0,0-0.062,0.015-0.174,0.027c-0.112,0.013-0.275,0.019-0.473-0.007 c-0.198-0.025-0.427-0.082-0.673-0.176c-0.123-0.047-0.25-0.101-0.382-0.162c-0.148-0.07-0.301-0.144-0.457-0.218 c-0.034-0.016-0.071-0.036-0.103-0.048l-0.028,0.102c-0.018,0.062-0.04,0.151-0.049,0.171c-0.021,0.07-0.047,0.137-0.073,0.202 c-0.055,0.13-0.118,0.252-0.185,0.364c-0.139,0.221-0.293,0.404-0.439,0.54c-0.146,0.137-0.279,0.234-0.375,0.294 c-0.096,0.061-0.151,0.091-0.151,0.091s0.06-0.019,0.165-0.065c0.106-0.045,0.254-0.123,0.422-0.246 c0.168-0.122,0.349-0.298,0.513-0.524c0.08-0.114,0.154-0.242,0.219-0.38c0.031-0.07,0.061-0.142,0.085-0.217l0.017-0.049 c0.003-0.009,0.004-0.013,0.003-0.01c0.053,0.025,0.105,0.049,0.157,0.074c0.07,0.031,0.139,0.061,0.206,0.09 c0.137,0.057,0.272,0.107,0.403,0.147c0.263,0.08,0.511,0.117,0.719,0.118c0.208,0.002,0.374-0.029,0.485-0.06 C267.516,206.294,267.574,206.268,267.574,206.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#547275"
    },
    d: "M265.93,209.366c0,0,0.085-0.604,0.07-1.349s-0.121-1.345-0.121-1.345 s-0.085,0.606-0.071,1.349C265.823,208.763,265.93,209.366,265.93,209.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#547275"
    },
    d: "M267.026,210.126c0,0,0.049-0.703-0.008-1.566c-0.057-0.863-0.199-1.554-0.199-1.554 s-0.049,0.707,0.008,1.566S267.026,210.126,267.026,210.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#547275"
    },
    d: "M268.166,208.556c0,0,0.069-0.41,0.003-0.907c-0.065-0.497-0.239-0.874-0.239-0.874 s-0.015,0.412,0.049,0.9C268.044,208.162,268.166,208.556,268.166,208.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M265.541,206.848c-0.124,0.063-0.283,0.119-0.415,0.16c0.022,0.83,0.043,1.661,0.065,2.491 c0.166,0.047,0.334,0.068,0.506,0.057c-0.077-0.092-0.124-0.225-0.178-0.333c0.052-0.77,0.062-1.56,0.012-2.331 C265.53,206.879,265.543,206.861,265.541,206.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M266.096,206.807c0.069,1.332,0.097,2.666,0.083,4c0.198-0.105,0.418-0.19,0.616-0.295 c-0.124,0.054-0.263-0.067-0.328-0.187c-0.065-0.12-0.068-0.263-0.069-0.399c-0.006-0.702-0.013-1.404-0.019-2.105 c-0.002-0.215-0.004-0.43-0.006-0.645c-0.001-0.078-0.002-0.16-0.033-0.231C266.31,206.874,266.174,206.802,266.096,206.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M266.932,206.907c0.24,1.121,0.335,2.274,0.283,3.419c-0.002,0.038-0.008,0.068-0.009,0.105 c0.28-0.134,0.561-0.271,0.834-0.419c-0.137,0.029-0.302-0.071-0.371-0.193c-0.068-0.122-0.083-0.267-0.095-0.407 c-0.082-0.898-0.165-1.795-0.247-2.693C267.255,206.82,267.055,206.898,266.932,206.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M267.986,206.527c0.274,0.659,0.366,1.394,0.264,2.102c0.138-0.059,0.286-0.103,0.424-0.162 c-0.16-0.649-0.266-1.331-0.25-2C268.297,206.527,268.125,206.541,267.986,206.527z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164477758866412280220000002324503835045679525_",
    gradientUnits: "userSpaceOnUse",
    x1: -202.0309,
    y1: 197.7012,
    x2: -191.2904,
    y2: 197.7012,
    gradientTransform: "matrix(1 0 0 1 458.452 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8759"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB1535"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164477758866412280220000002324503835045679525_)"
    },
    d: "M267.162,192.057h-10.741l0.711,11.148 c3.059,0.184,6.165,0.187,9.319,0L267.162,192.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    d: "M256.448,192.478l0.03,0.474l5.426,0.326l0.337,9.603l-1.566,0.241 c1.555,0.056,3.076,0.056,4.565,0l-0.494-0.111l0.465-9.564l1.85-0.042l0.101-0.926H256.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077317703071276321670000007750229732650820497_",
    gradientUnits: "userSpaceOnUse",
    x1: -199.9712,
    y1: 197.8866,
    x2: -192.8029,
    y2: 197.8866,
    gradientTransform: "matrix(1 0 0 1 458.452 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#E8A699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8277,
    style: {
      stopColor: "#E9A99B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8796,
    style: {
      stopColor: "#ECB39F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9268,
    style: {
      stopColor: "#F1C4A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    style: {
      stopColor: "#F9DBB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEFBC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000077317703071276321670000007750229732650820497_)"
    },
    points: "264.887,200.302  258.892,200.302 258.481,195.471 265.313,195.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7855F"
    },
    points: "263.973,198.169 259.828,198.169 259.703,196.976 264.042,196.976  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7855F"
    },
    points: "262.923,198.936 260.85,198.936 260.788,198.532 262.957,198.532  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7855F"
    },
    d: "M264.829,195.787l-5.867,0.074l-0.059,0.001l0.004,0.06c0.093,1.327,0.196,2.673,0.315,4.018 c1.765-0.001,3.526-0.022,5.26-0.049l0.03-0.001l0.004-0.031l0.441-3.931l0.016-0.143L264.829,195.787z M264.451,199.822 c-1.711-0.027-3.396-0.048-5.077-0.049c-0.103-1.261-0.222-2.521-0.35-3.799l5.669,0.071L264.451,199.822z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "257.746,201.915 257.838,202.825 259.791,202.918 259.791,201.989  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "265.893,201.915 265.81,202.881 265.547,202.881 265.617,201.915  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.222,
    y: 191.784,
    style: {
      fill: "#E1A300"
    },
    width: 11.305,
    height: 0.694
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.17,
    y: 191.125,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 449.5022 -65.2396)",
    style: {
      opacity: 0.25,
      fill: "#ECE0A0"
    },
    width: 0.402,
    height: 2.013
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.554,
    y: 191.594,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 458.8866 -74.624)",
    style: {
      opacity: 0.25,
      fill: "#ECE0A0"
    },
    width: 0.402,
    height: 1.075
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.187,
    y: 189.914,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 455.519 -71.2563)",
    style: {
      opacity: 0.4,
      fill: "#AB1535"
    },
    width: 0.402,
    height: 4.434
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#E7855F"
    },
    points: "262.167,195.62 262.37,200.135 264.693,200.135 265.068,195.62  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    d: "M257.048,193.09l0.603,8.41c0.712,0.034,1.43,0.059,2.147,0.075l-0.403-8.309 L257.048,193.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    d: "M265.95,193.535l-0.387,7.98c0.123-0.005,0.246-0.01,0.368-0.015l0.574-8.005 L265.95,193.535z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020393725277249421330000012754020560002089373_",
    gradientUnits: "userSpaceOnUse",
    x1: -208.5159,
    y1: 236.8079,
    x2: -199.2911,
    y2: 245.8388,
    gradientTransform: "matrix(1 0 0 1 468.2979 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    style: {
      stopColor: "#FEAA0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF4D4C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000020393725277249421330000012754020560002089373_)"
    },
    points: "268.38,245.349 258.409,245.349  257.661,235.657 268.704,235.657  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E4015"
    },
    points: "273,235.657 268.704,235.657 268.38,245.349 272.276,245.349  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183929207408246944030000001275993574233675963_",
    gradientUnits: "userSpaceOnUse",
    x1: -209.3535,
    y1: 236.5365,
    x2: -205.4302,
    y2: 239.0307,
    gradientTransform: "matrix(1 0 0 1 468.2979 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183929207408246944030000001275993574233675963_)"
    },
    points: "262.265,238.805  259.019,238.805 258.674,236.6 262.538,236.6  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#166678"
    },
    d: "M264.03,242.603l-0.012,1.391l0.903,0.427h-2.065l0.912-0.431l-0.021-1.388l-1.21-1.514 l2.764-0.076L264.03,242.603z M267.862,242.264l-0.805-1.519l-0.861,1.566l0.688-0.268l0.049,1.863h0.219l0.049-1.862 L267.862,242.264z M267.658,244.421h-1.242l-0.083-0.349l1.368,0.083L267.658,244.421z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183228934658943436090000008512886284357092284_",
    gradientUnits: "userSpaceOnUse",
    x1: -205.3068,
    y1: 229.0244,
    x2: -198.2774,
    y2: 235.906,
    gradientTransform: "matrix(1 0 0 1 468.2979 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    style: {
      stopColor: "#FEAA0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF4D4C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183228934658943436090000008512886284357092284_)"
    },
    points: "269.422,235.657  262.061,235.657 261.509,228.01 269.661,228.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E4015"
    },
    points: "272.832,228.01 269.661,228.01 269.422,235.657 272.297,235.657  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097488926244399955970000014784999955177192081_",
    gradientUnits: "userSpaceOnUse",
    x1: -205.8645,
    y1: 228.7489,
    x2: -202.9126,
    y2: 230.6256,
    gradientTransform: "matrix(1 0 0 1 468.2979 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000097488926244399955970000014784999955177192081_)"
    },
    points: "264.907,230.494  262.512,230.494 262.257,228.754 265.109,228.754  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#166678"
    },
    d: "M266.21,233.49l-0.009,1.098l0.666,0.337h-1.524l0.673-0.34l-0.016-1.095l-0.893-1.194l2.04-0.06 L266.21,233.49z M269.039,233.223l-0.594-1.198l-0.635,1.236l0.508-0.212l0.036,1.47h0.162l0.036-1.469L269.039,233.223z  M268.888,234.924h-0.917l-0.061-0.275l1.01,0.065L268.888,234.924z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035508071487732630040000006595508178206192270_",
    gradientUnits: "userSpaceOnUse",
    x1: -214.4285,
    y1: 216.2181,
    x2: -205.8417,
    y2: 224.6245,
    gradientTransform: "matrix(1 0 0 1 468.2979 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    style: {
      stopColor: "#FEAA0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF4D4C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000035508071487732630040000006595508178206192270_)"
    },
    points: "261.725,224.32 252.733,224.32  252.059,214.98 262.017,214.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E4015"
    },
    points: "265.89,214.98 262.017,214.98 261.725,224.32 265.237,224.32  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149361319066489383580000007937054478310600598_",
    gradientUnits: "userSpaceOnUse",
    x1: -215.1099,
    y1: 215.8816,
    x2: -211.5038,
    y2: 218.1742,
    gradientTransform: "matrix(1 0 0 1 468.2979 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000149361319066489383580000007937054478310600598_)"
    },
    points: "256.21,218.014 253.284,218.014  252.972,215.888 256.456,215.888  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#166678"
    },
    d: "M257.802,221.674l-0.01,1.341l0.814,0.411h-1.862l0.823-0.416l-0.019-1.338l-1.091-1.459 l2.492-0.074L257.802,221.674z M261.257,221.347l-0.725-1.464l-0.776,1.509l0.621-0.258l0.044,1.796h0.198l0.044-1.794 L261.257,221.347z M261.073,223.426h-1.12l-0.075-0.337l1.234,0.08L261.073,223.426z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123443133319399597310000007660309235949842352_",
    gradientUnits: "userSpaceOnUse",
    x1: -193.2559,
    y1: 199.1808,
    x2: -185.4405,
    y2: 199.1808,
    gradientTransform: "matrix(1 0 0 1 458.452 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#67D0D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#188FAB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123443133319399597310000007660309235949842352_)"
    },
    d: "M273.012,195.074h-7.815l0.517,8.112 c2.226,0.134,4.486,0.136,6.781,0L273.012,195.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    d: "M265.216,195.38l0.022,0.345l3.948,0.237l0.245,6.987l-1.139,0.176 c1.131,0.041,2.238,0.041,3.322,0l-0.359-0.081l0.338-6.96l1.346-0.031l0.074-0.674H265.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101812221624949110260000003875743129939316661_",
    gradientUnits: "userSpaceOnUse",
    x1: -191.7571,
    y1: 199.3157,
    x2: -186.541,
    y2: 199.3157,
    gradientTransform: "matrix(1 0 0 1 458.452 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1954,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7619,
    style: {
      stopColor: "#E8A699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8277,
    style: {
      stopColor: "#E9A99B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8796,
    style: {
      stopColor: "#ECB39F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9268,
    style: {
      stopColor: "#F1C4A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    style: {
      stopColor: "#F9DBB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEFBC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101812221624949110260000003875743129939316661_)"
    },
    points: "271.357,201.073  266.994,201.073 266.695,197.558 271.666,197.558  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7855F"
    },
    points: "270.691,199.521 267.675,199.521 267.585,198.653 270.741,198.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7855F"
    },
    points: "269.927,200.08 268.419,200.08 268.373,199.785 269.952,199.785  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7855F"
    },
    d: "M271.315,197.788l-4.269,0.054l-0.043,0.001l0.003,0.044c0.068,0.965,0.143,1.945,0.229,2.923 c1.284-0.001,2.565-0.016,3.828-0.036l0.022,0l0.002-0.022l0.321-2.86l0.012-0.104L271.315,197.788z M271.039,200.724 c-1.245-0.02-2.471-0.035-3.695-0.035c-0.075-0.918-0.161-1.834-0.255-2.765l4.125,0.052L271.039,200.724z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "266.16,202.247 266.227,202.909 267.648,202.977 267.648,202.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "272.088,202.247 272.028,202.95 271.837,202.95 271.887,202.247  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.051,
    y: 194.875,
    style: {
      fill: "#E1A300"
    },
    width: 8.226,
    height: 0.505
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.741,
    y: 194.396,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 461.0152 -70.7594)",
    style: {
      opacity: 0.25,
      fill: "#ECE0A0"
    },
    width: 0.292,
    height: 1.465
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.57,
    y: 194.737,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 467.8438 -77.588)",
    style: {
      opacity: 0.25,
      fill: "#ECE0A0"
    },
    width: 0.292,
    height: 0.782
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.119,
    y: 193.515,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 465.3933 -75.1375)",
    style: {
      opacity: 0.4,
      fill: "#AB1535"
    },
    width: 0.292,
    height: 3.226
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#E7855F"
    },
    points: "269.377,197.666 269.525,200.952 271.215,200.952 271.488,197.666  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    d: "M265.652,195.826l0.439,6.119c0.518,0.025,1.04,0.043,1.563,0.055l-0.294-6.046 L265.652,195.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    d: "M272.13,196.15l-0.282,5.807c0.089-0.004,0.179-0.007,0.268-0.011l0.418-5.825 L272.13,196.15z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000158709109316104292500000014382235617824285110_",
    cx: 496.9188,
    cy: -190.975,
    r: 7.9769,
    gradientTransform: "matrix(-0.7813 0.4455 0.4456 0.8166 739.5979 151.1864)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3346,
    style: {
      stopColor: "#FDF3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5397,
    style: {
      stopColor: "#FFF0B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6398,
    style: {
      stopColor: "#F9EAB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7727,
    style: {
      stopColor: "#EAD9A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9236,
    style: {
      stopColor: "#D0BE96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0AD8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158709109316104292500000014382235617824285110_)"
    },
    d: "M263.623,221.375 c-1.444-2.647-0.485-5.924,2.142-7.32c2.627-1.396,5.928-0.383,7.372,2.264c1.444,2.646,0.485,5.924-2.142,7.32 C268.367,225.035,265.067,224.022,263.623,221.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#295980"
    },
    d: "M270.395,219.063c0.237,0.949,0.221,1.856,0.185,2.668c-0.583,0.661-1.368,0.962-2.348,0.915 c-0.83-0.381-1.563-0.953-2.19-1.73c0.117-0.812,0.426-1.605,0.994-2.372C268.194,218.53,269.304,218.767,270.395,219.063z  M263.623,221.375c0.081,0.148,0.17,0.29,0.262,0.428l0.49-1.982l-1.268-2.324C262.802,218.756,262.945,220.134,263.623,221.375z  M273.136,216.318c-0.403-0.738-0.954-1.344-1.591-1.811l-0.995,0.22l1.299,2.114l1.764,0.68 C273.503,217.112,273.349,216.708,273.136,216.318z M265.764,214.055c-0.438,0.233-0.825,0.522-1.167,0.847l-0.104,0.999 l2.291-0.371l1.731-1.504l-1.201-0.51C266.785,213.613,266.263,213.79,265.764,214.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#4974AD"
    },
    d: "M270.634,214.766c-0.773-0.138-1.399-0.317-2.128-0.616 C269.276,214.098,269.994,214.308,270.634,214.766z M270.275,219.125c0.928-0.416,1.535-1.334,1.563-2.353 c-0.185,0.471-0.411,0.877-0.666,1.26C270.916,218.413,270.63,218.774,270.275,219.125z M270.479,221.69 c0.65,0.584,1.58,0.743,2.373,0.413c-0.431-0.007-0.82-0.055-1.204-0.121C271.265,221.913,270.885,221.825,270.479,221.69z  M267.264,224.048c0.611-0.139,1.028-0.738,0.954-1.362c-0.137,0.274-0.285,0.496-0.436,0.713 C267.628,223.614,267.47,223.826,267.264,224.048z M264.389,220.225c0.332,0.578,1.055,0.848,1.676,0.629 c-0.32-0.067-0.593-0.16-0.86-0.261C264.937,220.492,264.674,220.381,264.389,220.225z M266.97,218.594 c-0.142-0.526-0.22-1.018-0.27-1.511c-0.047-0.493-0.066-0.99-0.029-1.53C266.257,216.551,266.37,217.691,266.97,218.594z  M263.44,217.402c0.481-0.672,0.897-1.187,1.457-1.794C264.129,215.919,263.581,216.592,263.44,217.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#603813"
    },
    d: "M266.548,223.552c1.012,0.498,2.208,0.499,3.251,0.12 c1.043-0.38,1.936-1.118,2.626-2.006c0.52-0.67,0.939-1.445,1.085-2.296c0.147-0.851-0.003-1.783-0.517-2.478 c-0.342,1.595-1.185,2.945-2.343,4.043C269.493,222.033,267.972,222.858,266.548,223.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#603813"
    },
    d: "M270.714,222.166c-2.463,0.481-5.155-0.36-6.984-2.18 c0.431,1.425,1.346,2.58,2.603,3.323c0.751,0.444,1.617,0.712,2.47,0.628C269.655,223.853,270.296,222.932,270.714,222.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFF3D9"
    },
    d: "M268.798,214.309c0.354,0.153,0.72,0.45,0.713,0.844 c-0.005,0.305-0.242,0.557-0.51,0.677c-0.269,0.12-0.569,0.139-0.861,0.182c-0.759,0.11-1.491,0.391-2.131,0.819 c-0.252,0.168-0.511,0.366-0.814,0.369c-0.414,0.003-0.77-0.396-0.823-0.822c-0.198-1.578,1.909-2.162,3.031-2.278 C267.873,214.052,268.357,214.12,268.798,214.309z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "283.923,252.45 284.21,253.741 286.025,253.627 286.722,252.269  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305575"
    },
    d: "M287.359,255.089c0-1.356-1.099-2.242-2.455-2.242s-2.454,1.266-2.454,2.621 c0,1.356,1.099,2.288,2.454,2.288S287.359,256.445,287.359,255.089z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114779581723095100350000007845387100327662763_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.1095,
    y1: 252.6886,
    x2: 288.2004,
    y2: 258.234
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#305575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    style: {
      stopColor: "#349691"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#499FA9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114779581723095100350000007845387100327662763_)"
    },
    d: "M288.48,255.089 c0-1.356-1.099-2.242-2.455-2.242c-1.356,0-2.454,1.266-2.454,2.621c0,1.356,1.099,2.288,2.454,2.288 C287.381,257.756,288.48,256.445,288.48,255.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#305575"
    },
    d: "M287.359,255.186c0-0.736-0.597-1.218-1.333-1.218c-0.736,0-1.333,0.687-1.333,1.424 c0,0.736,0.597,1.243,1.333,1.243C286.762,256.634,287.359,255.922,287.359,255.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4DA9A3"
    },
    d: "M286.722,255.241c0-0.385-0.312-0.637-0.697-0.637c-0.385,0-0.697,0.359-0.697,0.744 c0,0.385,0.312,0.65,0.697,0.65C286.41,255.998,286.722,255.626,286.722,255.241z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB1535"
    },
    points: "272.058,228.207 264.173,228.207 265.324,239.685 266.93,239.685 269.779,257.62  276.27,257.62 275.688,228.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4DA9A3"
    },
    points: "287.986,223.197 273.036,224.173 265.173,227.029 264.673,227.645 271.316,227.645  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011731486165882496470000000207260896495782030_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.3157,
    y1: 225.4207,
    x2: 289.8591,
    y2: 225.4207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#305575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    style: {
      stopColor: "#349691"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#499FA9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000011731486165882496470000000207260896495782030_)"
    },
    points: "271.316,227.645  272.345,226.802 287.986,223.197 289.859,227.27  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146500208600355628550000013006478115749104036_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.4414,
    y1: 250.5987,
    x2: 289.2596,
    y2: 223.7805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8759"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB1535"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000146500208600355628550000013006478115749104036_)"
    },
    points: "272.058,228.207  272.845,239.685 275.148,239.685 276.27,257.62 282.905,257.62 283.406,252.483 288.332,252.165 288.815,239.685 289.209,228.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C728A"
    },
    points: "294.713,227.029 270.77,227.656 270.77,228.207 294.588,228.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B7263A"
    },
    points: "293.633,228.207 289.114,230.987 289.209,228.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4DA9A3"
    },
    points: "270.77,227.656 263.415,227.618 263.415,228.207 270.77,228.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    points: "266.93,239.685 275.148,239.685 275.503,245.358 267.533,243.481  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    points: "264.173,228.207 272.058,228.207 293.633,228.207 289.114,230.987  289.059,232.584 272.227,230.678 264.322,229.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFF7CC"
    },
    points: "272.991,230.764 273.658,238.883 275.899,238.883 277.163,256.634  281.658,256.634 278.118,255.612 277.324,237.794 274.567,237.673 274.379,230.987  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    points: "288.48,232.518 287.359,251.309 283.052,251.794 286.025,250.097  286.106,232.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFF7CC"
    },
    points: "287.445,223.975 288.749,226.703 286.324,226.703 286.021,224.218  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFF7CC"
    },
    points: "272.991,224.491 267.092,226.703 271.217,226.703 281.658,223.975  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031177925083022011920000013797727965991570824_",
    gradientUnits: "userSpaceOnUse",
    x1: -565.6517,
    y1: 250.3596,
    x2: -553.3306,
    y2: 262.4217,
    gradientTransform: "matrix(-1 0 0 1 -432.1942 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    style: {
      stopColor: "#FEAA0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF4D4C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031177925083022011920000013797727965991570824_)"
    },
    points: "121.973,261.767  135.292,261.767 136.29,248.822 121.541,248.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E4015"
    },
    points: "115.803,248.822 121.541,248.822 121.973,261.767 116.77,261.767  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147199900609716379990000007682906356709104035_",
    gradientUnits: "userSpaceOnUse",
    x1: -566.7703,
    y1: 249.9971,
    x2: -561.5303,
    y2: 253.3285,
    gradientTransform: "matrix(-1 0 0 1 -432.1942 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000147199900609716379990000007682906356709104035_)"
    },
    points: "130.141,253.027  134.476,253.027 134.938,250.081 129.777,250.081  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#166678"
    },
    d: "M126.085,255.973l3.692,0.102l-1.617,2.021l-0.028,1.854l1.218,0.576h-2.757l1.206-0.57 l-0.016-1.858L126.085,255.973z M123.546,257.354l0.066,2.486h0.293l0.066-2.488l0.919,0.358l-1.15-2.092l-1.075,2.029 L123.546,257.354z M122.88,260.172l1.827-0.111l-0.111,0.466h-1.658L122.88,260.172z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072270299940338560700000012608651932272119989_",
    gradientUnits: "userSpaceOnUse",
    x1: -561.3653,
    y1: 239.9636,
    x2: -551.9766,
    y2: 249.1549,
    gradientTransform: "matrix(-1 0 0 1 -432.1942 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    style: {
      stopColor: "#FEAA0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF4D4C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000072270299940338560700000012608651932272119989_)"
    },
    points: "120.582,248.822  130.414,248.822 131.151,238.609 120.263,238.609  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E4015"
    },
    points: "116.028,238.609 120.263,238.609 120.582,248.822 116.742,248.822  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132791156018313817660000002012618563745404545_",
    gradientUnits: "userSpaceOnUse",
    x1: -562.1103,
    y1: 239.5957,
    x2: -558.1676,
    y2: 242.1023,
    gradientTransform: "matrix(-1 0 0 1 -432.1942 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000132791156018313817660000002012618563745404545_)"
    },
    points: "126.612,241.927  129.811,241.927 130.152,239.603 126.343,239.603  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#166678"
    },
    d: "M123.618,244.251l2.725,0.081l-1.193,1.595l-0.021,1.463l0.899,0.455h-2.035l0.89-0.45 l-0.011-1.466L123.618,244.251z M121.743,245.34l0.049,1.962h0.216l0.049-1.963l0.679,0.283l-0.849-1.65l-0.793,1.601 L121.743,245.34z M121.252,247.563l1.349-0.087l-0.082,0.368h-1.224L121.252,247.563z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176043195020289544540000013550263373211770291_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.9646,
    y1: 211.0314,
    x2: 120.9173,
    y2: 211.0314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8759"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176043195020289544540000013550263373211770291_)"
    },
    d: "M120.058,225.41h-7.235l-0.856-25.241 c-0.038-1.107,0.534-2.163,1.51-2.687c2.063-1.107,4.02-1.08,5.885-0.077c0.992,0.533,1.592,1.588,1.554,2.713L120.058,225.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    d: "M113.94,207.899c-0.13-3.363-1.148-9.039,2.517-10.823 c-0.906,0.013-1.841,0.273-2.781,0.777c-0.815,0.437-1.321,1.34-1.288,2.301l0.843,24.834h1.629 C114.706,219.286,114.16,213.617,113.94,207.899z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057112367849418718050000007669557930905421217_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.9397,
    y1: 191.8561,
    x2: 121.6223,
    y2: 196.2803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0754,
    style: {
      stopColor: "#F5EBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    style: {
      stopColor: "#B8C2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    style: {
      stopColor: "#759696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6921,
    style: {
      stopColor: "#7A9B98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    style: {
      stopColor: "#8AAA9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    style: {
      stopColor: "#A4C3A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#C8E5AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E6AF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057112367849418718050000007669557930905421217_)"
    },
    points: "126.047,197.707 123.318,193.34  123.225,193.191 123.061,193.164 118.479,192.409 118.359,193.136 122.767,193.863 125.222,198.198  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011738669505808218790000008194974890781895577_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.6747,
    y1: 277.9601,
    x2: 135.3024,
    y2: 278.6711,
    gradientTransform: "matrix(0.8397 -0.543 0.543 0.8397 -138.5363 42.7711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DA9A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    style: {
      stopColor: "#4AA2A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1205,
    style: {
      stopColor: "#388191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2186,
    style: {
      stopColor: "#2C6986"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    style: {
      stopColor: "#255B7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    style: {
      stopColor: "#22567D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#131F49"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000011738669505808218790000008194974890781895577_)"
    },
    points: "127.138,197.697  126.559,198.071 125.947,197.124 124.775,197.882 125.387,198.829 124.808,199.204 129.093,207.09 132.572,204.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#ECE0A0"
    },
    points: "127.088,198.162 132.104,204.788 131.058,205.465 126.454,198.572  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005949493013592408660000006793389600926311090_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.7693,
    y1: 196.0621,
    x2: 118.0753,
    y2: 196.0621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    style: {
      stopColor: "#22567D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6906,
    style: {
      stopColor: "#255B7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7814,
    style: {
      stopColor: "#2C6986"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    style: {
      stopColor: "#388191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    style: {
      stopColor: "#4AA2A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4DA9A3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000005949493013592408660000006793389600926311090_)"
    },
    points: "117.823,196.919  115.021,196.919 114.769,195.205 118.075,195.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEAA0F"
    },
    points: "117.309,195.205 115.597,195.205 115.523,193.888 117.383,193.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEAA0F"
    },
    points: "118.67,194.115 116.967,193.888 116.967,192.001 118.67,191.774  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073718456005170795880000005831438623685429914_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.5354,
    y1: 190.6019,
    x2: 117.7545,
    y2: 195.6581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8759"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB1535"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000073718456005170795880000005831438623685429914_)"
    },
    points: "117.383,193.888  115.523,193.888 107.055,195.818 107.328,195.205 115.097,192.861 115.15,192.255 108.303,190.307 109.119,189.727  117.957,191.155  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#ECE0A0"
    },
    points: "108.786,190.157 109.207,189.894 117.818,191.316 117.265,193.686  117.055,191.774 109.54,190.193  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#ECE0A0"
    },
    points: "118.876,192.677 123.116,193.361 125.473,197.124 125.341,197.259  122.905,193.572 118.876,192.848  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#ECE0A0"
    },
    points: "107.486,195.303 115.141,193.019 115.141,193.388 107.486,195.442  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    points: "117.785,191.975 117.818,193.44 118.529,193.44 118.529,193.827  117.818,193.783 117.818,194.001 117.38,193.943 117.356,194.371 115.567,194.67 115.523,193.888 117.383,193.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#ECE0A0"
    },
    points: "117.818,195.442 117.691,196.719 116.796,196.719 116.545,195.666  115.387,195.442  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046321570392435194830000001658733775075985578_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.1409,
    y1: 207.1366,
    x2: 120.1057,
    y2: 207.1366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2381,
    style: {
      stopColor: "#E8A699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8046,
    style: {
      stopColor: "#FFEFBC"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 115.141,
    y: 202.71,
    style: {
      fill: "url(#SVGID_00000046321570392435194830000001658733775075985578_)"
    },
    width: 4.965,
    height: 8.853
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.215,
    y: 204.198,
    style: {
      fill: "#E7855F"
    },
    width: 3.49,
    height: 1.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.215,
    y: 206.626,
    style: {
      fill: "#E7855F"
    },
    width: 3.49,
    height: 1.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.939,
    y: 208.665,
    style: {
      fill: "#E7855F"
    },
    width: 2.042,
    height: 0.763
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFF7CC"
    },
    d: "M119.162,197.776c-0.867-0.466-1.753-0.702-2.634-0.702 c-0.104,0-0.208,0.005-0.313,0.011c3.063,1.833,2.5,7.091,2.344,10.181c-0.296,5.871-0.079,11.857-0.619,17.723h1.711 l0.844-24.886C120.527,199.142,120.004,198.229,119.162,197.776z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "151.327,175.94 150.624,175.94 150.41,159.273 151.541,159.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "176.58,175.94 175.877,175.94 175.663,159.273 176.794,159.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "180.309,179.652 146.822,179.652 148.457,175.94 178.674,175.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4A869A"
    },
    points: "148.457,175.94 153.082,175.94 154.627,179.652 146.822,179.652  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "222.852,175.94 222.149,175.94 221.935,159.273 223.065,159.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "248.105,175.94 247.401,175.94 247.188,159.273 248.318,159.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "251.833,179.652 218.346,179.652 219.981,175.94 250.198,175.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4A869A"
    },
    points: "219.981,175.94 224.606,175.94 226.152,179.652 218.346,179.652  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#295980"
    },
    points: "235.961,231.582 236.086,230.415 233.678,230.415 234.005,231.658  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#295980"
    },
    points: "236.352,230.733 233.467,230.812 233.532,231.28 236.352,231.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#FFF7CC"
    },
    points: "234.584,230.874 234.608,231.182 233.65,231.203 233.604,230.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#295980"
    },
    points: "232.033,231.759 232.174,230.447 229.465,230.447 229.833,231.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#295980"
    },
    points: "232.472,230.804 229.229,230.893 229.301,231.42 232.472,231.388  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#FFF7CC"
    },
    points: "230.484,230.963 230.511,231.309 229.433,231.333 229.382,230.984  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#295980"
    },
    points: "228.827,246.574 243.384,246.574 244.221,231.257 228.025,231.887  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087405498518684129440000018165453833985029526_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.4561,
    y1: 233.9533,
    x2: 370.6512,
    y2: 233.9533,
    gradientTransform: "matrix(-1 0 0 1 598.6767 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB614"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0356,
    style: {
      stopColor: "#FBAD13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1513,
    style: {
      stopColor: "#F99411"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2565,
    style: {
      stopColor: "#F7840F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3413,
    style: {
      stopColor: "#F77F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7923,
    style: {
      stopColor: "#FBD71D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9087,
    style: {
      stopColor: "#FCEE21"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000087405498518684129440000018165453833985029526_)"
    },
    points: "244.221,231.257  228.025,231.887 228.269,236.352 243.926,236.65  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22567D"
    },
    d: "M230.083,233.997c0.29,0.011,0.58,0.023,0.87,0.035c-0.01-0.266-0.019-0.532-0.028-0.798 c0.173,0.019,0.346,0.038,0.519,0.057c-0.009,0.253-0.019,0.506-0.028,0.759c0.29,0.012,0.58,0.023,0.87,0.035 c-0.024,0.121-0.048,0.243-0.072,0.364c-0.271,0.002-0.542,0.003-0.813,0.005c-0.009,0.253-0.019,0.506-0.028,0.759 c-0.125,0.014-0.25,0.028-0.376,0.042c-0.009-0.266-0.019-0.532-0.028-0.798c-0.271,0.002-0.542,0.003-0.813,0.005 C230.13,234.305,230.106,234.151,230.083,233.997z M233.476,234.515l2.004-0.048l0.132-0.335l-2.222-0.054L233.476,234.515z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFF7CC"
    },
    points: "228.584,232.439 229.373,246.091 235.212,246.091 231.183,245.66  230.421,232.62 235.711,232.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFF7CC"
    },
    points: "243.723,231.771 242.733,246.091 241.857,246.091 242.382,245.856  243.049,232.03 242.453,231.882  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043456433533684345650000013507929018415126692_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.0947,
    y1: 237.7209,
    x2: 235.0947,
    y2: 244.2599,
    gradientTransform: "matrix(1 0 0 1 1.2568 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8759"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB1535"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043456433533684345650000013507929018415126692_)"
    },
    d: "M239.755,241.011 c0-1.88-1.524-3.404-3.404-3.404c-1.88,0-3.404,1.524-3.404,3.404s1.524,3.404,3.404,3.404 C238.231,244.415,239.755,242.891,239.755,241.011z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#993352"
    },
    points: "235.559,239.124 237.624,239.124 236.656,241.098 237.838,241.098 236.206,243.397  236.698,242.004 235.487,242.004  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137093545567279886990000018052058803265332400_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.1684,
    y1: 238.8972,
    x2: 235.1684,
    y2: 243.3301,
    gradientTransform: "matrix(1 0 0 1 1.2568 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCEE21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1389,
    style: {
      stopColor: "#FAD220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    style: {
      stopColor: "#F9BC1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4573,
    style: {
      stopColor: "#F8AC1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6459,
    style: {
      stopColor: "#F7A31E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9048,
    style: {
      stopColor: "#F7A01E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000137093545567279886990000018052058803265332400_)"
    },
    points: "235.321,238.82 237.387,238.82  236.418,240.934 237.6,240.934 236.2,243.435 236.461,241.904 235.25,241.904  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#E8A699"
    },
    points: "241.857,232.03 241.331,246.091 238.736,246.091 238.736,232.165  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046331088222311979270000015349349102457895841_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.7926,
    y1: 228.3277,
    x2: 237.8229,
    y2: 219.1156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8759"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB1535"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000046331088222311979270000015349349102457895841_)"
    },
    points: "242.234,227.488  228.447,227.488 227.227,218.847 243.454,218.847  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085963346371372583330000005077423431305194166_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.2091,
    y1: 218.4875,
    x2: 244.1545,
    y2: 218.4875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8759"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB1535"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085963346371372583330000005077423431305194166_)"
    },
    points: "244,219.267 226.364,219.431  226.209,217.544 244.154,217.708  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    points: "227.31,219.431 243.392,219.288 243.163,220.909 242.576,220.909  241.818,227.211 228.727,227.211 240.891,226.679 240.891,220.715 227.422,220.225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFF7CC"
    },
    points: "228.182,220.543 228.909,226.86 230.97,226.769 230.879,220.543  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D0F0F"
    },
    d: "M231.471,224.216l-0.247-4.118h1.159l-0.062,4.118H231.471z M236.828,224.216l0.185-4.118h-1.159 l0.123,4.118H236.828z M234.575,224.216l0.123-4.118h-1.159l0.185,4.118H234.575z M241.335,224.216l0.308-4.118h-1.159v4.118 H241.335z M239.081,224.216l0.247-4.118h-1.159l0.062,4.118H239.081z M230.068,224.216v-4.118h-1.159l0.308,4.118H230.068z  M235.992,224.699l0.035,1.166h0.727l0.052-1.166H235.992z M240.484,224.699v1.166h0.727l0.087-1.166H240.484z M238.238,224.699 l0.017,1.166h0.727l0.07-1.166H238.238z M233.746,224.699l0.052,1.166h0.727l0.035-1.166H233.746z M231.5,224.699l0.07,1.166 h0.727l0.018-1.166H231.5z M229.254,224.699l0.087,1.166h0.727v-1.166H229.254z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFF7CC"
    },
    points: "226.598,217.754 226.636,219.163 228.909,219.163 228.909,218.345  243.392,218.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#305575"
    },
    points: "227.728,217.558 230.515,214.784 233.539,216.926 234.995,216.171 235.854,216.504  236.273,216.951 239.052,215.888 240.364,216.504 241.063,215.224 243.03,215.552 243.576,217.702  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183965742429087170620000015824605869117638055_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.8587,
    y1: 204.5754,
    x2: 239.3126,
    y2: 204.5754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BDD267"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#79AB18"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183965742429087170620000015824605869117638055_)"
    },
    points: "235.03,208.788 239.142,208.788  239.313,200.363 234.859,200.363  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059998718076176970310000005742424943921246653_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.2158,
    y1: 197.3642,
    x2: 240.5066,
    y2: 199.7342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DA9A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    style: {
      stopColor: "#4AA2A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1205,
    style: {
      stopColor: "#388191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2186,
    style: {
      stopColor: "#2C6986"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    style: {
      stopColor: "#255B7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    style: {
      stopColor: "#22567D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#131F49"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000059998718076176970310000005742424943921246653_)"
    },
    points: "234.781,196.557  234.859,200.363 239.313,200.363 239.39,196.557  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1A300"
    },
    d: "M239.62,200.595h-5.08v-0.464h5.08V200.595z M239.375,208.342h-4.59v0.464h4.59V208.342z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#ECE0A0"
    },
    points: "235.118,199.965 235.118,196.862 239.112,196.803 239.112,199.965  238.922,199.965 238.644,197.125 236.274,197.198 236.127,199.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "238.312,197.344 238.38,199.965 237.561,199.965 237.561,197.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "235.223,201.061 235.352,208.105 236.361,208.105 236.552,201.179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    points: "234.863,200.595 239.308,200.595 239.296,201.192 238.578,201.192  238.117,208.046 237.561,208.046 237.437,201.148 234.87,200.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "239.112,201.412 239.009,208.046 238.6,208.046 238.856,201.412  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#AB1535"
    },
    d: "M236.948,200.219h1.636l-0.005,0.289h-1.626L236.948,200.219z M238.444,208.43h-1.356 l0.005,0.288h1.346L238.444,208.43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.677,
    y: 200.193,
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    width: 1.594,
    height: 0.293
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.924,
    y: 208.428,
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    width: 1.347,
    height: 0.293
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025437701218769118340000008479084986851633298_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6359,
    y1: 204.4245,
    x2: 244.2487,
    y2: 204.4245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF8759"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB1535"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000025437701218769118340000008479084986851633298_)"
    },
    points: "239.813,208.787  244.072,208.787 244.249,200.062 239.636,200.062  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139990404431323925240000016412041845421814195_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.97,
    y1: 196.9561,
    x2: 245.4853,
    y2: 199.4107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4DA9A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    style: {
      stopColor: "#4AA2A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1205,
    style: {
      stopColor: "#388191"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2186,
    style: {
      stopColor: "#2C6986"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    style: {
      stopColor: "#255B7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    style: {
      stopColor: "#22567D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#131F49"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000139990404431323925240000016412041845421814195_)"
    },
    points: "239.556,196.12 239.636,200.062  244.249,200.062 244.329,196.12  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1A300"
    },
    d: "M244.567,200.302h-5.261v-0.481h5.261V200.302z M244.313,208.326h-4.754v0.48h4.754V208.326z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#ECE0A0"
    },
    points: "239.904,199.65 239.904,196.436 244.041,196.375 244.041,199.65  243.844,199.65 243.556,196.708 241.101,196.784 240.95,199.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "243.212,196.936 243.283,199.65 242.435,199.65 242.435,196.936  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "240.013,200.785 240.147,208.08 241.192,208.08 241.39,200.907  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#6B0A47"
    },
    points: "239.641,200.302 244.244,200.302 244.231,200.921 243.488,200.921  243.01,208.019 242.435,208.019 242.306,200.875 239.648,200.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    points: "244.041,201.148 243.935,208.019 243.51,208.019 243.776,201.148  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#AB1535"
    },
    d: "M241.8,199.912h1.694l-0.005,0.299h-1.684L241.8,199.912z M243.349,208.417h-1.404 l0.005,0.299h1.394L243.349,208.417z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.447,
    y: 199.885,
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    width: 1.651,
    height: 0.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.704,
    y: 208.414,
    style: {
      opacity: 0.65,
      fill: "#FFF7CC"
    },
    width: 1.395,
    height: 0.304
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119115670330195784540000006262099393450594688_",
    gradientUnits: "userSpaceOnUse",
    x1: -93.623,
    y1: 223.2523,
    x2: -74.7124,
    y2: 252.1701,
    gradientTransform: "matrix(1 0 0.0188 1 291.7885 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7C4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B71318"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119115670330195784540000006262099393450594688_)"
    },
    d: "M210.9,228.139h8.756l1.478,2.281 c0.406,5.748,0.508,11.568,0.328,17.453l-1.435,1.973h-13.613l-1.282-1.656c-0.364-4.838-0.494-9.454-0.258-13.723L210.9,228.139z  M212.346,229.666l1.415,2.888h6.107l-0.13-2.042l-1.036-1.306h-6.365L212.346,229.666z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B71318"
    },
    points: "206.839,232.404 205.815,231.855 208.724,228.775 209.346,229.772  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120558907906670575250000011815330720143772037_",
    gradientUnits: "userSpaceOnUse",
    x1: -87.4474,
    y1: 227.9366,
    x2: -91.5036,
    y2: 232.2412,
    gradientTransform: "matrix(1 0 0.0188 1 291.7885 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7C4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B71318"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000120558907906670575250000011815330720143772037_)"
    },
    points: "204.466,231.542  208.127,227.403 209.176,228.415 205.509,232.204  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039835407007429038700000013974190348210167683_",
    gradientUnits: "userSpaceOnUse",
    x1: -81.2894,
    y1: 245.2497,
    x2: -85.0697,
    y2: 236.8336,
    gradientTransform: "matrix(1 0 0.0188 1 291.7885 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF7C4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A61318"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#SVGID_00000039835407007429038700000013974190348210167683_)"
    },
    d: "M217.941,246.218 c-0.113,0-0.227-0.043-0.315-0.129l-1.874-1.839h-5.052l-1.805,1.839c-0.169,0.172-0.449,0.172-0.624,0 c-0.176-0.172-0.181-0.452-0.012-0.624l1.805-1.839l-0.095-5.052l-1.874-1.839c-0.176-0.172-0.181-0.452-0.012-0.624 c0.169-0.173,0.449-0.173,0.624,0l1.874,1.839h5.052l1.805-1.839c0.169-0.173,0.449-0.173,0.624,0 c0.176,0.172,0.181,0.452,0.012,0.624l-1.805,1.839l0.095,5.052l1.874,1.839c0.176,0.172,0.181,0.452,0.012,0.624 C218.166,246.175,218.054,246.218,217.941,246.218z M210.942,243.366h4.535l-0.085-4.535h-4.535L210.942,243.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFC1"
    },
    d: "M205.431,247.432c-0.282-4.745-0.421-9.161-0.241-12.845l5.815-6.237h8.389 l1.327,1.629l-1.543-1.369l-7.556,0.179l-5.747,6.268L205.431,247.432z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#5F2E0D"
    },
    points: "213.554,232.554 212.261,229.804 212.248,229.123 218.717,229.054  219.826,230.296 218.934,228.861 211.803,228.93 211.723,229.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFC1"
    },
    points: "213.805,232.71 220.055,232.71 220.011,230.337 220.417,232.876  220.035,233.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#5F2E0D"
    },
    points: "221.044,233.437 221.302,247.16 219.836,249.441 206.962,249.588  205.648,248.19 207.612,248.915 219.004,248.223 220.413,246.829  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFC1"
    },
    points: "215.151,238.992 211.123,238.992 211.196,242.892 211.437,239.553  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#5F2E0D"
    },
    points: "215.162,239.581 215.225,242.892 211.502,243.03 214.639,242.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#5F2E0D"
    },
    points: "205.815,231.855 208.778,228.861 209.162,229.477 206.36,232.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#5F2E0D"
    },
    points: "204.73,231.474 205.446,231.929 206.791,230.631 206.056,231.077  205.394,230.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFC1"
    },
    points: "208.104,227.624 206.764,229.206 207.66,228.479 208.348,228.861  208.252,229.132 208.974,228.415  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    points: "219.838,252.761 216.718,252.444 216.218,248.074 212.895,247.41  212.588,241.236 216.718,240.869 216.213,234.959 220.166,234.959  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171694150688166188380000006062725768324329612_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.4338,
    y1: 224.8063,
    x2: 230.0647,
    y2: 236.0208,
    gradientTransform: "matrix(0.9822 0.1876 -0.1876 0.9822 47.8438 -40.7667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#459CBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#287090"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171694150688166188380000006062725768324329612_)"
    },
    d: "M233.194,229.857 c0.775-4.059-1.887-7.978-5.946-8.753c-4.059-0.775-7.978,1.887-8.753,5.946s1.887,7.978,5.946,8.753 C228.5,236.579,232.419,233.916,233.194,229.857z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052814764139548486190000010728465162980799136_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.3633,
    y1: 226.3136,
    x2: 231.4276,
    y2: 236.8183,
    gradientTransform: "matrix(0.9822 0.1876 -0.1876 0.9822 47.8438 -40.7667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B5B78"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052814764139548486190000010728465162980799136_)"
    },
    d: "M224.524,235.367 c-3.812-0.728-6.321-4.421-5.593-8.233c0.728-3.812,4.421-6.321,8.233-5.593c3.812,0.728,6.321,4.422,5.593,8.234 C232.03,233.586,228.336,236.095,224.524,235.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    d: "M222.642,223.815c1.626-1.295,3.831-1.855,5.932-1.656 c-0.454-0.198-0.934-0.353-1.441-0.45c-3.718-0.71-7.322,1.737-8.032,5.456c-0.309,1.617-0.015,3.209,0.717,4.553 C219.209,228.903,220.452,225.558,222.642,223.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    d: "M231.535,224.619c-0.352,2.874-3.397,5.33-5.648,6.755 c-1.055,0.668-2.975,1.717-4.754,2.063c0.92,0.873,2.088,1.506,3.424,1.762c3.718,0.71,7.322-1.737,8.032-5.456 C232.942,227.891,232.512,226.07,231.535,224.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M224.977,232.999c-2.506-0.479-4.156-2.907-3.677-5.413c0.479-2.506,2.907-4.156,5.413-3.677 c2.506,0.479,4.156,2.907,3.677,5.413C229.911,231.828,227.483,233.477,224.977,232.999z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000012462618534926039360000001751562503753178518_",
    cx: 227.9528,
    cy: 233.2066,
    r: 8.77,
    gradientTransform: "matrix(0.9822 0.1876 -0.1876 0.9822 47.8438 -40.7667)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0754,
    style: {
      stopColor: "#F5EBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    style: {
      stopColor: "#B8C2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    style: {
      stopColor: "#759696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6921,
    style: {
      stopColor: "#7A9B98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    style: {
      stopColor: "#8AAA9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    style: {
      stopColor: "#A4C3A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#C8E5AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E6AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012462618534926039360000001751562503753178518_)"
    },
    d: "M225.037,232.684 c-2.333-0.446-3.868-2.706-3.422-5.038c0.445-2.333,2.706-3.868,5.038-3.423c2.333,0.445,3.868,2.706,3.422,5.038 C229.629,231.594,227.369,233.13,225.037,232.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#114973"
    },
    d: "M223.684,226.248c1.619-1.354,4.381-0.81,6,0.595 c-0.511-1.256-1.625-2.239-3.053-2.512c-2.239-0.428-4.409,1.046-4.837,3.286c-0.145,0.759-0.067,1.508,0.181,2.186 C222.162,228.422,222.677,227.091,223.684,226.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECE0A0"
    },
    d: "M229.878,229.346c-0.094,0.421-0.249,0.813-0.455,1.17 c-0.389-0.487-0.808-0.954-1.222-1.427c-0.034-0.039-0.065-0.08-0.098-0.12c0.076-0.237,0.129-0.484,0.163-0.733 C228.809,228.597,229.347,228.965,229.878,229.346z M227.708,229.79c-0.306,0.45-0.737,0.788-1.321,0.903 c-0.324,0.064-0.653,0.04-0.971-0.043c-0.006,0.101-0.011,0.203-0.017,0.303c0,0.002-0.001,0.003-0.001,0.004 c-0.009,0.532-0.026,1.064-0.058,1.596c1.363,0.168,2.673-0.356,3.553-1.313C228.521,230.744,228.12,230.269,227.708,229.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#114973"
    },
    d: "M225.477,231.982c-1.774-0.339-2.945-2.039-2.611-3.79 c0.335-1.751,2.05-2.9,3.824-2.562c1.774,0.339,2.945,2.039,2.611,3.79C228.967,231.172,227.251,232.321,225.477,231.982z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132054546765572019070000002111593754025851835_",
    cx: 222.7866,
    cy: 228.3848,
    r: 6.9124,
    gradientTransform: "matrix(0.9822 0.1876 -0.1876 0.9822 47.8438 -40.7667)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0754,
    style: {
      stopColor: "#F5EBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    style: {
      stopColor: "#B8C2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    style: {
      stopColor: "#759696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6921,
    style: {
      stopColor: "#7A9B98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    style: {
      stopColor: "#8AAA9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    style: {
      stopColor: "#A4C3A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#C8E5AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E6AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132054546765572019070000002111593754025851835_)"
    },
    d: "M225.256,231.533 c-1.698-0.324-2.816-1.97-2.491-3.668c0.324-1.698,1.97-2.816,3.668-2.492c1.698,0.324,2.816,1.97,2.491,3.668 C228.6,230.74,226.954,231.858,225.256,231.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECE0A0"
    },
    d: "M225.618,225.415c0.006-0.023,0.019-0.038,0.027-0.058 c-1.262,0.069-2.373,0.945-2.705,2.203c0.7,0.141,1.402,0.255,2.106,0.362C225.22,227.082,225.402,226.244,225.618,225.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#114973"
    },
    d: "M225.868,229.119c-0.155,0.79-0.331,1.571-0.529,2.337 c0.006,0.001,0.012,0.003,0.018,0.004c1.466,0.28,2.887-0.577,3.36-1.948C227.766,229.4,226.814,229.275,225.868,229.119z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088124780408308731160000013869614726323066782_",
    cx: 227.3214,
    cy: 232.6613,
    r: 5.7708,
    gradientTransform: "matrix(0.9822 0.1876 -0.1876 0.9822 47.8438 -40.7667)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0754,
    style: {
      stopColor: "#F5EBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    style: {
      stopColor: "#B8C2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    style: {
      stopColor: "#759696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6921,
    style: {
      stopColor: "#7A9B98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    style: {
      stopColor: "#8AAA9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8869,
    style: {
      stopColor: "#A4C3A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    style: {
      stopColor: "#C8E5AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9E6AF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088124780408308731160000013869614726323066782_)"
    },
    d: "M225.435,230.598 c-1.182-0.226-1.96-1.372-1.735-2.554c0.226-1.182,1.372-1.961,2.554-1.735s1.96,1.372,1.735,2.554 C227.763,230.046,226.617,230.824,225.435,230.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#ECE0A0"
    },
    d: "M226.766,229.597c-0.584,0.296-1.392,0.559-2.102,0.475 c0.233,0.171,0.501,0.299,0.804,0.357c1.089,0.208,2.144-0.509,2.352-1.598c0.002-0.009,0.002-0.018,0.003-0.027 C227.519,229.12,227.17,229.392,226.766,229.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#114973"
    },
    d: "M226.015,227.628c0.484-0.159,0.978-0.094,1.378,0.135 c0.157,0.061,0.297,0.148,0.415,0.259c-0.168-0.761-0.773-1.388-1.586-1.543c-1.089-0.208-2.145,0.509-2.352,1.598 c-0.116,0.606,0.055,1.201,0.417,1.645C224.404,228.813,225.239,227.882,226.015,227.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M225.717,229.121c-0.368-0.07-0.61-0.427-0.54-0.794c0.07-0.368,0.427-0.61,0.794-0.54 c0.368,0.07,0.61,0.427,0.54,0.794C226.441,228.949,226.085,229.191,225.717,229.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M227.168,228.542c-0.199,0.042-0.395-0.085-0.437-0.284c-0.042-0.199,0.085-0.395,0.284-0.437 c0.199-0.042,0.395,0.085,0.437,0.284C227.495,228.304,227.367,228.5,227.168,228.542z M224.917,228.642 c-0.042-0.199-0.238-0.326-0.437-0.284c-0.199,0.042-0.327,0.238-0.284,0.437c0.042,0.199,0.238,0.326,0.437,0.284 S224.959,228.841,224.917,228.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M225.732,229.794c-0.042-0.199,0.086-0.395,0.284-0.437c0.199-0.042,0.395,0.085,0.437,0.284 c0.042,0.199-0.086,0.395-0.284,0.437C225.97,230.12,225.774,229.993,225.732,229.794z M225.632,227.543 c0.199-0.042,0.327-0.238,0.284-0.437c-0.042-0.199-0.238-0.327-0.437-0.284c-0.199,0.042-0.326,0.238-0.284,0.437 C225.237,227.457,225.433,227.585,225.632,227.543z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M226.299,230.799c-0.126,0.091-0.154,0.268-0.063,0.393c0.091,0.126,0.268,0.154,0.393,0.063 c0.126-0.091,0.154-0.268,0.063-0.393S226.425,230.708,226.299,230.799z M225.074,225.574 c-0.126,0.091-0.154,0.268-0.063,0.393c0.091,0.126,0.268,0.154,0.393,0.063c0.126-0.091,0.154-0.268,0.063-0.393 C225.377,225.51,225.2,225.482,225.074,225.574z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M227.299,230.362c-0.073,0.137-0.021,0.308,0.116,0.381c0.137,0.073,0.308,0.021,0.381-0.116 c0.073-0.137,0.021-0.308-0.116-0.381C227.543,230.173,227.372,230.225,227.299,230.362z M223.908,226.202 c-0.073,0.137-0.021,0.308,0.116,0.381c0.137,0.073,0.308,0.021,0.381-0.116c0.073-0.137,0.021-0.308-0.116-0.381 C224.152,226.013,223.981,226.065,223.908,226.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M228.007,229.531c-0.006,0.155,0.116,0.286,0.271,0.292c0.155,0.005,0.286-0.116,0.291-0.271 c0.006-0.155-0.116-0.286-0.271-0.291C228.143,229.254,228.012,229.376,228.007,229.531z M223.135,227.278 c-0.005,0.155,0.116,0.286,0.271,0.292c0.155,0.006,0.286-0.116,0.291-0.271c0.006-0.155-0.116-0.286-0.271-0.291 C223.271,227.001,223.14,227.123,223.135,227.278z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M228.278,228.473c0.063,0.142,0.23,0.206,0.372,0.143c0.142-0.063,0.206-0.23,0.143-0.372 c-0.063-0.142-0.23-0.206-0.372-0.143C228.279,228.165,228.215,228.331,228.278,228.473z M222.912,228.585 c0.063,0.142,0.23,0.206,0.372,0.143c0.142-0.063,0.206-0.23,0.143-0.372c-0.063-0.142-0.23-0.206-0.372-0.143 C222.913,228.276,222.849,228.443,222.912,228.585z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M228.058,227.404c0.119,0.1,0.297,0.085,0.397-0.034c0.1-0.119,0.084-0.297-0.035-0.397 c-0.119-0.1-0.297-0.084-0.397,0.035C227.924,227.126,227.939,227.304,228.058,227.404z M223.284,229.856 c0.119,0.1,0.297,0.084,0.397-0.034c0.1-0.119,0.084-0.297-0.035-0.397c-0.119-0.1-0.297-0.084-0.397,0.035 S223.165,229.756,223.284,229.856z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M227.392,226.539c0.151,0.038,0.304-0.054,0.342-0.205c0.038-0.151-0.054-0.304-0.205-0.342 c-0.151-0.038-0.304,0.054-0.342,0.205C227.149,226.348,227.241,226.501,227.392,226.539z M224.176,230.836 c0.151,0.038,0.304-0.054,0.342-0.205c0.038-0.151-0.054-0.304-0.205-0.342c-0.151-0.038-0.304,0.054-0.342,0.205 C223.933,230.645,224.025,230.799,224.176,230.836z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4263"
    },
    d: "M226.414,226.054c0.152-0.032,0.249-0.182,0.217-0.334c-0.032-0.152-0.182-0.249-0.334-0.217 c-0.152,0.032-0.249,0.182-0.217,0.334C226.112,225.989,226.262,226.086,226.414,226.054z M225.407,231.326 c0.152-0.032,0.249-0.182,0.217-0.334c-0.032-0.152-0.182-0.249-0.334-0.217c-0.152,0.032-0.249,0.182-0.217,0.334 C225.105,231.261,225.255,231.358,225.407,231.326z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036252061829287129350000006197809497329169070_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.4118,
    y1: 236.5876,
    x2: 233.6689,
    y2: 236.5876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B5B78"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036252061829287129350000006197809497329169070_)"
    },
    points: "232.994,239.822  219.087,239.822 218.564,239.338 218.412,233.864 218.934,233.353 233.146,233.353 233.669,233.864 233.516,239.338  232.994,239.822  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14506B"
    },
    d: "M233.49,239.363l-0.004,0.004h-0.384l-0.421-1.7l-0.761-0.01l0.568,1.71h-0.389l-0.422-1.714 l-0.761-0.01l0.57,1.724h-0.389l-0.423-1.727l-0.762-0.01l0.572,1.738h-0.389l-0.425-1.741l-0.762-0.01l0.573,1.751h-0.389 l-0.426-1.755l-0.763-0.01l0.574,1.765h-0.389l-0.427-1.768l-0.763-0.01l0.576,1.778h-0.389l-0.428-1.782l-0.763-0.01 l0.577,1.792h-0.389l-0.429-1.795l-0.764-0.01l0.579,1.805h-0.389l-0.43-1.809l-0.764-0.01l0.581,1.819h-0.389l-0.431-1.822 l-0.764-0.01l0.582,1.833h-0.389l-0.432-1.836l-0.765-0.01l0.583,1.846h-0.389l-0.433-1.849l-0.765-0.01l0.585,1.86h-0.389 l-0.434-1.863l-0.766-0.01l0.586,1.873h-0.389l-0.436-1.876l-0.766-0.01l0.588,1.887h-0.389l-0.437-1.89l-0.112-0.001 l-0.01-0.378l15.078-0.061l-0.018,0.642l-0.638-0.009L233.49,239.363z M232.924,235.668l0.567-1.697h-0.389l-0.421,1.7 l-0.761,0.01l0.568-1.711h-0.389l-0.422,1.714l-0.761,0.01l0.57-1.724h-0.389l-0.423,1.727l-0.762,0.01l0.572-1.738h-0.389 l-0.425,1.741l-0.762,0.01l0.573-1.751h-0.389l-0.426,1.755l-0.763,0.01l0.574-1.765h-0.389l-0.427,1.768l-0.763,0.01 l0.576-1.778h-0.389l-0.428,1.782l-0.763,0.01l0.577-1.792h-0.389l-0.429,1.795l-0.764,0.01l0.579-1.805h-0.389l-0.43,1.809 l-0.764,0.01l0.581-1.819h-0.389l-0.431,1.822l-0.764,0.01l0.582-1.833h-0.389l-0.432,1.836l-0.765,0.01l0.583-1.846h-0.389 l-0.433,1.849l-0.765,0.01l0.585-1.86h-0.389l-0.434,1.863l-0.766,0.01l0.586-1.873h-0.389l-0.436,1.877l-0.766,0.01l0.588-1.887 h-0.389l-0.437,1.89l-0.157,0.002l0.01,0.377l15.123,0.061l0.018-0.643L232.924,235.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    d: "M221.582,233.67h-2.507l-0.326,0.319l0.146,5.212l0.328,0.304h1.493 C220.452,237.551,220.738,235.6,221.582,233.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    d: "M232.042,238.916c0.06-1.748,0.114-3.495,0.138-5.246h-2.416 c-0.191,1.777-0.351,3.556-0.528,5.334l-10.672,0.334l0.523,0.484h13.907l0.496-0.46l0.039-0.493L232.042,238.916z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115501022297889453800000012102130826839238830_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.4132,
    y1: 243.057,
    x2: 230.6703,
    y2: 243.057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B5B78"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000115501022297889453800000012102130826839238830_)"
    },
    points: "229.995,246.292  216.089,246.292 215.566,245.807 215.413,240.333 215.936,239.822 230.148,239.822 230.67,240.333 230.518,245.807  229.995,246.292  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14506B"
    },
    d: "M230.491,245.832l-0.004,0.004h-0.384l-0.421-1.7l-0.761-0.01l0.568,1.71h-0.389l-0.423-1.714 l-0.761-0.01l0.57,1.724h-0.389l-0.424-1.727l-0.762-0.01l0.571,1.738h-0.389l-0.425-1.741l-0.762-0.01l0.573,1.751h-0.389 l-0.426-1.754l-0.763-0.01l0.575,1.765h-0.389l-0.427-1.768l-0.763-0.01l0.576,1.778h-0.389l-0.428-1.782l-0.763-0.01 l0.578,1.792h-0.389l-0.429-1.795l-0.764-0.01l0.579,1.805h-0.389l-0.43-1.809l-0.764-0.01l0.581,1.819h-0.389l-0.431-1.822 l-0.765-0.01l0.582,1.833h-0.389L219.642,244l-0.765-0.01l0.583,1.846h-0.389l-0.433-1.849l-0.765-0.01l0.585,1.86h-0.389 l-0.434-1.863l-0.766-0.01l0.586,1.873h-0.389l-0.436-1.876l-0.766-0.01l0.587,1.887h-0.389l-0.436-1.89l-0.112-0.001 l-0.011-0.378l15.079-0.061l-0.018,0.642l-0.638-0.009L230.491,245.832z M229.926,242.137l0.567-1.697h-0.389l-0.421,1.7 l-0.761,0.01l0.568-1.71h-0.389l-0.423,1.714l-0.761,0.01l0.57-1.724h-0.389l-0.424,1.727l-0.762,0.01l0.571-1.738h-0.389 l-0.425,1.741l-0.762,0.01l0.573-1.751h-0.389l-0.426,1.755l-0.763,0.01l0.575-1.765h-0.389l-0.427,1.768l-0.763,0.01 l0.576-1.778h-0.389l-0.428,1.782l-0.763,0.01l0.578-1.792h-0.389l-0.429,1.795l-0.764,0.01l0.579-1.805h-0.389l-0.43,1.809 l-0.764,0.01l0.581-1.819h-0.389l-0.431,1.822l-0.765,0.01l0.582-1.833h-0.389l-0.432,1.836l-0.765,0.01l0.583-1.846h-0.389 l-0.433,1.849l-0.765,0.01l0.585-1.86h-0.389l-0.434,1.863l-0.766,0.01l0.586-1.873h-0.389l-0.436,1.876l-0.766,0.01 l0.587-1.887h-0.389l-0.436,1.89l-0.157,0.002l0.01,0.377l15.123,0.061l0.018-0.643L229.926,242.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    d: "M218.584,240.14h-2.507l-0.326,0.319l0.146,5.212l0.328,0.304h1.493 C217.542,244.02,217.828,242.07,218.584,240.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    d: "M229.044,245.385c0.059-1.748,0.113-3.495,0.138-5.246h-2.416 c-0.191,1.777-0.351,3.556-0.528,5.334l-10.672,0.334l0.523,0.484h13.907l0.496-0.46l0.039-0.493L229.044,245.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157300766425901139990000001833014529252715155_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.1628,
    y1: 249.5264,
    x2: 234.4198,
    y2: 249.5264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B5B78"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000157300766425901139990000001833014529252715155_)"
    },
    points: "233.745,252.761  219.838,252.761 219.315,252.277 219.163,246.802 219.685,246.292 233.897,246.292 234.42,246.802 234.267,252.277  233.745,252.761  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14506B"
    },
    d: "M234.241,252.301l-0.004,0.004h-0.384l-0.421-1.7l-0.761-0.01l0.568,1.71h-0.389l-0.422-1.714 l-0.761-0.01l0.57,1.724h-0.389l-0.423-1.727l-0.762-0.01l0.572,1.738h-0.389l-0.425-1.741l-0.762-0.01l0.573,1.751h-0.389 l-0.426-1.755l-0.763-0.01l0.575,1.765h-0.389l-0.427-1.768l-0.763-0.01l0.576,1.778h-0.389l-0.428-1.782l-0.763-0.01 l0.577,1.792h-0.389l-0.429-1.795l-0.764-0.01l0.579,1.805h-0.389l-0.43-1.809l-0.764-0.01l0.581,1.819h-0.389l-0.431-1.822 l-0.764-0.01l0.582,1.833h-0.389l-0.432-1.836l-0.765-0.01l0.583,1.846h-0.389l-0.433-1.849l-0.765-0.01l0.585,1.86h-0.389 l-0.435-1.863l-0.766-0.01l0.586,1.873h-0.389l-0.436-1.876l-0.766-0.01l0.588,1.887h-0.389l-0.436-1.89l-0.112-0.001 l-0.01-0.378l15.078-0.061l-0.018,0.642l-0.638-0.009L234.241,252.301z M233.675,248.606l0.567-1.697h-0.389l-0.421,1.7 l-0.761,0.01l0.568-1.711h-0.389l-0.422,1.714l-0.761,0.01l0.57-1.724h-0.389l-0.423,1.727l-0.762,0.01l0.572-1.738h-0.389 l-0.425,1.741l-0.762,0.01l0.573-1.751h-0.389l-0.426,1.755l-0.763,0.01l0.575-1.765h-0.389l-0.427,1.768l-0.763,0.01 l0.576-1.778h-0.389l-0.428,1.782l-0.763,0.01l0.577-1.792h-0.389l-0.429,1.795l-0.764,0.01l0.579-1.806h-0.389l-0.43,1.809 l-0.764,0.01l0.581-1.819h-0.389l-0.431,1.822l-0.764,0.01l0.582-1.833h-0.389l-0.432,1.836l-0.765,0.01l0.583-1.846h-0.389 l-0.433,1.849l-0.765,0.01l0.585-1.86h-0.389l-0.435,1.863l-0.766,0.01l0.586-1.873h-0.389l-0.436,1.877l-0.766,0.01 l0.588-1.887h-0.389l-0.436,1.89l-0.157,0.002l0.011,0.377l15.123,0.061l0.018-0.643L233.675,248.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    d: "M222.333,246.609h-2.507l-0.326,0.319l0.146,5.212l0.328,0.304h1.493 C221.268,250.405,221.595,248.464,222.333,246.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    d: "M232.793,251.855c0.06-1.748,0.114-3.495,0.138-5.246h-2.416 c-0.191,1.777-0.351,3.556-0.528,5.334l-10.672,0.334l0.523,0.484h13.907l0.496-0.46l0.039-0.493L232.793,251.855z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.75,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#305575"
    },
    points: " 103.5,171.557 123.515,186.727 136.37,195.818 252.972,197.294 263.415,227.618 264.673,227.645 265.173,227.029 273.046,224.176  287.986,223.197 289.859,227.27 302.826,170.954  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#1E4463"
    },
    points: " 190.864,260.166 148.686,260.166 157.393,251.348 182.158,251.348  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070082560176061747450000009926182610756188556_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.1525,
    y1: 257.7273,
    x2: 169.1525,
    y2: 233.3609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B5B78"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "url(#SVGID_00000070082560176061747450000009926182610756188556_)"
    },
    d: " M181.937,246.985l-0.942-0.557l0.006-0.016l-10.638-6.063l10.638-5.482l-0.627-1.626l-11.241,6.407l-11.241-6.407l-0.627,1.626 l10.638,5.482l-9.71,5.534l-1.824,0.992l11.534,5.943l-10.638,6.063l11.868-5.429l11.868,5.429l-10.638-6.063L181.937,246.985z  M158.872,246.27l10.261-5.287l10.261,5.287l-10.261,5.848L158.872,246.27z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166639015358497302570000013314150826463335567_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.1326,
    y1: 211.3471,
    x2: 132.9924,
    y2: 207.532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    style: {
      stopColor: "#AF1A37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3614,
    style: {
      stopColor: "#B9283B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5738,
    style: {
      stopColor: "#CB4043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    style: {
      stopColor: "#E4624D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8759"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166639015358497302570000013314150826463335567_)"
    },
    d: "M141.185,212.004 c-2.693,0.261-5.143,0.044-7.281-0.785c-0.51-1.305-0.776-2.527-0.585-3.595c3.261-0.566,6.536-0.562,9.824,0L141.185,212.004z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 133.564,
    y: 207.499,
    width: 9.143,
    height: 2.823
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 133.564,
    y: 207.499,
    width: 9.143,
    height: 2.823,
    id: "SVGID_00000111899413220939393900000005364632260162236326_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000159453908982363317030000001485916525890645671_",
    filterUnits: "userSpaceOnUse",
    x: 133.564,
    y: 207.499,
    width: 9.143,
    height: 2.823
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 133.564,
    y: 207.499,
    width: 9.143,
    height: 2.823,
    id: "SVGID_00000111899413220939393900000005364632260162236326_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000159453908982363317030000001485916525890645671_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106128941880078980250000011629637852003526042_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.3328,
    y1: 211.3355,
    x2: 137.9961,
    y2: 205.912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000111899413220939393900000005364632260162236326_)",
      fill: "url(#SVGID_00000106128941880078980250000011629637852003526042_)"
    },
    d: " M138.095,210.294c0.944,0.017,1.891,0.002,2.848,0.029c0.233-0.02,0.465-0.045,0.696-0.078l1.069-2.39 c-1.5-0.236-3.011-0.355-4.496-0.355c-1.539,0-3.093,0.128-4.621,0.382c-0.045,0.382-0.03,0.8,0.039,1.255 C134.899,209.959,136.59,210.167,138.095,210.294z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124136883152583940860000003214627788282599591_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.3328,
    y1: 211.3355,
    x2: 137.9961,
    y2: 205.912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF7CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#SVGID_00000124136883152583940860000003214627788282599591_)"
    },
    d: "M138.095,210.294 c0.944,0.017,1.891,0.002,2.848,0.029c0.233-0.02,0.465-0.045,0.696-0.078l1.069-2.39c-1.5-0.236-3.011-0.355-4.496-0.355 c-1.539,0-3.093,0.128-4.621,0.382c-0.045,0.382-0.03,0.8,0.039,1.255C134.899,209.959,136.59,210.167,138.095,210.294z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086672494359919334140000017046319187023089844_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.4981,
    y1: 211.3471,
    x2: 390.3579,
    y2: 207.532,
    gradientTransform: "matrix(-1 0 0 1 593.9381 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    style: {
      stopColor: "#AF1A37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3614,
    style: {
      stopColor: "#B9283B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5738,
    style: {
      stopColor: "#CB4043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    style: {
      stopColor: "#E4624D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8759"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086672494359919334140000017046319187023089844_)"
    },
    d: "M195.387,212.004 c2.693,0.261,5.143,0.044,7.281-0.785c0.51-1.305,0.775-2.527,0.585-3.595c-3.261-0.566-6.536-0.562-9.824,0L195.387,212.004z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000000924167847152116580000002304076237368131484_",
    filterUnits: "userSpaceOnUse",
    x: 193.865,
    y: 207.499,
    width: 9.143,
    height: 2.823
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 193.865,
    y: 207.499,
    width: 9.143,
    height: 2.823,
    id: "SVGID_00000012454937462311075230000016341421516083883918_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000000924167847152116580000002304076237368131484_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000139276210987237275690000016075013706269460121_",
    filterUnits: "userSpaceOnUse",
    x: 193.865,
    y: 207.499,
    width: 9.143,
    height: 2.823
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 193.865,
    y: 207.499,
    width: 9.143,
    height: 2.823,
    id: "SVGID_00000012454937462311075230000016341421516083883918_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000139276210987237275690000016075013706269460121_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161611093711959220520000000217609639795091632_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.6983,
    y1: 211.3355,
    x2: 395.3617,
    y2: 205.912,
    gradientTransform: "matrix(-1 0 0 1 593.9381 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000012454937462311075230000016341421516083883918_)",
      fill: "url(#SVGID_00000161611093711959220520000000217609639795091632_)"
    },
    d: " M198.478,210.294c-0.944,0.017-1.891,0.002-2.848,0.029c-0.233-0.02-0.465-0.045-0.696-0.078l-1.069-2.39 c1.5-0.236,3.011-0.355,4.496-0.355c1.539,0,3.093,0.128,4.621,0.382c0.045,0.382,0.03,0.8-0.039,1.255 C201.674,209.959,199.982,210.167,198.478,210.294z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051373822635514641210000000197567145363141558_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.6983,
    y1: 211.3355,
    x2: 395.3617,
    y2: 205.912,
    gradientTransform: "matrix(-1 0 0 1 593.9381 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF7CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#SVGID_00000051373822635514641210000000197567145363141558_)"
    },
    d: "M198.478,210.294 c-0.944,0.017-1.891,0.002-2.848,0.029c-0.233-0.02-0.465-0.045-0.696-0.078l-1.069-2.39c1.5-0.236,3.011-0.355,4.496-0.355 c1.539,0,3.093,0.128,4.621,0.382c0.045,0.382,0.03,0.8-0.039,1.255C201.674,209.959,199.982,210.167,198.478,210.294z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010299197103374824770000000516350895218897299_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.2341,
    y1: 243.6112,
    x2: 146.5129,
    y2: 232.2224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B5B78"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010299197103374824770000000516350895218897299_)"
    },
    d: "M141.989,233.262 c0.857,3.398,2.186,6.464,3.926,9.192c1.994,0.331,3.87,0.367,5.584,0c0.391-2.759,0.659-5.325,0.502-7.234L141.989,233.262z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151508932784347671550000000363144417071599034_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.7693,
    y1: 234.1819,
    x2: 151.3957,
    y2: 241.8557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22567D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151508932784347671550000000363144417071599034_)"
    },
    d: "M151.499,242.454 c-0.998-2.321-1.647-4.858-1.825-7.689l2.327,0.455C152.129,237.377,151.896,239.844,151.499,242.454z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14506B"
    },
    d: "M147.072,235.69c-0.099-0.493-0.187-0.989-0.27-1.487l-0.413-0.081 c0.475,2.967,1.253,5.853,2.32,8.59c0.145,0.002,0.287-0.001,0.43-0.003c-0.191-0.483-0.37-0.973-0.543-1.466 c0.476-0.242,0.926-0.551,1.336-0.928l-0.239-0.375c-0.383,0.352-0.803,0.641-1.248,0.867c-0.112-0.33-0.218-0.661-0.322-0.995 c0.595-0.267,1.298-0.986,1.443-1.139l-0.259-0.355c-0.37,0.389-0.915,0.87-1.323,1.052c-0.141-0.473-0.27-0.95-0.395-1.429 c0.634-0.362,1.227-0.822,1.759-1.374l-0.257-0.357c-0.49,0.51-1.035,0.934-1.617,1.274c-0.11-0.443-0.213-0.889-0.308-1.337 c0.788-0.203,1.517-0.696,2.066-1.407l-0.067-0.075l-0.366-0.072C148.322,235.143,147.719,235.526,147.072,235.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14506B"
    },
    d: "M148.023,242.572c-1.465-2.618-2.5-5.624-3.019-8.72l-0.415-0.081 c0.107,0.659,0.234,1.314,0.385,1.963c-0.638-0.359-1.228-0.822-1.75-1.395l-0.265,0.348c0.633,0.695,1.355,1.247,2.147,1.641 l0.009-0.026c0.13,0.507,0.274,1.009,0.43,1.506c-0.48-0.175-0.925-0.474-1.292-0.89l-0.269,0.343 c0.481,0.545,1.077,0.923,1.723,1.093l0.003-0.019c0.108,0.32,0.225,0.634,0.343,0.948c-0.391-0.118-0.772-0.277-1.139-0.476 l-0.162,0.43c0.483,0.263,0.992,0.459,1.513,0.588c0.128,0.319,0.26,0.637,0.399,0.949c-0.324-0.077-0.642-0.188-0.949-0.334 l-0.145,0.438c0.406,0.193,0.831,0.332,1.262,0.412l0.016-0.123c0.238,0.509,0.488,1.008,0.754,1.494 c0.095,0.008,0.19,0.014,0.284,0.02L148.023,242.572z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#305575"
    },
    d: "M141.989,233.262c0.252,1.02,0.58,2.081,0.971,3.175l7.034,1.006 c-0.172-0.988-0.301-1.914-0.321-2.678L141.989,233.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093156998532785297140000009603166293885811074_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.1313,
    y1: 243.6112,
    x2: 359.4102,
    y2: 232.2224,
    gradientTransform: "matrix(-1 0 0 1 549.5944 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C728A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B5B78"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093156998532785297140000009603166293885811074_)"
    },
    d: "M194.708,233.262 c-0.857,3.398-2.186,6.464-3.926,9.192c-1.994,0.331-3.87,0.367-5.584,0c-0.391-2.759-0.659-5.325-0.502-7.234L194.708,233.262z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054977014802795614960000002526631932525889163_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.6665,
    y1: 234.1819,
    x2: 364.2929,
    y2: 241.8557,
    gradientTransform: "matrix(-1 0 0 1 549.5944 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22567D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054977014802795614960000002526631932525889163_)"
    },
    d: "M185.198,242.454 c0.998-2.321,1.647-4.858,1.825-7.689l-2.327,0.455C184.569,237.377,184.801,239.844,185.198,242.454z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14506B"
    },
    d: "M189.625,235.69c0.099-0.493,0.187-0.989,0.27-1.487l0.413-0.081 c-0.475,2.967-1.253,5.853-2.32,8.59c-0.145,0.002-0.287-0.001-0.43-0.003c0.191-0.483,0.37-0.973,0.544-1.466 c-0.476-0.242-0.926-0.551-1.336-0.928l0.239-0.375c0.383,0.352,0.803,0.641,1.248,0.867c0.112-0.33,0.218-0.661,0.322-0.995 c-0.596-0.267-1.298-0.986-1.443-1.139l0.259-0.355c0.369,0.389,0.915,0.87,1.323,1.052c0.141-0.473,0.27-0.95,0.395-1.429 c-0.634-0.362-1.227-0.822-1.759-1.374l0.257-0.357c0.49,0.51,1.035,0.934,1.617,1.274c0.11-0.443,0.213-0.889,0.309-1.337 c-0.788-0.203-1.517-0.696-2.066-1.407l0.067-0.075l0.366-0.072C188.375,235.143,188.978,235.526,189.625,235.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14506B"
    },
    d: "M188.674,242.572c1.465-2.618,2.5-5.624,3.019-8.72l0.415-0.081 c-0.107,0.659-0.234,1.314-0.385,1.963c0.638-0.359,1.228-0.822,1.75-1.395l0.265,0.348c-0.633,0.695-1.355,1.247-2.147,1.641 l-0.009-0.026c-0.13,0.507-0.274,1.009-0.43,1.506c0.48-0.175,0.925-0.474,1.292-0.89l0.269,0.343 c-0.481,0.545-1.077,0.923-1.723,1.093l-0.003-0.019c-0.108,0.32-0.224,0.634-0.343,0.948c0.391-0.118,0.772-0.277,1.139-0.476 l0.162,0.43c-0.483,0.263-0.992,0.459-1.513,0.588c-0.128,0.319-0.26,0.637-0.399,0.949c0.324-0.077,0.642-0.188,0.949-0.334 l0.145,0.438c-0.406,0.193-0.831,0.332-1.262,0.412l-0.016-0.123c-0.238,0.509-0.488,1.008-0.754,1.494 c-0.095,0.008-0.19,0.014-0.284,0.02L188.674,242.572z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#305575"
    },
    d: "M194.708,233.262c-0.252,1.02-0.58,2.081-0.971,3.175l-7.034,1.006 c0.172-0.988,0.301-1.914,0.321-2.678L194.708,233.262z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121974719110807878160000013235551960019412899_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.312,
    y1: 222.5591,
    x2: 197.0076,
    y2: 222.5591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8759"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121974719110807878160000013235551960019412899_)"
    },
    d: "M196.805,232.812 c-19.098,5.054-38.189,4.879-57.287-0.175c-0.517-7.729-0.08-15.098,1.555-22.013c17.944-2.73,36.008-2.661,54.184,0 C196.864,217.797,197.322,225.318,196.805,232.812z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000039812944218227541790000014485555996414620817_",
    filterUnits: "userSpaceOnUse",
    x: 181.313,
    y: 216.814,
    width: 15.182,
    height: 13.063
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 181.313,
    y: 216.814,
    width: 15.182,
    height: 13.063,
    id: "SVGID_00000137831638355650869900000017716871317725582225_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000039812944218227541790000014485555996414620817_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000084488656888355963320000004996124442895006092_",
    filterUnits: "userSpaceOnUse",
    x: 181.313,
    y: 216.814,
    width: 15.182,
    height: 13.063
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 181.313,
    y: 216.814,
    width: 15.182,
    height: 13.063,
    id: "SVGID_00000137831638355650869900000017716871317725582225_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000084488656888355963320000004996124442895006092_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170978052699291906160000006197043828579771572_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.0101,
    y1: 221.3361,
    x2: 185.917,
    y2: 224.0976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000137831638355650869900000017716871317725582225_)",
      fill: "url(#SVGID_00000170978052699291906160000006197043828579771572_)"
    },
    d: " M195.788,216.814c0.557,3.406,0.787,6.878,0.683,10.338c-4.826,1.714-10.008,2.295-15.058,2.725 c-0.151-1.657-0.125-3.424,0.04-5.079C186.263,222.499,191.231,219.685,195.788,216.814z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018224829099545415720000009951493992078529417_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.0101,
    y1: 221.3361,
    x2: 185.917,
    y2: 224.0976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF7CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#SVGID_00000018224829099545415720000009951493992078529417_)"
    },
    d: "M195.788,216.814 c0.557,3.406,0.787,6.878,0.683,10.338c-4.826,1.714-10.008,2.295-15.058,2.725c-0.151-1.657-0.125-3.424,0.04-5.079 C186.263,222.499,191.231,219.685,195.788,216.814z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114754717165222925290000007530528836976793791_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.0663,
    y1: 225.8658,
    x2: 168.0663,
    y2: 229.8483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#131F49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    style: {
      stopColor: "#14466A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22567D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114754717165222925290000007530528836976793791_)"
    },
    d: "M157.18,227.449l-0.285-1.531 c7.089,1.055,14.552,1.043,22.342,0l-0.284,1.527C171.487,228.221,164.221,228.243,157.18,227.449z M157.337,228.296l0.128,0.688 c6.837,0.748,13.919,0.719,21.202,0l0.128-0.689C171.515,228.949,164.355,228.986,157.337,228.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8759"
    },
    d: "M194.844,211.353c-6.464-1.539-16.648-2.201-26.738-2.201s-20.274,0.662-26.738,2.201 l-0.361,4.716c3.431,2.818,7.995,5.34,13.069,7.729c4.8,0.391,9.484,0.541,14.03,0.406c4.546,0.135,9.23-0.015,14.03-0.406 c5.074-2.389,9.638-4.912,13.069-7.729L194.844,211.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#285072"
    },
    d: "M194.668,211.302c-6.421-1.503-16.538-2.15-26.562-2.15c-10.024,0-20.141,0.647-26.562,2.15 l-0.359,4.607c3.408,2.752,7.942,5.216,12.983,7.55c4.769,0.382,9.422,0.529,13.938,0.397c4.516,0.132,9.169-0.014,13.938-0.397 c5.041-2.334,9.575-4.798,12.983-7.55L194.668,211.302z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D96118"
    },
    d: "M143.406,220.437c-0.564-0.276-1.125-0.552-1.679-0.83c-0.531,2.41-0.4,4.788,0,7.153 c0.493,0.196,0.999,0.376,1.514,0.546C143.07,225.018,143.126,222.709,143.406,220.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A01E"
    },
    d: "M142.758,224.143c0.018-1.139,0.089-2.278,0.216-3.408c-0.326-0.16-0.651-0.32-0.973-0.481 c-0.195,1.081-0.263,2.215-0.213,3.442C142.076,223.919,142.409,224.056,142.758,224.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD586"
    },
    d: "M154.357,225.423c-3.809-1.625-7.47-3.285-10.951-4.986c-0.28,2.272-0.336,4.581-0.165,6.869 c3.344,1.104,7.113,1.681,11.116,1.969V225.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF7CC"
    },
    d: "M148.946,226.302c1.617,0.347,3.322,0.733,5.018,0.91v-1.456 c-3.645-1.559-7.085-3.123-10.238-4.654c-0.107,1.014-0.167,2.035-0.184,3.056C145.303,225.01,147.006,225.886,148.946,226.302z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D96118"
    },
    d: "M192.997,220.437c0.564-0.276,1.125-0.552,1.679-0.83c0.531,2.41,0.4,4.788,0,7.153 c-0.494,0.196-1,0.376-1.514,0.546C193.333,225.018,193.276,222.709,192.997,220.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A01E"
    },
    d: "M193.645,224.143c-0.018-1.139-0.089-2.278-0.216-3.408c0.326-0.16,0.651-0.32,0.973-0.481 c0.195,1.081,0.263,2.215,0.213,3.442C194.327,223.919,193.994,224.056,193.645,224.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD586"
    },
    d: "M182.046,225.423c3.809-1.625,7.47-3.285,10.951-4.986c0.28,2.272,0.336,4.581,0.165,6.869 c-3.344,1.104-7.113,1.681-11.116,1.969V225.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF7CC"
    },
    d: "M187.457,226.302c-1.617,0.347-3.322,0.733-5.018,0.91v-1.456 c3.645-1.559,7.085-3.123,10.238-4.654c0.107,1.014,0.167,2.035,0.184,3.056C191.1,225.01,189.397,225.886,187.457,226.302z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034068000568232963930000015568586272088839814_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.4367,
    y1: 195.0751,
    x2: 136.1949,
    y2: 213.1259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB1535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    style: {
      stopColor: "#AF1A37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3614,
    style: {
      stopColor: "#B9283B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5738,
    style: {
      stopColor: "#CB4043"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    style: {
      stopColor: "#E4624D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8759"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034068000568232963930000015568586272088839814_)"
    },
    d: "M186.624,189.953 c-12.313-3.225-24.636-3.219-36.97,0l-8.763,21.243c18.047-2.761,36.212-2.764,54.496,0L186.624,189.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#D96981"
    },
    d: "M186.228,190.496c-5.994-1.546-12.073-2.33-18.074-2.33 c-2.942,0-5.906,0.19-8.872,0.564c4.851,4.483,6.217,12.349,6.284,19.789c0.831-0.012,1.662-0.023,2.491-0.023 c8.73,0,17.602,0.648,26.39,1.927L186.228,190.496z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A1418"
    },
    d: "M175.894,191.467c-5.236-0.492-10.507-0.486-15.811,0l-1.801,2.358l4.875,13.572h9.355 l4.831-12.996L175.894,191.467z M171.715,206.973h-8.319l-4.469-12.442l1.246-1.632c2.535-0.223,5.084-0.336,7.584-0.336 c2.464,0,4.945,0.11,7.382,0.327l1.033,2.093L171.715,206.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A1418"
    },
    d: "M185.567,193.353l-5.204-1.336c-2.446,4.826-4.635,10.118-6.654,15.721 c6.074,0.062,12.203,0.547,18.38,1.415L185.567,193.353z M180.466,193.6l4.277,1.098l5.713,13.841 c-5.375-0.703-10.689-1.109-15.832-1.208C176.537,202.139,178.456,197.629,180.466,193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A1418"
    },
    d: "M150.245,193.353l-6.522,15.799c6.177-0.868,12.306-1.353,18.38-1.415 c-2.019-5.602-4.208-10.895-6.654-15.721L150.245,193.353z M144.789,208.539l5.714-13.841l4.278-1.098 c2.01,4.029,3.929,8.538,5.841,13.731C155.478,207.43,150.164,207.836,144.789,208.539z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156554651098591600930000017729621507028594846_",
    filterUnits: "userSpaceOnUse",
    x: 168.726,
    y: 227.939,
    width: 27.801,
    height: 8.094
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 168.726,
    y: 227.939,
    width: 27.801,
    height: 8.094,
    id: "SVGID_00000047767460459053689300000001721668212156172422_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000156554651098591600930000017729621507028594846_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000012466533366631658140000008074435547270742169_",
    filterUnits: "userSpaceOnUse",
    x: 168.726,
    y: 227.939,
    width: 27.801,
    height: 8.094
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 168.726,
    y: 227.939,
    width: 27.801,
    height: 8.094,
    id: "SVGID_00000047767460459053689300000001721668212156172422_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000012466533366631658140000008074435547270742169_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099658609862117181090000004990866311652417168_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.6343,
    y1: 228.709,
    x2: 171.6914,
    y2: 234.4025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000047767460459053689300000001721668212156172422_)",
      fill: "url(#SVGID_00000099658609862117181090000004990866311652417168_)"
    },
    d: " M196.477,227.939c0.105,1.52,0.048,3.054-0.17,4.559c-8.996,2.417-18.327,3.614-27.58,3.531 c-0.011-1.34,0.215-2.794,0.401-4.119C178.279,231.83,187.458,230.183,196.477,227.939z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131348722729360307210000016927191311977606586_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.6343,
    y1: 228.709,
    x2: 171.6914,
    y2: 234.4025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF7CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "url(#SVGID_00000131348722729360307210000016927191311977606586_)"
    },
    d: "M196.477,227.939 c0.105,1.52,0.048,3.054-0.17,4.559c-8.996,2.417-18.327,3.614-27.58,3.531c-0.011-1.34,0.215-2.794,0.401-4.119 C178.279,231.83,187.458,230.183,196.477,227.939z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#305575"
    },
    points: "173.664,235.555 161.61,235.555 161.189,230.97 174.086,230.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF7CC"
    },
    points: "174.086,235.353 162.032,235.353 161.611,230.768 174.508,230.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD586"
    },
    points: "162.302,231.279 173.81,231.279 173.529,234.875 171.928,234.875 173.265,234.541  173.406,231.829 162.449,231.535 162.343,231.986  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#305575"
    },
    d: "M143.088,219.857c0.105-0.486,0.213-0.971,0.331-1.454 c2.774,1.73,5.386,3.425,8.336,4.849c-0.022,0.241-0.039,0.482-0.058,0.723c-1.133-0.579-6.978-2.995-8.527-4.072 C143.143,219.884,143.115,219.87,143.088,219.857z M151.468,229.43c-1.425-0.085-6.251-1.102-9.507-2.162 c-0.159,1.768-0.245,3.543-0.245,5.318c3.145,1.028,6.547,1.667,9.854,1.901C151.491,232.796,151.455,231.112,151.468,229.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E4463"
    },
    d: "M194.668,211.302c-6.421-1.503-16.538-2.15-26.562-2.15c-10.024,0-20.141,0.647-26.562,2.15 l-0.359,4.607c0.612,0.494,1.261,0.978,1.942,1.455c0.056-0.002,0.116-0.004,0.172-0.006c0.383-0.948,0.923-1.836,1.59-2.62 c2.344-0.092,4.613-0.293,6.951-0.484c9.08-0.743,18.148,0.308,27.232-0.404c0.178-0.299,0.365-0.674,0.543-0.973 c3.693-0.095,7.234,0.071,10.908,0.452c0.406,0.847,0.673,1.607,1.079,2.454c0.382-0.1,0.753-0.195,1.134-0.294 c0.158,0.604,0.302,1.2,0.455,1.801c0.642-0.452,1.257-0.912,1.837-1.38L194.668,211.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F7387"
    },
    d: "M179.771,213.911c-0.691-0.332-0.692-1.32-0.015-1.679c1.465-0.777,3.147-1.213,4.841-1.238 c1.714-0.026,3.431,0.369,4.935,1.118c0.682,0.34,0.719,1.316,0.046,1.673C187.023,215.139,183.185,215.554,179.771,213.911z  M186.363,216.021c-2.088-0.248-4.282-0.294-6.379-0.148c0.248,1.069,0.369,2.17,0.36,3.269c1.948-0.053,3.996-0.188,5.904-0.601 C186.438,217.733,186.451,216.849,186.363,216.021z M144.535,215.824c-0.217-1.298-0.197-2.64,0.058-3.931 c2.414-0.436,4.925-0.46,7.36-0.183c-0.221,1.443-0.397,2.878-0.619,4.321c0.014-0.044,0.029-0.087,0.043-0.131 C149.259,216.097,146.654,216.02,144.535,215.824z M148.045,218.385c-0.102-0.48-0.204-0.96-0.305-1.44 c1.157-0.092,2.365-0.245,3.523-0.337c0.147,0.599,0.039,1.28-0.07,1.888C150.225,218.566,149.003,218.548,148.045,218.385z  M156.426,215.149c0.036-0.359,0.124-0.727,0.209-1.084l0.083-0.354l0.112-0.008c1.603-0.112,2.953-0.129,4.247-0.054l0.09,0.005 l0.039,0.085c0.119,0.257,0.215,0.483,0.31,0.71c0.082,0.195,0.165,0.39,0.262,0.605c2.799-0.133,5.154-0.14,7.389-0.023 c0.013-0.154,0.029-0.326,0.046-0.497c0.022-0.229,0.045-0.458,0.057-0.644l0.009-0.141l0.135-0.007 c0.551-0.029,1.123-0.077,1.676-0.123c0.553-0.046,1.126-0.094,1.681-0.123l0.1-0.005l0.044,0.094 c0.135,0.285,0.245,0.563,0.351,0.832c0.092,0.234,0.187,0.476,0.299,0.72c0.95-0.033,1.873-0.076,2.797-0.12 c0.726-0.034,1.456-0.067,2.195-0.096c-0.404-1.359-0.913-2.686-1.492-3.945c-7.835-0.109-15.78,0.05-23.608,0.404 c-0.359,1.274-0.67,2.563-0.932,3.863L156.426,215.149z M178.648,215.237c-0.765,0.029-1.52,0.063-2.271,0.099 c-0.956,0.045-1.913,0.09-2.9,0.123l-0.098,0.003l-0.044-0.092c-0.135-0.285-0.245-0.563-0.35-0.832 c-0.092-0.234-0.187-0.474-0.298-0.718c-0.519,0.03-1.054,0.074-1.572,0.117c-0.51,0.043-1.037,0.086-1.551,0.116 c-0.013,0.158-0.03,0.335-0.047,0.512c-0.022,0.229-0.045,0.459-0.057,0.644l-0.011,0.157l-0.15-0.008 c-2.296-0.127-4.713-0.121-7.608,0.02l-0.1,0.005l-0.044-0.095c-0.119-0.257-0.215-0.483-0.31-0.71 c-0.084-0.198-0.167-0.396-0.267-0.615c-1.225-0.066-2.504-0.05-4.009,0.051l-0.03,0.128c-0.094,0.392-0.191,0.798-0.212,1.173 l-0.008,0.147l-4.247,0.101c-0.216,1.105-0.399,2.218-0.544,3.336c3.211,0.874,6.607,0.86,9.925,0.878 c5.953,0.031,11.702,0.334,17.588-0.6C179.292,217.857,179.017,216.534,178.648,215.237z M190.738,217.467 c0.221-0.557,0.092-1.177,0.051-1.779c-1.134-0.066-2.191-0.339-3.268,0.041c-0.207,0.602-0.304,1.246-0.284,1.886 C188.271,217.785,189.704,217.647,190.738,217.467z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000136396895524029878410000006595209405534522517_",
    filterUnits: "userSpaceOnUse",
    x: 145.245,
    y: 211.167,
    width: 45.256,
    height: 7.628
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 145.245,
    y: 211.167,
    width: 45.256,
    height: 7.628,
    id: "SVGID_00000083068456425777668840000005273362998339621778_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000136396895524029878410000006595209405534522517_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000100378002217668352360000002916887589071614901_",
    filterUnits: "userSpaceOnUse",
    x: 145.245,
    y: 211.167,
    width: 45.256,
    height: 7.628
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 145.245,
    y: 211.167,
    width: 45.256,
    height: 7.628,
    id: "SVGID_00000083068456425777668840000005273362998339621778_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000100378002217668352360000002916887589071614901_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018219876129030533480000014640501737504810387_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.2292,
    y1: 207.7431,
    x2: 135.9628,
    y2: 221.0677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1448,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2729,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3948,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5129,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6282,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#7C7C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#161616"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000083068456425777668840000005273362998339621778_)",
      fill: "url(#SVGID_00000018219876129030533480000014640501737504810387_)"
    },
    d: " M169.35,218.795c-1.334,0-2.7-0.019-4.021-0.037c-1.072-0.014-2.149-0.029-3.233-0.035l-0.339-0.002 c-2.967-0.014-6.03-0.029-8.906-0.72c0.104-0.733,0.226-1.477,0.364-2.224l4.32-0.103l0.042-0.736 c0.013-0.221,0.061-0.472,0.118-0.728c0.722-0.042,1.387-0.062,2.022-0.062c0.378,0,0.742,0.007,1.104,0.021 c0.034,0.079,0.067,0.157,0.1,0.235c0.106,0.25,0.204,0.483,0.326,0.747l0.219,0.474l0.502-0.024 c1.52-0.074,2.888-0.109,4.181-0.109c1.173,0,2.274,0.029,3.367,0.089l0.748,0.041l0.054-0.783 c0.012-0.173,0.032-0.385,0.053-0.598c0.346-0.025,0.694-0.054,1.035-0.082c0.383-0.032,0.768-0.064,1.147-0.09 c0.038,0.094,0.075,0.188,0.111,0.28c0.117,0.297,0.23,0.585,0.375,0.889l0.218,0.46l0.489-0.016 c0.989-0.033,1.948-0.078,2.908-0.123c0.593-0.028,1.188-0.055,1.789-0.079c0.248,0.937,0.434,1.854,0.557,2.739 C175.524,218.724,172.185,218.795,169.35,218.795C169.35,218.795,169.35,218.795,169.35,218.795z M181.193,218.069 c-0.025-0.675-0.097-1.349-0.215-2.013c0.547-0.026,1.1-0.039,1.65-0.039c1.157,0,2.304,0.058,3.415,0.171 c0.023,0.494,0.001,0.965-0.064,1.393C184.328,217.903,182.62,218.017,181.193,218.069z M150.33,217.481 c-0.553,0-1.075-0.029-1.533-0.083l-0.062-0.29c0.355-0.034,0.713-0.071,1.071-0.108c0.39-0.04,0.779-0.081,1.165-0.117 c-0.003,0.187-0.022,0.383-0.05,0.586C150.727,217.477,150.527,217.481,150.33,217.481z M188.575,216.639 c-0.163,0-0.318-0.004-0.464-0.013c0.024-0.266,0.07-0.531,0.139-0.787c0.237-0.055,0.492-0.081,0.782-0.081 c0.357,0,0.725,0.039,1.114,0.08c0.11,0.012,0.22,0.023,0.331,0.034c0.02,0.218,0.033,0.426,0.016,0.613 C189.993,216.559,189.287,216.639,188.575,216.639C188.575,216.639,188.575,216.639,188.575,216.639z M148.879,214.961 c-1.152,0-2.375-0.051-3.564-0.147c-0.108-0.918-0.091-1.862,0.049-2.774c1.18-0.189,2.42-0.284,3.692-0.284 c0.8,0,1.619,0.038,2.443,0.113c-0.073,0.499-0.141,0.997-0.21,1.494c-0.07,0.509-0.14,1.018-0.215,1.528 C150.403,214.937,149.667,214.961,148.879,214.961z M153.538,214.169c0.19-0.87,0.402-1.736,0.633-2.584 c6.268-0.277,12.393-0.418,18.213-0.418c1.524,0,3.05,0.01,4.543,0.029c0.398,0.895,0.748,1.8,1.047,2.704 c-0.466,0.02-0.928,0.041-1.39,0.063c-0.79,0.037-1.577,0.075-2.381,0.105c-0.04-0.098-0.078-0.195-0.116-0.29 c-0.118-0.299-0.231-0.587-0.376-0.892l-0.222-0.47l-0.5,0.027c-0.569,0.03-1.169,0.08-1.698,0.125 c-0.557,0.046-1.12,0.093-1.658,0.122l-0.675,0.036l-0.048,0.707c-0.01,0.151-0.027,0.333-0.046,0.519 c-0.883-0.038-1.778-0.056-2.718-0.056c-1.17,0-2.396,0.029-3.737,0.087c-0.03-0.069-0.058-0.138-0.087-0.206 c-0.098-0.233-0.197-0.466-0.319-0.73l-0.196-0.424l-0.449-0.026c-0.541-0.031-1.079-0.046-1.644-0.046 c-0.827,0-1.702,0.033-2.677,0.101l-0.557,0.039l-0.19,0.809c-0.048,0.199-0.096,0.402-0.137,0.609L153.538,214.169z  M184.787,213.927c-1.578,0-3.138-0.35-4.513-1.011c-0.141-0.068-0.164-0.185-0.165-0.248 c-0.001-0.056,0.014-0.195,0.171-0.278c1.398-0.741,2.979-1.146,4.574-1.169l0.149-0.001c1.565,0,3.126,0.366,4.515,1.058 c0.164,0.081,0.183,0.222,0.183,0.279c0.001,0.075-0.025,0.178-0.151,0.245C188.178,213.527,186.487,213.927,184.787,213.927z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135652533173332337800000010378621668772555917_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.2292,
    y1: 207.7431,
    x2: 135.9628,
    y2: 221.0677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9417,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF7CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000135652533173332337800000010378621668772555917_)"
    },
    d: "M169.35,218.795 c-1.334,0-2.7-0.019-4.021-0.037c-1.072-0.014-2.149-0.029-3.233-0.035l-0.339-0.002c-2.967-0.014-6.03-0.029-8.906-0.72 c0.104-0.733,0.226-1.477,0.364-2.224l4.32-0.103l0.042-0.736c0.013-0.221,0.061-0.472,0.118-0.728 c0.722-0.042,1.387-0.062,2.022-0.062c0.378,0,0.742,0.007,1.104,0.021c0.034,0.079,0.067,0.157,0.1,0.235 c0.106,0.25,0.204,0.483,0.326,0.747l0.219,0.474l0.502-0.024c1.52-0.074,2.888-0.109,4.181-0.109 c1.173,0,2.274,0.029,3.367,0.089l0.748,0.041l0.054-0.783c0.012-0.173,0.032-0.385,0.053-0.598 c0.346-0.025,0.694-0.054,1.035-0.082c0.383-0.032,0.768-0.064,1.147-0.09c0.038,0.094,0.075,0.188,0.111,0.28 c0.117,0.297,0.23,0.585,0.375,0.889l0.218,0.46l0.489-0.016c0.989-0.033,1.948-0.078,2.908-0.123 c0.593-0.028,1.188-0.055,1.789-0.079c0.248,0.937,0.434,1.854,0.557,2.739C175.524,218.724,172.185,218.795,169.35,218.795 C169.35,218.795,169.35,218.795,169.35,218.795z M181.193,218.069c-0.025-0.675-0.097-1.349-0.215-2.013 c0.547-0.026,1.1-0.039,1.65-0.039c1.157,0,2.304,0.058,3.415,0.171c0.023,0.494,0.001,0.965-0.064,1.393 C184.328,217.903,182.62,218.017,181.193,218.069z M150.33,217.481c-0.553,0-1.075-0.029-1.533-0.083l-0.062-0.29 c0.355-0.034,0.713-0.071,1.071-0.108c0.39-0.04,0.779-0.081,1.165-0.117c-0.003,0.187-0.022,0.383-0.05,0.586 C150.727,217.477,150.527,217.481,150.33,217.481z M188.575,216.639c-0.163,0-0.318-0.004-0.464-0.013 c0.024-0.266,0.07-0.531,0.139-0.787c0.237-0.055,0.492-0.081,0.782-0.081c0.357,0,0.725,0.039,1.114,0.08 c0.11,0.012,0.22,0.023,0.331,0.034c0.02,0.218,0.033,0.426,0.016,0.613C189.993,216.559,189.287,216.639,188.575,216.639 C188.575,216.639,188.575,216.639,188.575,216.639z M148.879,214.961c-1.152,0-2.375-0.051-3.564-0.147 c-0.108-0.918-0.091-1.862,0.049-2.774c1.18-0.189,2.42-0.284,3.692-0.284c0.8,0,1.619,0.038,2.443,0.113 c-0.073,0.499-0.141,0.997-0.21,1.494c-0.07,0.509-0.14,1.018-0.215,1.528C150.403,214.937,149.667,214.961,148.879,214.961z  M153.538,214.169c0.19-0.87,0.402-1.736,0.633-2.584c6.268-0.277,12.393-0.418,18.213-0.418c1.524,0,3.05,0.01,4.543,0.029 c0.398,0.895,0.748,1.8,1.047,2.704c-0.466,0.02-0.928,0.041-1.39,0.063c-0.79,0.037-1.577,0.075-2.381,0.105 c-0.04-0.098-0.078-0.195-0.116-0.29c-0.118-0.299-0.231-0.587-0.376-0.892l-0.222-0.47l-0.5,0.027 c-0.569,0.03-1.169,0.08-1.698,0.125c-0.557,0.046-1.12,0.093-1.658,0.122l-0.675,0.036l-0.048,0.707 c-0.01,0.151-0.027,0.333-0.046,0.519c-0.883-0.038-1.778-0.056-2.718-0.056c-1.17,0-2.396,0.029-3.737,0.087 c-0.03-0.069-0.058-0.138-0.087-0.206c-0.098-0.233-0.197-0.466-0.319-0.73l-0.196-0.424l-0.449-0.026 c-0.541-0.031-1.079-0.046-1.644-0.046c-0.827,0-1.702,0.033-2.677,0.101l-0.557,0.039l-0.19,0.809 c-0.048,0.199-0.096,0.402-0.137,0.609L153.538,214.169z M184.787,213.927c-1.578,0-3.138-0.35-4.513-1.011 c-0.141-0.068-0.164-0.185-0.165-0.248c-0.001-0.056,0.014-0.195,0.171-0.278c1.398-0.741,2.979-1.146,4.574-1.169l0.149-0.001 c1.565,0,3.126,0.366,4.515,1.058c0.164,0.081,0.183,0.222,0.183,0.279c0.001,0.075-0.025,0.178-0.151,0.245 C188.178,213.527,186.487,213.927,184.787,213.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F7387"
    },
    d: "M162.582,222.998c-0.37-0.712-0.639-1.578-0.859-2.465c5.809,0.228,11.602,0.077,17.402-0.412 c-0.081,0.925-0.122,1.91-0.241,2.83C173.56,223.311,167.901,223.377,162.582,222.998z M153.481,220.098 c0.093,0.968,0.534,2.002,1.051,2.803c2.31-0.01,4.777,0.12,7.097,0.147c-0.351-0.814-0.638-1.659-0.857-2.525 C158.458,220.438,156.056,220.251,153.481,220.098z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000114047688083379580410000011448358999918949556_",
    filterUnits: "userSpaceOnUse",
    x: 154.317,
    y: 220.344,
    width: 24.242,
    height: 1.914
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 154.317,
    y: 220.344,
    width: 24.242,
    height: 1.914,
    id: "SVGID_00000036939417562911027130000002654386774021971088_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000114047688083379580410000011448358999918949556_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000026856995989140620290000014847778247213187519_",
    filterUnits: "userSpaceOnUse",
    x: 154.317,
    y: 220.344,
    width: 24.242,
    height: 1.914
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 154.317,
    y: 220.344,
    width: 24.242,
    height: 1.914,
    id: "SVGID_00000036939417562911027130000002654386774021971088_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000026856995989140620290000014847778247213187519_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004516090616153746600000005380474989971985078_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.6231,
    y1: 217.9541,
    x2: 153.1029,
    y2: 224.1602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1448,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2729,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3948,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5129,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6282,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#7C7C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    style: {
      stopColor: "#4C4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#161616"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000036939417562911027130000002654386774021971088_)",
      fill: "url(#SVGID_00000004516090616153746600000005380474989971985078_)"
    },
    d: " M170.205,222.258c-2.471,0-4.867-0.077-7.126-0.229c-0.162-0.358-0.312-0.774-0.458-1.267c1.502,0.05,3.022,0.075,4.53,0.075 c3.739,0,7.574-0.154,11.409-0.46c-0.007,0.096-0.014,0.193-0.02,0.29c-0.031,0.439-0.063,0.888-0.107,1.324 C175.651,222.168,172.886,222.258,170.205,222.258z M160.826,222.037c-0.689-0.015-1.39-0.035-2.074-0.055 c-1.249-0.037-2.539-0.075-3.777-0.077c-0.293-0.506-0.521-1.049-0.658-1.561c0.563,0.035,1.119,0.071,1.667,0.107 c1.529,0.099,2.981,0.193,4.409,0.254C160.52,221.154,160.664,221.6,160.826,222.037z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048497998513832107500000005230301391178612627_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.6231,
    y1: 217.9541,
    x2: 153.1029,
    y2: 224.1602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9417,
    style: {
      stopColor: "#FFF7CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF7CC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000048497998513832107500000005230301391178612627_)"
    },
    d: "M170.205,222.258 c-2.471,0-4.867-0.077-7.126-0.229c-0.162-0.358-0.312-0.774-0.458-1.267c1.502,0.05,3.022,0.075,4.53,0.075 c3.739,0,7.574-0.154,11.409-0.46c-0.007,0.096-0.014,0.193-0.02,0.29c-0.031,0.439-0.063,0.888-0.107,1.324 C175.651,222.168,172.886,222.258,170.205,222.258z M160.826,222.037c-0.689-0.015-1.39-0.035-2.074-0.055 c-1.249-0.037-2.539-0.075-3.777-0.077c-0.293-0.506-0.521-1.049-0.658-1.561c0.563,0.035,1.119,0.071,1.667,0.107 c1.529,0.099,2.981,0.193,4.409,0.254C160.52,221.154,160.664,221.6,160.826,222.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#D96981"
    },
    d: "M194.668,211.302l-5.15,0.975c-1.061-0.407-2.113-0.763-3.103-0.748 c-2.728,0.372-5.111,1.055-7.178,2.026l-0.994,0.372l-1.571-1.612c-6.347-0.276-12.754-0.574-15.847,0.353l-7.288,1.501 l-1.011,1.072l-1.264,1.366l-2.51,0.227l-0.855,0.858l0.147,0.693l-2.286,0.689l-4.575-3.165l0.359-4.607 C158.144,208.073,179.984,208.371,194.668,211.302z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072241953805984691460000002421625488522422710_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.4655,
    y1: 266.2235,
    x2: 198.4655,
    y2: 52.8239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "url(#SVGID_00000072241953805984691460000002421625488522422710_)"
    },
    points: " 51.758,115.83 60.485,265.163 105.182,265.163 100.364,150.193 308.909,153.83 296.364,265.163 336.364,265.163 345.173,115.642  198.424,64.011  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#E8A699"
    },
    d: " M145.26,82.795l104.036-0.885l3.598,1.266L141.5,84.123L145.26,82.795z M338.793,223.929l0.044-0.742l-37.683-0.531l-0.084,0.742 L338.793,223.929z M339.388,213.831l0.046-0.782l-37.146-0.463l-0.088,0.782L339.388,213.831z M337.01,112.77l-3.313-1.166 l-272.822,1.004l-3.369,1.19L337.01,112.77z M308.719,102.816l-3.409-1.199l-216.567,1.146l-3.498,1.236L308.719,102.816z  M344.152,132.973l0.065-1.099l-291.514,0.134l0.064,1.099L344.152,132.973z M339.983,203.73l0.048-0.822l-36.608-0.397 l-0.092,0.821L339.983,203.73z M344.748,122.857l0.067-1.138l-292.678,0.606l0.067,1.138L344.748,122.857z M259.518,152.969 l83.443,0.231l0.06-1.02l-153.023-0.423L259.518,152.969z M299.94,233.425l38.258,0.601l0.042-0.703l-38.22-0.6L299.94,233.425z  M298.81,243.449l38.793,0.672l0.039-0.663l-38.757-0.671L298.81,243.449z M341.769,173.417l0.055-0.94l-34.993-0.21l-0.106,0.94 L341.769,173.417z M341.174,183.524l0.053-0.901l-35.532-0.27l-0.101,0.9L341.174,183.524z M342.365,163.309l0.058-0.98 l-34.454-0.151l-0.11,0.98L342.365,163.309z M340.578,193.628l0.051-0.861l-36.07-0.333l-0.097,0.861L340.578,193.628z  M280.681,92.952l-3.504-1.233L116.87,92.825l-3.628,1.282L280.681,92.952z M104.512,249.184l-45.011-0.853l0.036,0.625 l45.001,0.852L104.512,249.184z M103.284,219.87L57.8,219.229l0.043,0.744l45.471,0.64L103.284,219.87z M104.922,258.957 l-44.853-0.923l0.034,0.585l44.844,0.922L104.922,258.957z M103.693,229.64l-45.326-0.712l0.041,0.704l45.314,0.712L103.693,229.64 z M104.103,239.411l-45.168-0.783l0.039,0.665l45.158,0.782L104.103,239.411z M296.553,263.484l39.861,0.82l0.034-0.584 l-39.83-0.819L296.553,263.484z M173.917,72.67l-3.893,1.376l55.329-0.56l-3.691-1.299L173.917,72.67z M297.681,253.468 l39.327,0.745l0.037-0.624l-39.294-0.744L297.681,253.468z M101.237,171.035l-46.269-0.277l0.055,0.941l46.254,0.277 L101.237,171.035z M102.874,210.1l-45.64-0.569l0.046,0.783l45.628,0.569L102.874,210.1z M100.828,161.271l-46.426-0.203 l0.057,0.98l46.41,0.203L100.828,161.271z M100.419,151.508l-46.583-0.129l0.06,1.02l46.567,0.129L100.419,151.508z  M343.619,142.028l-290.35-0.335l0.062,1.059l290.225,0.335L343.619,142.028z M102.465,200.333l-45.798-0.497l0.048,0.823 l45.784,0.497L102.465,200.333z M102.056,190.566L56.1,190.141l0.05,0.862l45.941,0.424L102.056,190.566z M101.646,180.799 l-46.112-0.351l0.053,0.902l46.097,0.351L101.646,180.799z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#FFF7CC"
    },
    points: " 297.383,264.262 310.535,154.013 310.748,152.225 308.938,152.194 100.392,148.557 98.643,148.527 98.729,150.262 104.353,264.374  59.879,264.383 59.879,265.943 105.999,265.953 105.971,265.13 102.058,151.859 307.093,155.435 295.464,265.061 295.356,266.074  337.151,265.951 337.151,264.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#AB1535"
    },
    points: " 98.643,148.527 104.353,264.374 102.909,264.374 97.333,148.527  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095318006663103898790000008084158731415031685_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.3525,
    y1: 161.6367,
    x2: 304.0085,
    y2: 161.6367
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2232,
    style: {
      stopColor: "#FFEFBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    style: {
      stopColor: "#FAE0B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    style: {
      stopColor: "#EEB9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8A699"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "url(#SVGID_00000095318006663103898790000008084158731415031685_)"
    },
    points: " 104.353,153.83 304.008,156.061 302.251,169.444 104.353,169.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#FFF7CC"
    },
    points: " 302.826,170.954 103.5,171.557 103.5,169.106 303.13,169.106  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#E8A699"
    },
    d: " M104.353,166.905v-1.676h198.452l-0.166,1.266L104.353,166.905z M104.353,162.033v1.583l198.639,0.19l0.166-1.266L104.353,162.033z  M104.353,158.631v1.49l199.019,0.79l0.166-1.266L104.353,158.631z M104.353,155.228v1.397l199.399,1.39l0.166-1.266 L104.353,155.228z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#AB1535"
    },
    points: " 104.353,153.83 104.353,157.648 298.06,159.617 298.606,169.106 299.758,169.106 299.758,170.964 302.826,170.954 303.13,169.106  302.32,168.921 304.008,156.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#FFF7CC"
    },
    points: " 359.09,117.878 200.059,59.383 198.442,58.789 196.819,59.373 28.577,119.919 30.362,125.074 198.41,69.189 357.273,123.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#65A0A8"
    },
    points: " 359.404,117.024 199.074,57.072 198.45,56.839 197.823,57.068 28.27,119.064 28.885,120.774 198.436,60.731 358.776,118.731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#AB1535"
    },
    points: " 51.742,117.963 198.41,69.189 344.984,118.856 344.436,128.152 185.454,81.91 52.204,123.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)",
      fill: "#AB1535"
    },
    points: " 28.885,120.774 198.436,60.731 358.776,118.731 358.067,120.774 198.363,62.375 29.2,121.719  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    points: "82.785,181.287 79.592,175.519 70.037,175.519 66.659,181.287 68.717,181.287  68.808,182.366 68.808,182.366 69.988,196.346 68.717,196.346 71.233,202.114 78.349,202.114 80.728,196.346 79.878,196.346  81.52,181.287  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A869A"
    },
    d: "M75.917,175.393h9.646l3.223,5.823H72.507L75.917,175.393z M77.123,202.24h7.184l2.401-5.823 H74.584L77.123,202.24z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    points: "85.146,176.156 87.508,180.754 83.282,180.754 83.282,176.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    points: "85.022,197.314 83.662,201.385 81.294,201.385 81.294,197.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "76.157,176.156 73.795,180.754 76.157,180.754 76.983,176.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "75.867,197.314 77.399,201.626 78.589,201.626 78.269,197.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A6EAC3"
    },
    points: "74.584,181.216 75.867,196.417 85.851,196.417 87.508,181.216  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#FFFBF3"
    },
    points: "86.481,182.305 85.022,195.859 82.996,195.84 82.996,182.784 76.654,183.016  77.228,195.787 76.393,195.779 75.389,182.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "77.524,183.53 78.187,195.556 80.079,195.556 80.079,183.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "87.508,181.216 74.675,182.305 74.584,181.216  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000022545713040613794130000013595285676791165355_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#AB1535"
    },
    points: "326.744,181.287 323.551,175.519 313.996,175.519 310.618,181.287  312.676,181.287 312.767,182.366 312.767,182.366 313.947,196.346 312.676,196.346 315.192,202.114 322.308,202.114  324.686,196.346 323.837,196.346 325.478,181.287  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A869A"
    },
    d: "M319.876,175.393h9.646l3.223,5.823h-16.279L319.876,175.393z M321.082,202.24h7.184l2.401-5.823 h-12.125L321.082,202.24z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    points: "329.105,176.156 331.467,180.754 327.241,180.754 327.241,176.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#DAD1C0"
    },
    points: "328.981,197.314 327.621,201.385 325.253,201.385 325.253,197.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "320.115,176.156 317.754,180.754 320.115,180.754 320.942,176.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "319.826,197.314 321.358,201.626 322.548,201.626 322.228,197.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A6EAC3"
    },
    points: "318.543,181.216 319.826,196.417 329.81,196.417 331.467,181.216  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#FFFBF3"
    },
    points: "330.44,182.305 328.981,195.859 326.955,195.84 326.955,182.784  320.613,183.016 321.187,195.787 320.352,195.779 319.348,182.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "321.483,183.53 322.145,195.556 324.038,195.556 324.038,183.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#305575"
    },
    points: "331.467,181.216 318.634,182.305 318.543,181.216  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.8fb5bc5648ef6fe8d2e0a4aef42e4c53.svg";
export { ForwardRef as ReactComponent };